(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1ntui", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $100ed00c92162f20$var$_default;
    }
});
function $100ed00c92162f20$var$createPlugin(plugin, config) {
    return {
        handler: plugin,
        config: config
    };
}
$100ed00c92162f20$var$createPlugin.withOptions = function(pluginFunction, configFunction = ()=>({})) {
    const optionsFunction = function(options) {
        return {
            __options: options,
            handler: pluginFunction(options),
            config: configFunction(options)
        };
    };
    optionsFunction.__isOptionsFunction = true;
    // Expose plugin dependencies so that `object-hash` returns a different
    // value if anything here changes, to ensure a rebuild is triggered.
    optionsFunction.__pluginFunction = pluginFunction;
    optionsFunction.__configFunction = configFunction;
    return optionsFunction;
};
const $100ed00c92162f20$var$_default = $100ed00c92162f20$var$createPlugin;

});

parcelRegister("kXWDL", function(module, exports) {
/**
 * This is a minimal config.
 *
 * If you need the full config, get it from here:
 * https://unpkg.com/browse/tailwindcss@latest/stubs/defaultConfig.stub.js
 */ 

module.exports = {
    theme: {
        extend: {
            colors: {
                "neutral": "#DEE8F5",
                "background": "#FAFBFC",
                "separator": "#F4F6FA",
                "primary": {
                    DEFAULT: "#14499A",
                    light: "#376FC4"
                },
                "secondary": "#FDC40A",
                "text": "#072149",
                "display-text": "#7A87BD"
            }
        }
    },
    plugins: [
        (parcelRequire("grNhi")),
        (parcelRequire("jQyqX"))
    ]
};

});
parcelRegister("grNhi", function(module, exports) {

var $dXH7e = parcelRequire("dXH7e");

var $VVGo7 = parcelRequire("VVGo7");

var $cS711 = parcelRequire("cS711");

var $1UypR = parcelRequire("1UypR");

var $dfJwk = parcelRequire("dfJwk");
var $bf95648a59e73a98$require$commonTrailingPseudos = $dfJwk.commonTrailingPseudos;
const $bf95648a59e73a98$var$computed = {
};
function $bf95648a59e73a98$var$inWhere(selector, { className: className, modifier: modifier, prefix: prefix }) {
    let prefixedNot = prefix(`.not-${className}`).slice(1);
    let selectorPrefix = selector.startsWith(">") ? `${modifier === "DEFAULT" ? `.${className}` : `.${className}-${modifier}`} ` : "";
    // Parse the selector, if every component ends in the same pseudo element(s) then move it to the end
    let [trailingPseudo, rebuiltSelector] = $bf95648a59e73a98$require$commonTrailingPseudos(selector);
    if (trailingPseudo) return `:where(${selectorPrefix}${rebuiltSelector}):not(:where([class~="${prefixedNot}"],[class~="${prefixedNot}"] *))${trailingPseudo}`;
    return `:where(${selectorPrefix}${selector}):not(:where([class~="${prefixedNot}"],[class~="${prefixedNot}"] *))`;
}
function $bf95648a59e73a98$var$isObject(value) {
    return typeof value === "object" && value !== null;
}
function $bf95648a59e73a98$var$configToCss(config = {}, { target: target, className: className, modifier: modifier, prefix: prefix }) {
    function updateSelector(k, v) {
        if (target === "legacy") return [
            k,
            v
        ];
        if (Array.isArray(v)) return [
            k,
            v
        ];
        if ($bf95648a59e73a98$var$isObject(v)) {
            let nested = Object.values(v).some($bf95648a59e73a98$var$isObject);
            if (nested) return [
                $bf95648a59e73a98$var$inWhere(k, {
                    className: className,
                    modifier: modifier,
                    prefix: prefix
                }),
                v,
                Object.fromEntries(Object.entries(v).map(([k, v])=>updateSelector(k, v)))
            ];
            return [
                $bf95648a59e73a98$var$inWhere(k, {
                    className: className,
                    modifier: modifier,
                    prefix: prefix
                }),
                v
            ];
        }
        return [
            k,
            v
        ];
    }
    return Object.fromEntries(Object.entries($VVGo7({}, ...Object.keys(config).filter((key)=>$bf95648a59e73a98$var$computed[key]).map((key)=>$bf95648a59e73a98$var$computed[key](config[key])), ...$cS711(config.css || {}))).map(([k, v])=>updateSelector(k, v)));
}
module.exports = $dXH7e.withOptions(({ className: className = "prose", target: target = "modern" } = {})=>{
    return function({ addVariant: addVariant, addComponents: addComponents, theme: theme, prefix: prefix }) {
        let modifiers = theme("typography");
        let options = {
            className: className,
            prefix: prefix
        };
        for (let [name, ...selectors] of [
            [
                "headings",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "th"
            ],
            [
                "h1"
            ],
            [
                "h2"
            ],
            [
                "h3"
            ],
            [
                "h4"
            ],
            [
                "h5"
            ],
            [
                "h6"
            ],
            [
                "p"
            ],
            [
                "a"
            ],
            [
                "blockquote"
            ],
            [
                "figure"
            ],
            [
                "figcaption"
            ],
            [
                "strong"
            ],
            [
                "em"
            ],
            [
                "kbd"
            ],
            [
                "code"
            ],
            [
                "pre"
            ],
            [
                "ol"
            ],
            [
                "ul"
            ],
            [
                "li"
            ],
            [
                "table"
            ],
            [
                "thead"
            ],
            [
                "tr"
            ],
            [
                "th"
            ],
            [
                "td"
            ],
            [
                "img"
            ],
            [
                "video"
            ],
            [
                "hr"
            ],
            [
                "lead",
                '[class~="lead"]'
            ]
        ]){
            selectors = selectors.length === 0 ? [
                name
            ] : selectors;
            let selector = target === "legacy" ? selectors.map((selector)=>`& ${selector}`) : selectors.join(", ");
            addVariant(`${className}-${name}`, target === "legacy" ? selector : `& :is(${$bf95648a59e73a98$var$inWhere(selector, options)})`);
        }
        addComponents(Object.keys(modifiers).map((modifier)=>({
                [modifier === "DEFAULT" ? `.${className}` : `.${className}-${modifier}`]: $bf95648a59e73a98$var$configToCss(modifiers[modifier], {
                    target: target,
                    className: className,
                    modifier: modifier,
                    prefix: prefix
                })
            })));
    };
}, ()=>{
    return {
        theme: {
            typography: $1UypR
        }
    };
});

});
parcelRegister("dXH7e", function(module, exports) {

var $gwjdu = parcelRequire("gwjdu");
module.exports = ($gwjdu.__esModule ? $gwjdu : {
    default: $gwjdu
}).default;

});
parcelRegister("gwjdu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c06e8a87413bb820$var$_default;
    }
});

const $c06e8a87413bb820$var$_createPlugin = /*#__PURE__*/ $c06e8a87413bb820$var$_interop_require_default((parcelRequire("1ntui")));
function $c06e8a87413bb820$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c06e8a87413bb820$var$_default = $c06e8a87413bb820$var$_createPlugin.default;

});


parcelRegister("VVGo7", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = merge;

});

parcelRegister("cS711", function(module, exports) {
/**
 * lodash 4.4.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $95eff855b41c00fc$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $95eff855b41c00fc$var$isArray(value) ? value : [
        value
    ];
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type {Function}
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $95eff855b41c00fc$var$isArray = Array.isArray;
module.exports = $95eff855b41c00fc$var$castArray;

});

parcelRegister("1UypR", function(module, exports) {

var $7qkdK = parcelRequire("7qkdK");
const $1645b7b9013cc8ac$var$round = (num)=>num.toFixed(7).replace(/(\.[0-9]+?)0+$/, "$1").replace(/\.0$/, "");
const $1645b7b9013cc8ac$var$rem = (px)=>`${$1645b7b9013cc8ac$var$round(px / 16)}rem`;
const $1645b7b9013cc8ac$var$em = (px, base)=>`${$1645b7b9013cc8ac$var$round(px / base)}em`;
const $1645b7b9013cc8ac$var$hexToRgb = (hex)=>{
    hex = hex.replace("#", "");
    hex = hex.length === 3 ? hex.replace(/./g, "$&$&") : hex;
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `${r} ${g} ${b}`;
};
let $1645b7b9013cc8ac$var$defaultModifiers = {
    sm: {
        css: [
            {
                fontSize: $1645b7b9013cc8ac$var$rem(14),
                lineHeight: $1645b7b9013cc8ac$var$round(24 / 14),
                p: {
                    marginTop: $1645b7b9013cc8ac$var$em(16, 14),
                    marginBottom: $1645b7b9013cc8ac$var$em(16, 14)
                },
                '[class~="lead"]': {
                    fontSize: $1645b7b9013cc8ac$var$em(18, 14),
                    lineHeight: $1645b7b9013cc8ac$var$round(28 / 18),
                    marginTop: $1645b7b9013cc8ac$var$em(16, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(16, 18)
                },
                blockquote: {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 18),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(20, 18)
                },
                h1: {
                    fontSize: $1645b7b9013cc8ac$var$em(30, 14),
                    marginTop: "0",
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 30),
                    lineHeight: $1645b7b9013cc8ac$var$round(1.2)
                },
                h2: {
                    fontSize: $1645b7b9013cc8ac$var$em(20, 14),
                    marginTop: $1645b7b9013cc8ac$var$em(32, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(16, 20),
                    lineHeight: $1645b7b9013cc8ac$var$round(1.4)
                },
                h3: {
                    fontSize: $1645b7b9013cc8ac$var$em(18, 14),
                    marginTop: $1645b7b9013cc8ac$var$em(28, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(8, 18),
                    lineHeight: $1645b7b9013cc8ac$var$round(28 / 18)
                },
                h4: {
                    marginTop: $1645b7b9013cc8ac$var$em(20, 14),
                    marginBottom: $1645b7b9013cc8ac$var$em(8, 14),
                    lineHeight: $1645b7b9013cc8ac$var$round(20 / 14)
                },
                img: {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 14),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 14)
                },
                picture: {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 14),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 14)
                },
                "picture > img": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                video: {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 14),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 14)
                },
                kbd: {
                    fontSize: $1645b7b9013cc8ac$var$em(12, 14),
                    borderRadius: $1645b7b9013cc8ac$var$rem(5),
                    paddingTop: $1645b7b9013cc8ac$var$em(2, 14),
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(5, 14),
                    paddingBottom: $1645b7b9013cc8ac$var$em(2, 14),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(5, 14)
                },
                code: {
                    fontSize: $1645b7b9013cc8ac$var$em(12, 14)
                },
                "h2 code": {
                    fontSize: $1645b7b9013cc8ac$var$em(18, 20)
                },
                "h3 code": {
                    fontSize: $1645b7b9013cc8ac$var$em(16, 18)
                },
                pre: {
                    fontSize: $1645b7b9013cc8ac$var$em(12, 14),
                    lineHeight: $1645b7b9013cc8ac$var$round(20 / 12),
                    marginTop: $1645b7b9013cc8ac$var$em(20, 12),
                    marginBottom: $1645b7b9013cc8ac$var$em(20, 12),
                    borderRadius: $1645b7b9013cc8ac$var$rem(4),
                    paddingTop: $1645b7b9013cc8ac$var$em(8, 12),
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(12, 12),
                    paddingBottom: $1645b7b9013cc8ac$var$em(8, 12),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(12, 12)
                },
                ol: {
                    marginTop: $1645b7b9013cc8ac$var$em(16, 14),
                    marginBottom: $1645b7b9013cc8ac$var$em(16, 14),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(22, 14)
                },
                ul: {
                    marginTop: $1645b7b9013cc8ac$var$em(16, 14),
                    marginBottom: $1645b7b9013cc8ac$var$em(16, 14),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(22, 14)
                },
                li: {
                    marginTop: $1645b7b9013cc8ac$var$em(4, 14),
                    marginBottom: $1645b7b9013cc8ac$var$em(4, 14)
                },
                "ol > li": {
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(6, 14)
                },
                "ul > li": {
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(6, 14)
                },
                "> ul > li p": {
                    marginTop: $1645b7b9013cc8ac$var$em(8, 14),
                    marginBottom: $1645b7b9013cc8ac$var$em(8, 14)
                },
                "> ul > li > p:first-child": {
                    marginTop: $1645b7b9013cc8ac$var$em(16, 14)
                },
                "> ul > li > p:last-child": {
                    marginBottom: $1645b7b9013cc8ac$var$em(16, 14)
                },
                "> ol > li > p:first-child": {
                    marginTop: $1645b7b9013cc8ac$var$em(16, 14)
                },
                "> ol > li > p:last-child": {
                    marginBottom: $1645b7b9013cc8ac$var$em(16, 14)
                },
                "ul ul, ul ol, ol ul, ol ol": {
                    marginTop: $1645b7b9013cc8ac$var$em(8, 14),
                    marginBottom: $1645b7b9013cc8ac$var$em(8, 14)
                },
                dl: {
                    marginTop: $1645b7b9013cc8ac$var$em(16, 14),
                    marginBottom: $1645b7b9013cc8ac$var$em(16, 14)
                },
                dt: {
                    marginTop: $1645b7b9013cc8ac$var$em(16, 14)
                },
                dd: {
                    marginTop: $1645b7b9013cc8ac$var$em(4, 14),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(22, 14)
                },
                hr: {
                    marginTop: $1645b7b9013cc8ac$var$em(40, 14),
                    marginBottom: $1645b7b9013cc8ac$var$em(40, 14)
                },
                "hr + *": {
                    marginTop: "0"
                },
                "h2 + *": {
                    marginTop: "0"
                },
                "h3 + *": {
                    marginTop: "0"
                },
                "h4 + *": {
                    marginTop: "0"
                },
                table: {
                    fontSize: $1645b7b9013cc8ac$var$em(12, 14),
                    lineHeight: $1645b7b9013cc8ac$var$round(1.5)
                },
                "thead th": {
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(12, 12),
                    paddingBottom: $1645b7b9013cc8ac$var$em(8, 12),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(12, 12)
                },
                "thead th:first-child": {
                    paddingInlineStart: "0"
                },
                "thead th:last-child": {
                    paddingInlineEnd: "0"
                },
                "tbody td, tfoot td": {
                    paddingTop: $1645b7b9013cc8ac$var$em(8, 12),
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(12, 12),
                    paddingBottom: $1645b7b9013cc8ac$var$em(8, 12),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(12, 12)
                },
                "tbody td:first-child, tfoot td:first-child": {
                    paddingInlineStart: "0"
                },
                "tbody td:last-child, tfoot td:last-child": {
                    paddingInlineEnd: "0"
                },
                figure: {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 14),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 14)
                },
                "figure > *": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                figcaption: {
                    fontSize: $1645b7b9013cc8ac$var$em(12, 14),
                    lineHeight: $1645b7b9013cc8ac$var$round(16 / 12),
                    marginTop: $1645b7b9013cc8ac$var$em(8, 12)
                }
            },
            {
                "> :first-child": {
                    marginTop: "0"
                },
                "> :last-child": {
                    marginBottom: "0"
                }
            }
        ]
    },
    base: {
        css: [
            {
                fontSize: $1645b7b9013cc8ac$var$rem(16),
                lineHeight: $1645b7b9013cc8ac$var$round(1.75),
                p: {
                    marginTop: $1645b7b9013cc8ac$var$em(20, 16),
                    marginBottom: $1645b7b9013cc8ac$var$em(20, 16)
                },
                '[class~="lead"]': {
                    fontSize: $1645b7b9013cc8ac$var$em(20, 16),
                    lineHeight: $1645b7b9013cc8ac$var$round(1.6),
                    marginTop: $1645b7b9013cc8ac$var$em(24, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 20)
                },
                blockquote: {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 20),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(20, 20)
                },
                h1: {
                    fontSize: $1645b7b9013cc8ac$var$em(36, 16),
                    marginTop: "0",
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 36),
                    lineHeight: $1645b7b9013cc8ac$var$round(40 / 36)
                },
                h2: {
                    fontSize: $1645b7b9013cc8ac$var$em(24, 16),
                    marginTop: $1645b7b9013cc8ac$var$em(48, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 24),
                    lineHeight: $1645b7b9013cc8ac$var$round(32 / 24)
                },
                h3: {
                    fontSize: $1645b7b9013cc8ac$var$em(20, 16),
                    marginTop: $1645b7b9013cc8ac$var$em(32, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(12, 20),
                    lineHeight: $1645b7b9013cc8ac$var$round(1.6)
                },
                h4: {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 16),
                    marginBottom: $1645b7b9013cc8ac$var$em(8, 16),
                    lineHeight: $1645b7b9013cc8ac$var$round(1.5)
                },
                img: {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 16),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 16)
                },
                picture: {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 16),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 16)
                },
                "picture > img": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                video: {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 16),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 16)
                },
                kbd: {
                    fontSize: $1645b7b9013cc8ac$var$em(14, 16),
                    borderRadius: $1645b7b9013cc8ac$var$rem(5),
                    paddingTop: $1645b7b9013cc8ac$var$em(3, 16),
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(6, 16),
                    paddingBottom: $1645b7b9013cc8ac$var$em(3, 16),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(6, 16)
                },
                code: {
                    fontSize: $1645b7b9013cc8ac$var$em(14, 16)
                },
                "h2 code": {
                    fontSize: $1645b7b9013cc8ac$var$em(21, 24)
                },
                "h3 code": {
                    fontSize: $1645b7b9013cc8ac$var$em(18, 20)
                },
                pre: {
                    fontSize: $1645b7b9013cc8ac$var$em(14, 16),
                    lineHeight: $1645b7b9013cc8ac$var$round(24 / 14),
                    marginTop: $1645b7b9013cc8ac$var$em(24, 14),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 14),
                    borderRadius: $1645b7b9013cc8ac$var$rem(6),
                    paddingTop: $1645b7b9013cc8ac$var$em(12, 14),
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(16, 14),
                    paddingBottom: $1645b7b9013cc8ac$var$em(12, 14),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(16, 14)
                },
                ol: {
                    marginTop: $1645b7b9013cc8ac$var$em(20, 16),
                    marginBottom: $1645b7b9013cc8ac$var$em(20, 16),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(26, 16)
                },
                ul: {
                    marginTop: $1645b7b9013cc8ac$var$em(20, 16),
                    marginBottom: $1645b7b9013cc8ac$var$em(20, 16),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(26, 16)
                },
                li: {
                    marginTop: $1645b7b9013cc8ac$var$em(8, 16),
                    marginBottom: $1645b7b9013cc8ac$var$em(8, 16)
                },
                "ol > li": {
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(6, 16)
                },
                "ul > li": {
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(6, 16)
                },
                "> ul > li p": {
                    marginTop: $1645b7b9013cc8ac$var$em(12, 16),
                    marginBottom: $1645b7b9013cc8ac$var$em(12, 16)
                },
                "> ul > li > p:first-child": {
                    marginTop: $1645b7b9013cc8ac$var$em(20, 16)
                },
                "> ul > li > p:last-child": {
                    marginBottom: $1645b7b9013cc8ac$var$em(20, 16)
                },
                "> ol > li > p:first-child": {
                    marginTop: $1645b7b9013cc8ac$var$em(20, 16)
                },
                "> ol > li > p:last-child": {
                    marginBottom: $1645b7b9013cc8ac$var$em(20, 16)
                },
                "ul ul, ul ol, ol ul, ol ol": {
                    marginTop: $1645b7b9013cc8ac$var$em(12, 16),
                    marginBottom: $1645b7b9013cc8ac$var$em(12, 16)
                },
                dl: {
                    marginTop: $1645b7b9013cc8ac$var$em(20, 16),
                    marginBottom: $1645b7b9013cc8ac$var$em(20, 16)
                },
                dt: {
                    marginTop: $1645b7b9013cc8ac$var$em(20, 16)
                },
                dd: {
                    marginTop: $1645b7b9013cc8ac$var$em(8, 16),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(26, 16)
                },
                hr: {
                    marginTop: $1645b7b9013cc8ac$var$em(48, 16),
                    marginBottom: $1645b7b9013cc8ac$var$em(48, 16)
                },
                "hr + *": {
                    marginTop: "0"
                },
                "h2 + *": {
                    marginTop: "0"
                },
                "h3 + *": {
                    marginTop: "0"
                },
                "h4 + *": {
                    marginTop: "0"
                },
                table: {
                    fontSize: $1645b7b9013cc8ac$var$em(14, 16),
                    lineHeight: $1645b7b9013cc8ac$var$round(24 / 14)
                },
                "thead th": {
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(8, 14),
                    paddingBottom: $1645b7b9013cc8ac$var$em(8, 14),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(8, 14)
                },
                "thead th:first-child": {
                    paddingInlineStart: "0"
                },
                "thead th:last-child": {
                    paddingInlineEnd: "0"
                },
                "tbody td, tfoot td": {
                    paddingTop: $1645b7b9013cc8ac$var$em(8, 14),
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(8, 14),
                    paddingBottom: $1645b7b9013cc8ac$var$em(8, 14),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(8, 14)
                },
                "tbody td:first-child, tfoot td:first-child": {
                    paddingInlineStart: "0"
                },
                "tbody td:last-child, tfoot td:last-child": {
                    paddingInlineEnd: "0"
                },
                figure: {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 16),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 16)
                },
                "figure > *": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                figcaption: {
                    fontSize: $1645b7b9013cc8ac$var$em(14, 16),
                    lineHeight: $1645b7b9013cc8ac$var$round(20 / 14),
                    marginTop: $1645b7b9013cc8ac$var$em(12, 14)
                }
            },
            {
                "> :first-child": {
                    marginTop: "0"
                },
                "> :last-child": {
                    marginBottom: "0"
                }
            }
        ]
    },
    lg: {
        css: [
            {
                fontSize: $1645b7b9013cc8ac$var$rem(18),
                lineHeight: $1645b7b9013cc8ac$var$round(32 / 18),
                p: {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 18)
                },
                '[class~="lead"]': {
                    fontSize: $1645b7b9013cc8ac$var$em(22, 18),
                    lineHeight: $1645b7b9013cc8ac$var$round(32 / 22),
                    marginTop: $1645b7b9013cc8ac$var$em(24, 22),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 22)
                },
                blockquote: {
                    marginTop: $1645b7b9013cc8ac$var$em(40, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(40, 24),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(24, 24)
                },
                h1: {
                    fontSize: $1645b7b9013cc8ac$var$em(48, 18),
                    marginTop: "0",
                    marginBottom: $1645b7b9013cc8ac$var$em(40, 48),
                    lineHeight: $1645b7b9013cc8ac$var$round(1)
                },
                h2: {
                    fontSize: $1645b7b9013cc8ac$var$em(30, 18),
                    marginTop: $1645b7b9013cc8ac$var$em(56, 30),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 30),
                    lineHeight: $1645b7b9013cc8ac$var$round(40 / 30)
                },
                h3: {
                    fontSize: $1645b7b9013cc8ac$var$em(24, 18),
                    marginTop: $1645b7b9013cc8ac$var$em(40, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(16, 24),
                    lineHeight: $1645b7b9013cc8ac$var$round(1.5)
                },
                h4: {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(8, 18),
                    lineHeight: $1645b7b9013cc8ac$var$round(28 / 18)
                },
                img: {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 18)
                },
                picture: {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 18)
                },
                "picture > img": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                video: {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 18)
                },
                kbd: {
                    fontSize: $1645b7b9013cc8ac$var$em(16, 18),
                    borderRadius: $1645b7b9013cc8ac$var$rem(5),
                    paddingTop: $1645b7b9013cc8ac$var$em(4, 18),
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(8, 18),
                    paddingBottom: $1645b7b9013cc8ac$var$em(4, 18),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(8, 18)
                },
                code: {
                    fontSize: $1645b7b9013cc8ac$var$em(16, 18)
                },
                "h2 code": {
                    fontSize: $1645b7b9013cc8ac$var$em(26, 30)
                },
                "h3 code": {
                    fontSize: $1645b7b9013cc8ac$var$em(21, 24)
                },
                pre: {
                    fontSize: $1645b7b9013cc8ac$var$em(16, 18),
                    lineHeight: $1645b7b9013cc8ac$var$round(1.75),
                    marginTop: $1645b7b9013cc8ac$var$em(32, 16),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 16),
                    borderRadius: $1645b7b9013cc8ac$var$rem(6),
                    paddingTop: $1645b7b9013cc8ac$var$em(16, 16),
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(24, 16),
                    paddingBottom: $1645b7b9013cc8ac$var$em(16, 16),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(24, 16)
                },
                ol: {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 18),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(28, 18)
                },
                ul: {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 18),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(28, 18)
                },
                li: {
                    marginTop: $1645b7b9013cc8ac$var$em(12, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(12, 18)
                },
                "ol > li": {
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(8, 18)
                },
                "ul > li": {
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(8, 18)
                },
                "> ul > li p": {
                    marginTop: $1645b7b9013cc8ac$var$em(16, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(16, 18)
                },
                "> ul > li > p:first-child": {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 18)
                },
                "> ul > li > p:last-child": {
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 18)
                },
                "> ol > li > p:first-child": {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 18)
                },
                "> ol > li > p:last-child": {
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 18)
                },
                "ul ul, ul ol, ol ul, ol ol": {
                    marginTop: $1645b7b9013cc8ac$var$em(16, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(16, 18)
                },
                dl: {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 18)
                },
                dt: {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 18)
                },
                dd: {
                    marginTop: $1645b7b9013cc8ac$var$em(12, 18),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(28, 18)
                },
                hr: {
                    marginTop: $1645b7b9013cc8ac$var$em(56, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(56, 18)
                },
                "hr + *": {
                    marginTop: "0"
                },
                "h2 + *": {
                    marginTop: "0"
                },
                "h3 + *": {
                    marginTop: "0"
                },
                "h4 + *": {
                    marginTop: "0"
                },
                table: {
                    fontSize: $1645b7b9013cc8ac$var$em(16, 18),
                    lineHeight: $1645b7b9013cc8ac$var$round(1.5)
                },
                "thead th": {
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(12, 16),
                    paddingBottom: $1645b7b9013cc8ac$var$em(12, 16),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(12, 16)
                },
                "thead th:first-child": {
                    paddingInlineStart: "0"
                },
                "thead th:last-child": {
                    paddingInlineEnd: "0"
                },
                "tbody td, tfoot td": {
                    paddingTop: $1645b7b9013cc8ac$var$em(12, 16),
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(12, 16),
                    paddingBottom: $1645b7b9013cc8ac$var$em(12, 16),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(12, 16)
                },
                "tbody td:first-child, tfoot td:first-child": {
                    paddingInlineStart: "0"
                },
                "tbody td:last-child, tfoot td:last-child": {
                    paddingInlineEnd: "0"
                },
                figure: {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 18)
                },
                "figure > *": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                figcaption: {
                    fontSize: $1645b7b9013cc8ac$var$em(16, 18),
                    lineHeight: $1645b7b9013cc8ac$var$round(1.5),
                    marginTop: $1645b7b9013cc8ac$var$em(16, 16)
                }
            },
            {
                "> :first-child": {
                    marginTop: "0"
                },
                "> :last-child": {
                    marginBottom: "0"
                }
            }
        ]
    },
    xl: {
        css: [
            {
                fontSize: $1645b7b9013cc8ac$var$rem(20),
                lineHeight: $1645b7b9013cc8ac$var$round(1.8),
                p: {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 20)
                },
                '[class~="lead"]': {
                    fontSize: $1645b7b9013cc8ac$var$em(24, 20),
                    lineHeight: $1645b7b9013cc8ac$var$round(1.5),
                    marginTop: $1645b7b9013cc8ac$var$em(24, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 24)
                },
                blockquote: {
                    marginTop: $1645b7b9013cc8ac$var$em(48, 30),
                    marginBottom: $1645b7b9013cc8ac$var$em(48, 30),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(32, 30)
                },
                h1: {
                    fontSize: $1645b7b9013cc8ac$var$em(56, 20),
                    marginTop: "0",
                    marginBottom: $1645b7b9013cc8ac$var$em(48, 56),
                    lineHeight: $1645b7b9013cc8ac$var$round(1)
                },
                h2: {
                    fontSize: $1645b7b9013cc8ac$var$em(36, 20),
                    marginTop: $1645b7b9013cc8ac$var$em(56, 36),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 36),
                    lineHeight: $1645b7b9013cc8ac$var$round(40 / 36)
                },
                h3: {
                    fontSize: $1645b7b9013cc8ac$var$em(30, 20),
                    marginTop: $1645b7b9013cc8ac$var$em(48, 30),
                    marginBottom: $1645b7b9013cc8ac$var$em(20, 30),
                    lineHeight: $1645b7b9013cc8ac$var$round(40 / 30)
                },
                h4: {
                    marginTop: $1645b7b9013cc8ac$var$em(36, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(12, 20),
                    lineHeight: $1645b7b9013cc8ac$var$round(1.6)
                },
                img: {
                    marginTop: $1645b7b9013cc8ac$var$em(40, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(40, 20)
                },
                picture: {
                    marginTop: $1645b7b9013cc8ac$var$em(40, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(40, 20)
                },
                "picture > img": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                video: {
                    marginTop: $1645b7b9013cc8ac$var$em(40, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(40, 20)
                },
                kbd: {
                    fontSize: $1645b7b9013cc8ac$var$em(18, 20),
                    borderRadius: $1645b7b9013cc8ac$var$rem(5),
                    paddingTop: $1645b7b9013cc8ac$var$em(5, 20),
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(8, 20),
                    paddingBottom: $1645b7b9013cc8ac$var$em(5, 20),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(8, 20)
                },
                code: {
                    fontSize: $1645b7b9013cc8ac$var$em(18, 20)
                },
                "h2 code": {
                    fontSize: $1645b7b9013cc8ac$var$em(31, 36)
                },
                "h3 code": {
                    fontSize: $1645b7b9013cc8ac$var$em(27, 30)
                },
                pre: {
                    fontSize: $1645b7b9013cc8ac$var$em(18, 20),
                    lineHeight: $1645b7b9013cc8ac$var$round(32 / 18),
                    marginTop: $1645b7b9013cc8ac$var$em(36, 18),
                    marginBottom: $1645b7b9013cc8ac$var$em(36, 18),
                    borderRadius: $1645b7b9013cc8ac$var$rem(8),
                    paddingTop: $1645b7b9013cc8ac$var$em(20, 18),
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(24, 18),
                    paddingBottom: $1645b7b9013cc8ac$var$em(20, 18),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(24, 18)
                },
                ol: {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 20),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(32, 20)
                },
                ul: {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 20),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(32, 20)
                },
                li: {
                    marginTop: $1645b7b9013cc8ac$var$em(12, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(12, 20)
                },
                "ol > li": {
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(8, 20)
                },
                "ul > li": {
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(8, 20)
                },
                "> ul > li p": {
                    marginTop: $1645b7b9013cc8ac$var$em(16, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(16, 20)
                },
                "> ul > li > p:first-child": {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 20)
                },
                "> ul > li > p:last-child": {
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 20)
                },
                "> ol > li > p:first-child": {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 20)
                },
                "> ol > li > p:last-child": {
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 20)
                },
                "ul ul, ul ol, ol ul, ol ol": {
                    marginTop: $1645b7b9013cc8ac$var$em(16, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(16, 20)
                },
                dl: {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 20)
                },
                dt: {
                    marginTop: $1645b7b9013cc8ac$var$em(24, 20)
                },
                dd: {
                    marginTop: $1645b7b9013cc8ac$var$em(12, 20),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(32, 20)
                },
                hr: {
                    marginTop: $1645b7b9013cc8ac$var$em(56, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(56, 20)
                },
                "hr + *": {
                    marginTop: "0"
                },
                "h2 + *": {
                    marginTop: "0"
                },
                "h3 + *": {
                    marginTop: "0"
                },
                "h4 + *": {
                    marginTop: "0"
                },
                table: {
                    fontSize: $1645b7b9013cc8ac$var$em(18, 20),
                    lineHeight: $1645b7b9013cc8ac$var$round(28 / 18)
                },
                "thead th": {
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(12, 18),
                    paddingBottom: $1645b7b9013cc8ac$var$em(16, 18),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(12, 18)
                },
                "thead th:first-child": {
                    paddingInlineStart: "0"
                },
                "thead th:last-child": {
                    paddingInlineEnd: "0"
                },
                "tbody td, tfoot td": {
                    paddingTop: $1645b7b9013cc8ac$var$em(16, 18),
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(12, 18),
                    paddingBottom: $1645b7b9013cc8ac$var$em(16, 18),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(12, 18)
                },
                "tbody td:first-child, tfoot td:first-child": {
                    paddingInlineStart: "0"
                },
                "tbody td:last-child, tfoot td:last-child": {
                    paddingInlineEnd: "0"
                },
                figure: {
                    marginTop: $1645b7b9013cc8ac$var$em(40, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(40, 20)
                },
                "figure > *": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                figcaption: {
                    fontSize: $1645b7b9013cc8ac$var$em(18, 20),
                    lineHeight: $1645b7b9013cc8ac$var$round(28 / 18),
                    marginTop: $1645b7b9013cc8ac$var$em(18, 18)
                }
            },
            {
                "> :first-child": {
                    marginTop: "0"
                },
                "> :last-child": {
                    marginBottom: "0"
                }
            }
        ]
    },
    "2xl": {
        css: [
            {
                fontSize: $1645b7b9013cc8ac$var$rem(24),
                lineHeight: $1645b7b9013cc8ac$var$round(40 / 24),
                p: {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 24)
                },
                '[class~="lead"]': {
                    fontSize: $1645b7b9013cc8ac$var$em(30, 24),
                    lineHeight: $1645b7b9013cc8ac$var$round(44 / 30),
                    marginTop: $1645b7b9013cc8ac$var$em(32, 30),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 30)
                },
                blockquote: {
                    marginTop: $1645b7b9013cc8ac$var$em(64, 36),
                    marginBottom: $1645b7b9013cc8ac$var$em(64, 36),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(40, 36)
                },
                h1: {
                    fontSize: $1645b7b9013cc8ac$var$em(64, 24),
                    marginTop: "0",
                    marginBottom: $1645b7b9013cc8ac$var$em(56, 64),
                    lineHeight: $1645b7b9013cc8ac$var$round(1)
                },
                h2: {
                    fontSize: $1645b7b9013cc8ac$var$em(48, 24),
                    marginTop: $1645b7b9013cc8ac$var$em(72, 48),
                    marginBottom: $1645b7b9013cc8ac$var$em(40, 48),
                    lineHeight: $1645b7b9013cc8ac$var$round(52 / 48)
                },
                h3: {
                    fontSize: $1645b7b9013cc8ac$var$em(36, 24),
                    marginTop: $1645b7b9013cc8ac$var$em(56, 36),
                    marginBottom: $1645b7b9013cc8ac$var$em(24, 36),
                    lineHeight: $1645b7b9013cc8ac$var$round(44 / 36)
                },
                h4: {
                    marginTop: $1645b7b9013cc8ac$var$em(40, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(16, 24),
                    lineHeight: $1645b7b9013cc8ac$var$round(1.5)
                },
                img: {
                    marginTop: $1645b7b9013cc8ac$var$em(48, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(48, 24)
                },
                picture: {
                    marginTop: $1645b7b9013cc8ac$var$em(48, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(48, 24)
                },
                "picture > img": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                video: {
                    marginTop: $1645b7b9013cc8ac$var$em(48, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(48, 24)
                },
                kbd: {
                    fontSize: $1645b7b9013cc8ac$var$em(20, 24),
                    borderRadius: $1645b7b9013cc8ac$var$rem(6),
                    paddingTop: $1645b7b9013cc8ac$var$em(6, 24),
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(8, 24),
                    paddingBottom: $1645b7b9013cc8ac$var$em(6, 24),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(8, 24)
                },
                code: {
                    fontSize: $1645b7b9013cc8ac$var$em(20, 24)
                },
                "h2 code": {
                    fontSize: $1645b7b9013cc8ac$var$em(42, 48)
                },
                "h3 code": {
                    fontSize: $1645b7b9013cc8ac$var$em(32, 36)
                },
                pre: {
                    fontSize: $1645b7b9013cc8ac$var$em(20, 24),
                    lineHeight: $1645b7b9013cc8ac$var$round(1.8),
                    marginTop: $1645b7b9013cc8ac$var$em(40, 20),
                    marginBottom: $1645b7b9013cc8ac$var$em(40, 20),
                    borderRadius: $1645b7b9013cc8ac$var$rem(8),
                    paddingTop: $1645b7b9013cc8ac$var$em(24, 20),
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(32, 20),
                    paddingBottom: $1645b7b9013cc8ac$var$em(24, 20),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(32, 20)
                },
                ol: {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 24),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(38, 24)
                },
                ul: {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 24),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(38, 24)
                },
                li: {
                    marginTop: $1645b7b9013cc8ac$var$em(12, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(12, 24)
                },
                "ol > li": {
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(10, 24)
                },
                "ul > li": {
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(10, 24)
                },
                "> ul > li p": {
                    marginTop: $1645b7b9013cc8ac$var$em(20, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(20, 24)
                },
                "> ul > li > p:first-child": {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 24)
                },
                "> ul > li > p:last-child": {
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 24)
                },
                "> ol > li > p:first-child": {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 24)
                },
                "> ol > li > p:last-child": {
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 24)
                },
                "ul ul, ul ol, ol ul, ol ol": {
                    marginTop: $1645b7b9013cc8ac$var$em(16, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(16, 24)
                },
                dl: {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 24)
                },
                dt: {
                    marginTop: $1645b7b9013cc8ac$var$em(32, 24)
                },
                dd: {
                    marginTop: $1645b7b9013cc8ac$var$em(12, 24),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(38, 24)
                },
                hr: {
                    marginTop: $1645b7b9013cc8ac$var$em(72, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(72, 24)
                },
                "hr + *": {
                    marginTop: "0"
                },
                "h2 + *": {
                    marginTop: "0"
                },
                "h3 + *": {
                    marginTop: "0"
                },
                "h4 + *": {
                    marginTop: "0"
                },
                table: {
                    fontSize: $1645b7b9013cc8ac$var$em(20, 24),
                    lineHeight: $1645b7b9013cc8ac$var$round(1.4)
                },
                "thead th": {
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(12, 20),
                    paddingBottom: $1645b7b9013cc8ac$var$em(16, 20),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(12, 20)
                },
                "thead th:first-child": {
                    paddingInlineStart: "0"
                },
                "thead th:last-child": {
                    paddingInlineEnd: "0"
                },
                "tbody td, tfoot td": {
                    paddingTop: $1645b7b9013cc8ac$var$em(16, 20),
                    paddingInlineEnd: $1645b7b9013cc8ac$var$em(12, 20),
                    paddingBottom: $1645b7b9013cc8ac$var$em(16, 20),
                    paddingInlineStart: $1645b7b9013cc8ac$var$em(12, 20)
                },
                "tbody td:first-child, tfoot td:first-child": {
                    paddingInlineStart: "0"
                },
                "tbody td:last-child, tfoot td:last-child": {
                    paddingInlineEnd: "0"
                },
                figure: {
                    marginTop: $1645b7b9013cc8ac$var$em(48, 24),
                    marginBottom: $1645b7b9013cc8ac$var$em(48, 24)
                },
                "figure > *": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                figcaption: {
                    fontSize: $1645b7b9013cc8ac$var$em(20, 24),
                    lineHeight: $1645b7b9013cc8ac$var$round(1.6),
                    marginTop: $1645b7b9013cc8ac$var$em(20, 20)
                }
            },
            {
                "> :first-child": {
                    marginTop: "0"
                },
                "> :last-child": {
                    marginBottom: "0"
                }
            }
        ]
    },
    // Gray color themes
    slate: {
        css: {
            "--tw-prose-body": $7qkdK.slate[700],
            "--tw-prose-headings": $7qkdK.slate[900],
            "--tw-prose-lead": $7qkdK.slate[600],
            "--tw-prose-links": $7qkdK.slate[900],
            "--tw-prose-bold": $7qkdK.slate[900],
            "--tw-prose-counters": $7qkdK.slate[500],
            "--tw-prose-bullets": $7qkdK.slate[300],
            "--tw-prose-hr": $7qkdK.slate[200],
            "--tw-prose-quotes": $7qkdK.slate[900],
            "--tw-prose-quote-borders": $7qkdK.slate[200],
            "--tw-prose-captions": $7qkdK.slate[500],
            "--tw-prose-kbd": $7qkdK.slate[900],
            "--tw-prose-kbd-shadows": $1645b7b9013cc8ac$var$hexToRgb($7qkdK.slate[900]),
            "--tw-prose-code": $7qkdK.slate[900],
            "--tw-prose-pre-code": $7qkdK.slate[200],
            "--tw-prose-pre-bg": $7qkdK.slate[800],
            "--tw-prose-th-borders": $7qkdK.slate[300],
            "--tw-prose-td-borders": $7qkdK.slate[200],
            "--tw-prose-invert-body": $7qkdK.slate[300],
            "--tw-prose-invert-headings": $7qkdK.white,
            "--tw-prose-invert-lead": $7qkdK.slate[400],
            "--tw-prose-invert-links": $7qkdK.white,
            "--tw-prose-invert-bold": $7qkdK.white,
            "--tw-prose-invert-counters": $7qkdK.slate[400],
            "--tw-prose-invert-bullets": $7qkdK.slate[600],
            "--tw-prose-invert-hr": $7qkdK.slate[700],
            "--tw-prose-invert-quotes": $7qkdK.slate[100],
            "--tw-prose-invert-quote-borders": $7qkdK.slate[700],
            "--tw-prose-invert-captions": $7qkdK.slate[400],
            "--tw-prose-invert-kbd": $7qkdK.white,
            "--tw-prose-invert-kbd-shadows": $1645b7b9013cc8ac$var$hexToRgb($7qkdK.white),
            "--tw-prose-invert-code": $7qkdK.white,
            "--tw-prose-invert-pre-code": $7qkdK.slate[300],
            "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
            "--tw-prose-invert-th-borders": $7qkdK.slate[600],
            "--tw-prose-invert-td-borders": $7qkdK.slate[700]
        }
    },
    gray: {
        css: {
            "--tw-prose-body": $7qkdK.gray[700],
            "--tw-prose-headings": $7qkdK.gray[900],
            "--tw-prose-lead": $7qkdK.gray[600],
            "--tw-prose-links": $7qkdK.gray[900],
            "--tw-prose-bold": $7qkdK.gray[900],
            "--tw-prose-counters": $7qkdK.gray[500],
            "--tw-prose-bullets": $7qkdK.gray[300],
            "--tw-prose-hr": $7qkdK.gray[200],
            "--tw-prose-quotes": $7qkdK.gray[900],
            "--tw-prose-quote-borders": $7qkdK.gray[200],
            "--tw-prose-captions": $7qkdK.gray[500],
            "--tw-prose-kbd": $7qkdK.gray[900],
            "--tw-prose-kbd-shadows": $1645b7b9013cc8ac$var$hexToRgb($7qkdK.gray[900]),
            "--tw-prose-code": $7qkdK.gray[900],
            "--tw-prose-pre-code": $7qkdK.gray[200],
            "--tw-prose-pre-bg": $7qkdK.gray[800],
            "--tw-prose-th-borders": $7qkdK.gray[300],
            "--tw-prose-td-borders": $7qkdK.gray[200],
            "--tw-prose-invert-body": $7qkdK.gray[300],
            "--tw-prose-invert-headings": $7qkdK.white,
            "--tw-prose-invert-lead": $7qkdK.gray[400],
            "--tw-prose-invert-links": $7qkdK.white,
            "--tw-prose-invert-bold": $7qkdK.white,
            "--tw-prose-invert-counters": $7qkdK.gray[400],
            "--tw-prose-invert-bullets": $7qkdK.gray[600],
            "--tw-prose-invert-hr": $7qkdK.gray[700],
            "--tw-prose-invert-quotes": $7qkdK.gray[100],
            "--tw-prose-invert-quote-borders": $7qkdK.gray[700],
            "--tw-prose-invert-captions": $7qkdK.gray[400],
            "--tw-prose-invert-kbd": $7qkdK.white,
            "--tw-prose-invert-kbd-shadows": $1645b7b9013cc8ac$var$hexToRgb($7qkdK.white),
            "--tw-prose-invert-code": $7qkdK.white,
            "--tw-prose-invert-pre-code": $7qkdK.gray[300],
            "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
            "--tw-prose-invert-th-borders": $7qkdK.gray[600],
            "--tw-prose-invert-td-borders": $7qkdK.gray[700]
        }
    },
    zinc: {
        css: {
            "--tw-prose-body": $7qkdK.zinc[700],
            "--tw-prose-headings": $7qkdK.zinc[900],
            "--tw-prose-lead": $7qkdK.zinc[600],
            "--tw-prose-links": $7qkdK.zinc[900],
            "--tw-prose-bold": $7qkdK.zinc[900],
            "--tw-prose-counters": $7qkdK.zinc[500],
            "--tw-prose-bullets": $7qkdK.zinc[300],
            "--tw-prose-hr": $7qkdK.zinc[200],
            "--tw-prose-quotes": $7qkdK.zinc[900],
            "--tw-prose-quote-borders": $7qkdK.zinc[200],
            "--tw-prose-captions": $7qkdK.zinc[500],
            "--tw-prose-kbd": $7qkdK.zinc[900],
            "--tw-prose-kbd-shadows": $1645b7b9013cc8ac$var$hexToRgb($7qkdK.zinc[900]),
            "--tw-prose-code": $7qkdK.zinc[900],
            "--tw-prose-pre-code": $7qkdK.zinc[200],
            "--tw-prose-pre-bg": $7qkdK.zinc[800],
            "--tw-prose-th-borders": $7qkdK.zinc[300],
            "--tw-prose-td-borders": $7qkdK.zinc[200],
            "--tw-prose-invert-body": $7qkdK.zinc[300],
            "--tw-prose-invert-headings": $7qkdK.white,
            "--tw-prose-invert-lead": $7qkdK.zinc[400],
            "--tw-prose-invert-links": $7qkdK.white,
            "--tw-prose-invert-bold": $7qkdK.white,
            "--tw-prose-invert-counters": $7qkdK.zinc[400],
            "--tw-prose-invert-bullets": $7qkdK.zinc[600],
            "--tw-prose-invert-hr": $7qkdK.zinc[700],
            "--tw-prose-invert-quotes": $7qkdK.zinc[100],
            "--tw-prose-invert-quote-borders": $7qkdK.zinc[700],
            "--tw-prose-invert-captions": $7qkdK.zinc[400],
            "--tw-prose-invert-kbd": $7qkdK.white,
            "--tw-prose-invert-kbd-shadows": $1645b7b9013cc8ac$var$hexToRgb($7qkdK.white),
            "--tw-prose-invert-code": $7qkdK.white,
            "--tw-prose-invert-pre-code": $7qkdK.zinc[300],
            "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
            "--tw-prose-invert-th-borders": $7qkdK.zinc[600],
            "--tw-prose-invert-td-borders": $7qkdK.zinc[700]
        }
    },
    neutral: {
        css: {
            "--tw-prose-body": $7qkdK.neutral[700],
            "--tw-prose-headings": $7qkdK.neutral[900],
            "--tw-prose-lead": $7qkdK.neutral[600],
            "--tw-prose-links": $7qkdK.neutral[900],
            "--tw-prose-bold": $7qkdK.neutral[900],
            "--tw-prose-counters": $7qkdK.neutral[500],
            "--tw-prose-bullets": $7qkdK.neutral[300],
            "--tw-prose-hr": $7qkdK.neutral[200],
            "--tw-prose-quotes": $7qkdK.neutral[900],
            "--tw-prose-quote-borders": $7qkdK.neutral[200],
            "--tw-prose-captions": $7qkdK.neutral[500],
            "--tw-prose-kbd": $7qkdK.neutral[900],
            "--tw-prose-kbd-shadows": $1645b7b9013cc8ac$var$hexToRgb($7qkdK.neutral[900]),
            "--tw-prose-code": $7qkdK.neutral[900],
            "--tw-prose-pre-code": $7qkdK.neutral[200],
            "--tw-prose-pre-bg": $7qkdK.neutral[800],
            "--tw-prose-th-borders": $7qkdK.neutral[300],
            "--tw-prose-td-borders": $7qkdK.neutral[200],
            "--tw-prose-invert-body": $7qkdK.neutral[300],
            "--tw-prose-invert-headings": $7qkdK.white,
            "--tw-prose-invert-lead": $7qkdK.neutral[400],
            "--tw-prose-invert-links": $7qkdK.white,
            "--tw-prose-invert-bold": $7qkdK.white,
            "--tw-prose-invert-counters": $7qkdK.neutral[400],
            "--tw-prose-invert-bullets": $7qkdK.neutral[600],
            "--tw-prose-invert-hr": $7qkdK.neutral[700],
            "--tw-prose-invert-quotes": $7qkdK.neutral[100],
            "--tw-prose-invert-quote-borders": $7qkdK.neutral[700],
            "--tw-prose-invert-captions": $7qkdK.neutral[400],
            "--tw-prose-invert-kbd": $7qkdK.white,
            "--tw-prose-invert-kbd-shadows": $1645b7b9013cc8ac$var$hexToRgb($7qkdK.white),
            "--tw-prose-invert-code": $7qkdK.white,
            "--tw-prose-invert-pre-code": $7qkdK.neutral[300],
            "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
            "--tw-prose-invert-th-borders": $7qkdK.neutral[600],
            "--tw-prose-invert-td-borders": $7qkdK.neutral[700]
        }
    },
    stone: {
        css: {
            "--tw-prose-body": $7qkdK.stone[700],
            "--tw-prose-headings": $7qkdK.stone[900],
            "--tw-prose-lead": $7qkdK.stone[600],
            "--tw-prose-links": $7qkdK.stone[900],
            "--tw-prose-bold": $7qkdK.stone[900],
            "--tw-prose-counters": $7qkdK.stone[500],
            "--tw-prose-bullets": $7qkdK.stone[300],
            "--tw-prose-hr": $7qkdK.stone[200],
            "--tw-prose-quotes": $7qkdK.stone[900],
            "--tw-prose-quote-borders": $7qkdK.stone[200],
            "--tw-prose-captions": $7qkdK.stone[500],
            "--tw-prose-kbd": $7qkdK.stone[900],
            "--tw-prose-kbd-shadows": $1645b7b9013cc8ac$var$hexToRgb($7qkdK.stone[900]),
            "--tw-prose-code": $7qkdK.stone[900],
            "--tw-prose-pre-code": $7qkdK.stone[200],
            "--tw-prose-pre-bg": $7qkdK.stone[800],
            "--tw-prose-th-borders": $7qkdK.stone[300],
            "--tw-prose-td-borders": $7qkdK.stone[200],
            "--tw-prose-invert-body": $7qkdK.stone[300],
            "--tw-prose-invert-headings": $7qkdK.white,
            "--tw-prose-invert-lead": $7qkdK.stone[400],
            "--tw-prose-invert-links": $7qkdK.white,
            "--tw-prose-invert-bold": $7qkdK.white,
            "--tw-prose-invert-counters": $7qkdK.stone[400],
            "--tw-prose-invert-bullets": $7qkdK.stone[600],
            "--tw-prose-invert-hr": $7qkdK.stone[700],
            "--tw-prose-invert-quotes": $7qkdK.stone[100],
            "--tw-prose-invert-quote-borders": $7qkdK.stone[700],
            "--tw-prose-invert-captions": $7qkdK.stone[400],
            "--tw-prose-invert-kbd": $7qkdK.white,
            "--tw-prose-invert-kbd-shadows": $1645b7b9013cc8ac$var$hexToRgb($7qkdK.white),
            "--tw-prose-invert-code": $7qkdK.white,
            "--tw-prose-invert-pre-code": $7qkdK.stone[300],
            "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
            "--tw-prose-invert-th-borders": $7qkdK.stone[600],
            "--tw-prose-invert-td-borders": $7qkdK.stone[700]
        }
    },
    // Link-only themes (for backward compatibility)
    red: {
        css: {
            "--tw-prose-links": $7qkdK.red[600],
            "--tw-prose-invert-links": $7qkdK.red[500]
        }
    },
    orange: {
        css: {
            "--tw-prose-links": $7qkdK.orange[600],
            "--tw-prose-invert-links": $7qkdK.orange[500]
        }
    },
    amber: {
        css: {
            "--tw-prose-links": $7qkdK.amber[600],
            "--tw-prose-invert-links": $7qkdK.amber[500]
        }
    },
    yellow: {
        css: {
            "--tw-prose-links": $7qkdK.yellow[600],
            "--tw-prose-invert-links": $7qkdK.yellow[500]
        }
    },
    lime: {
        css: {
            "--tw-prose-links": $7qkdK.lime[600],
            "--tw-prose-invert-links": $7qkdK.lime[500]
        }
    },
    green: {
        css: {
            "--tw-prose-links": $7qkdK.green[600],
            "--tw-prose-invert-links": $7qkdK.green[500]
        }
    },
    emerald: {
        css: {
            "--tw-prose-links": $7qkdK.emerald[600],
            "--tw-prose-invert-links": $7qkdK.emerald[500]
        }
    },
    teal: {
        css: {
            "--tw-prose-links": $7qkdK.teal[600],
            "--tw-prose-invert-links": $7qkdK.teal[500]
        }
    },
    cyan: {
        css: {
            "--tw-prose-links": $7qkdK.cyan[600],
            "--tw-prose-invert-links": $7qkdK.cyan[500]
        }
    },
    sky: {
        css: {
            "--tw-prose-links": $7qkdK.sky[600],
            "--tw-prose-invert-links": $7qkdK.sky[500]
        }
    },
    blue: {
        css: {
            "--tw-prose-links": $7qkdK.blue[600],
            "--tw-prose-invert-links": $7qkdK.blue[500]
        }
    },
    indigo: {
        css: {
            "--tw-prose-links": $7qkdK.indigo[600],
            "--tw-prose-invert-links": $7qkdK.indigo[500]
        }
    },
    violet: {
        css: {
            "--tw-prose-links": $7qkdK.violet[600],
            "--tw-prose-invert-links": $7qkdK.violet[500]
        }
    },
    purple: {
        css: {
            "--tw-prose-links": $7qkdK.purple[600],
            "--tw-prose-invert-links": $7qkdK.purple[500]
        }
    },
    fuchsia: {
        css: {
            "--tw-prose-links": $7qkdK.fuchsia[600],
            "--tw-prose-invert-links": $7qkdK.fuchsia[500]
        }
    },
    pink: {
        css: {
            "--tw-prose-links": $7qkdK.pink[600],
            "--tw-prose-invert-links": $7qkdK.pink[500]
        }
    },
    rose: {
        css: {
            "--tw-prose-links": $7qkdK.rose[600],
            "--tw-prose-invert-links": $7qkdK.rose[500]
        }
    },
    // Invert (for dark mode)
    invert: {
        css: {
            "--tw-prose-body": "var(--tw-prose-invert-body)",
            "--tw-prose-headings": "var(--tw-prose-invert-headings)",
            "--tw-prose-lead": "var(--tw-prose-invert-lead)",
            "--tw-prose-links": "var(--tw-prose-invert-links)",
            "--tw-prose-bold": "var(--tw-prose-invert-bold)",
            "--tw-prose-counters": "var(--tw-prose-invert-counters)",
            "--tw-prose-bullets": "var(--tw-prose-invert-bullets)",
            "--tw-prose-hr": "var(--tw-prose-invert-hr)",
            "--tw-prose-quotes": "var(--tw-prose-invert-quotes)",
            "--tw-prose-quote-borders": "var(--tw-prose-invert-quote-borders)",
            "--tw-prose-captions": "var(--tw-prose-invert-captions)",
            "--tw-prose-kbd": "var(--tw-prose-invert-kbd)",
            "--tw-prose-kbd-shadows": "var(--tw-prose-invert-kbd-shadows)",
            "--tw-prose-code": "var(--tw-prose-invert-code)",
            "--tw-prose-pre-code": "var(--tw-prose-invert-pre-code)",
            "--tw-prose-pre-bg": "var(--tw-prose-invert-pre-bg)",
            "--tw-prose-th-borders": "var(--tw-prose-invert-th-borders)",
            "--tw-prose-td-borders": "var(--tw-prose-invert-td-borders)"
        }
    }
};
module.exports = {
    DEFAULT: {
        css: [
            {
                color: "var(--tw-prose-body)",
                maxWidth: "65ch",
                p: {},
                '[class~="lead"]': {
                    color: "var(--tw-prose-lead)"
                },
                a: {
                    color: "var(--tw-prose-links)",
                    textDecoration: "underline",
                    fontWeight: "500"
                },
                strong: {
                    color: "var(--tw-prose-bold)",
                    fontWeight: "600"
                },
                "a strong": {
                    color: "inherit"
                },
                "blockquote strong": {
                    color: "inherit"
                },
                "thead th strong": {
                    color: "inherit"
                },
                ol: {
                    listStyleType: "decimal"
                },
                'ol[type="A"]': {
                    listStyleType: "upper-alpha"
                },
                'ol[type="a"]': {
                    listStyleType: "lower-alpha"
                },
                'ol[type="A" s]': {
                    listStyleType: "upper-alpha"
                },
                'ol[type="a" s]': {
                    listStyleType: "lower-alpha"
                },
                'ol[type="I"]': {
                    listStyleType: "upper-roman"
                },
                'ol[type="i"]': {
                    listStyleType: "lower-roman"
                },
                'ol[type="I" s]': {
                    listStyleType: "upper-roman"
                },
                'ol[type="i" s]': {
                    listStyleType: "lower-roman"
                },
                'ol[type="1"]': {
                    listStyleType: "decimal"
                },
                ul: {
                    listStyleType: "disc"
                },
                "ol > li::marker": {
                    fontWeight: "400",
                    color: "var(--tw-prose-counters)"
                },
                "ul > li::marker": {
                    color: "var(--tw-prose-bullets)"
                },
                dt: {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "600"
                },
                hr: {
                    borderColor: "var(--tw-prose-hr)",
                    borderTopWidth: 1
                },
                blockquote: {
                    fontWeight: "500",
                    fontStyle: "italic",
                    color: "var(--tw-prose-quotes)",
                    borderInlineStartWidth: "0.25rem",
                    borderInlineStartColor: "var(--tw-prose-quote-borders)",
                    quotes: '"\\201C""\\201D""\\2018""\\2019"'
                },
                "blockquote p:first-of-type::before": {
                    content: "open-quote"
                },
                "blockquote p:last-of-type::after": {
                    content: "close-quote"
                },
                h1: {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "800"
                },
                "h1 strong": {
                    fontWeight: "900",
                    color: "inherit"
                },
                h2: {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "700"
                },
                "h2 strong": {
                    fontWeight: "800",
                    color: "inherit"
                },
                h3: {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "600"
                },
                "h3 strong": {
                    fontWeight: "700",
                    color: "inherit"
                },
                h4: {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "600"
                },
                "h4 strong": {
                    fontWeight: "700",
                    color: "inherit"
                },
                img: {},
                picture: {
                    display: "block"
                },
                video: {},
                kbd: {
                    fontWeight: "500",
                    fontFamily: "inherit",
                    color: "var(--tw-prose-kbd)",
                    boxShadow: "0 0 0 1px rgb(var(--tw-prose-kbd-shadows) / 10%), 0 3px 0 rgb(var(--tw-prose-kbd-shadows) / 10%)"
                },
                code: {
                    color: "var(--tw-prose-code)",
                    fontWeight: "600"
                },
                "code::before": {
                    content: '"`"'
                },
                "code::after": {
                    content: '"`"'
                },
                "a code": {
                    color: "inherit"
                },
                "h1 code": {
                    color: "inherit"
                },
                "h2 code": {
                    color: "inherit"
                },
                "h3 code": {
                    color: "inherit"
                },
                "h4 code": {
                    color: "inherit"
                },
                "blockquote code": {
                    color: "inherit"
                },
                "thead th code": {
                    color: "inherit"
                },
                pre: {
                    color: "var(--tw-prose-pre-code)",
                    backgroundColor: "var(--tw-prose-pre-bg)",
                    overflowX: "auto",
                    fontWeight: "400"
                },
                "pre code": {
                    backgroundColor: "transparent",
                    borderWidth: "0",
                    borderRadius: "0",
                    padding: "0",
                    fontWeight: "inherit",
                    color: "inherit",
                    fontSize: "inherit",
                    fontFamily: "inherit",
                    lineHeight: "inherit"
                },
                "pre code::before": {
                    content: "none"
                },
                "pre code::after": {
                    content: "none"
                },
                table: {
                    width: "100%",
                    tableLayout: "auto",
                    marginTop: $1645b7b9013cc8ac$var$em(32, 16),
                    marginBottom: $1645b7b9013cc8ac$var$em(32, 16)
                },
                thead: {
                    borderBottomWidth: "1px",
                    borderBottomColor: "var(--tw-prose-th-borders)"
                },
                "thead th": {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "600",
                    verticalAlign: "bottom"
                },
                "tbody tr": {
                    borderBottomWidth: "1px",
                    borderBottomColor: "var(--tw-prose-td-borders)"
                },
                "tbody tr:last-child": {
                    borderBottomWidth: "0"
                },
                "tbody td": {
                    verticalAlign: "baseline"
                },
                tfoot: {
                    borderTopWidth: "1px",
                    borderTopColor: "var(--tw-prose-th-borders)"
                },
                "tfoot td": {
                    verticalAlign: "top"
                },
                "th, td": {
                    textAlign: "start"
                },
                "figure > *": {},
                figcaption: {
                    color: "var(--tw-prose-captions)"
                }
            },
            $1645b7b9013cc8ac$var$defaultModifiers.gray.css,
            ...$1645b7b9013cc8ac$var$defaultModifiers.base.css
        ]
    },
    ...$1645b7b9013cc8ac$var$defaultModifiers
};

});
parcelRegister("7qkdK", function(module, exports) {

var $iFKdC = parcelRequire("iFKdC");
module.exports = ($iFKdC.__esModule ? $iFKdC : {
    default: $iFKdC
}).default;

});
parcelRegister("iFKdC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d97fe86712eb0072$var$_default;
    }
});

const $d97fe86712eb0072$var$_log = /*#__PURE__*/ $d97fe86712eb0072$var$_interop_require_default((parcelRequire("7uaNc")));
function $d97fe86712eb0072$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d97fe86712eb0072$var$warn({ version: version, from: from, to: to }) {
    $d97fe86712eb0072$var$_log.default.warn(`${from}-color-renamed`, [
        `As of Tailwind CSS ${version}, \`${from}\` has been renamed to \`${to}\`.`,
        "Update your configuration file to silence this warning."
    ]);
}
const $d97fe86712eb0072$var$_default = {
    inherit: "inherit",
    current: "currentColor",
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    slate: {
        50: "#f8fafc",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b",
        600: "#475569",
        700: "#334155",
        800: "#1e293b",
        900: "#0f172a",
        950: "#020617"
    },
    gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827",
        950: "#030712"
    },
    zinc: {
        50: "#fafafa",
        100: "#f4f4f5",
        200: "#e4e4e7",
        300: "#d4d4d8",
        400: "#a1a1aa",
        500: "#71717a",
        600: "#52525b",
        700: "#3f3f46",
        800: "#27272a",
        900: "#18181b",
        950: "#09090b"
    },
    neutral: {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#e5e5e5",
        300: "#d4d4d4",
        400: "#a3a3a3",
        500: "#737373",
        600: "#525252",
        700: "#404040",
        800: "#262626",
        900: "#171717",
        950: "#0a0a0a"
    },
    stone: {
        50: "#fafaf9",
        100: "#f5f5f4",
        200: "#e7e5e4",
        300: "#d6d3d1",
        400: "#a8a29e",
        500: "#78716c",
        600: "#57534e",
        700: "#44403c",
        800: "#292524",
        900: "#1c1917",
        950: "#0c0a09"
    },
    red: {
        50: "#fef2f2",
        100: "#fee2e2",
        200: "#fecaca",
        300: "#fca5a5",
        400: "#f87171",
        500: "#ef4444",
        600: "#dc2626",
        700: "#b91c1c",
        800: "#991b1b",
        900: "#7f1d1d",
        950: "#450a0a"
    },
    orange: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#fed7aa",
        300: "#fdba74",
        400: "#fb923c",
        500: "#f97316",
        600: "#ea580c",
        700: "#c2410c",
        800: "#9a3412",
        900: "#7c2d12",
        950: "#431407"
    },
    amber: {
        50: "#fffbeb",
        100: "#fef3c7",
        200: "#fde68a",
        300: "#fcd34d",
        400: "#fbbf24",
        500: "#f59e0b",
        600: "#d97706",
        700: "#b45309",
        800: "#92400e",
        900: "#78350f",
        950: "#451a03"
    },
    yellow: {
        50: "#fefce8",
        100: "#fef9c3",
        200: "#fef08a",
        300: "#fde047",
        400: "#facc15",
        500: "#eab308",
        600: "#ca8a04",
        700: "#a16207",
        800: "#854d0e",
        900: "#713f12",
        950: "#422006"
    },
    lime: {
        50: "#f7fee7",
        100: "#ecfccb",
        200: "#d9f99d",
        300: "#bef264",
        400: "#a3e635",
        500: "#84cc16",
        600: "#65a30d",
        700: "#4d7c0f",
        800: "#3f6212",
        900: "#365314",
        950: "#1a2e05"
    },
    green: {
        50: "#f0fdf4",
        100: "#dcfce7",
        200: "#bbf7d0",
        300: "#86efac",
        400: "#4ade80",
        500: "#22c55e",
        600: "#16a34a",
        700: "#15803d",
        800: "#166534",
        900: "#14532d",
        950: "#052e16"
    },
    emerald: {
        50: "#ecfdf5",
        100: "#d1fae5",
        200: "#a7f3d0",
        300: "#6ee7b7",
        400: "#34d399",
        500: "#10b981",
        600: "#059669",
        700: "#047857",
        800: "#065f46",
        900: "#064e3b",
        950: "#022c22"
    },
    teal: {
        50: "#f0fdfa",
        100: "#ccfbf1",
        200: "#99f6e4",
        300: "#5eead4",
        400: "#2dd4bf",
        500: "#14b8a6",
        600: "#0d9488",
        700: "#0f766e",
        800: "#115e59",
        900: "#134e4a",
        950: "#042f2e"
    },
    cyan: {
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4",
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63",
        950: "#083344"
    },
    sky: {
        50: "#f0f9ff",
        100: "#e0f2fe",
        200: "#bae6fd",
        300: "#7dd3fc",
        400: "#38bdf8",
        500: "#0ea5e9",
        600: "#0284c7",
        700: "#0369a1",
        800: "#075985",
        900: "#0c4a6e",
        950: "#082f49"
    },
    blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
        950: "#172554"
    },
    indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81",
        950: "#1e1b4b"
    },
    violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6fe",
        300: "#c4b5fd",
        400: "#a78bfa",
        500: "#8b5cf6",
        600: "#7c3aed",
        700: "#6d28d9",
        800: "#5b21b6",
        900: "#4c1d95",
        950: "#2e1065"
    },
    purple: {
        50: "#faf5ff",
        100: "#f3e8ff",
        200: "#e9d5ff",
        300: "#d8b4fe",
        400: "#c084fc",
        500: "#a855f7",
        600: "#9333ea",
        700: "#7e22ce",
        800: "#6b21a8",
        900: "#581c87",
        950: "#3b0764"
    },
    fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f5d0fe",
        300: "#f0abfc",
        400: "#e879f9",
        500: "#d946ef",
        600: "#c026d3",
        700: "#a21caf",
        800: "#86198f",
        900: "#701a75",
        950: "#4a044e"
    },
    pink: {
        50: "#fdf2f8",
        100: "#fce7f3",
        200: "#fbcfe8",
        300: "#f9a8d4",
        400: "#f472b6",
        500: "#ec4899",
        600: "#db2777",
        700: "#be185d",
        800: "#9d174d",
        900: "#831843",
        950: "#500724"
    },
    rose: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337",
        950: "#4c0519"
    },
    get lightBlue () {
        $d97fe86712eb0072$var$warn({
            version: "v2.2",
            from: "lightBlue",
            to: "sky"
        });
        return this.sky;
    },
    get warmGray () {
        $d97fe86712eb0072$var$warn({
            version: "v3.0",
            from: "warmGray",
            to: "stone"
        });
        return this.stone;
    },
    get trueGray () {
        $d97fe86712eb0072$var$warn({
            version: "v3.0",
            from: "trueGray",
            to: "neutral"
        });
        return this.neutral;
    },
    get coolGray () {
        $d97fe86712eb0072$var$warn({
            version: "v3.0",
            from: "coolGray",
            to: "gray"
        });
        return this.gray;
    },
    get blueGray () {
        $d97fe86712eb0072$var$warn({
            version: "v3.0",
            from: "blueGray",
            to: "slate"
        });
        return this.slate;
    }
};

});
parcelRegister("7uaNc", function(module, exports) {

var $cmlvI = parcelRequire("cmlvI");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $5733b4ea1539dc3a$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$5733b4ea1539dc3a$var$_export(module.exports, {
    dim: function() {
        return $5733b4ea1539dc3a$var$dim;
    },
    default: function() {
        return $5733b4ea1539dc3a$var$_default;
    }
});

const $5733b4ea1539dc3a$var$_picocolors = /*#__PURE__*/ $5733b4ea1539dc3a$var$_interop_require_default((parcelRequire("43SCK")));
function $5733b4ea1539dc3a$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let $5733b4ea1539dc3a$var$alreadyShown = new Set();
function $5733b4ea1539dc3a$var$log(type, messages, key) {
    typeof $cmlvI !== "undefined" && undefined;
    if (key && $5733b4ea1539dc3a$var$alreadyShown.has(key)) return;
    if (key) $5733b4ea1539dc3a$var$alreadyShown.add(key);
    console.warn("");
    messages.forEach((message)=>console.warn(type, "-", message));
}
function $5733b4ea1539dc3a$var$dim(input) {
    return $5733b4ea1539dc3a$var$_picocolors.default.dim(input);
}
const $5733b4ea1539dc3a$var$_default = {
    info (key, messages) {
        $5733b4ea1539dc3a$var$log($5733b4ea1539dc3a$var$_picocolors.default.bold($5733b4ea1539dc3a$var$_picocolors.default.cyan("info")), ...Array.isArray(key) ? [
            key
        ] : [
            messages,
            key
        ]);
    },
    warn (key, messages) {
        $5733b4ea1539dc3a$var$log($5733b4ea1539dc3a$var$_picocolors.default.bold($5733b4ea1539dc3a$var$_picocolors.default.yellow("warn")), ...Array.isArray(key) ? [
            key
        ] : [
            messages,
            key
        ]);
    },
    risk (key, messages) {
        $5733b4ea1539dc3a$var$log($5733b4ea1539dc3a$var$_picocolors.default.bold($5733b4ea1539dc3a$var$_picocolors.default.magenta("risk")), ...Array.isArray(key) ? [
            key
        ] : [
            messages,
            key
        ]);
    }
};

});
parcelRegister("cmlvI", function(module, exports) {
// shim for using process in browser
var $8ff839a7d0ad494d$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $8ff839a7d0ad494d$var$cachedSetTimeout;
var $8ff839a7d0ad494d$var$cachedClearTimeout;
function $8ff839a7d0ad494d$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $8ff839a7d0ad494d$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $8ff839a7d0ad494d$var$cachedSetTimeout = setTimeout;
        else $8ff839a7d0ad494d$var$cachedSetTimeout = $8ff839a7d0ad494d$var$defaultSetTimout;
    } catch (e) {
        $8ff839a7d0ad494d$var$cachedSetTimeout = $8ff839a7d0ad494d$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $8ff839a7d0ad494d$var$cachedClearTimeout = clearTimeout;
        else $8ff839a7d0ad494d$var$cachedClearTimeout = $8ff839a7d0ad494d$var$defaultClearTimeout;
    } catch (e) {
        $8ff839a7d0ad494d$var$cachedClearTimeout = $8ff839a7d0ad494d$var$defaultClearTimeout;
    }
})();
function $8ff839a7d0ad494d$var$runTimeout(fun) {
    if ($8ff839a7d0ad494d$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($8ff839a7d0ad494d$var$cachedSetTimeout === $8ff839a7d0ad494d$var$defaultSetTimout || !$8ff839a7d0ad494d$var$cachedSetTimeout) && setTimeout) {
        $8ff839a7d0ad494d$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8ff839a7d0ad494d$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $8ff839a7d0ad494d$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $8ff839a7d0ad494d$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $8ff839a7d0ad494d$var$runClearTimeout(marker) {
    if ($8ff839a7d0ad494d$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($8ff839a7d0ad494d$var$cachedClearTimeout === $8ff839a7d0ad494d$var$defaultClearTimeout || !$8ff839a7d0ad494d$var$cachedClearTimeout) && clearTimeout) {
        $8ff839a7d0ad494d$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8ff839a7d0ad494d$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $8ff839a7d0ad494d$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $8ff839a7d0ad494d$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $8ff839a7d0ad494d$var$queue = [];
var $8ff839a7d0ad494d$var$draining = false;
var $8ff839a7d0ad494d$var$currentQueue;
var $8ff839a7d0ad494d$var$queueIndex = -1;
function $8ff839a7d0ad494d$var$cleanUpNextTick() {
    if (!$8ff839a7d0ad494d$var$draining || !$8ff839a7d0ad494d$var$currentQueue) return;
    $8ff839a7d0ad494d$var$draining = false;
    if ($8ff839a7d0ad494d$var$currentQueue.length) $8ff839a7d0ad494d$var$queue = $8ff839a7d0ad494d$var$currentQueue.concat($8ff839a7d0ad494d$var$queue);
    else $8ff839a7d0ad494d$var$queueIndex = -1;
    if ($8ff839a7d0ad494d$var$queue.length) $8ff839a7d0ad494d$var$drainQueue();
}
function $8ff839a7d0ad494d$var$drainQueue() {
    if ($8ff839a7d0ad494d$var$draining) return;
    var timeout = $8ff839a7d0ad494d$var$runTimeout($8ff839a7d0ad494d$var$cleanUpNextTick);
    $8ff839a7d0ad494d$var$draining = true;
    var len = $8ff839a7d0ad494d$var$queue.length;
    while(len){
        $8ff839a7d0ad494d$var$currentQueue = $8ff839a7d0ad494d$var$queue;
        $8ff839a7d0ad494d$var$queue = [];
        while(++$8ff839a7d0ad494d$var$queueIndex < len)if ($8ff839a7d0ad494d$var$currentQueue) $8ff839a7d0ad494d$var$currentQueue[$8ff839a7d0ad494d$var$queueIndex].run();
        $8ff839a7d0ad494d$var$queueIndex = -1;
        len = $8ff839a7d0ad494d$var$queue.length;
    }
    $8ff839a7d0ad494d$var$currentQueue = null;
    $8ff839a7d0ad494d$var$draining = false;
    $8ff839a7d0ad494d$var$runClearTimeout(timeout);
}
$8ff839a7d0ad494d$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $8ff839a7d0ad494d$var$queue.push(new $8ff839a7d0ad494d$var$Item(fun, args));
    if ($8ff839a7d0ad494d$var$queue.length === 1 && !$8ff839a7d0ad494d$var$draining) $8ff839a7d0ad494d$var$runTimeout($8ff839a7d0ad494d$var$drainQueue);
};
// v8 likes predictible objects
function $8ff839a7d0ad494d$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$8ff839a7d0ad494d$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$8ff839a7d0ad494d$var$process.title = "browser";
$8ff839a7d0ad494d$var$process.browser = true;
$8ff839a7d0ad494d$var$process.env = {};
$8ff839a7d0ad494d$var$process.argv = [];
$8ff839a7d0ad494d$var$process.version = ""; // empty string to avoid regexp issues
$8ff839a7d0ad494d$var$process.versions = {};
function $8ff839a7d0ad494d$var$noop() {}
$8ff839a7d0ad494d$var$process.on = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.addListener = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.once = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.off = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.removeListener = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.removeAllListeners = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.emit = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.prependListener = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.prependOnceListener = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.listeners = function(name) {
    return [];
};
$8ff839a7d0ad494d$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$8ff839a7d0ad494d$var$process.cwd = function() {
    return "/";
};
$8ff839a7d0ad494d$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$8ff839a7d0ad494d$var$process.umask = function() {
    return 0;
};

});

parcelRegister("43SCK", function(module, exports) {
var $2f51d06b3cd69ceb$var$x = String;
var $2f51d06b3cd69ceb$var$create = function() {
    return {
        isColorSupported: false,
        reset: $2f51d06b3cd69ceb$var$x,
        bold: $2f51d06b3cd69ceb$var$x,
        dim: $2f51d06b3cd69ceb$var$x,
        italic: $2f51d06b3cd69ceb$var$x,
        underline: $2f51d06b3cd69ceb$var$x,
        inverse: $2f51d06b3cd69ceb$var$x,
        hidden: $2f51d06b3cd69ceb$var$x,
        strikethrough: $2f51d06b3cd69ceb$var$x,
        black: $2f51d06b3cd69ceb$var$x,
        red: $2f51d06b3cd69ceb$var$x,
        green: $2f51d06b3cd69ceb$var$x,
        yellow: $2f51d06b3cd69ceb$var$x,
        blue: $2f51d06b3cd69ceb$var$x,
        magenta: $2f51d06b3cd69ceb$var$x,
        cyan: $2f51d06b3cd69ceb$var$x,
        white: $2f51d06b3cd69ceb$var$x,
        gray: $2f51d06b3cd69ceb$var$x,
        bgBlack: $2f51d06b3cd69ceb$var$x,
        bgRed: $2f51d06b3cd69ceb$var$x,
        bgGreen: $2f51d06b3cd69ceb$var$x,
        bgYellow: $2f51d06b3cd69ceb$var$x,
        bgBlue: $2f51d06b3cd69ceb$var$x,
        bgMagenta: $2f51d06b3cd69ceb$var$x,
        bgCyan: $2f51d06b3cd69ceb$var$x,
        bgWhite: $2f51d06b3cd69ceb$var$x,
        blackBright: $2f51d06b3cd69ceb$var$x,
        redBright: $2f51d06b3cd69ceb$var$x,
        greenBright: $2f51d06b3cd69ceb$var$x,
        yellowBright: $2f51d06b3cd69ceb$var$x,
        blueBright: $2f51d06b3cd69ceb$var$x,
        magentaBright: $2f51d06b3cd69ceb$var$x,
        cyanBright: $2f51d06b3cd69ceb$var$x,
        whiteBright: $2f51d06b3cd69ceb$var$x,
        bgBlackBright: $2f51d06b3cd69ceb$var$x,
        bgRedBright: $2f51d06b3cd69ceb$var$x,
        bgGreenBright: $2f51d06b3cd69ceb$var$x,
        bgYellowBright: $2f51d06b3cd69ceb$var$x,
        bgBlueBright: $2f51d06b3cd69ceb$var$x,
        bgMagentaBright: $2f51d06b3cd69ceb$var$x,
        bgCyanBright: $2f51d06b3cd69ceb$var$x,
        bgWhiteBright: $2f51d06b3cd69ceb$var$x
    };
};
module.exports = $2f51d06b3cd69ceb$var$create();
module.exports.createColors = $2f51d06b3cd69ceb$var$create;

});





parcelRegister("dfJwk", function(module, exports) {

var $4r5Bz = parcelRequire("4r5Bz");

var $6ddxR = parcelRequire("6ddxR");
const $9a5ffc79a825228c$var$parseSelector = $6ddxR();
module.exports = {
    isUsableColor (color, values) {
        return $4r5Bz(values) && color !== "gray" && values[600];
    },
    /**
   * @param {string} selector
   */ commonTrailingPseudos (selector) {
        let ast = $9a5ffc79a825228c$var$parseSelector.astSync(selector);
        /** @type {import('postcss-selector-parser').Pseudo[][]} */ let matrix = [];
        // Put the pseudo elements in reverse order in a sparse, column-major 2D array
        for (let [i, sel] of ast.nodes.entries())for (const [j, child] of [
            ...sel.nodes
        ].reverse().entries()){
            // We only care about pseudo elements
            if (child.type !== "pseudo" || !child.value.startsWith("::")) break;
            matrix[j] = matrix[j] || [];
            matrix[j][i] = child;
        }
        let trailingPseudos = $6ddxR.selector();
        // At this point the pseudo elements are in a column-major 2D array
        // This means each row contains one "column" of pseudo elements from each selector
        // We can compare all the pseudo elements in a row to see if they are the same
        for (const pseudos of matrix){
            // It's a sparse 2D array so there are going to be holes in the rows
            // We skip those
            if (!pseudos) continue;
            let values = new Set([
                ...pseudos.map((p)=>p.value)
            ]);
            // The pseudo elements are not the same
            if (values.size > 1) break;
            pseudos.forEach((pseudo)=>pseudo.remove());
            trailingPseudos.prepend(pseudos[0]);
        }
        if (trailingPseudos.nodes.length) return [
            trailingPseudos.toString(),
            ast.toString()
        ];
        return [
            null,
            selector
        ];
    }
};

});
parcelRegister("4r5Bz", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $33ae08106ebc79de$var$objectTag = "[object Object]";
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $33ae08106ebc79de$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $33ae08106ebc79de$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $33ae08106ebc79de$var$funcProto = Function.prototype, $33ae08106ebc79de$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $33ae08106ebc79de$var$funcToString = $33ae08106ebc79de$var$funcProto.toString;
/** Used to check objects for own properties. */ var $33ae08106ebc79de$var$hasOwnProperty = $33ae08106ebc79de$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $33ae08106ebc79de$var$objectCtorString = $33ae08106ebc79de$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $33ae08106ebc79de$var$objectToString = $33ae08106ebc79de$var$objectProto.toString;
/** Built-in value references. */ var $33ae08106ebc79de$var$getPrototype = $33ae08106ebc79de$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $33ae08106ebc79de$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $33ae08106ebc79de$var$isPlainObject(value) {
    if (!$33ae08106ebc79de$var$isObjectLike(value) || $33ae08106ebc79de$var$objectToString.call(value) != $33ae08106ebc79de$var$objectTag || $33ae08106ebc79de$var$isHostObject(value)) return false;
    var proto = $33ae08106ebc79de$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $33ae08106ebc79de$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $33ae08106ebc79de$var$funcToString.call(Ctor) == $33ae08106ebc79de$var$objectCtorString;
}
module.exports = $33ae08106ebc79de$var$isPlainObject;

});

parcelRegister("6ddxR", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $485e76c3433709af$var$_processor = $485e76c3433709af$var$_interopRequireDefault((parcelRequire("ffSjo")));

var $485e76c3433709af$var$selectors = $485e76c3433709af$var$_interopRequireWildcard((parcelRequire("233S9")));
function $485e76c3433709af$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $485e76c3433709af$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $485e76c3433709af$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $485e76c3433709af$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $485e76c3433709af$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $485e76c3433709af$var$parser = function parser(processor) {
    return new $485e76c3433709af$var$_processor["default"](processor);
};
Object.assign($485e76c3433709af$var$parser, $485e76c3433709af$var$selectors);
delete $485e76c3433709af$var$parser.__esModule;
var $485e76c3433709af$var$_default = $485e76c3433709af$var$parser;
module.exports["default"] = $485e76c3433709af$var$_default;
module.exports = module.exports.default;

});
parcelRegister("ffSjo", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $b1b262eccf18c0a6$var$_parser = $b1b262eccf18c0a6$var$_interopRequireDefault((parcelRequire("17x7y")));
function $b1b262eccf18c0a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $b1b262eccf18c0a6$var$Processor = /*#__PURE__*/ function() {
    function Processor(func, options) {
        this.func = func || function noop() {};
        this.funcRes = null;
        this.options = options;
    }
    var _proto = Processor.prototype;
    _proto._shouldUpdateSelector = function _shouldUpdateSelector(rule, options) {
        if (options === void 0) options = {};
        var merged = Object.assign({}, this.options, options);
        if (merged.updateSelector === false) return false;
        else return typeof rule !== "string";
    };
    _proto._isLossy = function _isLossy(options) {
        if (options === void 0) options = {};
        var merged = Object.assign({}, this.options, options);
        if (merged.lossless === false) return true;
        else return false;
    };
    _proto._root = function _root(rule, options) {
        if (options === void 0) options = {};
        var parser = new $b1b262eccf18c0a6$var$_parser["default"](rule, this._parseOptions(options));
        return parser.root;
    };
    _proto._parseOptions = function _parseOptions(options) {
        return {
            lossy: this._isLossy(options)
        };
    };
    _proto._run = function _run(rule, options) {
        var _this = this;
        if (options === void 0) options = {};
        return new Promise(function(resolve, reject) {
            try {
                var root = _this._root(rule, options);
                Promise.resolve(_this.func(root)).then(function(transform) {
                    var string = undefined;
                    if (_this._shouldUpdateSelector(rule, options)) {
                        string = root.toString();
                        rule.selector = string;
                    }
                    return {
                        transform: transform,
                        root: root,
                        string: string
                    };
                }).then(resolve, reject);
            } catch (e) {
                reject(e);
                return;
            }
        });
    };
    _proto._runSync = function _runSync(rule, options) {
        if (options === void 0) options = {};
        var root = this._root(rule, options);
        var transform = this.func(root);
        if (transform && typeof transform.then === "function") throw new Error("Selector processor returned a promise to a synchronous call.");
        var string = undefined;
        if (options.updateSelector && typeof rule !== "string") {
            string = root.toString();
            rule.selector = string;
        }
        return {
            transform: transform,
            root: root,
            string: string
        };
    } /**
   * Process rule into a selector AST.
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {Promise<parser.Root>} The AST of the selector after processing it.
   */ ;
    _proto.ast = function ast(rule, options) {
        return this._run(rule, options).then(function(result) {
            return result.root;
        });
    } /**
   * Process rule into a selector AST synchronously.
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {parser.Root} The AST of the selector after processing it.
   */ ;
    _proto.astSync = function astSync(rule, options) {
        return this._runSync(rule, options).root;
    } /**
   * Process a selector into a transformed value asynchronously
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {Promise<any>} The value returned by the processor.
   */ ;
    _proto.transform = function transform(rule, options) {
        return this._run(rule, options).then(function(result) {
            return result.transform;
        });
    } /**
   * Process a selector into a transformed value synchronously.
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {any} The value returned by the processor.
   */ ;
    _proto.transformSync = function transformSync(rule, options) {
        return this._runSync(rule, options).transform;
    } /**
   * Process a selector into a new selector string asynchronously.
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {string} the selector after processing.
   */ ;
    _proto.process = function process(rule, options) {
        return this._run(rule, options).then(function(result) {
            return result.string || result.root.toString();
        });
    } /**
   * Process a selector into a new selector string synchronously.
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {string} the selector after processing.
   */ ;
    _proto.processSync = function processSync(rule, options) {
        var result = this._runSync(rule, options);
        return result.string || result.root.toString();
    };
    return Processor;
}();
module.exports["default"] = $b1b262eccf18c0a6$var$Processor;
module.exports = module.exports.default;

});
parcelRegister("17x7y", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $0d1022fdfdaea520$var$_root = $0d1022fdfdaea520$var$_interopRequireDefault((parcelRequire("kd4c2")));

var $0d1022fdfdaea520$var$_selector = $0d1022fdfdaea520$var$_interopRequireDefault((parcelRequire("9bR8u")));

var $0d1022fdfdaea520$var$_className = $0d1022fdfdaea520$var$_interopRequireDefault((parcelRequire("9Wgfr")));

var $0d1022fdfdaea520$var$_comment = $0d1022fdfdaea520$var$_interopRequireDefault((parcelRequire("fZuGj")));

var $0d1022fdfdaea520$var$_id = $0d1022fdfdaea520$var$_interopRequireDefault((parcelRequire("6ue9S")));

var $0d1022fdfdaea520$var$_tag = $0d1022fdfdaea520$var$_interopRequireDefault((parcelRequire("1S2V3")));

var $0d1022fdfdaea520$var$_string = $0d1022fdfdaea520$var$_interopRequireDefault((parcelRequire("9Isdm")));

var $0d1022fdfdaea520$var$_pseudo = $0d1022fdfdaea520$var$_interopRequireDefault((parcelRequire("gNv3v")));

var $0d1022fdfdaea520$var$_attribute = $0d1022fdfdaea520$var$_interopRequireWildcard((parcelRequire("eQ84Q")));

var $0d1022fdfdaea520$var$_universal = $0d1022fdfdaea520$var$_interopRequireDefault((parcelRequire("bHUDw")));

var $0d1022fdfdaea520$var$_combinator = $0d1022fdfdaea520$var$_interopRequireDefault((parcelRequire("18Vp1")));

var $0d1022fdfdaea520$var$_nesting = $0d1022fdfdaea520$var$_interopRequireDefault((parcelRequire("6lFrk")));

var $0d1022fdfdaea520$var$_sortAscending = $0d1022fdfdaea520$var$_interopRequireDefault((parcelRequire("5j5kG")));

var $0d1022fdfdaea520$var$_tokenize = $0d1022fdfdaea520$var$_interopRequireWildcard((parcelRequire("73CIw")));

var $0d1022fdfdaea520$var$tokens = $0d1022fdfdaea520$var$_interopRequireWildcard((parcelRequire("enfcP")));

var $0d1022fdfdaea520$var$types = $0d1022fdfdaea520$var$_interopRequireWildcard((parcelRequire("8pBKt")));

var $1CKTu = parcelRequire("1CKTu");
var $0d1022fdfdaea520$var$_WHITESPACE_TOKENS, $0d1022fdfdaea520$var$_Object$assign;
function $0d1022fdfdaea520$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $0d1022fdfdaea520$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $0d1022fdfdaea520$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $0d1022fdfdaea520$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $0d1022fdfdaea520$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $0d1022fdfdaea520$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0d1022fdfdaea520$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0d1022fdfdaea520$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0d1022fdfdaea520$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $0d1022fdfdaea520$var$WHITESPACE_TOKENS = ($0d1022fdfdaea520$var$_WHITESPACE_TOKENS = {}, $0d1022fdfdaea520$var$_WHITESPACE_TOKENS[$0d1022fdfdaea520$var$tokens.space] = true, $0d1022fdfdaea520$var$_WHITESPACE_TOKENS[$0d1022fdfdaea520$var$tokens.cr] = true, $0d1022fdfdaea520$var$_WHITESPACE_TOKENS[$0d1022fdfdaea520$var$tokens.feed] = true, $0d1022fdfdaea520$var$_WHITESPACE_TOKENS[$0d1022fdfdaea520$var$tokens.newline] = true, $0d1022fdfdaea520$var$_WHITESPACE_TOKENS[$0d1022fdfdaea520$var$tokens.tab] = true, $0d1022fdfdaea520$var$_WHITESPACE_TOKENS);
var $0d1022fdfdaea520$var$WHITESPACE_EQUIV_TOKENS = Object.assign({}, $0d1022fdfdaea520$var$WHITESPACE_TOKENS, ($0d1022fdfdaea520$var$_Object$assign = {}, $0d1022fdfdaea520$var$_Object$assign[$0d1022fdfdaea520$var$tokens.comment] = true, $0d1022fdfdaea520$var$_Object$assign));
function $0d1022fdfdaea520$var$tokenStart(token) {
    return {
        line: token[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_LINE],
        column: token[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_COL]
    };
}
function $0d1022fdfdaea520$var$tokenEnd(token) {
    return {
        line: token[$0d1022fdfdaea520$var$_tokenize.FIELDS.END_LINE],
        column: token[$0d1022fdfdaea520$var$_tokenize.FIELDS.END_COL]
    };
}
function $0d1022fdfdaea520$var$getSource(startLine, startColumn, endLine, endColumn) {
    return {
        start: {
            line: startLine,
            column: startColumn
        },
        end: {
            line: endLine,
            column: endColumn
        }
    };
}
function $0d1022fdfdaea520$var$getTokenSource(token) {
    return $0d1022fdfdaea520$var$getSource(token[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_LINE], token[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_COL], token[$0d1022fdfdaea520$var$_tokenize.FIELDS.END_LINE], token[$0d1022fdfdaea520$var$_tokenize.FIELDS.END_COL]);
}
function $0d1022fdfdaea520$var$getTokenSourceSpan(startToken, endToken) {
    if (!startToken) return undefined;
    return $0d1022fdfdaea520$var$getSource(startToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_LINE], startToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_COL], endToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.END_LINE], endToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.END_COL]);
}
function $0d1022fdfdaea520$var$unescapeProp(node, prop) {
    var value = node[prop];
    if (typeof value !== "string") return;
    if (value.indexOf("\\") !== -1) {
        (0, $1CKTu.ensureObject)(node, "raws");
        node[prop] = (0, $1CKTu.unesc)(value);
        if (node.raws[prop] === undefined) node.raws[prop] = value;
    }
    return node;
}
function $0d1022fdfdaea520$var$indexesOf(array, item) {
    var i = -1;
    var indexes = [];
    while((i = array.indexOf(item, i + 1)) !== -1)indexes.push(i);
    return indexes;
}
function $0d1022fdfdaea520$var$uniqs() {
    var list = Array.prototype.concat.apply([], arguments);
    return list.filter(function(item, i) {
        return i === list.indexOf(item);
    });
}
var $0d1022fdfdaea520$var$Parser = /*#__PURE__*/ function() {
    function Parser(rule, options) {
        if (options === void 0) options = {};
        this.rule = rule;
        this.options = Object.assign({
            lossy: false,
            safe: false
        }, options);
        this.position = 0;
        this.css = typeof this.rule === "string" ? this.rule : this.rule.selector;
        this.tokens = (0, $0d1022fdfdaea520$var$_tokenize["default"])({
            css: this.css,
            error: this._errorGenerator(),
            safe: this.options.safe
        });
        var rootSource = $0d1022fdfdaea520$var$getTokenSourceSpan(this.tokens[0], this.tokens[this.tokens.length - 1]);
        this.root = new $0d1022fdfdaea520$var$_root["default"]({
            source: rootSource
        });
        this.root.errorGenerator = this._errorGenerator();
        var selector = new $0d1022fdfdaea520$var$_selector["default"]({
            source: {
                start: {
                    line: 1,
                    column: 1
                }
            }
        });
        this.root.append(selector);
        this.current = selector;
        this.loop();
    }
    var _proto = Parser.prototype;
    _proto._errorGenerator = function _errorGenerator() {
        var _this = this;
        return function(message, errorOptions) {
            if (typeof _this.rule === "string") return new Error(message);
            return _this.rule.error(message, errorOptions);
        };
    };
    _proto.attribute = function attribute() {
        var attr = [];
        var startingToken = this.currToken;
        this.position++;
        while(this.position < this.tokens.length && this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] !== $0d1022fdfdaea520$var$tokens.closeSquare){
            attr.push(this.currToken);
            this.position++;
        }
        if (this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] !== $0d1022fdfdaea520$var$tokens.closeSquare) return this.expected("closing square bracket", this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]);
        var len = attr.length;
        var node = {
            source: $0d1022fdfdaea520$var$getSource(startingToken[1], startingToken[2], this.currToken[3], this.currToken[4]),
            sourceIndex: startingToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]
        };
        if (len === 1 && !~[
            $0d1022fdfdaea520$var$tokens.word
        ].indexOf(attr[0][$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE])) return this.expected("attribute", attr[0][$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]);
        var pos = 0;
        var spaceBefore = "";
        var commentBefore = "";
        var lastAdded = null;
        var spaceAfterMeaningfulToken = false;
        while(pos < len){
            var token = attr[pos];
            var content = this.content(token);
            var next = attr[pos + 1];
            switch(token[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE]){
                case $0d1022fdfdaea520$var$tokens.space:
                    // if (
                    //     len === 1 ||
                    //     pos === 0 && this.content(next) === '|'
                    // ) {
                    //     return this.expected('attribute', token[TOKEN.START_POS], content);
                    // }
                    spaceAfterMeaningfulToken = true;
                    if (this.options.lossy) break;
                    if (lastAdded) {
                        (0, $1CKTu.ensureObject)(node, "spaces", lastAdded);
                        var prevContent = node.spaces[lastAdded].after || "";
                        node.spaces[lastAdded].after = prevContent + content;
                        var existingComment = (0, $1CKTu.getProp)(node, "raws", "spaces", lastAdded, "after") || null;
                        if (existingComment) node.raws.spaces[lastAdded].after = existingComment + content;
                    } else {
                        spaceBefore = spaceBefore + content;
                        commentBefore = commentBefore + content;
                    }
                    break;
                case $0d1022fdfdaea520$var$tokens.asterisk:
                    if (next[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.equals) {
                        node.operator = content;
                        lastAdded = "operator";
                    } else if ((!node.namespace || lastAdded === "namespace" && !spaceAfterMeaningfulToken) && next) {
                        if (spaceBefore) {
                            (0, $1CKTu.ensureObject)(node, "spaces", "attribute");
                            node.spaces.attribute.before = spaceBefore;
                            spaceBefore = "";
                        }
                        if (commentBefore) {
                            (0, $1CKTu.ensureObject)(node, "raws", "spaces", "attribute");
                            node.raws.spaces.attribute.before = spaceBefore;
                            commentBefore = "";
                        }
                        node.namespace = (node.namespace || "") + content;
                        var rawValue = (0, $1CKTu.getProp)(node, "raws", "namespace") || null;
                        if (rawValue) node.raws.namespace += content;
                        lastAdded = "namespace";
                    }
                    spaceAfterMeaningfulToken = false;
                    break;
                case $0d1022fdfdaea520$var$tokens.dollar:
                    if (lastAdded === "value") {
                        var oldRawValue = (0, $1CKTu.getProp)(node, "raws", "value");
                        node.value += "$";
                        if (oldRawValue) node.raws.value = oldRawValue + "$";
                        break;
                    }
                // Falls through
                case $0d1022fdfdaea520$var$tokens.caret:
                    if (next[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.equals) {
                        node.operator = content;
                        lastAdded = "operator";
                    }
                    spaceAfterMeaningfulToken = false;
                    break;
                case $0d1022fdfdaea520$var$tokens.combinator:
                    if (content === "~" && next[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.equals) {
                        node.operator = content;
                        lastAdded = "operator";
                    }
                    if (content !== "|") {
                        spaceAfterMeaningfulToken = false;
                        break;
                    }
                    if (next[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.equals) {
                        node.operator = content;
                        lastAdded = "operator";
                    } else if (!node.namespace && !node.attribute) node.namespace = true;
                    spaceAfterMeaningfulToken = false;
                    break;
                case $0d1022fdfdaea520$var$tokens.word:
                    if (next && this.content(next) === "|" && attr[pos + 2] && attr[pos + 2][$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] !== $0d1022fdfdaea520$var$tokens.equals && // this look-ahead probably fails with comment nodes involved.
                    !node.operator && !node.namespace) {
                        node.namespace = content;
                        lastAdded = "namespace";
                    } else if (!node.attribute || lastAdded === "attribute" && !spaceAfterMeaningfulToken) {
                        if (spaceBefore) {
                            (0, $1CKTu.ensureObject)(node, "spaces", "attribute");
                            node.spaces.attribute.before = spaceBefore;
                            spaceBefore = "";
                        }
                        if (commentBefore) {
                            (0, $1CKTu.ensureObject)(node, "raws", "spaces", "attribute");
                            node.raws.spaces.attribute.before = commentBefore;
                            commentBefore = "";
                        }
                        node.attribute = (node.attribute || "") + content;
                        var _rawValue = (0, $1CKTu.getProp)(node, "raws", "attribute") || null;
                        if (_rawValue) node.raws.attribute += content;
                        lastAdded = "attribute";
                    } else if (!node.value && node.value !== "" || lastAdded === "value" && !spaceAfterMeaningfulToken) {
                        var _unescaped = (0, $1CKTu.unesc)(content);
                        var _oldRawValue = (0, $1CKTu.getProp)(node, "raws", "value") || "";
                        var oldValue = node.value || "";
                        node.value = oldValue + _unescaped;
                        node.quoteMark = null;
                        if (_unescaped !== content || _oldRawValue) {
                            (0, $1CKTu.ensureObject)(node, "raws");
                            node.raws.value = (_oldRawValue || oldValue) + content;
                        }
                        lastAdded = "value";
                    } else {
                        var insensitive = content === "i" || content === "I";
                        if ((node.value || node.value === "") && (node.quoteMark || spaceAfterMeaningfulToken)) {
                            node.insensitive = insensitive;
                            if (!insensitive || content === "I") {
                                (0, $1CKTu.ensureObject)(node, "raws");
                                node.raws.insensitiveFlag = content;
                            }
                            lastAdded = "insensitive";
                            if (spaceBefore) {
                                (0, $1CKTu.ensureObject)(node, "spaces", "insensitive");
                                node.spaces.insensitive.before = spaceBefore;
                                spaceBefore = "";
                            }
                            if (commentBefore) {
                                (0, $1CKTu.ensureObject)(node, "raws", "spaces", "insensitive");
                                node.raws.spaces.insensitive.before = commentBefore;
                                commentBefore = "";
                            }
                        } else if (node.value || node.value === "") {
                            lastAdded = "value";
                            node.value += content;
                            if (node.raws.value) node.raws.value += content;
                        }
                    }
                    spaceAfterMeaningfulToken = false;
                    break;
                case $0d1022fdfdaea520$var$tokens.str:
                    if (!node.attribute || !node.operator) return this.error("Expected an attribute followed by an operator preceding the string.", {
                        index: token[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]
                    });
                    var _unescapeValue = (0, $0d1022fdfdaea520$var$_attribute.unescapeValue)(content), unescaped = _unescapeValue.unescaped, quoteMark = _unescapeValue.quoteMark;
                    node.value = unescaped;
                    node.quoteMark = quoteMark;
                    lastAdded = "value";
                    (0, $1CKTu.ensureObject)(node, "raws");
                    node.raws.value = content;
                    spaceAfterMeaningfulToken = false;
                    break;
                case $0d1022fdfdaea520$var$tokens.equals:
                    if (!node.attribute) return this.expected("attribute", token[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS], content);
                    if (node.value) return this.error('Unexpected "=" found; an operator was already defined.', {
                        index: token[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]
                    });
                    node.operator = node.operator ? node.operator + content : content;
                    lastAdded = "operator";
                    spaceAfterMeaningfulToken = false;
                    break;
                case $0d1022fdfdaea520$var$tokens.comment:
                    if (lastAdded) {
                        if (spaceAfterMeaningfulToken || next && next[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.space || lastAdded === "insensitive") {
                            var lastComment = (0, $1CKTu.getProp)(node, "spaces", lastAdded, "after") || "";
                            var rawLastComment = (0, $1CKTu.getProp)(node, "raws", "spaces", lastAdded, "after") || lastComment;
                            (0, $1CKTu.ensureObject)(node, "raws", "spaces", lastAdded);
                            node.raws.spaces[lastAdded].after = rawLastComment + content;
                        } else {
                            var lastValue = node[lastAdded] || "";
                            var rawLastValue = (0, $1CKTu.getProp)(node, "raws", lastAdded) || lastValue;
                            (0, $1CKTu.ensureObject)(node, "raws");
                            node.raws[lastAdded] = rawLastValue + content;
                        }
                    } else commentBefore = commentBefore + content;
                    break;
                default:
                    return this.error('Unexpected "' + content + '" found.', {
                        index: token[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]
                    });
            }
            pos++;
        }
        $0d1022fdfdaea520$var$unescapeProp(node, "attribute");
        $0d1022fdfdaea520$var$unescapeProp(node, "namespace");
        this.newNode(new $0d1022fdfdaea520$var$_attribute["default"](node));
        this.position++;
    } /**
   * return a node containing meaningless garbage up to (but not including) the specified token position.
   * if the token position is negative, all remaining tokens are consumed.
   *
   * This returns an array containing a single string node if all whitespace,
   * otherwise an array of comment nodes with space before and after.
   *
   * These tokens are not added to the current selector, the caller can add them or use them to amend
   * a previous node's space metadata.
   *
   * In lossy mode, this returns only comments.
   */ ;
    _proto.parseWhitespaceEquivalentTokens = function parseWhitespaceEquivalentTokens(stopPosition) {
        if (stopPosition < 0) stopPosition = this.tokens.length;
        var startPosition = this.position;
        var nodes = [];
        var space = "";
        var lastComment = undefined;
        do {
            if ($0d1022fdfdaea520$var$WHITESPACE_TOKENS[this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE]]) {
                if (!this.options.lossy) space += this.content();
            } else if (this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.comment) {
                var spaces = {};
                if (space) {
                    spaces.before = space;
                    space = "";
                }
                lastComment = new $0d1022fdfdaea520$var$_comment["default"]({
                    value: this.content(),
                    source: $0d1022fdfdaea520$var$getTokenSource(this.currToken),
                    sourceIndex: this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS],
                    spaces: spaces
                });
                nodes.push(lastComment);
            }
        }while (++this.position < stopPosition);
        if (space) {
            if (lastComment) lastComment.spaces.after = space;
            else if (!this.options.lossy) {
                var firstToken = this.tokens[startPosition];
                var lastToken = this.tokens[this.position - 1];
                nodes.push(new $0d1022fdfdaea520$var$_string["default"]({
                    value: "",
                    source: $0d1022fdfdaea520$var$getSource(firstToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_LINE], firstToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_COL], lastToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.END_LINE], lastToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.END_COL]),
                    sourceIndex: firstToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS],
                    spaces: {
                        before: space,
                        after: ""
                    }
                }));
            }
        }
        return nodes;
    } /**
   * 
   * @param {*} nodes 
   */ ;
    _proto.convertWhitespaceNodesToSpace = function convertWhitespaceNodesToSpace(nodes, requiredSpace) {
        var _this2 = this;
        if (requiredSpace === void 0) requiredSpace = false;
        var space = "";
        var rawSpace = "";
        nodes.forEach(function(n) {
            var spaceBefore = _this2.lossySpace(n.spaces.before, requiredSpace);
            var rawSpaceBefore = _this2.lossySpace(n.rawSpaceBefore, requiredSpace);
            space += spaceBefore + _this2.lossySpace(n.spaces.after, requiredSpace && spaceBefore.length === 0);
            rawSpace += spaceBefore + n.value + _this2.lossySpace(n.rawSpaceAfter, requiredSpace && rawSpaceBefore.length === 0);
        });
        if (rawSpace === space) rawSpace = undefined;
        var result = {
            space: space,
            rawSpace: rawSpace
        };
        return result;
    };
    _proto.isNamedCombinator = function isNamedCombinator(position) {
        if (position === void 0) position = this.position;
        return this.tokens[position + 0] && this.tokens[position + 0][$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.slash && this.tokens[position + 1] && this.tokens[position + 1][$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.word && this.tokens[position + 2] && this.tokens[position + 2][$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.slash;
    };
    _proto.namedCombinator = function namedCombinator() {
        if (this.isNamedCombinator()) {
            var nameRaw = this.content(this.tokens[this.position + 1]);
            var name = (0, $1CKTu.unesc)(nameRaw).toLowerCase();
            var raws = {};
            if (name !== nameRaw) raws.value = "/" + nameRaw + "/";
            var node = new $0d1022fdfdaea520$var$_combinator["default"]({
                value: "/" + name + "/",
                source: $0d1022fdfdaea520$var$getSource(this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_LINE], this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_COL], this.tokens[this.position + 2][$0d1022fdfdaea520$var$_tokenize.FIELDS.END_LINE], this.tokens[this.position + 2][$0d1022fdfdaea520$var$_tokenize.FIELDS.END_COL]),
                sourceIndex: this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS],
                raws: raws
            });
            this.position = this.position + 3;
            return node;
        } else this.unexpected();
    };
    _proto.combinator = function combinator() {
        var _this3 = this;
        if (this.content() === "|") return this.namespace();
         // We need to decide between a space that's a descendant combinator and meaningless whitespace at the end of a selector.
        var nextSigTokenPos = this.locateNextMeaningfulToken(this.position);
        if (nextSigTokenPos < 0 || this.tokens[nextSigTokenPos][$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.comma) {
            var nodes = this.parseWhitespaceEquivalentTokens(nextSigTokenPos);
            if (nodes.length > 0) {
                var last = this.current.last;
                if (last) {
                    var _this$convertWhitespa = this.convertWhitespaceNodesToSpace(nodes), space = _this$convertWhitespa.space, rawSpace = _this$convertWhitespa.rawSpace;
                    if (rawSpace !== undefined) last.rawSpaceAfter += rawSpace;
                    last.spaces.after += space;
                } else nodes.forEach(function(n) {
                    return _this3.newNode(n);
                });
            }
            return;
        }
        var firstToken = this.currToken;
        var spaceOrDescendantSelectorNodes = undefined;
        if (nextSigTokenPos > this.position) spaceOrDescendantSelectorNodes = this.parseWhitespaceEquivalentTokens(nextSigTokenPos);
        var node;
        if (this.isNamedCombinator()) node = this.namedCombinator();
        else if (this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.combinator) {
            node = new $0d1022fdfdaea520$var$_combinator["default"]({
                value: this.content(),
                source: $0d1022fdfdaea520$var$getTokenSource(this.currToken),
                sourceIndex: this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]
            });
            this.position++;
        } else if ($0d1022fdfdaea520$var$WHITESPACE_TOKENS[this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE]]) ;
        else if (!spaceOrDescendantSelectorNodes) this.unexpected();
        if (node) {
            if (spaceOrDescendantSelectorNodes) {
                var _this$convertWhitespa2 = this.convertWhitespaceNodesToSpace(spaceOrDescendantSelectorNodes), _space = _this$convertWhitespa2.space, _rawSpace = _this$convertWhitespa2.rawSpace;
                node.spaces.before = _space;
                node.rawSpaceBefore = _rawSpace;
            }
        } else {
            // descendant combinator
            var _this$convertWhitespa3 = this.convertWhitespaceNodesToSpace(spaceOrDescendantSelectorNodes, true), _space2 = _this$convertWhitespa3.space, _rawSpace2 = _this$convertWhitespa3.rawSpace;
            if (!_rawSpace2) _rawSpace2 = _space2;
            var spaces = {};
            var raws = {
                spaces: {}
            };
            if (_space2.endsWith(" ") && _rawSpace2.endsWith(" ")) {
                spaces.before = _space2.slice(0, _space2.length - 1);
                raws.spaces.before = _rawSpace2.slice(0, _rawSpace2.length - 1);
            } else if (_space2.startsWith(" ") && _rawSpace2.startsWith(" ")) {
                spaces.after = _space2.slice(1);
                raws.spaces.after = _rawSpace2.slice(1);
            } else raws.value = _rawSpace2;
            node = new $0d1022fdfdaea520$var$_combinator["default"]({
                value: " ",
                source: $0d1022fdfdaea520$var$getTokenSourceSpan(firstToken, this.tokens[this.position - 1]),
                sourceIndex: firstToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS],
                spaces: spaces,
                raws: raws
            });
        }
        if (this.currToken && this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.space) {
            node.spaces.after = this.optionalSpace(this.content());
            this.position++;
        }
        return this.newNode(node);
    };
    _proto.comma = function comma() {
        if (this.position === this.tokens.length - 1) {
            this.root.trailingComma = true;
            this.position++;
            return;
        }
        this.current._inferEndPosition();
        var selector = new $0d1022fdfdaea520$var$_selector["default"]({
            source: {
                start: $0d1022fdfdaea520$var$tokenStart(this.tokens[this.position + 1])
            }
        });
        this.current.parent.append(selector);
        this.current = selector;
        this.position++;
    };
    _proto.comment = function comment() {
        var current = this.currToken;
        this.newNode(new $0d1022fdfdaea520$var$_comment["default"]({
            value: this.content(),
            source: $0d1022fdfdaea520$var$getTokenSource(current),
            sourceIndex: current[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]
        }));
        this.position++;
    };
    _proto.error = function error(message, opts) {
        throw this.root.error(message, opts);
    };
    _proto.missingBackslash = function missingBackslash() {
        return this.error("Expected a backslash preceding the semicolon.", {
            index: this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]
        });
    };
    _proto.missingParenthesis = function missingParenthesis() {
        return this.expected("opening parenthesis", this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]);
    };
    _proto.missingSquareBracket = function missingSquareBracket() {
        return this.expected("opening square bracket", this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]);
    };
    _proto.unexpected = function unexpected() {
        return this.error("Unexpected '" + this.content() + "'. Escaping special characters with \\ may help.", this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]);
    };
    _proto.namespace = function namespace() {
        var before = this.prevToken && this.content(this.prevToken) || true;
        if (this.nextToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.word) {
            this.position++;
            return this.word(before);
        } else if (this.nextToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.asterisk) {
            this.position++;
            return this.universal(before);
        }
    };
    _proto.nesting = function nesting() {
        if (this.nextToken) {
            var nextContent = this.content(this.nextToken);
            if (nextContent === "|") {
                this.position++;
                return;
            }
        }
        var current = this.currToken;
        this.newNode(new $0d1022fdfdaea520$var$_nesting["default"]({
            value: this.content(),
            source: $0d1022fdfdaea520$var$getTokenSource(current),
            sourceIndex: current[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]
        }));
        this.position++;
    };
    _proto.parentheses = function parentheses() {
        var last = this.current.last;
        var unbalanced = 1;
        this.position++;
        if (last && last.type === $0d1022fdfdaea520$var$types.PSEUDO) {
            var selector = new $0d1022fdfdaea520$var$_selector["default"]({
                source: {
                    start: $0d1022fdfdaea520$var$tokenStart(this.tokens[this.position - 1])
                }
            });
            var cache = this.current;
            last.append(selector);
            this.current = selector;
            while(this.position < this.tokens.length && unbalanced){
                if (this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.openParenthesis) unbalanced++;
                if (this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.closeParenthesis) unbalanced--;
                if (unbalanced) this.parse();
                else {
                    this.current.source.end = $0d1022fdfdaea520$var$tokenEnd(this.currToken);
                    this.current.parent.source.end = $0d1022fdfdaea520$var$tokenEnd(this.currToken);
                    this.position++;
                }
            }
            this.current = cache;
        } else {
            // I think this case should be an error. It's used to implement a basic parse of media queries
            // but I don't think it's a good idea.
            var parenStart = this.currToken;
            var parenValue = "(";
            var parenEnd;
            while(this.position < this.tokens.length && unbalanced){
                if (this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.openParenthesis) unbalanced++;
                if (this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.closeParenthesis) unbalanced--;
                parenEnd = this.currToken;
                parenValue += this.parseParenthesisToken(this.currToken);
                this.position++;
            }
            if (last) last.appendToPropertyAndEscape("value", parenValue, parenValue);
            else this.newNode(new $0d1022fdfdaea520$var$_string["default"]({
                value: parenValue,
                source: $0d1022fdfdaea520$var$getSource(parenStart[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_LINE], parenStart[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_COL], parenEnd[$0d1022fdfdaea520$var$_tokenize.FIELDS.END_LINE], parenEnd[$0d1022fdfdaea520$var$_tokenize.FIELDS.END_COL]),
                sourceIndex: parenStart[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]
            }));
        }
        if (unbalanced) return this.expected("closing parenthesis", this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]);
    };
    _proto.pseudo = function pseudo() {
        var _this4 = this;
        var pseudoStr = "";
        var startingToken = this.currToken;
        while(this.currToken && this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.colon){
            pseudoStr += this.content();
            this.position++;
        }
        if (!this.currToken) return this.expected([
            "pseudo-class",
            "pseudo-element"
        ], this.position - 1);
        if (this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.word) this.splitWord(false, function(first, length) {
            pseudoStr += first;
            _this4.newNode(new $0d1022fdfdaea520$var$_pseudo["default"]({
                value: pseudoStr,
                source: $0d1022fdfdaea520$var$getTokenSourceSpan(startingToken, _this4.currToken),
                sourceIndex: startingToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]
            }));
            if (length > 1 && _this4.nextToken && _this4.nextToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.openParenthesis) _this4.error("Misplaced parenthesis.", {
                index: _this4.nextToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]
            });
        });
        else return this.expected([
            "pseudo-class",
            "pseudo-element"
        ], this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]);
    };
    _proto.space = function space() {
        var content = this.content(); // Handle space before and after the selector
        if (this.position === 0 || this.prevToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.comma || this.prevToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.openParenthesis || this.current.nodes.every(function(node) {
            return node.type === "comment";
        })) {
            this.spaces = this.optionalSpace(content);
            this.position++;
        } else if (this.position === this.tokens.length - 1 || this.nextToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.comma || this.nextToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.closeParenthesis) {
            this.current.last.spaces.after = this.optionalSpace(content);
            this.position++;
        } else this.combinator();
    };
    _proto.string = function string() {
        var current = this.currToken;
        this.newNode(new $0d1022fdfdaea520$var$_string["default"]({
            value: this.content(),
            source: $0d1022fdfdaea520$var$getTokenSource(current),
            sourceIndex: current[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]
        }));
        this.position++;
    };
    _proto.universal = function universal(namespace) {
        var nextToken = this.nextToken;
        if (nextToken && this.content(nextToken) === "|") {
            this.position++;
            return this.namespace();
        }
        var current = this.currToken;
        this.newNode(new $0d1022fdfdaea520$var$_universal["default"]({
            value: this.content(),
            source: $0d1022fdfdaea520$var$getTokenSource(current),
            sourceIndex: current[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS]
        }), namespace);
        this.position++;
    };
    _proto.splitWord = function splitWord(namespace, firstCallback) {
        var _this5 = this;
        var nextToken = this.nextToken;
        var word = this.content();
        while(nextToken && ~[
            $0d1022fdfdaea520$var$tokens.dollar,
            $0d1022fdfdaea520$var$tokens.caret,
            $0d1022fdfdaea520$var$tokens.equals,
            $0d1022fdfdaea520$var$tokens.word
        ].indexOf(nextToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE])){
            this.position++;
            var current = this.content();
            word += current;
            if (current.lastIndexOf("\\") === current.length - 1) {
                var next = this.nextToken;
                if (next && next[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.space) {
                    word += this.requiredSpace(this.content(next));
                    this.position++;
                }
            }
            nextToken = this.nextToken;
        }
        var hasClass = $0d1022fdfdaea520$var$indexesOf(word, ".").filter(function(i) {
            // Allow escaped dot within class name
            var escapedDot = word[i - 1] === "\\"; // Allow decimal numbers percent in @keyframes
            var isKeyframesPercent = /^\d+\.\d+%$/.test(word);
            return !escapedDot && !isKeyframesPercent;
        });
        var hasId = $0d1022fdfdaea520$var$indexesOf(word, "#").filter(function(i) {
            return word[i - 1] !== "\\";
        }); // Eliminate Sass interpolations from the list of id indexes
        var interpolations = $0d1022fdfdaea520$var$indexesOf(word, "#{");
        if (interpolations.length) hasId = hasId.filter(function(hashIndex) {
            return !~interpolations.indexOf(hashIndex);
        });
        var indices = (0, $0d1022fdfdaea520$var$_sortAscending["default"])($0d1022fdfdaea520$var$uniqs([
            0
        ].concat(hasClass, hasId)));
        indices.forEach(function(ind, i) {
            var index = indices[i + 1] || word.length;
            var value = word.slice(ind, index);
            if (i === 0 && firstCallback) return firstCallback.call(_this5, value, indices.length);
            var node;
            var current = _this5.currToken;
            var sourceIndex = current[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS] + indices[i];
            var source = $0d1022fdfdaea520$var$getSource(current[1], current[2] + ind, current[3], current[2] + (index - 1));
            if (~hasClass.indexOf(ind)) {
                var classNameOpts = {
                    value: value.slice(1),
                    source: source,
                    sourceIndex: sourceIndex
                };
                node = new $0d1022fdfdaea520$var$_className["default"]($0d1022fdfdaea520$var$unescapeProp(classNameOpts, "value"));
            } else if (~hasId.indexOf(ind)) {
                var idOpts = {
                    value: value.slice(1),
                    source: source,
                    sourceIndex: sourceIndex
                };
                node = new $0d1022fdfdaea520$var$_id["default"]($0d1022fdfdaea520$var$unescapeProp(idOpts, "value"));
            } else {
                var tagOpts = {
                    value: value,
                    source: source,
                    sourceIndex: sourceIndex
                };
                $0d1022fdfdaea520$var$unescapeProp(tagOpts, "value");
                node = new $0d1022fdfdaea520$var$_tag["default"](tagOpts);
            }
            _this5.newNode(node, namespace); // Ensure that the namespace is used only once
            namespace = null;
        });
        this.position++;
    };
    _proto.word = function word(namespace) {
        var nextToken = this.nextToken;
        if (nextToken && this.content(nextToken) === "|") {
            this.position++;
            return this.namespace();
        }
        return this.splitWord(namespace);
    };
    _proto.loop = function loop() {
        while(this.position < this.tokens.length)this.parse(true);
        this.current._inferEndPosition();
        return this.root;
    };
    _proto.parse = function parse(throwOnParenthesis) {
        switch(this.currToken[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE]){
            case $0d1022fdfdaea520$var$tokens.space:
                this.space();
                break;
            case $0d1022fdfdaea520$var$tokens.comment:
                this.comment();
                break;
            case $0d1022fdfdaea520$var$tokens.openParenthesis:
                this.parentheses();
                break;
            case $0d1022fdfdaea520$var$tokens.closeParenthesis:
                if (throwOnParenthesis) this.missingParenthesis();
                break;
            case $0d1022fdfdaea520$var$tokens.openSquare:
                this.attribute();
                break;
            case $0d1022fdfdaea520$var$tokens.dollar:
            case $0d1022fdfdaea520$var$tokens.caret:
            case $0d1022fdfdaea520$var$tokens.equals:
            case $0d1022fdfdaea520$var$tokens.word:
                this.word();
                break;
            case $0d1022fdfdaea520$var$tokens.colon:
                this.pseudo();
                break;
            case $0d1022fdfdaea520$var$tokens.comma:
                this.comma();
                break;
            case $0d1022fdfdaea520$var$tokens.asterisk:
                this.universal();
                break;
            case $0d1022fdfdaea520$var$tokens.ampersand:
                this.nesting();
                break;
            case $0d1022fdfdaea520$var$tokens.slash:
            case $0d1022fdfdaea520$var$tokens.combinator:
                this.combinator();
                break;
            case $0d1022fdfdaea520$var$tokens.str:
                this.string();
                break;
            // These cases throw; no break needed.
            case $0d1022fdfdaea520$var$tokens.closeSquare:
                this.missingSquareBracket();
            case $0d1022fdfdaea520$var$tokens.semicolon:
                this.missingBackslash();
            default:
                this.unexpected();
        }
    } /**
   * Helpers
   */ ;
    _proto.expected = function expected(description, index, found) {
        if (Array.isArray(description)) {
            var last = description.pop();
            description = description.join(", ") + " or " + last;
        }
        var an = /^[aeiou]/.test(description[0]) ? "an" : "a";
        if (!found) return this.error("Expected " + an + " " + description + ".", {
            index: index
        });
        return this.error("Expected " + an + " " + description + ', found "' + found + '" instead.', {
            index: index
        });
    };
    _proto.requiredSpace = function requiredSpace(space) {
        return this.options.lossy ? " " : space;
    };
    _proto.optionalSpace = function optionalSpace(space) {
        return this.options.lossy ? "" : space;
    };
    _proto.lossySpace = function lossySpace(space, required) {
        if (this.options.lossy) return required ? " " : "";
        else return space;
    };
    _proto.parseParenthesisToken = function parseParenthesisToken(token) {
        var content = this.content(token);
        if (token[$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE] === $0d1022fdfdaea520$var$tokens.space) return this.requiredSpace(content);
        else return content;
    };
    _proto.newNode = function newNode(node, namespace) {
        if (namespace) {
            if (/^ +$/.test(namespace)) {
                if (!this.options.lossy) this.spaces = (this.spaces || "") + namespace;
                namespace = true;
            }
            node.namespace = namespace;
            $0d1022fdfdaea520$var$unescapeProp(node, "namespace");
        }
        if (this.spaces) {
            node.spaces.before = this.spaces;
            this.spaces = "";
        }
        return this.current.append(node);
    };
    _proto.content = function content(token) {
        if (token === void 0) token = this.currToken;
        return this.css.slice(token[$0d1022fdfdaea520$var$_tokenize.FIELDS.START_POS], token[$0d1022fdfdaea520$var$_tokenize.FIELDS.END_POS]);
    };
    /**
   * returns the index of the next non-whitespace, non-comment token.
   * returns -1 if no meaningful token is found.
   */ _proto.locateNextMeaningfulToken = function locateNextMeaningfulToken(startPosition) {
        if (startPosition === void 0) startPosition = this.position + 1;
        var searchPosition = startPosition;
        while(searchPosition < this.tokens.length){
            if ($0d1022fdfdaea520$var$WHITESPACE_EQUIV_TOKENS[this.tokens[searchPosition][$0d1022fdfdaea520$var$_tokenize.FIELDS.TYPE]]) {
                searchPosition++;
                continue;
            } else return searchPosition;
        }
        return -1;
    };
    $0d1022fdfdaea520$var$_createClass(Parser, [
        {
            key: "currToken",
            get: function get() {
                return this.tokens[this.position];
            }
        },
        {
            key: "nextToken",
            get: function get() {
                return this.tokens[this.position + 1];
            }
        },
        {
            key: "prevToken",
            get: function get() {
                return this.tokens[this.position - 1];
            }
        }
    ]);
    return Parser;
}();
module.exports["default"] = $0d1022fdfdaea520$var$Parser;
module.exports = module.exports.default;

});
parcelRegister("kd4c2", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $eb68463e972799c9$var$_container = $eb68463e972799c9$var$_interopRequireDefault((parcelRequire("fOrry")));

var $8pBKt = parcelRequire("8pBKt");
function $eb68463e972799c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $eb68463e972799c9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $eb68463e972799c9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $eb68463e972799c9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $eb68463e972799c9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $eb68463e972799c9$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $eb68463e972799c9$var$_setPrototypeOf(subClass, superClass);
}
function $eb68463e972799c9$var$_setPrototypeOf(o, p) {
    $eb68463e972799c9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $eb68463e972799c9$var$_setPrototypeOf(o, p);
}
var $eb68463e972799c9$var$Root = /*#__PURE__*/ function(_Container) {
    $eb68463e972799c9$var$_inheritsLoose(Root, _Container);
    function Root(opts) {
        var _this;
        _this = _Container.call(this, opts) || this;
        _this.type = $8pBKt.ROOT;
        return _this;
    }
    var _proto = Root.prototype;
    _proto.toString = function toString() {
        var str = this.reduce(function(memo, selector) {
            memo.push(String(selector));
            return memo;
        }, []).join(",");
        return this.trailingComma ? str + "," : str;
    };
    _proto.error = function error(message, options) {
        if (this._error) return this._error(message, options);
        else return new Error(message);
    };
    $eb68463e972799c9$var$_createClass(Root, [
        {
            key: "errorGenerator",
            set: function set(handler) {
                this._error = handler;
            }
        }
    ]);
    return Root;
}($eb68463e972799c9$var$_container["default"]);
module.exports["default"] = $eb68463e972799c9$var$Root;
module.exports = module.exports.default;

});
parcelRegister("fOrry", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $b830d032b4a03dce$var$_node = $b830d032b4a03dce$var$_interopRequireDefault((parcelRequire("bJ7Kk")));

var $b830d032b4a03dce$var$types = $b830d032b4a03dce$var$_interopRequireWildcard((parcelRequire("8pBKt")));
function $b830d032b4a03dce$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $b830d032b4a03dce$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $b830d032b4a03dce$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $b830d032b4a03dce$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b830d032b4a03dce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b830d032b4a03dce$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $b830d032b4a03dce$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    it = o[Symbol.iterator]();
    return it.next.bind(it);
}
function $b830d032b4a03dce$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b830d032b4a03dce$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b830d032b4a03dce$var$_arrayLikeToArray(o, minLen);
}
function $b830d032b4a03dce$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b830d032b4a03dce$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b830d032b4a03dce$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b830d032b4a03dce$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b830d032b4a03dce$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b830d032b4a03dce$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $b830d032b4a03dce$var$_setPrototypeOf(subClass, superClass);
}
function $b830d032b4a03dce$var$_setPrototypeOf(o, p) {
    $b830d032b4a03dce$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b830d032b4a03dce$var$_setPrototypeOf(o, p);
}
var $b830d032b4a03dce$var$Container = /*#__PURE__*/ function(_Node) {
    $b830d032b4a03dce$var$_inheritsLoose(Container, _Node);
    function Container(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Container.prototype;
    _proto.append = function append(selector) {
        selector.parent = this;
        this.nodes.push(selector);
        return this;
    };
    _proto.prepend = function prepend(selector) {
        selector.parent = this;
        this.nodes.unshift(selector);
        return this;
    };
    _proto.at = function at(index) {
        return this.nodes[index];
    };
    _proto.index = function index(child) {
        if (typeof child === "number") return child;
        return this.nodes.indexOf(child);
    };
    _proto.removeChild = function removeChild(child) {
        child = this.index(child);
        this.at(child).parent = undefined;
        this.nodes.splice(child, 1);
        var index;
        for(var id in this.indexes){
            index = this.indexes[id];
            if (index >= child) this.indexes[id] = index - 1;
        }
        return this;
    };
    _proto.removeAll = function removeAll() {
        for(var _iterator = $b830d032b4a03dce$var$_createForOfIteratorHelperLoose(this.nodes), _step; !(_step = _iterator()).done;){
            var node = _step.value;
            node.parent = undefined;
        }
        this.nodes = [];
        return this;
    };
    _proto.empty = function empty() {
        return this.removeAll();
    };
    _proto.insertAfter = function insertAfter(oldNode, newNode) {
        newNode.parent = this;
        var oldIndex = this.index(oldNode);
        this.nodes.splice(oldIndex + 1, 0, newNode);
        newNode.parent = this;
        var index;
        for(var id in this.indexes){
            index = this.indexes[id];
            if (oldIndex <= index) this.indexes[id] = index + 1;
        }
        return this;
    };
    _proto.insertBefore = function insertBefore(oldNode, newNode) {
        newNode.parent = this;
        var oldIndex = this.index(oldNode);
        this.nodes.splice(oldIndex, 0, newNode);
        newNode.parent = this;
        var index;
        for(var id in this.indexes){
            index = this.indexes[id];
            if (index <= oldIndex) this.indexes[id] = index + 1;
        }
        return this;
    };
    _proto._findChildAtPosition = function _findChildAtPosition(line, col) {
        var found = undefined;
        this.each(function(node) {
            if (node.atPosition) {
                var foundChild = node.atPosition(line, col);
                if (foundChild) {
                    found = foundChild;
                    return false;
                }
            } else if (node.isAtPosition(line, col)) {
                found = node;
                return false;
            }
        });
        return found;
    } /**
   * Return the most specific node at the line and column number given.
   * The source location is based on the original parsed location, locations aren't
   * updated as selector nodes are mutated.
   * 
   * Note that this location is relative to the location of the first character
   * of the selector, and not the location of the selector in the overall document
   * when used in conjunction with postcss.
   *
   * If not found, returns undefined.
   * @param {number} line The line number of the node to find. (1-based index)
   * @param {number} col  The column number of the node to find. (1-based index)
   */ ;
    _proto.atPosition = function atPosition(line, col) {
        if (this.isAtPosition(line, col)) return this._findChildAtPosition(line, col) || this;
        else return undefined;
    };
    _proto._inferEndPosition = function _inferEndPosition() {
        if (this.last && this.last.source && this.last.source.end) {
            this.source = this.source || {};
            this.source.end = this.source.end || {};
            Object.assign(this.source.end, this.last.source.end);
        }
    };
    _proto.each = function each(callback) {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach++;
        var id = this.lastEach;
        this.indexes[id] = 0;
        if (!this.length) return undefined;
        var index, result;
        while(this.indexes[id] < this.length){
            index = this.indexes[id];
            result = callback(this.at(index), index);
            if (result === false) break;
            this.indexes[id] += 1;
        }
        delete this.indexes[id];
        if (result === false) return false;
    };
    _proto.walk = function walk(callback) {
        return this.each(function(node, i) {
            var result = callback(node, i);
            if (result !== false && node.length) result = node.walk(callback);
            if (result === false) return false;
        });
    };
    _proto.walkAttributes = function walkAttributes(callback) {
        var _this2 = this;
        return this.walk(function(selector) {
            if (selector.type === $b830d032b4a03dce$var$types.ATTRIBUTE) return callback.call(_this2, selector);
        });
    };
    _proto.walkClasses = function walkClasses(callback) {
        var _this3 = this;
        return this.walk(function(selector) {
            if (selector.type === $b830d032b4a03dce$var$types.CLASS) return callback.call(_this3, selector);
        });
    };
    _proto.walkCombinators = function walkCombinators(callback) {
        var _this4 = this;
        return this.walk(function(selector) {
            if (selector.type === $b830d032b4a03dce$var$types.COMBINATOR) return callback.call(_this4, selector);
        });
    };
    _proto.walkComments = function walkComments(callback) {
        var _this5 = this;
        return this.walk(function(selector) {
            if (selector.type === $b830d032b4a03dce$var$types.COMMENT) return callback.call(_this5, selector);
        });
    };
    _proto.walkIds = function walkIds(callback) {
        var _this6 = this;
        return this.walk(function(selector) {
            if (selector.type === $b830d032b4a03dce$var$types.ID) return callback.call(_this6, selector);
        });
    };
    _proto.walkNesting = function walkNesting(callback) {
        var _this7 = this;
        return this.walk(function(selector) {
            if (selector.type === $b830d032b4a03dce$var$types.NESTING) return callback.call(_this7, selector);
        });
    };
    _proto.walkPseudos = function walkPseudos(callback) {
        var _this8 = this;
        return this.walk(function(selector) {
            if (selector.type === $b830d032b4a03dce$var$types.PSEUDO) return callback.call(_this8, selector);
        });
    };
    _proto.walkTags = function walkTags(callback) {
        var _this9 = this;
        return this.walk(function(selector) {
            if (selector.type === $b830d032b4a03dce$var$types.TAG) return callback.call(_this9, selector);
        });
    };
    _proto.walkUniversals = function walkUniversals(callback) {
        var _this10 = this;
        return this.walk(function(selector) {
            if (selector.type === $b830d032b4a03dce$var$types.UNIVERSAL) return callback.call(_this10, selector);
        });
    };
    _proto.split = function split(callback) {
        var _this11 = this;
        var current = [];
        return this.reduce(function(memo, node, index) {
            var split = callback.call(_this11, node);
            current.push(node);
            if (split) {
                memo.push(current);
                current = [];
            } else if (index === _this11.length - 1) memo.push(current);
            return memo;
        }, []);
    };
    _proto.map = function map(callback) {
        return this.nodes.map(callback);
    };
    _proto.reduce = function reduce(callback, memo) {
        return this.nodes.reduce(callback, memo);
    };
    _proto.every = function every(callback) {
        return this.nodes.every(callback);
    };
    _proto.some = function some(callback) {
        return this.nodes.some(callback);
    };
    _proto.filter = function filter(callback) {
        return this.nodes.filter(callback);
    };
    _proto.sort = function sort(callback) {
        return this.nodes.sort(callback);
    };
    _proto.toString = function toString() {
        return this.map(String).join("");
    };
    $b830d032b4a03dce$var$_createClass(Container, [
        {
            key: "first",
            get: function get() {
                return this.at(0);
            }
        },
        {
            key: "last",
            get: function get() {
                return this.at(this.length - 1);
            }
        },
        {
            key: "length",
            get: function get() {
                return this.nodes.length;
            }
        }
    ]);
    return Container;
}($b830d032b4a03dce$var$_node["default"]);
module.exports["default"] = $b830d032b4a03dce$var$Container;
module.exports = module.exports.default;

});
parcelRegister("bJ7Kk", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $1CKTu = parcelRequire("1CKTu");
function $8899e7edfbe86a3b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8899e7edfbe86a3b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8899e7edfbe86a3b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8899e7edfbe86a3b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $8899e7edfbe86a3b$var$cloneNode = function cloneNode(obj, parent) {
    if (typeof obj !== "object" || obj === null) return obj;
    var cloned = new obj.constructor();
    for(var i in obj){
        if (!obj.hasOwnProperty(i)) continue;
        var value = obj[i];
        var type = typeof value;
        if (i === "parent" && type === "object") {
            if (parent) cloned[i] = parent;
        } else if (value instanceof Array) cloned[i] = value.map(function(j) {
            return cloneNode(j, cloned);
        });
        else cloned[i] = cloneNode(value, cloned);
    }
    return cloned;
};
var $8899e7edfbe86a3b$var$Node = /*#__PURE__*/ function() {
    function Node(opts) {
        if (opts === void 0) opts = {};
        Object.assign(this, opts);
        this.spaces = this.spaces || {};
        this.spaces.before = this.spaces.before || "";
        this.spaces.after = this.spaces.after || "";
    }
    var _proto = Node.prototype;
    _proto.remove = function remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = undefined;
        return this;
    };
    _proto.replaceWith = function replaceWith() {
        if (this.parent) {
            for(var index in arguments)this.parent.insertBefore(this, arguments[index]);
            this.remove();
        }
        return this;
    };
    _proto.next = function next() {
        return this.parent.at(this.parent.index(this) + 1);
    };
    _proto.prev = function prev() {
        return this.parent.at(this.parent.index(this) - 1);
    };
    _proto.clone = function clone(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = $8899e7edfbe86a3b$var$cloneNode(this);
        for(var name in overrides)cloned[name] = overrides[name];
        return cloned;
    } /**
   * Some non-standard syntax doesn't follow normal escaping rules for css.
   * This allows non standard syntax to be appended to an existing property
   * by specifying the escaped value. By specifying the escaped value,
   * illegal characters are allowed to be directly inserted into css output.
   * @param {string} name the property to set
   * @param {any} value the unescaped value of the property
   * @param {string} valueEscaped optional. the escaped value of the property.
   */ ;
    _proto.appendToPropertyAndEscape = function appendToPropertyAndEscape(name, value, valueEscaped) {
        if (!this.raws) this.raws = {};
        var originalValue = this[name];
        var originalEscaped = this.raws[name];
        this[name] = originalValue + value; // this may trigger a setter that updates raws, so it has to be set first.
        if (originalEscaped || valueEscaped !== value) this.raws[name] = (originalEscaped || originalValue) + valueEscaped;
        else delete this.raws[name]; // delete any escaped value that was created by the setter.
    } /**
   * Some non-standard syntax doesn't follow normal escaping rules for css.
   * This allows the escaped value to be specified directly, allowing illegal
   * characters to be directly inserted into css output.
   * @param {string} name the property to set
   * @param {any} value the unescaped value of the property
   * @param {string} valueEscaped the escaped value of the property.
   */ ;
    _proto.setPropertyAndEscape = function setPropertyAndEscape(name, value, valueEscaped) {
        if (!this.raws) this.raws = {};
        this[name] = value; // this may trigger a setter that updates raws, so it has to be set first.
        this.raws[name] = valueEscaped;
    } /**
   * When you want a value to passed through to CSS directly. This method
   * deletes the corresponding raw value causing the stringifier to fallback
   * to the unescaped value.
   * @param {string} name the property to set.
   * @param {any} value The value that is both escaped and unescaped.
   */ ;
    _proto.setPropertyWithoutEscape = function setPropertyWithoutEscape(name, value) {
        this[name] = value; // this may trigger a setter that updates raws, so it has to be set first.
        if (this.raws) delete this.raws[name];
    } /**
   *
   * @param {number} line The number (starting with 1)
   * @param {number} column The column number (starting with 1)
   */ ;
    _proto.isAtPosition = function isAtPosition(line, column) {
        if (this.source && this.source.start && this.source.end) {
            if (this.source.start.line > line) return false;
            if (this.source.end.line < line) return false;
            if (this.source.start.line === line && this.source.start.column > column) return false;
            if (this.source.end.line === line && this.source.end.column < column) return false;
            return true;
        }
        return undefined;
    };
    _proto.stringifyProperty = function stringifyProperty(name) {
        return this.raws && this.raws[name] || this[name];
    };
    _proto.valueToString = function valueToString() {
        return String(this.stringifyProperty("value"));
    };
    _proto.toString = function toString() {
        return [
            this.rawSpaceBefore,
            this.valueToString(),
            this.rawSpaceAfter
        ].join("");
    };
    $8899e7edfbe86a3b$var$_createClass(Node, [
        {
            key: "rawSpaceBefore",
            get: function get() {
                var rawSpace = this.raws && this.raws.spaces && this.raws.spaces.before;
                if (rawSpace === undefined) rawSpace = this.spaces && this.spaces.before;
                return rawSpace || "";
            },
            set: function set(raw) {
                (0, $1CKTu.ensureObject)(this, "raws", "spaces");
                this.raws.spaces.before = raw;
            }
        },
        {
            key: "rawSpaceAfter",
            get: function get() {
                var rawSpace = this.raws && this.raws.spaces && this.raws.spaces.after;
                if (rawSpace === undefined) rawSpace = this.spaces.after;
                return rawSpace || "";
            },
            set: function set(raw) {
                (0, $1CKTu.ensureObject)(this, "raws", "spaces");
                this.raws.spaces.after = raw;
            }
        }
    ]);
    return Node;
}();
module.exports["default"] = $8899e7edfbe86a3b$var$Node;
module.exports = module.exports.default;

});
parcelRegister("1CKTu", function(module, exports) {

$parcel$export(module.exports, "ensureObject", function () { return $12edb735e6b12638$export$b5478a1684008f71; }, function (v) { return $12edb735e6b12638$export$b5478a1684008f71 = v; });
$parcel$export(module.exports, "getProp", function () { return $12edb735e6b12638$export$88c9ddb45cea7241; }, function (v) { return $12edb735e6b12638$export$88c9ddb45cea7241 = v; });
$parcel$export(module.exports, "unesc", function () { return $12edb735e6b12638$export$9db703a29422957e; }, function (v) { return $12edb735e6b12638$export$9db703a29422957e = v; });
var $12edb735e6b12638$export$1e511d4a378977f5;
var $12edb735e6b12638$export$f46565c3d339d23a;
var $12edb735e6b12638$export$b5478a1684008f71;
var $12edb735e6b12638$export$88c9ddb45cea7241;
var $12edb735e6b12638$export$9db703a29422957e;
"use strict";
$12edb735e6b12638$export$1e511d4a378977f5 = true;
$12edb735e6b12638$export$f46565c3d339d23a = $12edb735e6b12638$export$b5478a1684008f71 = $12edb735e6b12638$export$88c9ddb45cea7241 = $12edb735e6b12638$export$9db703a29422957e = void 0;

var $12edb735e6b12638$var$_unesc = $12edb735e6b12638$var$_interopRequireDefault((parcelRequire("8rHtO")));
$12edb735e6b12638$export$9db703a29422957e = $12edb735e6b12638$var$_unesc["default"];

var $12edb735e6b12638$var$_getProp = $12edb735e6b12638$var$_interopRequireDefault((parcelRequire("b7D7r")));
$12edb735e6b12638$export$88c9ddb45cea7241 = $12edb735e6b12638$var$_getProp["default"];

var $12edb735e6b12638$var$_ensureObject = $12edb735e6b12638$var$_interopRequireDefault((parcelRequire("l58aJ")));
$12edb735e6b12638$export$b5478a1684008f71 = $12edb735e6b12638$var$_ensureObject["default"];

var $12edb735e6b12638$var$_stripComments = $12edb735e6b12638$var$_interopRequireDefault((parcelRequire("eSlkx")));
$12edb735e6b12638$export$f46565c3d339d23a = $12edb735e6b12638$var$_stripComments["default"];
function $12edb735e6b12638$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("8rHtO", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $62629286b73f05e9$var$unesc;
// Many thanks for this post which made this migration much easier.
// https://mathiasbynens.be/notes/css-escapes
/**
 * 
 * @param {string} str 
 * @returns {[string, number]|undefined}
 */ function $62629286b73f05e9$var$gobbleHex(str) {
    var lower = str.toLowerCase();
    var hex = "";
    var spaceTerminated = false;
    for(var i = 0; i < 6 && lower[i] !== undefined; i++){
        var code = lower.charCodeAt(i); // check to see if we are dealing with a valid hex char [a-f|0-9]
        var valid = code >= 97 && code <= 102 || code >= 48 && code <= 57; // https://drafts.csswg.org/css-syntax/#consume-escaped-code-point
        spaceTerminated = code === 32;
        if (!valid) break;
        hex += lower[i];
    }
    if (hex.length === 0) return undefined;
    var codePoint = parseInt(hex, 16);
    var isSurrogate = codePoint >= 0xD800 && codePoint <= 0xDFFF; // Add special case for
    // "If this number is zero, or is for a surrogate, or is greater than the maximum allowed code point"
    // https://drafts.csswg.org/css-syntax/#maximum-allowed-code-point
    if (isSurrogate || codePoint === 0x0000 || codePoint > 0x10FFFF) return [
        "\uFFFD",
        hex.length + (spaceTerminated ? 1 : 0)
    ];
    return [
        String.fromCodePoint(codePoint),
        hex.length + (spaceTerminated ? 1 : 0)
    ];
}
var $62629286b73f05e9$var$CONTAINS_ESCAPE = /\\/;
function $62629286b73f05e9$var$unesc(str) {
    var needToProcess = $62629286b73f05e9$var$CONTAINS_ESCAPE.test(str);
    if (!needToProcess) return str;
    var ret = "";
    for(var i = 0; i < str.length; i++){
        if (str[i] === "\\") {
            var gobbled = $62629286b73f05e9$var$gobbleHex(str.slice(i + 1, i + 7));
            if (gobbled !== undefined) {
                ret += gobbled[0];
                i += gobbled[1];
                continue;
            } // Retain a pair of \\ if double escaped `\\\\`
            // https://github.com/postcss/postcss-selector-parser/commit/268c9a7656fb53f543dc620aa5b73a30ec3ff20e
            if (str[i + 1] === "\\") {
                ret += "\\";
                i++;
                continue;
            } // if \\ is at the end of the string retain it
            // https://github.com/postcss/postcss-selector-parser/commit/01a6b346e3612ce1ab20219acc26abdc259ccefb
            if (str.length === i + 1) ret += str[i];
            continue;
        }
        ret += str[i];
    }
    return ret;
}
module.exports = module.exports.default;

});

parcelRegister("b7D7r", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $818eb166fe39b562$var$getProp;
function $818eb166fe39b562$var$getProp(obj) {
    for(var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)props[_key - 1] = arguments[_key];
    while(props.length > 0){
        var prop = props.shift();
        if (!obj[prop]) return undefined;
        obj = obj[prop];
    }
    return obj;
}
module.exports = module.exports.default;

});

parcelRegister("l58aJ", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $f5906764585ffa73$var$ensureObject;
function $f5906764585ffa73$var$ensureObject(obj) {
    for(var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)props[_key - 1] = arguments[_key];
    while(props.length > 0){
        var prop = props.shift();
        if (!obj[prop]) obj[prop] = {};
        obj = obj[prop];
    }
}
module.exports = module.exports.default;

});

parcelRegister("eSlkx", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $ad46a797917f8aa9$var$stripComments;
function $ad46a797917f8aa9$var$stripComments(str) {
    var s = "";
    var commentStart = str.indexOf("/*");
    var lastEnd = 0;
    while(commentStart >= 0){
        s = s + str.slice(lastEnd, commentStart);
        var commentEnd = str.indexOf("*/", commentStart + 2);
        if (commentEnd < 0) return s;
        lastEnd = commentEnd + 2;
        commentStart = str.indexOf("/*", lastEnd);
    }
    s = s + str.slice(lastEnd);
    return s;
}
module.exports = module.exports.default;

});



parcelRegister("8pBKt", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $61fdf097ed26d6a7$export$1e511d4a378977f5; }, function (v) { return $61fdf097ed26d6a7$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "UNIVERSAL", function () { return $61fdf097ed26d6a7$export$1b322f0de0b7013c; }, function (v) { return $61fdf097ed26d6a7$export$1b322f0de0b7013c = v; });
$parcel$export(module.exports, "ATTRIBUTE", function () { return $61fdf097ed26d6a7$export$77a31abf1489fff; }, function (v) { return $61fdf097ed26d6a7$export$77a31abf1489fff = v; });
$parcel$export(module.exports, "CLASS", function () { return $61fdf097ed26d6a7$export$6120d77db9a8f6cb; }, function (v) { return $61fdf097ed26d6a7$export$6120d77db9a8f6cb = v; });
$parcel$export(module.exports, "COMBINATOR", function () { return $61fdf097ed26d6a7$export$79b4952c4e8820f9; }, function (v) { return $61fdf097ed26d6a7$export$79b4952c4e8820f9 = v; });
$parcel$export(module.exports, "COMMENT", function () { return $61fdf097ed26d6a7$export$a29989082612d0d9; }, function (v) { return $61fdf097ed26d6a7$export$a29989082612d0d9 = v; });
$parcel$export(module.exports, "ID", function () { return $61fdf097ed26d6a7$export$8be180ec26319f9f; }, function (v) { return $61fdf097ed26d6a7$export$8be180ec26319f9f = v; });
$parcel$export(module.exports, "NESTING", function () { return $61fdf097ed26d6a7$export$cc64a2a6b37abd26; }, function (v) { return $61fdf097ed26d6a7$export$cc64a2a6b37abd26 = v; });
$parcel$export(module.exports, "PSEUDO", function () { return $61fdf097ed26d6a7$export$92b96eef0c524913; }, function (v) { return $61fdf097ed26d6a7$export$92b96eef0c524913 = v; });
$parcel$export(module.exports, "ROOT", function () { return $61fdf097ed26d6a7$export$fbea82a1c0574ef4; }, function (v) { return $61fdf097ed26d6a7$export$fbea82a1c0574ef4 = v; });
$parcel$export(module.exports, "SELECTOR", function () { return $61fdf097ed26d6a7$export$c63acf214e1d55ea; }, function (v) { return $61fdf097ed26d6a7$export$c63acf214e1d55ea = v; });
$parcel$export(module.exports, "STRING", function () { return $61fdf097ed26d6a7$export$a0e01ba2ebef17f2; }, function (v) { return $61fdf097ed26d6a7$export$a0e01ba2ebef17f2 = v; });
$parcel$export(module.exports, "TAG", function () { return $61fdf097ed26d6a7$export$2680f340d0781853; }, function (v) { return $61fdf097ed26d6a7$export$2680f340d0781853 = v; });
var $61fdf097ed26d6a7$export$1e511d4a378977f5;
var $61fdf097ed26d6a7$export$1b322f0de0b7013c;
var $61fdf097ed26d6a7$export$77a31abf1489fff;
var $61fdf097ed26d6a7$export$6120d77db9a8f6cb;
var $61fdf097ed26d6a7$export$79b4952c4e8820f9;
var $61fdf097ed26d6a7$export$a29989082612d0d9;
var $61fdf097ed26d6a7$export$8be180ec26319f9f;
var $61fdf097ed26d6a7$export$cc64a2a6b37abd26;
var $61fdf097ed26d6a7$export$92b96eef0c524913;
var $61fdf097ed26d6a7$export$fbea82a1c0574ef4;
var $61fdf097ed26d6a7$export$c63acf214e1d55ea;
var $61fdf097ed26d6a7$export$a0e01ba2ebef17f2;
var $61fdf097ed26d6a7$export$2680f340d0781853;
"use strict";
$61fdf097ed26d6a7$export$1e511d4a378977f5 = true;
$61fdf097ed26d6a7$export$1b322f0de0b7013c = $61fdf097ed26d6a7$export$77a31abf1489fff = $61fdf097ed26d6a7$export$6120d77db9a8f6cb = $61fdf097ed26d6a7$export$79b4952c4e8820f9 = $61fdf097ed26d6a7$export$a29989082612d0d9 = $61fdf097ed26d6a7$export$8be180ec26319f9f = $61fdf097ed26d6a7$export$cc64a2a6b37abd26 = $61fdf097ed26d6a7$export$92b96eef0c524913 = $61fdf097ed26d6a7$export$fbea82a1c0574ef4 = $61fdf097ed26d6a7$export$c63acf214e1d55ea = $61fdf097ed26d6a7$export$a0e01ba2ebef17f2 = $61fdf097ed26d6a7$export$2680f340d0781853 = void 0;
var $61fdf097ed26d6a7$var$TAG = "tag";
$61fdf097ed26d6a7$export$2680f340d0781853 = $61fdf097ed26d6a7$var$TAG;
var $61fdf097ed26d6a7$var$STRING = "string";
$61fdf097ed26d6a7$export$a0e01ba2ebef17f2 = $61fdf097ed26d6a7$var$STRING;
var $61fdf097ed26d6a7$var$SELECTOR = "selector";
$61fdf097ed26d6a7$export$c63acf214e1d55ea = $61fdf097ed26d6a7$var$SELECTOR;
var $61fdf097ed26d6a7$var$ROOT = "root";
$61fdf097ed26d6a7$export$fbea82a1c0574ef4 = $61fdf097ed26d6a7$var$ROOT;
var $61fdf097ed26d6a7$var$PSEUDO = "pseudo";
$61fdf097ed26d6a7$export$92b96eef0c524913 = $61fdf097ed26d6a7$var$PSEUDO;
var $61fdf097ed26d6a7$var$NESTING = "nesting";
$61fdf097ed26d6a7$export$cc64a2a6b37abd26 = $61fdf097ed26d6a7$var$NESTING;
var $61fdf097ed26d6a7$var$ID = "id";
$61fdf097ed26d6a7$export$8be180ec26319f9f = $61fdf097ed26d6a7$var$ID;
var $61fdf097ed26d6a7$var$COMMENT = "comment";
$61fdf097ed26d6a7$export$a29989082612d0d9 = $61fdf097ed26d6a7$var$COMMENT;
var $61fdf097ed26d6a7$var$COMBINATOR = "combinator";
$61fdf097ed26d6a7$export$79b4952c4e8820f9 = $61fdf097ed26d6a7$var$COMBINATOR;
var $61fdf097ed26d6a7$var$CLASS = "class";
$61fdf097ed26d6a7$export$6120d77db9a8f6cb = $61fdf097ed26d6a7$var$CLASS;
var $61fdf097ed26d6a7$var$ATTRIBUTE = "attribute";
$61fdf097ed26d6a7$export$77a31abf1489fff = $61fdf097ed26d6a7$var$ATTRIBUTE;
var $61fdf097ed26d6a7$var$UNIVERSAL = "universal";
$61fdf097ed26d6a7$export$1b322f0de0b7013c = $61fdf097ed26d6a7$var$UNIVERSAL;

});



parcelRegister("9bR8u", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $6b0e5bcde3b82144$var$_container = $6b0e5bcde3b82144$var$_interopRequireDefault((parcelRequire("fOrry")));

var $8pBKt = parcelRequire("8pBKt");
function $6b0e5bcde3b82144$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6b0e5bcde3b82144$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $6b0e5bcde3b82144$var$_setPrototypeOf(subClass, superClass);
}
function $6b0e5bcde3b82144$var$_setPrototypeOf(o, p) {
    $6b0e5bcde3b82144$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6b0e5bcde3b82144$var$_setPrototypeOf(o, p);
}
var $6b0e5bcde3b82144$var$Selector = /*#__PURE__*/ function(_Container) {
    $6b0e5bcde3b82144$var$_inheritsLoose(Selector, _Container);
    function Selector(opts) {
        var _this;
        _this = _Container.call(this, opts) || this;
        _this.type = $8pBKt.SELECTOR;
        return _this;
    }
    return Selector;
}($6b0e5bcde3b82144$var$_container["default"]);
module.exports["default"] = $6b0e5bcde3b82144$var$Selector;
module.exports = module.exports.default;

});

parcelRegister("9Wgfr", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $73c62257bb228f0a$var$_cssesc = $73c62257bb228f0a$var$_interopRequireDefault((parcelRequire("jBlz6")));

var $1CKTu = parcelRequire("1CKTu");

var $73c62257bb228f0a$var$_node = $73c62257bb228f0a$var$_interopRequireDefault((parcelRequire("bJ7Kk")));

var $8pBKt = parcelRequire("8pBKt");
function $73c62257bb228f0a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $73c62257bb228f0a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $73c62257bb228f0a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $73c62257bb228f0a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $73c62257bb228f0a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $73c62257bb228f0a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $73c62257bb228f0a$var$_setPrototypeOf(subClass, superClass);
}
function $73c62257bb228f0a$var$_setPrototypeOf(o, p) {
    $73c62257bb228f0a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $73c62257bb228f0a$var$_setPrototypeOf(o, p);
}
var $73c62257bb228f0a$var$ClassName = /*#__PURE__*/ function(_Node) {
    $73c62257bb228f0a$var$_inheritsLoose(ClassName, _Node);
    function ClassName(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $8pBKt.CLASS;
        _this._constructed = true;
        return _this;
    }
    var _proto = ClassName.prototype;
    _proto.valueToString = function valueToString() {
        return "." + _Node.prototype.valueToString.call(this);
    };
    $73c62257bb228f0a$var$_createClass(ClassName, [
        {
            key: "value",
            get: function get() {
                return this._value;
            },
            set: function set(v) {
                if (this._constructed) {
                    var escaped = (0, $73c62257bb228f0a$var$_cssesc["default"])(v, {
                        isIdentifier: true
                    });
                    if (escaped !== v) {
                        (0, $1CKTu.ensureObject)(this, "raws");
                        this.raws.value = escaped;
                    } else if (this.raws) delete this.raws.value;
                }
                this._value = v;
            }
        }
    ]);
    return ClassName;
}($73c62257bb228f0a$var$_node["default"]);
module.exports["default"] = $73c62257bb228f0a$var$ClassName;
module.exports = module.exports.default;

});
parcelRegister("jBlz6", function(module, exports) {
/*! https://mths.be/cssesc v3.0.0 by @mathias */ "use strict";
var $e4523370a7e01542$var$object = {};
var $e4523370a7e01542$var$hasOwnProperty = $e4523370a7e01542$var$object.hasOwnProperty;
var $e4523370a7e01542$var$merge = function merge(options, defaults) {
    if (!options) return defaults;
    var result = {};
    for(var key in defaults)// `if (defaults.hasOwnProperty(key) { … }` is not needed here, since
    // only recognized option names are used.
    result[key] = $e4523370a7e01542$var$hasOwnProperty.call(options, key) ? options[key] : defaults[key];
    return result;
};
var $e4523370a7e01542$var$regexAnySingleEscape = /[ -,\.\/:-@\[-\^`\{-~]/;
var $e4523370a7e01542$var$regexSingleEscape = /[ -,\.\/:-@\[\]\^`\{-~]/;
var $e4523370a7e01542$var$regexAlwaysEscape = /['"\\]/;
var $e4523370a7e01542$var$regexExcessiveSpaces = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g;
// https://mathiasbynens.be/notes/css-escapes#css
var $e4523370a7e01542$var$cssesc = function cssesc(string, options) {
    options = $e4523370a7e01542$var$merge(options, cssesc.options);
    if (options.quotes != "single" && options.quotes != "double") options.quotes = "single";
    var quote = options.quotes == "double" ? '"' : "'";
    var isIdentifier = options.isIdentifier;
    var firstChar = string.charAt(0);
    var output = "";
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var character = string.charAt(counter++);
        var codePoint = character.charCodeAt();
        var value = void 0;
        // If it’s not a printable ASCII character…
        if (codePoint < 0x20 || codePoint > 0x7E) {
            if (codePoint >= 0xD800 && codePoint <= 0xDBFF && counter < length) {
                // It’s a high surrogate, and there is a next character.
                var extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) // next character is low surrogate
                codePoint = ((codePoint & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000;
                else // It’s an unmatched surrogate; only append this code unit, in case
                // the next code unit is the high surrogate of a surrogate pair.
                counter--;
            }
            value = "\\" + codePoint.toString(16).toUpperCase() + " ";
        } else {
            if (options.escapeEverything) {
                if ($e4523370a7e01542$var$regexAnySingleEscape.test(character)) value = "\\" + character;
                else value = "\\" + codePoint.toString(16).toUpperCase() + " ";
            } else if (/[\t\n\f\r\x0B]/.test(character)) value = "\\" + codePoint.toString(16).toUpperCase() + " ";
            else if (character == "\\" || !isIdentifier && (character == '"' && quote == character || character == "'" && quote == character) || isIdentifier && $e4523370a7e01542$var$regexSingleEscape.test(character)) value = "\\" + character;
            else value = character;
        }
        output += value;
    }
    if (isIdentifier) {
        if (/^-[-\d]/.test(output)) output = "\\-" + output.slice(1);
        else if (/\d/.test(firstChar)) output = "\\3" + firstChar + " " + output.slice(1);
    }
    // Remove spaces after `\HEX` escapes that are not followed by a hex digit,
    // since they’re redundant. Note that this is only possible if the escape
    // sequence isn’t preceded by an odd number of backslashes.
    output = output.replace($e4523370a7e01542$var$regexExcessiveSpaces, function($0, $1, $2) {
        if ($1 && $1.length % 2) // It’s not safe to remove the space, so don’t.
        return $0;
        // Strip the space.
        return ($1 || "") + $2;
    });
    if (!isIdentifier && options.wrap) return quote + output + quote;
    return output;
};
// Expose default options (so they can be overridden globally).
$e4523370a7e01542$var$cssesc.options = {
    "escapeEverything": false,
    "isIdentifier": false,
    "quotes": "single",
    "wrap": false
};
$e4523370a7e01542$var$cssesc.version = "3.0.0";
module.exports = $e4523370a7e01542$var$cssesc;

});


parcelRegister("fZuGj", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $ba445a345e50b280$var$_node = $ba445a345e50b280$var$_interopRequireDefault((parcelRequire("bJ7Kk")));

var $8pBKt = parcelRequire("8pBKt");
function $ba445a345e50b280$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ba445a345e50b280$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $ba445a345e50b280$var$_setPrototypeOf(subClass, superClass);
}
function $ba445a345e50b280$var$_setPrototypeOf(o, p) {
    $ba445a345e50b280$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ba445a345e50b280$var$_setPrototypeOf(o, p);
}
var $ba445a345e50b280$var$Comment = /*#__PURE__*/ function(_Node) {
    $ba445a345e50b280$var$_inheritsLoose(Comment, _Node);
    function Comment(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $8pBKt.COMMENT;
        return _this;
    }
    return Comment;
}($ba445a345e50b280$var$_node["default"]);
module.exports["default"] = $ba445a345e50b280$var$Comment;
module.exports = module.exports.default;

});

parcelRegister("6ue9S", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $4b9086f9f9503de3$var$_node = $4b9086f9f9503de3$var$_interopRequireDefault((parcelRequire("bJ7Kk")));

var $8pBKt = parcelRequire("8pBKt");
function $4b9086f9f9503de3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $4b9086f9f9503de3$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $4b9086f9f9503de3$var$_setPrototypeOf(subClass, superClass);
}
function $4b9086f9f9503de3$var$_setPrototypeOf(o, p) {
    $4b9086f9f9503de3$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4b9086f9f9503de3$var$_setPrototypeOf(o, p);
}
var $4b9086f9f9503de3$var$ID = /*#__PURE__*/ function(_Node) {
    $4b9086f9f9503de3$var$_inheritsLoose(ID, _Node);
    function ID(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $8pBKt.ID;
        return _this;
    }
    var _proto = ID.prototype;
    _proto.valueToString = function valueToString() {
        return "#" + _Node.prototype.valueToString.call(this);
    };
    return ID;
}($4b9086f9f9503de3$var$_node["default"]);
module.exports["default"] = $4b9086f9f9503de3$var$ID;
module.exports = module.exports.default;

});

parcelRegister("1S2V3", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $15cd194b0cb83df9$var$_namespace = $15cd194b0cb83df9$var$_interopRequireDefault((parcelRequire("akWin")));

var $8pBKt = parcelRequire("8pBKt");
function $15cd194b0cb83df9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $15cd194b0cb83df9$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $15cd194b0cb83df9$var$_setPrototypeOf(subClass, superClass);
}
function $15cd194b0cb83df9$var$_setPrototypeOf(o, p) {
    $15cd194b0cb83df9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $15cd194b0cb83df9$var$_setPrototypeOf(o, p);
}
var $15cd194b0cb83df9$var$Tag = /*#__PURE__*/ function(_Namespace) {
    $15cd194b0cb83df9$var$_inheritsLoose(Tag, _Namespace);
    function Tag(opts) {
        var _this;
        _this = _Namespace.call(this, opts) || this;
        _this.type = $8pBKt.TAG;
        return _this;
    }
    return Tag;
}($15cd194b0cb83df9$var$_namespace["default"]);
module.exports["default"] = $15cd194b0cb83df9$var$Tag;
module.exports = module.exports.default;

});
parcelRegister("akWin", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $7868fddf1170a22d$var$_cssesc = $7868fddf1170a22d$var$_interopRequireDefault((parcelRequire("jBlz6")));

var $1CKTu = parcelRequire("1CKTu");

var $7868fddf1170a22d$var$_node = $7868fddf1170a22d$var$_interopRequireDefault((parcelRequire("bJ7Kk")));
function $7868fddf1170a22d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $7868fddf1170a22d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7868fddf1170a22d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7868fddf1170a22d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7868fddf1170a22d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $7868fddf1170a22d$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $7868fddf1170a22d$var$_setPrototypeOf(subClass, superClass);
}
function $7868fddf1170a22d$var$_setPrototypeOf(o, p) {
    $7868fddf1170a22d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7868fddf1170a22d$var$_setPrototypeOf(o, p);
}
var $7868fddf1170a22d$var$Namespace = /*#__PURE__*/ function(_Node) {
    $7868fddf1170a22d$var$_inheritsLoose(Namespace, _Node);
    function Namespace() {
        return _Node.apply(this, arguments) || this;
    }
    var _proto = Namespace.prototype;
    _proto.qualifiedName = function qualifiedName(value) {
        if (this.namespace) return this.namespaceString + "|" + value;
        else return value;
    };
    _proto.valueToString = function valueToString() {
        return this.qualifiedName(_Node.prototype.valueToString.call(this));
    };
    $7868fddf1170a22d$var$_createClass(Namespace, [
        {
            key: "namespace",
            get: function get() {
                return this._namespace;
            },
            set: function set(namespace) {
                if (namespace === true || namespace === "*" || namespace === "&") {
                    this._namespace = namespace;
                    if (this.raws) delete this.raws.namespace;
                    return;
                }
                var escaped = (0, $7868fddf1170a22d$var$_cssesc["default"])(namespace, {
                    isIdentifier: true
                });
                this._namespace = namespace;
                if (escaped !== namespace) {
                    (0, $1CKTu.ensureObject)(this, "raws");
                    this.raws.namespace = escaped;
                } else if (this.raws) delete this.raws.namespace;
            }
        },
        {
            key: "ns",
            get: function get() {
                return this._namespace;
            },
            set: function set(namespace) {
                this.namespace = namespace;
            }
        },
        {
            key: "namespaceString",
            get: function get() {
                if (this.namespace) {
                    var ns = this.stringifyProperty("namespace");
                    if (ns === true) return "";
                    else return ns;
                } else return "";
            }
        }
    ]);
    return Namespace;
}($7868fddf1170a22d$var$_node["default"]);
module.exports["default"] = $7868fddf1170a22d$var$Namespace;
module.exports = module.exports.default;

});


parcelRegister("9Isdm", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $712e1bea63a4c2f5$var$_node = $712e1bea63a4c2f5$var$_interopRequireDefault((parcelRequire("bJ7Kk")));

var $8pBKt = parcelRequire("8pBKt");
function $712e1bea63a4c2f5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $712e1bea63a4c2f5$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $712e1bea63a4c2f5$var$_setPrototypeOf(subClass, superClass);
}
function $712e1bea63a4c2f5$var$_setPrototypeOf(o, p) {
    $712e1bea63a4c2f5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $712e1bea63a4c2f5$var$_setPrototypeOf(o, p);
}
var $712e1bea63a4c2f5$var$String = /*#__PURE__*/ function(_Node) {
    $712e1bea63a4c2f5$var$_inheritsLoose(String, _Node);
    function String(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $8pBKt.STRING;
        return _this;
    }
    return String;
}($712e1bea63a4c2f5$var$_node["default"]);
module.exports["default"] = $712e1bea63a4c2f5$var$String;
module.exports = module.exports.default;

});

parcelRegister("gNv3v", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $c3a94ff34e1d37c2$var$_container = $c3a94ff34e1d37c2$var$_interopRequireDefault((parcelRequire("fOrry")));

var $8pBKt = parcelRequire("8pBKt");
function $c3a94ff34e1d37c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c3a94ff34e1d37c2$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $c3a94ff34e1d37c2$var$_setPrototypeOf(subClass, superClass);
}
function $c3a94ff34e1d37c2$var$_setPrototypeOf(o, p) {
    $c3a94ff34e1d37c2$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c3a94ff34e1d37c2$var$_setPrototypeOf(o, p);
}
var $c3a94ff34e1d37c2$var$Pseudo = /*#__PURE__*/ function(_Container) {
    $c3a94ff34e1d37c2$var$_inheritsLoose(Pseudo, _Container);
    function Pseudo(opts) {
        var _this;
        _this = _Container.call(this, opts) || this;
        _this.type = $8pBKt.PSEUDO;
        return _this;
    }
    var _proto = Pseudo.prototype;
    _proto.toString = function toString() {
        var params = this.length ? "(" + this.map(String).join(",") + ")" : "";
        return [
            this.rawSpaceBefore,
            this.stringifyProperty("value"),
            params,
            this.rawSpaceAfter
        ].join("");
    };
    return Pseudo;
}($c3a94ff34e1d37c2$var$_container["default"]);
module.exports["default"] = $c3a94ff34e1d37c2$var$Pseudo;
module.exports = module.exports.default;

});

parcelRegister("eQ84Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $acdc2ff695b49786$export$1e511d4a378977f5; }, function (v) { return $acdc2ff695b49786$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "unescapeValue", function () { return $acdc2ff695b49786$export$1cd2dcb7d1153f00; }, function (v) { return $acdc2ff695b49786$export$1cd2dcb7d1153f00 = v; });
$parcel$export(module.exports, "default", function () { return $acdc2ff695b49786$export$2e2bcd8739ae039; }, function (v) { return $acdc2ff695b49786$export$2e2bcd8739ae039 = v; });
var $acdc2ff695b49786$export$1e511d4a378977f5;
var $acdc2ff695b49786$export$1cd2dcb7d1153f00;
var $acdc2ff695b49786$export$2e2bcd8739ae039;
"use strict";
$acdc2ff695b49786$export$1e511d4a378977f5 = true;
$acdc2ff695b49786$export$1cd2dcb7d1153f00 = $acdc2ff695b49786$var$unescapeValue;
$acdc2ff695b49786$export$2e2bcd8739ae039 = void 0;

var $acdc2ff695b49786$var$_cssesc = $acdc2ff695b49786$var$_interopRequireDefault((parcelRequire("jBlz6")));

var $acdc2ff695b49786$var$_unesc = $acdc2ff695b49786$var$_interopRequireDefault((parcelRequire("8rHtO")));

var $acdc2ff695b49786$var$_namespace = $acdc2ff695b49786$var$_interopRequireDefault((parcelRequire("akWin")));

var $8pBKt = parcelRequire("8pBKt");
var $acdc2ff695b49786$var$_CSSESC_QUOTE_OPTIONS;
function $acdc2ff695b49786$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $acdc2ff695b49786$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $acdc2ff695b49786$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $acdc2ff695b49786$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $acdc2ff695b49786$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $acdc2ff695b49786$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $acdc2ff695b49786$var$_setPrototypeOf(subClass, superClass);
}
function $acdc2ff695b49786$var$_setPrototypeOf(o, p) {
    $acdc2ff695b49786$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $acdc2ff695b49786$var$_setPrototypeOf(o, p);
}

var $gJKXK = parcelRequire("gJKXK");
var $acdc2ff695b49786$var$WRAPPED_IN_QUOTES = /^('|")([^]*)\1$/;
var $acdc2ff695b49786$var$warnOfDeprecatedValueAssignment = $gJKXK(function() {}, "Assigning an attribute a value containing characters that might need to be escaped is deprecated. Call attribute.setValue() instead.");
var $acdc2ff695b49786$var$warnOfDeprecatedQuotedAssignment = $gJKXK(function() {}, "Assigning attr.quoted is deprecated and has no effect. Assign to attr.quoteMark instead.");
var $acdc2ff695b49786$var$warnOfDeprecatedConstructor = $gJKXK(function() {}, "Constructing an Attribute selector with a value without specifying quoteMark is deprecated. Note: The value should be unescaped now.");
function $acdc2ff695b49786$var$unescapeValue(value) {
    var deprecatedUsage = false;
    var quoteMark = null;
    var unescaped = value;
    var m = unescaped.match($acdc2ff695b49786$var$WRAPPED_IN_QUOTES);
    if (m) {
        quoteMark = m[1];
        unescaped = m[2];
    }
    unescaped = (0, $acdc2ff695b49786$var$_unesc["default"])(unescaped);
    if (unescaped !== value) deprecatedUsage = true;
    return {
        deprecatedUsage: deprecatedUsage,
        unescaped: unescaped,
        quoteMark: quoteMark
    };
}
function $acdc2ff695b49786$var$handleDeprecatedContructorOpts(opts) {
    if (opts.quoteMark !== undefined) return opts;
    if (opts.value === undefined) return opts;
    $acdc2ff695b49786$var$warnOfDeprecatedConstructor();
    var _unescapeValue = $acdc2ff695b49786$var$unescapeValue(opts.value), quoteMark = _unescapeValue.quoteMark, unescaped = _unescapeValue.unescaped;
    if (!opts.raws) opts.raws = {};
    if (opts.raws.value === undefined) opts.raws.value = opts.value;
    opts.value = unescaped;
    opts.quoteMark = quoteMark;
    return opts;
}
var $acdc2ff695b49786$var$Attribute = /*#__PURE__*/ function(_Namespace) {
    $acdc2ff695b49786$var$_inheritsLoose(Attribute, _Namespace);
    function Attribute(opts) {
        var _this;
        if (opts === void 0) opts = {};
        _this = _Namespace.call(this, $acdc2ff695b49786$var$handleDeprecatedContructorOpts(opts)) || this;
        _this.type = $8pBKt.ATTRIBUTE;
        _this.raws = _this.raws || {};
        Object.defineProperty(_this.raws, "unquoted", {
            get: $gJKXK(function() {
                return _this.value;
            }, "attr.raws.unquoted is deprecated. Call attr.value instead."),
            set: $gJKXK(function() {
                return _this.value;
            }, "Setting attr.raws.unquoted is deprecated and has no effect. attr.value is unescaped by default now.")
        });
        _this._constructed = true;
        return _this;
    }
    /**
   * Returns the Attribute's value quoted such that it would be legal to use
   * in the value of a css file. The original value's quotation setting
   * used for stringification is left unchanged. See `setValue(value, options)`
   * if you want to control the quote settings of a new value for the attribute.
   *
   * You can also change the quotation used for the current value by setting quoteMark.
   *
   * Options:
   *   * quoteMark {'"' | "'" | null} - Use this value to quote the value. If this
   *     option is not set, the original value for quoteMark will be used. If
   *     indeterminate, a double quote is used. The legal values are:
   *     * `null` - the value will be unquoted and characters will be escaped as necessary.
   *     * `'` - the value will be quoted with a single quote and single quotes are escaped.
   *     * `"` - the value will be quoted with a double quote and double quotes are escaped.
   *   * preferCurrentQuoteMark {boolean} - if true, prefer the source quote mark
   *     over the quoteMark option value.
   *   * smart {boolean} - if true, will select a quote mark based on the value
   *     and the other options specified here. See the `smartQuoteMark()`
   *     method.
   **/ var _proto = Attribute.prototype;
    _proto.getQuotedValue = function getQuotedValue(options) {
        if (options === void 0) options = {};
        var quoteMark = this._determineQuoteMark(options);
        var cssescopts = $acdc2ff695b49786$var$CSSESC_QUOTE_OPTIONS[quoteMark];
        var escaped = (0, $acdc2ff695b49786$var$_cssesc["default"])(this._value, cssescopts);
        return escaped;
    };
    _proto._determineQuoteMark = function _determineQuoteMark(options) {
        return options.smart ? this.smartQuoteMark(options) : this.preferredQuoteMark(options);
    } /**
   * Set the unescaped value with the specified quotation options. The value
   * provided must not include any wrapping quote marks -- those quotes will
   * be interpreted as part of the value and escaped accordingly.
   */ ;
    _proto.setValue = function setValue(value, options) {
        if (options === void 0) options = {};
        this._value = value;
        this._quoteMark = this._determineQuoteMark(options);
        this._syncRawValue();
    } /**
   * Intelligently select a quoteMark value based on the value's contents. If
   * the value is a legal CSS ident, it will not be quoted. Otherwise a quote
   * mark will be picked that minimizes the number of escapes.
   *
   * If there's no clear winner, the quote mark from these options is used,
   * then the source quote mark (this is inverted if `preferCurrentQuoteMark` is
   * true). If the quoteMark is unspecified, a double quote is used.
   *
   * @param options This takes the quoteMark and preferCurrentQuoteMark options
   * from the quoteValue method.
   */ ;
    _proto.smartQuoteMark = function smartQuoteMark(options) {
        var v = this.value;
        var numSingleQuotes = v.replace(/[^']/g, "").length;
        var numDoubleQuotes = v.replace(/[^"]/g, "").length;
        if (numSingleQuotes + numDoubleQuotes === 0) {
            var escaped = (0, $acdc2ff695b49786$var$_cssesc["default"])(v, {
                isIdentifier: true
            });
            if (escaped === v) return Attribute.NO_QUOTE;
            else {
                var pref = this.preferredQuoteMark(options);
                if (pref === Attribute.NO_QUOTE) {
                    // pick a quote mark that isn't none and see if it's smaller
                    var quote = this.quoteMark || options.quoteMark || Attribute.DOUBLE_QUOTE;
                    var opts = $acdc2ff695b49786$var$CSSESC_QUOTE_OPTIONS[quote];
                    var quoteValue = (0, $acdc2ff695b49786$var$_cssesc["default"])(v, opts);
                    if (quoteValue.length < escaped.length) return quote;
                }
                return pref;
            }
        } else if (numDoubleQuotes === numSingleQuotes) return this.preferredQuoteMark(options);
        else if (numDoubleQuotes < numSingleQuotes) return Attribute.DOUBLE_QUOTE;
        else return Attribute.SINGLE_QUOTE;
    } /**
   * Selects the preferred quote mark based on the options and the current quote mark value.
   * If you want the quote mark to depend on the attribute value, call `smartQuoteMark(opts)`
   * instead.
   */ ;
    _proto.preferredQuoteMark = function preferredQuoteMark(options) {
        var quoteMark = options.preferCurrentQuoteMark ? this.quoteMark : options.quoteMark;
        if (quoteMark === undefined) quoteMark = options.preferCurrentQuoteMark ? options.quoteMark : this.quoteMark;
        if (quoteMark === undefined) quoteMark = Attribute.DOUBLE_QUOTE;
        return quoteMark;
    };
    _proto._syncRawValue = function _syncRawValue() {
        var rawValue = (0, $acdc2ff695b49786$var$_cssesc["default"])(this._value, $acdc2ff695b49786$var$CSSESC_QUOTE_OPTIONS[this.quoteMark]);
        if (rawValue === this._value) {
            if (this.raws) delete this.raws.value;
        } else this.raws.value = rawValue;
    };
    _proto._handleEscapes = function _handleEscapes(prop, value) {
        if (this._constructed) {
            var escaped = (0, $acdc2ff695b49786$var$_cssesc["default"])(value, {
                isIdentifier: true
            });
            if (escaped !== value) this.raws[prop] = escaped;
            else delete this.raws[prop];
        }
    };
    _proto._spacesFor = function _spacesFor(name) {
        var attrSpaces = {
            before: "",
            after: ""
        };
        var spaces = this.spaces[name] || {};
        var rawSpaces = this.raws.spaces && this.raws.spaces[name] || {};
        return Object.assign(attrSpaces, spaces, rawSpaces);
    };
    _proto._stringFor = function _stringFor(name, spaceName, concat) {
        if (spaceName === void 0) spaceName = name;
        if (concat === void 0) concat = $acdc2ff695b49786$var$defaultAttrConcat;
        var attrSpaces = this._spacesFor(spaceName);
        return concat(this.stringifyProperty(name), attrSpaces);
    } /**
   * returns the offset of the attribute part specified relative to the
   * start of the node of the output string.
   *
   * * "ns" - alias for "namespace"
   * * "namespace" - the namespace if it exists.
   * * "attribute" - the attribute name
   * * "attributeNS" - the start of the attribute or its namespace
   * * "operator" - the match operator of the attribute
   * * "value" - The value (string or identifier)
   * * "insensitive" - the case insensitivity flag;
   * @param part One of the possible values inside an attribute.
   * @returns -1 if the name is invalid or the value doesn't exist in this attribute.
   */ ;
    _proto.offsetOf = function offsetOf(name) {
        var count = 1;
        var attributeSpaces = this._spacesFor("attribute");
        count += attributeSpaces.before.length;
        if (name === "namespace" || name === "ns") return this.namespace ? count : -1;
        if (name === "attributeNS") return count;
        count += this.namespaceString.length;
        if (this.namespace) count += 1;
        if (name === "attribute") return count;
        count += this.stringifyProperty("attribute").length;
        count += attributeSpaces.after.length;
        var operatorSpaces = this._spacesFor("operator");
        count += operatorSpaces.before.length;
        var operator = this.stringifyProperty("operator");
        if (name === "operator") return operator ? count : -1;
        count += operator.length;
        count += operatorSpaces.after.length;
        var valueSpaces = this._spacesFor("value");
        count += valueSpaces.before.length;
        var value = this.stringifyProperty("value");
        if (name === "value") return value ? count : -1;
        count += value.length;
        count += valueSpaces.after.length;
        var insensitiveSpaces = this._spacesFor("insensitive");
        count += insensitiveSpaces.before.length;
        if (name === "insensitive") return this.insensitive ? count : -1;
        return -1;
    };
    _proto.toString = function toString() {
        var _this2 = this;
        var selector = [
            this.rawSpaceBefore,
            "["
        ];
        selector.push(this._stringFor("qualifiedAttribute", "attribute"));
        if (this.operator && (this.value || this.value === "")) {
            selector.push(this._stringFor("operator"));
            selector.push(this._stringFor("value"));
            selector.push(this._stringFor("insensitiveFlag", "insensitive", function(attrValue, attrSpaces) {
                if (attrValue.length > 0 && !_this2.quoted && attrSpaces.before.length === 0 && !(_this2.spaces.value && _this2.spaces.value.after)) attrSpaces.before = " ";
                return $acdc2ff695b49786$var$defaultAttrConcat(attrValue, attrSpaces);
            }));
        }
        selector.push("]");
        selector.push(this.rawSpaceAfter);
        return selector.join("");
    };
    $acdc2ff695b49786$var$_createClass(Attribute, [
        {
            key: "quoted",
            get: function get() {
                var qm = this.quoteMark;
                return qm === "'" || qm === '"';
            },
            set: function set(value) {
                $acdc2ff695b49786$var$warnOfDeprecatedQuotedAssignment();
            }
        },
        {
            key: "quoteMark",
            get: function get() {
                return this._quoteMark;
            },
            set: function set(quoteMark) {
                if (!this._constructed) {
                    this._quoteMark = quoteMark;
                    return;
                }
                if (this._quoteMark !== quoteMark) {
                    this._quoteMark = quoteMark;
                    this._syncRawValue();
                }
            }
        },
        {
            key: "qualifiedAttribute",
            get: function get() {
                return this.qualifiedName(this.raws.attribute || this.attribute);
            }
        },
        {
            key: "insensitiveFlag",
            get: function get() {
                return this.insensitive ? "i" : "";
            }
        },
        {
            key: "value",
            get: function get() {
                return this._value;
            },
            set: function set(v) {
                if (this._constructed) {
                    var _unescapeValue2 = $acdc2ff695b49786$var$unescapeValue(v), deprecatedUsage = _unescapeValue2.deprecatedUsage, unescaped = _unescapeValue2.unescaped, quoteMark = _unescapeValue2.quoteMark;
                    if (deprecatedUsage) $acdc2ff695b49786$var$warnOfDeprecatedValueAssignment();
                    if (unescaped === this._value && quoteMark === this._quoteMark) return;
                    this._value = unescaped;
                    this._quoteMark = quoteMark;
                    this._syncRawValue();
                } else this._value = v;
            }
        },
        {
            key: "attribute",
            get: function get() {
                return this._attribute;
            },
            set: function set(name) {
                this._handleEscapes("attribute", name);
                this._attribute = name;
            }
        }
    ]);
    return Attribute;
}($acdc2ff695b49786$var$_namespace["default"]);
$acdc2ff695b49786$export$2e2bcd8739ae039 = $acdc2ff695b49786$var$Attribute;
$acdc2ff695b49786$var$Attribute.NO_QUOTE = null;
$acdc2ff695b49786$var$Attribute.SINGLE_QUOTE = "'";
$acdc2ff695b49786$var$Attribute.DOUBLE_QUOTE = '"';
var $acdc2ff695b49786$var$CSSESC_QUOTE_OPTIONS = ($acdc2ff695b49786$var$_CSSESC_QUOTE_OPTIONS = {
    "'": {
        quotes: "single",
        wrap: true
    },
    '"': {
        quotes: "double",
        wrap: true
    }
}, $acdc2ff695b49786$var$_CSSESC_QUOTE_OPTIONS[null] = {
    isIdentifier: true
}, $acdc2ff695b49786$var$_CSSESC_QUOTE_OPTIONS);
function $acdc2ff695b49786$var$defaultAttrConcat(attrValue, attrSpaces) {
    return "" + attrSpaces.before + attrValue + attrSpaces.after;
}

});
parcelRegister("gJKXK", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $c2f5471fc0cf264a$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $c2f5471fc0cf264a$var$deprecate(fn, msg) {
    if ($c2f5471fc0cf264a$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($c2f5471fc0cf264a$var$config("throwDeprecation")) throw new Error(msg);
            else if ($c2f5471fc0cf264a$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $c2f5471fc0cf264a$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});


parcelRegister("bHUDw", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $885fa4ae04d8b8ff$var$_namespace = $885fa4ae04d8b8ff$var$_interopRequireDefault((parcelRequire("akWin")));

var $8pBKt = parcelRequire("8pBKt");
function $885fa4ae04d8b8ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $885fa4ae04d8b8ff$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $885fa4ae04d8b8ff$var$_setPrototypeOf(subClass, superClass);
}
function $885fa4ae04d8b8ff$var$_setPrototypeOf(o, p) {
    $885fa4ae04d8b8ff$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $885fa4ae04d8b8ff$var$_setPrototypeOf(o, p);
}
var $885fa4ae04d8b8ff$var$Universal = /*#__PURE__*/ function(_Namespace) {
    $885fa4ae04d8b8ff$var$_inheritsLoose(Universal, _Namespace);
    function Universal(opts) {
        var _this;
        _this = _Namespace.call(this, opts) || this;
        _this.type = $8pBKt.UNIVERSAL;
        _this.value = "*";
        return _this;
    }
    return Universal;
}($885fa4ae04d8b8ff$var$_namespace["default"]);
module.exports["default"] = $885fa4ae04d8b8ff$var$Universal;
module.exports = module.exports.default;

});

parcelRegister("18Vp1", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $0d5310bcda8a4fa4$var$_node = $0d5310bcda8a4fa4$var$_interopRequireDefault((parcelRequire("bJ7Kk")));

var $8pBKt = parcelRequire("8pBKt");
function $0d5310bcda8a4fa4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $0d5310bcda8a4fa4$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $0d5310bcda8a4fa4$var$_setPrototypeOf(subClass, superClass);
}
function $0d5310bcda8a4fa4$var$_setPrototypeOf(o, p) {
    $0d5310bcda8a4fa4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0d5310bcda8a4fa4$var$_setPrototypeOf(o, p);
}
var $0d5310bcda8a4fa4$var$Combinator = /*#__PURE__*/ function(_Node) {
    $0d5310bcda8a4fa4$var$_inheritsLoose(Combinator, _Node);
    function Combinator(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $8pBKt.COMBINATOR;
        return _this;
    }
    return Combinator;
}($0d5310bcda8a4fa4$var$_node["default"]);
module.exports["default"] = $0d5310bcda8a4fa4$var$Combinator;
module.exports = module.exports.default;

});

parcelRegister("6lFrk", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $49f4d957e3221222$var$_node = $49f4d957e3221222$var$_interopRequireDefault((parcelRequire("bJ7Kk")));

var $8pBKt = parcelRequire("8pBKt");
function $49f4d957e3221222$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $49f4d957e3221222$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $49f4d957e3221222$var$_setPrototypeOf(subClass, superClass);
}
function $49f4d957e3221222$var$_setPrototypeOf(o, p) {
    $49f4d957e3221222$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $49f4d957e3221222$var$_setPrototypeOf(o, p);
}
var $49f4d957e3221222$var$Nesting = /*#__PURE__*/ function(_Node) {
    $49f4d957e3221222$var$_inheritsLoose(Nesting, _Node);
    function Nesting(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $8pBKt.NESTING;
        _this.value = "&";
        return _this;
    }
    return Nesting;
}($49f4d957e3221222$var$_node["default"]);
module.exports["default"] = $49f4d957e3221222$var$Nesting;
module.exports = module.exports.default;

});

parcelRegister("5j5kG", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $3dd2dd060d60b65f$var$sortAscending;
function $3dd2dd060d60b65f$var$sortAscending(list) {
    return list.sort(function(a, b) {
        return a - b;
    });
}
module.exports = module.exports.default;

});

parcelRegister("73CIw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $5236d89abe592d98$export$1e511d4a378977f5; }, function (v) { return $5236d89abe592d98$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $5236d89abe592d98$export$2e2bcd8739ae039; }, function (v) { return $5236d89abe592d98$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "FIELDS", function () { return $5236d89abe592d98$export$e6909ad44e61103d; }, function (v) { return $5236d89abe592d98$export$e6909ad44e61103d = v; });
var $5236d89abe592d98$export$1e511d4a378977f5;
var $5236d89abe592d98$export$2e2bcd8739ae039;
var $5236d89abe592d98$export$e6909ad44e61103d;
"use strict";
$5236d89abe592d98$export$1e511d4a378977f5 = true;
$5236d89abe592d98$export$2e2bcd8739ae039 = $5236d89abe592d98$var$tokenize;
$5236d89abe592d98$export$e6909ad44e61103d = void 0;

var $5236d89abe592d98$var$t = $5236d89abe592d98$var$_interopRequireWildcard((parcelRequire("enfcP")));
var $5236d89abe592d98$var$_unescapable, $5236d89abe592d98$var$_wordDelimiters;
function $5236d89abe592d98$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $5236d89abe592d98$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $5236d89abe592d98$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $5236d89abe592d98$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $5236d89abe592d98$var$unescapable = ($5236d89abe592d98$var$_unescapable = {}, $5236d89abe592d98$var$_unescapable[$5236d89abe592d98$var$t.tab] = true, $5236d89abe592d98$var$_unescapable[$5236d89abe592d98$var$t.newline] = true, $5236d89abe592d98$var$_unescapable[$5236d89abe592d98$var$t.cr] = true, $5236d89abe592d98$var$_unescapable[$5236d89abe592d98$var$t.feed] = true, $5236d89abe592d98$var$_unescapable);
var $5236d89abe592d98$var$wordDelimiters = ($5236d89abe592d98$var$_wordDelimiters = {}, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.space] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.tab] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.newline] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.cr] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.feed] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.ampersand] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.asterisk] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.bang] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.comma] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.colon] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.semicolon] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.openParenthesis] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.closeParenthesis] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.openSquare] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.closeSquare] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.singleQuote] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.doubleQuote] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.plus] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.pipe] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.tilde] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.greaterThan] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.equals] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.dollar] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.caret] = true, $5236d89abe592d98$var$_wordDelimiters[$5236d89abe592d98$var$t.slash] = true, $5236d89abe592d98$var$_wordDelimiters);
var $5236d89abe592d98$var$hex = {};
var $5236d89abe592d98$var$hexChars = "0123456789abcdefABCDEF";
for(var $5236d89abe592d98$var$i = 0; $5236d89abe592d98$var$i < $5236d89abe592d98$var$hexChars.length; $5236d89abe592d98$var$i++)$5236d89abe592d98$var$hex[$5236d89abe592d98$var$hexChars.charCodeAt($5236d89abe592d98$var$i)] = true;
/**
 *  Returns the last index of the bar css word
 * @param {string} css The string in which the word begins
 * @param {number} start The index into the string where word's first letter occurs
 */ function $5236d89abe592d98$var$consumeWord(css, start) {
    var next = start;
    var code;
    do {
        code = css.charCodeAt(next);
        if ($5236d89abe592d98$var$wordDelimiters[code]) return next - 1;
        else if (code === $5236d89abe592d98$var$t.backslash) next = $5236d89abe592d98$var$consumeEscape(css, next) + 1;
        else // All other characters are part of the word
        next++;
    }while (next < css.length);
    return next - 1;
}
/**
 *  Returns the last index of the escape sequence
 * @param {string} css The string in which the sequence begins
 * @param {number} start The index into the string where escape character (`\`) occurs.
 */ function $5236d89abe592d98$var$consumeEscape(css, start) {
    var next = start;
    var code = css.charCodeAt(next + 1);
    if ($5236d89abe592d98$var$unescapable[code]) ;
    else if ($5236d89abe592d98$var$hex[code]) {
        var hexDigits = 0; // consume up to 6 hex chars
        do {
            next++;
            hexDigits++;
            code = css.charCodeAt(next + 1);
        }while ($5236d89abe592d98$var$hex[code] && hexDigits < 6); // if fewer than 6 hex chars, a trailing space ends the escape
        if (hexDigits < 6 && code === $5236d89abe592d98$var$t.space) next++;
    } else // the next char is part of the current word
    next++;
    return next;
}
var $5236d89abe592d98$var$FIELDS = {
    TYPE: 0,
    START_LINE: 1,
    START_COL: 2,
    END_LINE: 3,
    END_COL: 4,
    START_POS: 5,
    END_POS: 6
};
$5236d89abe592d98$export$e6909ad44e61103d = $5236d89abe592d98$var$FIELDS;
function $5236d89abe592d98$var$tokenize(input) {
    var tokens = [];
    var css = input.css.valueOf();
    var _css = css, length = _css.length;
    var offset = -1;
    var line = 1;
    var start = 0;
    var end = 0;
    var code, content, endColumn, endLine, escaped, escapePos, last, lines, next, nextLine, nextOffset, quote, tokenType;
    function unclosed(what, fix) {
        if (input.safe) {
            // fyi: this is never set to true.
            css += fix;
            next = css.length - 1;
        } else throw input.error("Unclosed " + what, line, start - offset, start);
    }
    while(start < length){
        code = css.charCodeAt(start);
        if (code === $5236d89abe592d98$var$t.newline) {
            offset = start;
            line += 1;
        }
        switch(code){
            case $5236d89abe592d98$var$t.space:
            case $5236d89abe592d98$var$t.tab:
            case $5236d89abe592d98$var$t.newline:
            case $5236d89abe592d98$var$t.cr:
            case $5236d89abe592d98$var$t.feed:
                next = start;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                    if (code === $5236d89abe592d98$var$t.newline) {
                        offset = next;
                        line += 1;
                    }
                }while (code === $5236d89abe592d98$var$t.space || code === $5236d89abe592d98$var$t.newline || code === $5236d89abe592d98$var$t.tab || code === $5236d89abe592d98$var$t.cr || code === $5236d89abe592d98$var$t.feed);
                tokenType = $5236d89abe592d98$var$t.space;
                endLine = line;
                endColumn = next - offset - 1;
                end = next;
                break;
            case $5236d89abe592d98$var$t.plus:
            case $5236d89abe592d98$var$t.greaterThan:
            case $5236d89abe592d98$var$t.tilde:
            case $5236d89abe592d98$var$t.pipe:
                next = start;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $5236d89abe592d98$var$t.plus || code === $5236d89abe592d98$var$t.greaterThan || code === $5236d89abe592d98$var$t.tilde || code === $5236d89abe592d98$var$t.pipe);
                tokenType = $5236d89abe592d98$var$t.combinator;
                endLine = line;
                endColumn = start - offset;
                end = next;
                break;
            // Consume these characters as single tokens.
            case $5236d89abe592d98$var$t.asterisk:
            case $5236d89abe592d98$var$t.ampersand:
            case $5236d89abe592d98$var$t.bang:
            case $5236d89abe592d98$var$t.comma:
            case $5236d89abe592d98$var$t.equals:
            case $5236d89abe592d98$var$t.dollar:
            case $5236d89abe592d98$var$t.caret:
            case $5236d89abe592d98$var$t.openSquare:
            case $5236d89abe592d98$var$t.closeSquare:
            case $5236d89abe592d98$var$t.colon:
            case $5236d89abe592d98$var$t.semicolon:
            case $5236d89abe592d98$var$t.openParenthesis:
            case $5236d89abe592d98$var$t.closeParenthesis:
                next = start;
                tokenType = code;
                endLine = line;
                endColumn = start - offset;
                end = next + 1;
                break;
            case $5236d89abe592d98$var$t.singleQuote:
            case $5236d89abe592d98$var$t.doubleQuote:
                quote = code === $5236d89abe592d98$var$t.singleQuote ? "'" : '"';
                next = start;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) unclosed("quote", quote);
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $5236d89abe592d98$var$t.backslash){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                tokenType = $5236d89abe592d98$var$t.str;
                endLine = line;
                endColumn = start - offset;
                end = next + 1;
                break;
            default:
                if (code === $5236d89abe592d98$var$t.slash && css.charCodeAt(start + 1) === $5236d89abe592d98$var$t.asterisk) {
                    next = css.indexOf("*/", start + 2) + 1;
                    if (next === 0) unclosed("comment", "*/");
                    content = css.slice(start, next + 1);
                    lines = content.split("\n");
                    last = lines.length - 1;
                    if (last > 0) {
                        nextLine = line + last;
                        nextOffset = next - lines[last].length;
                    } else {
                        nextLine = line;
                        nextOffset = offset;
                    }
                    tokenType = $5236d89abe592d98$var$t.comment;
                    line = nextLine;
                    endLine = nextLine;
                    endColumn = next - nextOffset;
                } else if (code === $5236d89abe592d98$var$t.slash) {
                    next = start;
                    tokenType = code;
                    endLine = line;
                    endColumn = start - offset;
                    end = next + 1;
                } else {
                    next = $5236d89abe592d98$var$consumeWord(css, start);
                    tokenType = $5236d89abe592d98$var$t.word;
                    endLine = line;
                    endColumn = next - offset;
                }
                end = next + 1;
                break;
        } // Ensure that the token structure remains consistent
        tokens.push([
            tokenType,
            line,
            start - offset,
            endLine,
            endColumn,
            start,
            end // [6] End position
        ]); // Reset offset for the next token
        if (nextOffset) {
            offset = nextOffset;
            nextOffset = null;
        }
        start = end;
    }
    return tokens;
}

});
parcelRegister("enfcP", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $a76f02412a2be87a$export$1e511d4a378977f5; }, function (v) { return $a76f02412a2be87a$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "combinator", function () { return $a76f02412a2be87a$export$bc8905068a6d4174; }, function (v) { return $a76f02412a2be87a$export$bc8905068a6d4174 = v; });
$parcel$export(module.exports, "word", function () { return $a76f02412a2be87a$export$ac351257249182a8; }, function (v) { return $a76f02412a2be87a$export$ac351257249182a8 = v; });
$parcel$export(module.exports, "comment", function () { return $a76f02412a2be87a$export$4a34f930e789283c; }, function (v) { return $a76f02412a2be87a$export$4a34f930e789283c = v; });
$parcel$export(module.exports, "str", function () { return $a76f02412a2be87a$export$42d51816ce590c93; }, function (v) { return $a76f02412a2be87a$export$42d51816ce590c93 = v; });
$parcel$export(module.exports, "tab", function () { return $a76f02412a2be87a$export$62d58b1c91e8e902; }, function (v) { return $a76f02412a2be87a$export$62d58b1c91e8e902 = v; });
$parcel$export(module.exports, "newline", function () { return $a76f02412a2be87a$export$2ddee7401a648d43; }, function (v) { return $a76f02412a2be87a$export$2ddee7401a648d43 = v; });
$parcel$export(module.exports, "feed", function () { return $a76f02412a2be87a$export$93d5e4db1316498e; }, function (v) { return $a76f02412a2be87a$export$93d5e4db1316498e = v; });
$parcel$export(module.exports, "cr", function () { return $a76f02412a2be87a$export$cbfbec548517f2b6; }, function (v) { return $a76f02412a2be87a$export$cbfbec548517f2b6 = v; });
$parcel$export(module.exports, "backslash", function () { return $a76f02412a2be87a$export$799abffcbb2717d6; }, function (v) { return $a76f02412a2be87a$export$799abffcbb2717d6 = v; });
$parcel$export(module.exports, "bang", function () { return $a76f02412a2be87a$export$87bdb54b7ea1f8e2; }, function (v) { return $a76f02412a2be87a$export$87bdb54b7ea1f8e2 = v; });
$parcel$export(module.exports, "slash", function () { return $a76f02412a2be87a$export$6882e7e72b50612e; }, function (v) { return $a76f02412a2be87a$export$6882e7e72b50612e = v; });
$parcel$export(module.exports, "doubleQuote", function () { return $a76f02412a2be87a$export$730a07918a7a7d93; }, function (v) { return $a76f02412a2be87a$export$730a07918a7a7d93 = v; });
$parcel$export(module.exports, "singleQuote", function () { return $a76f02412a2be87a$export$1909b7b8a28995a9; }, function (v) { return $a76f02412a2be87a$export$1909b7b8a28995a9 = v; });
$parcel$export(module.exports, "space", function () { return $a76f02412a2be87a$export$a941ed4b947d12f8; }, function (v) { return $a76f02412a2be87a$export$a941ed4b947d12f8 = v; });
$parcel$export(module.exports, "greaterThan", function () { return $a76f02412a2be87a$export$f517ea36c68d4644; }, function (v) { return $a76f02412a2be87a$export$f517ea36c68d4644 = v; });
$parcel$export(module.exports, "pipe", function () { return $a76f02412a2be87a$export$a4627e546088548d; }, function (v) { return $a76f02412a2be87a$export$a4627e546088548d = v; });
$parcel$export(module.exports, "equals", function () { return $a76f02412a2be87a$export$e9bab7fafb253603; }, function (v) { return $a76f02412a2be87a$export$e9bab7fafb253603 = v; });
$parcel$export(module.exports, "plus", function () { return $a76f02412a2be87a$export$f25d54de1f4102d2; }, function (v) { return $a76f02412a2be87a$export$f25d54de1f4102d2 = v; });
$parcel$export(module.exports, "caret", function () { return $a76f02412a2be87a$export$e88cb2efb12ae807; }, function (v) { return $a76f02412a2be87a$export$e88cb2efb12ae807 = v; });
$parcel$export(module.exports, "tilde", function () { return $a76f02412a2be87a$export$a611fa4b0fba35ad; }, function (v) { return $a76f02412a2be87a$export$a611fa4b0fba35ad = v; });
$parcel$export(module.exports, "dollar", function () { return $a76f02412a2be87a$export$8fe35dc8637e3206; }, function (v) { return $a76f02412a2be87a$export$8fe35dc8637e3206 = v; });
$parcel$export(module.exports, "closeSquare", function () { return $a76f02412a2be87a$export$7b6078f56cfde01c; }, function (v) { return $a76f02412a2be87a$export$7b6078f56cfde01c = v; });
$parcel$export(module.exports, "openSquare", function () { return $a76f02412a2be87a$export$9ddc23fa6328dffe; }, function (v) { return $a76f02412a2be87a$export$9ddc23fa6328dffe = v; });
$parcel$export(module.exports, "closeParenthesis", function () { return $a76f02412a2be87a$export$aa2a86779c63174c; }, function (v) { return $a76f02412a2be87a$export$aa2a86779c63174c = v; });
$parcel$export(module.exports, "openParenthesis", function () { return $a76f02412a2be87a$export$c9fe493072ea3774; }, function (v) { return $a76f02412a2be87a$export$c9fe493072ea3774 = v; });
$parcel$export(module.exports, "semicolon", function () { return $a76f02412a2be87a$export$62fa27d385e555f3; }, function (v) { return $a76f02412a2be87a$export$62fa27d385e555f3 = v; });
$parcel$export(module.exports, "colon", function () { return $a76f02412a2be87a$export$3f956a517cb1b4c7; }, function (v) { return $a76f02412a2be87a$export$3f956a517cb1b4c7 = v; });
$parcel$export(module.exports, "comma", function () { return $a76f02412a2be87a$export$55e60fd3fa53db0b; }, function (v) { return $a76f02412a2be87a$export$55e60fd3fa53db0b = v; });
$parcel$export(module.exports, "at", function () { return $a76f02412a2be87a$export$493d36ec626b6698; }, function (v) { return $a76f02412a2be87a$export$493d36ec626b6698 = v; });
$parcel$export(module.exports, "asterisk", function () { return $a76f02412a2be87a$export$c0ec2bc372804b43; }, function (v) { return $a76f02412a2be87a$export$c0ec2bc372804b43 = v; });
$parcel$export(module.exports, "ampersand", function () { return $a76f02412a2be87a$export$1014e5a0857b6a20; }, function (v) { return $a76f02412a2be87a$export$1014e5a0857b6a20 = v; });
var $a76f02412a2be87a$export$1e511d4a378977f5;
var $a76f02412a2be87a$export$bc8905068a6d4174;
var $a76f02412a2be87a$export$ac351257249182a8;
var $a76f02412a2be87a$export$4a34f930e789283c;
var $a76f02412a2be87a$export$42d51816ce590c93;
var $a76f02412a2be87a$export$62d58b1c91e8e902;
var $a76f02412a2be87a$export$2ddee7401a648d43;
var $a76f02412a2be87a$export$93d5e4db1316498e;
var $a76f02412a2be87a$export$cbfbec548517f2b6;
var $a76f02412a2be87a$export$799abffcbb2717d6;
var $a76f02412a2be87a$export$87bdb54b7ea1f8e2;
var $a76f02412a2be87a$export$6882e7e72b50612e;
var $a76f02412a2be87a$export$730a07918a7a7d93;
var $a76f02412a2be87a$export$1909b7b8a28995a9;
var $a76f02412a2be87a$export$a941ed4b947d12f8;
var $a76f02412a2be87a$export$f517ea36c68d4644;
var $a76f02412a2be87a$export$a4627e546088548d;
var $a76f02412a2be87a$export$e9bab7fafb253603;
var $a76f02412a2be87a$export$f25d54de1f4102d2;
var $a76f02412a2be87a$export$e88cb2efb12ae807;
var $a76f02412a2be87a$export$a611fa4b0fba35ad;
var $a76f02412a2be87a$export$8fe35dc8637e3206;
var $a76f02412a2be87a$export$7b6078f56cfde01c;
var $a76f02412a2be87a$export$9ddc23fa6328dffe;
var $a76f02412a2be87a$export$aa2a86779c63174c;
var $a76f02412a2be87a$export$c9fe493072ea3774;
var $a76f02412a2be87a$export$62fa27d385e555f3;
var $a76f02412a2be87a$export$3f956a517cb1b4c7;
var $a76f02412a2be87a$export$55e60fd3fa53db0b;
var $a76f02412a2be87a$export$493d36ec626b6698;
var $a76f02412a2be87a$export$c0ec2bc372804b43;
var $a76f02412a2be87a$export$1014e5a0857b6a20;
"use strict";
$a76f02412a2be87a$export$1e511d4a378977f5 = true;
$a76f02412a2be87a$export$bc8905068a6d4174 = $a76f02412a2be87a$export$ac351257249182a8 = $a76f02412a2be87a$export$4a34f930e789283c = $a76f02412a2be87a$export$42d51816ce590c93 = $a76f02412a2be87a$export$62d58b1c91e8e902 = $a76f02412a2be87a$export$2ddee7401a648d43 = $a76f02412a2be87a$export$93d5e4db1316498e = $a76f02412a2be87a$export$cbfbec548517f2b6 = $a76f02412a2be87a$export$799abffcbb2717d6 = $a76f02412a2be87a$export$87bdb54b7ea1f8e2 = $a76f02412a2be87a$export$6882e7e72b50612e = $a76f02412a2be87a$export$730a07918a7a7d93 = $a76f02412a2be87a$export$1909b7b8a28995a9 = $a76f02412a2be87a$export$a941ed4b947d12f8 = $a76f02412a2be87a$export$f517ea36c68d4644 = $a76f02412a2be87a$export$a4627e546088548d = $a76f02412a2be87a$export$e9bab7fafb253603 = $a76f02412a2be87a$export$f25d54de1f4102d2 = $a76f02412a2be87a$export$e88cb2efb12ae807 = $a76f02412a2be87a$export$a611fa4b0fba35ad = $a76f02412a2be87a$export$8fe35dc8637e3206 = $a76f02412a2be87a$export$7b6078f56cfde01c = $a76f02412a2be87a$export$9ddc23fa6328dffe = $a76f02412a2be87a$export$aa2a86779c63174c = $a76f02412a2be87a$export$c9fe493072ea3774 = $a76f02412a2be87a$export$62fa27d385e555f3 = $a76f02412a2be87a$export$3f956a517cb1b4c7 = $a76f02412a2be87a$export$55e60fd3fa53db0b = $a76f02412a2be87a$export$493d36ec626b6698 = $a76f02412a2be87a$export$c0ec2bc372804b43 = $a76f02412a2be87a$export$1014e5a0857b6a20 = void 0;
var $a76f02412a2be87a$var$ampersand = 38; // `&`.charCodeAt(0);
$a76f02412a2be87a$export$1014e5a0857b6a20 = $a76f02412a2be87a$var$ampersand;
var $a76f02412a2be87a$var$asterisk = 42; // `*`.charCodeAt(0);
$a76f02412a2be87a$export$c0ec2bc372804b43 = $a76f02412a2be87a$var$asterisk;
var $a76f02412a2be87a$var$at = 64; // `@`.charCodeAt(0);
$a76f02412a2be87a$export$493d36ec626b6698 = $a76f02412a2be87a$var$at;
var $a76f02412a2be87a$var$comma = 44; // `,`.charCodeAt(0);
$a76f02412a2be87a$export$55e60fd3fa53db0b = $a76f02412a2be87a$var$comma;
var $a76f02412a2be87a$var$colon = 58; // `:`.charCodeAt(0);
$a76f02412a2be87a$export$3f956a517cb1b4c7 = $a76f02412a2be87a$var$colon;
var $a76f02412a2be87a$var$semicolon = 59; // `;`.charCodeAt(0);
$a76f02412a2be87a$export$62fa27d385e555f3 = $a76f02412a2be87a$var$semicolon;
var $a76f02412a2be87a$var$openParenthesis = 40; // `(`.charCodeAt(0);
$a76f02412a2be87a$export$c9fe493072ea3774 = $a76f02412a2be87a$var$openParenthesis;
var $a76f02412a2be87a$var$closeParenthesis = 41; // `)`.charCodeAt(0);
$a76f02412a2be87a$export$aa2a86779c63174c = $a76f02412a2be87a$var$closeParenthesis;
var $a76f02412a2be87a$var$openSquare = 91; // `[`.charCodeAt(0);
$a76f02412a2be87a$export$9ddc23fa6328dffe = $a76f02412a2be87a$var$openSquare;
var $a76f02412a2be87a$var$closeSquare = 93; // `]`.charCodeAt(0);
$a76f02412a2be87a$export$7b6078f56cfde01c = $a76f02412a2be87a$var$closeSquare;
var $a76f02412a2be87a$var$dollar = 36; // `$`.charCodeAt(0);
$a76f02412a2be87a$export$8fe35dc8637e3206 = $a76f02412a2be87a$var$dollar;
var $a76f02412a2be87a$var$tilde = 126; // `~`.charCodeAt(0);
$a76f02412a2be87a$export$a611fa4b0fba35ad = $a76f02412a2be87a$var$tilde;
var $a76f02412a2be87a$var$caret = 94; // `^`.charCodeAt(0);
$a76f02412a2be87a$export$e88cb2efb12ae807 = $a76f02412a2be87a$var$caret;
var $a76f02412a2be87a$var$plus = 43; // `+`.charCodeAt(0);
$a76f02412a2be87a$export$f25d54de1f4102d2 = $a76f02412a2be87a$var$plus;
var $a76f02412a2be87a$var$equals = 61; // `=`.charCodeAt(0);
$a76f02412a2be87a$export$e9bab7fafb253603 = $a76f02412a2be87a$var$equals;
var $a76f02412a2be87a$var$pipe = 124; // `|`.charCodeAt(0);
$a76f02412a2be87a$export$a4627e546088548d = $a76f02412a2be87a$var$pipe;
var $a76f02412a2be87a$var$greaterThan = 62; // `>`.charCodeAt(0);
$a76f02412a2be87a$export$f517ea36c68d4644 = $a76f02412a2be87a$var$greaterThan;
var $a76f02412a2be87a$var$space = 32; // ` `.charCodeAt(0);
$a76f02412a2be87a$export$a941ed4b947d12f8 = $a76f02412a2be87a$var$space;
var $a76f02412a2be87a$var$singleQuote = 39; // `'`.charCodeAt(0);
$a76f02412a2be87a$export$1909b7b8a28995a9 = $a76f02412a2be87a$var$singleQuote;
var $a76f02412a2be87a$var$doubleQuote = 34; // `"`.charCodeAt(0);
$a76f02412a2be87a$export$730a07918a7a7d93 = $a76f02412a2be87a$var$doubleQuote;
var $a76f02412a2be87a$var$slash = 47; // `/`.charCodeAt(0);
$a76f02412a2be87a$export$6882e7e72b50612e = $a76f02412a2be87a$var$slash;
var $a76f02412a2be87a$var$bang = 33; // `!`.charCodeAt(0);
$a76f02412a2be87a$export$87bdb54b7ea1f8e2 = $a76f02412a2be87a$var$bang;
var $a76f02412a2be87a$var$backslash = 92; // '\\'.charCodeAt(0);
$a76f02412a2be87a$export$799abffcbb2717d6 = $a76f02412a2be87a$var$backslash;
var $a76f02412a2be87a$var$cr = 13; // '\r'.charCodeAt(0);
$a76f02412a2be87a$export$cbfbec548517f2b6 = $a76f02412a2be87a$var$cr;
var $a76f02412a2be87a$var$feed = 12; // '\f'.charCodeAt(0);
$a76f02412a2be87a$export$93d5e4db1316498e = $a76f02412a2be87a$var$feed;
var $a76f02412a2be87a$var$newline = 10; // '\n'.charCodeAt(0);
$a76f02412a2be87a$export$2ddee7401a648d43 = $a76f02412a2be87a$var$newline;
var $a76f02412a2be87a$var$tab = 9; // '\t'.charCodeAt(0);
// Expose aliases primarily for readability.
$a76f02412a2be87a$export$62d58b1c91e8e902 = $a76f02412a2be87a$var$tab;
var $a76f02412a2be87a$var$str = $a76f02412a2be87a$var$singleQuote; // No good single character representation!
$a76f02412a2be87a$export$42d51816ce590c93 = $a76f02412a2be87a$var$str;
var $a76f02412a2be87a$var$comment = -1;
$a76f02412a2be87a$export$4a34f930e789283c = $a76f02412a2be87a$var$comment;
var $a76f02412a2be87a$var$word = -2;
$a76f02412a2be87a$export$ac351257249182a8 = $a76f02412a2be87a$var$word;
var $a76f02412a2be87a$var$combinator = -3;
$a76f02412a2be87a$export$bc8905068a6d4174 = $a76f02412a2be87a$var$combinator;

});




parcelRegister("233S9", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $8pBKt = parcelRequire("8pBKt");
Object.keys($8pBKt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8pBKt[key]) return;
    module.exports[key] = $8pBKt[key];
});

var $6RjRC = parcelRequire("6RjRC");
Object.keys($6RjRC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6RjRC[key]) return;
    module.exports[key] = $6RjRC[key];
});

var $fYVG9 = parcelRequire("fYVG9");
Object.keys($fYVG9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fYVG9[key]) return;
    module.exports[key] = $fYVG9[key];
});

});
parcelRegister("6RjRC", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $4fe719d7fd313b42$export$1e511d4a378977f5; }, function (v) { return $4fe719d7fd313b42$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "universal", function () { return $4fe719d7fd313b42$export$253a18498b608cc0; }, function (v) { return $4fe719d7fd313b42$export$253a18498b608cc0 = v; });
$parcel$export(module.exports, "tag", function () { return $4fe719d7fd313b42$export$2b067c6666111485; }, function (v) { return $4fe719d7fd313b42$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "string", function () { return $4fe719d7fd313b42$export$22b082955e083ec3; }, function (v) { return $4fe719d7fd313b42$export$22b082955e083ec3 = v; });
$parcel$export(module.exports, "selector", function () { return $4fe719d7fd313b42$export$aea217a45095ce11; }, function (v) { return $4fe719d7fd313b42$export$aea217a45095ce11 = v; });
$parcel$export(module.exports, "root", function () { return $4fe719d7fd313b42$export$e8e78c978b129247; }, function (v) { return $4fe719d7fd313b42$export$e8e78c978b129247 = v; });
$parcel$export(module.exports, "pseudo", function () { return $4fe719d7fd313b42$export$4a40d01fa098dd92; }, function (v) { return $4fe719d7fd313b42$export$4a40d01fa098dd92 = v; });
$parcel$export(module.exports, "nesting", function () { return $4fe719d7fd313b42$export$3c4951fc6df31dde; }, function (v) { return $4fe719d7fd313b42$export$3c4951fc6df31dde = v; });
$parcel$export(module.exports, "id", function () { return $4fe719d7fd313b42$export$d560c7e4a29451c2; }, function (v) { return $4fe719d7fd313b42$export$d560c7e4a29451c2 = v; });
$parcel$export(module.exports, "comment", function () { return $4fe719d7fd313b42$export$4a34f930e789283c; }, function (v) { return $4fe719d7fd313b42$export$4a34f930e789283c = v; });
$parcel$export(module.exports, "combinator", function () { return $4fe719d7fd313b42$export$bc8905068a6d4174; }, function (v) { return $4fe719d7fd313b42$export$bc8905068a6d4174 = v; });
$parcel$export(module.exports, "className", function () { return $4fe719d7fd313b42$export$2913c0c0b5623090; }, function (v) { return $4fe719d7fd313b42$export$2913c0c0b5623090 = v; });
$parcel$export(module.exports, "attribute", function () { return $4fe719d7fd313b42$export$af4b9a83f4b00434; }, function (v) { return $4fe719d7fd313b42$export$af4b9a83f4b00434 = v; });
var $4fe719d7fd313b42$export$1e511d4a378977f5;
var $4fe719d7fd313b42$export$253a18498b608cc0;
var $4fe719d7fd313b42$export$2b067c6666111485;
var $4fe719d7fd313b42$export$22b082955e083ec3;
var $4fe719d7fd313b42$export$aea217a45095ce11;
var $4fe719d7fd313b42$export$e8e78c978b129247;
var $4fe719d7fd313b42$export$4a40d01fa098dd92;
var $4fe719d7fd313b42$export$3c4951fc6df31dde;
var $4fe719d7fd313b42$export$d560c7e4a29451c2;
var $4fe719d7fd313b42$export$4a34f930e789283c;
var $4fe719d7fd313b42$export$bc8905068a6d4174;
var $4fe719d7fd313b42$export$2913c0c0b5623090;
var $4fe719d7fd313b42$export$af4b9a83f4b00434;
"use strict";
$4fe719d7fd313b42$export$1e511d4a378977f5 = true;
$4fe719d7fd313b42$export$253a18498b608cc0 = $4fe719d7fd313b42$export$2b067c6666111485 = $4fe719d7fd313b42$export$22b082955e083ec3 = $4fe719d7fd313b42$export$aea217a45095ce11 = $4fe719d7fd313b42$export$e8e78c978b129247 = $4fe719d7fd313b42$export$4a40d01fa098dd92 = $4fe719d7fd313b42$export$3c4951fc6df31dde = $4fe719d7fd313b42$export$d560c7e4a29451c2 = $4fe719d7fd313b42$export$4a34f930e789283c = $4fe719d7fd313b42$export$bc8905068a6d4174 = $4fe719d7fd313b42$export$2913c0c0b5623090 = $4fe719d7fd313b42$export$af4b9a83f4b00434 = void 0;

var $4fe719d7fd313b42$var$_attribute = $4fe719d7fd313b42$var$_interopRequireDefault((parcelRequire("eQ84Q")));

var $4fe719d7fd313b42$var$_className = $4fe719d7fd313b42$var$_interopRequireDefault((parcelRequire("9Wgfr")));

var $4fe719d7fd313b42$var$_combinator = $4fe719d7fd313b42$var$_interopRequireDefault((parcelRequire("18Vp1")));

var $4fe719d7fd313b42$var$_comment = $4fe719d7fd313b42$var$_interopRequireDefault((parcelRequire("fZuGj")));

var $4fe719d7fd313b42$var$_id = $4fe719d7fd313b42$var$_interopRequireDefault((parcelRequire("6ue9S")));

var $4fe719d7fd313b42$var$_nesting = $4fe719d7fd313b42$var$_interopRequireDefault((parcelRequire("6lFrk")));

var $4fe719d7fd313b42$var$_pseudo = $4fe719d7fd313b42$var$_interopRequireDefault((parcelRequire("gNv3v")));

var $4fe719d7fd313b42$var$_root = $4fe719d7fd313b42$var$_interopRequireDefault((parcelRequire("kd4c2")));

var $4fe719d7fd313b42$var$_selector = $4fe719d7fd313b42$var$_interopRequireDefault((parcelRequire("9bR8u")));

var $4fe719d7fd313b42$var$_string = $4fe719d7fd313b42$var$_interopRequireDefault((parcelRequire("9Isdm")));

var $4fe719d7fd313b42$var$_tag = $4fe719d7fd313b42$var$_interopRequireDefault((parcelRequire("1S2V3")));

var $4fe719d7fd313b42$var$_universal = $4fe719d7fd313b42$var$_interopRequireDefault((parcelRequire("bHUDw")));
function $4fe719d7fd313b42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $4fe719d7fd313b42$var$attribute = function attribute(opts) {
    return new $4fe719d7fd313b42$var$_attribute["default"](opts);
};
$4fe719d7fd313b42$export$af4b9a83f4b00434 = $4fe719d7fd313b42$var$attribute;
var $4fe719d7fd313b42$var$className = function className(opts) {
    return new $4fe719d7fd313b42$var$_className["default"](opts);
};
$4fe719d7fd313b42$export$2913c0c0b5623090 = $4fe719d7fd313b42$var$className;
var $4fe719d7fd313b42$var$combinator = function combinator(opts) {
    return new $4fe719d7fd313b42$var$_combinator["default"](opts);
};
$4fe719d7fd313b42$export$bc8905068a6d4174 = $4fe719d7fd313b42$var$combinator;
var $4fe719d7fd313b42$var$comment = function comment(opts) {
    return new $4fe719d7fd313b42$var$_comment["default"](opts);
};
$4fe719d7fd313b42$export$4a34f930e789283c = $4fe719d7fd313b42$var$comment;
var $4fe719d7fd313b42$var$id = function id(opts) {
    return new $4fe719d7fd313b42$var$_id["default"](opts);
};
$4fe719d7fd313b42$export$d560c7e4a29451c2 = $4fe719d7fd313b42$var$id;
var $4fe719d7fd313b42$var$nesting = function nesting(opts) {
    return new $4fe719d7fd313b42$var$_nesting["default"](opts);
};
$4fe719d7fd313b42$export$3c4951fc6df31dde = $4fe719d7fd313b42$var$nesting;
var $4fe719d7fd313b42$var$pseudo = function pseudo(opts) {
    return new $4fe719d7fd313b42$var$_pseudo["default"](opts);
};
$4fe719d7fd313b42$export$4a40d01fa098dd92 = $4fe719d7fd313b42$var$pseudo;
var $4fe719d7fd313b42$var$root = function root(opts) {
    return new $4fe719d7fd313b42$var$_root["default"](opts);
};
$4fe719d7fd313b42$export$e8e78c978b129247 = $4fe719d7fd313b42$var$root;
var $4fe719d7fd313b42$var$selector = function selector(opts) {
    return new $4fe719d7fd313b42$var$_selector["default"](opts);
};
$4fe719d7fd313b42$export$aea217a45095ce11 = $4fe719d7fd313b42$var$selector;
var $4fe719d7fd313b42$var$string = function string(opts) {
    return new $4fe719d7fd313b42$var$_string["default"](opts);
};
$4fe719d7fd313b42$export$22b082955e083ec3 = $4fe719d7fd313b42$var$string;
var $4fe719d7fd313b42$var$tag = function tag(opts) {
    return new $4fe719d7fd313b42$var$_tag["default"](opts);
};
$4fe719d7fd313b42$export$2b067c6666111485 = $4fe719d7fd313b42$var$tag;
var $4fe719d7fd313b42$var$universal = function universal(opts) {
    return new $4fe719d7fd313b42$var$_universal["default"](opts);
};
$4fe719d7fd313b42$export$253a18498b608cc0 = $4fe719d7fd313b42$var$universal;

});

parcelRegister("fYVG9", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $ba29336b455a78dd$export$1e511d4a378977f5; }, function (v) { return $ba29336b455a78dd$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "isNode", function () { return $ba29336b455a78dd$export$8ee0fc9ee280b4ee; }, function (v) { return $ba29336b455a78dd$export$8ee0fc9ee280b4ee = v; });
$parcel$export(module.exports, "isPseudoElement", function () { return $ba29336b455a78dd$export$50c377054049744f; }, function (v) { return $ba29336b455a78dd$export$50c377054049744f = v; });
$parcel$export(module.exports, "isPseudoClass", function () { return $ba29336b455a78dd$export$4f9a537d87bfe39; }, function (v) { return $ba29336b455a78dd$export$4f9a537d87bfe39 = v; });
$parcel$export(module.exports, "isContainer", function () { return $ba29336b455a78dd$export$16f58a42b9d38aa; }, function (v) { return $ba29336b455a78dd$export$16f58a42b9d38aa = v; });
$parcel$export(module.exports, "isNamespace", function () { return $ba29336b455a78dd$export$f7be8ad7c940f0dc; }, function (v) { return $ba29336b455a78dd$export$f7be8ad7c940f0dc = v; });
$parcel$export(module.exports, "isUniversal", function () { return $ba29336b455a78dd$export$c7e5a35eb76305e; }, function (v) { return $ba29336b455a78dd$export$c7e5a35eb76305e = v; });
$parcel$export(module.exports, "isTag", function () { return $ba29336b455a78dd$export$3bf645f08efe3292; }, function (v) { return $ba29336b455a78dd$export$3bf645f08efe3292 = v; });
$parcel$export(module.exports, "isString", function () { return $ba29336b455a78dd$export$844ec244b1367d54; }, function (v) { return $ba29336b455a78dd$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "isSelector", function () { return $ba29336b455a78dd$export$faef9c3580d96b22; }, function (v) { return $ba29336b455a78dd$export$faef9c3580d96b22 = v; });
$parcel$export(module.exports, "isRoot", function () { return $ba29336b455a78dd$export$e3140dc7d0c35e48; }, function (v) { return $ba29336b455a78dd$export$e3140dc7d0c35e48 = v; });
$parcel$export(module.exports, "isPseudo", function () { return $ba29336b455a78dd$export$128e5790e44a4eef; }, function (v) { return $ba29336b455a78dd$export$128e5790e44a4eef = v; });
$parcel$export(module.exports, "isNesting", function () { return $ba29336b455a78dd$export$c0384a4fd85c6979; }, function (v) { return $ba29336b455a78dd$export$c0384a4fd85c6979 = v; });
$parcel$export(module.exports, "isIdentifier", function () { return $ba29336b455a78dd$export$8ce3792bf42f8358; }, function (v) { return $ba29336b455a78dd$export$8ce3792bf42f8358 = v; });
$parcel$export(module.exports, "isComment", function () { return $ba29336b455a78dd$export$3ab01370f5e64ac8; }, function (v) { return $ba29336b455a78dd$export$3ab01370f5e64ac8 = v; });
$parcel$export(module.exports, "isCombinator", function () { return $ba29336b455a78dd$export$d16bf37c1d7d3358; }, function (v) { return $ba29336b455a78dd$export$d16bf37c1d7d3358 = v; });
$parcel$export(module.exports, "isClassName", function () { return $ba29336b455a78dd$export$d53f3db2f43345df; }, function (v) { return $ba29336b455a78dd$export$d53f3db2f43345df = v; });
$parcel$export(module.exports, "isAttribute", function () { return $ba29336b455a78dd$export$7500d9bbb9458138; }, function (v) { return $ba29336b455a78dd$export$7500d9bbb9458138 = v; });
var $ba29336b455a78dd$export$1e511d4a378977f5;
var $ba29336b455a78dd$export$8ee0fc9ee280b4ee;
var $ba29336b455a78dd$export$50c377054049744f;
var $ba29336b455a78dd$export$4f9a537d87bfe39;
var $ba29336b455a78dd$export$16f58a42b9d38aa;
var $ba29336b455a78dd$export$f7be8ad7c940f0dc;
var $ba29336b455a78dd$export$c7e5a35eb76305e;
var $ba29336b455a78dd$export$3bf645f08efe3292;
var $ba29336b455a78dd$export$844ec244b1367d54;
var $ba29336b455a78dd$export$faef9c3580d96b22;
var $ba29336b455a78dd$export$e3140dc7d0c35e48;
var $ba29336b455a78dd$export$128e5790e44a4eef;
var $ba29336b455a78dd$export$c0384a4fd85c6979;
var $ba29336b455a78dd$export$8ce3792bf42f8358;
var $ba29336b455a78dd$export$3ab01370f5e64ac8;
var $ba29336b455a78dd$export$d16bf37c1d7d3358;
var $ba29336b455a78dd$export$d53f3db2f43345df;
var $ba29336b455a78dd$export$7500d9bbb9458138;
"use strict";
$ba29336b455a78dd$export$1e511d4a378977f5 = true;
$ba29336b455a78dd$export$8ee0fc9ee280b4ee = $ba29336b455a78dd$var$isNode;
$ba29336b455a78dd$export$50c377054049744f = $ba29336b455a78dd$var$isPseudoElement;
$ba29336b455a78dd$export$4f9a537d87bfe39 = $ba29336b455a78dd$var$isPseudoClass;
$ba29336b455a78dd$export$16f58a42b9d38aa = $ba29336b455a78dd$var$isContainer;
$ba29336b455a78dd$export$f7be8ad7c940f0dc = $ba29336b455a78dd$var$isNamespace;
$ba29336b455a78dd$export$c7e5a35eb76305e = $ba29336b455a78dd$export$3bf645f08efe3292 = $ba29336b455a78dd$export$844ec244b1367d54 = $ba29336b455a78dd$export$faef9c3580d96b22 = $ba29336b455a78dd$export$e3140dc7d0c35e48 = $ba29336b455a78dd$export$128e5790e44a4eef = $ba29336b455a78dd$export$c0384a4fd85c6979 = $ba29336b455a78dd$export$8ce3792bf42f8358 = $ba29336b455a78dd$export$3ab01370f5e64ac8 = $ba29336b455a78dd$export$d16bf37c1d7d3358 = $ba29336b455a78dd$export$d53f3db2f43345df = $ba29336b455a78dd$export$7500d9bbb9458138 = void 0;

var $8pBKt = parcelRequire("8pBKt");
var $ba29336b455a78dd$var$_IS_TYPE;
var $ba29336b455a78dd$var$IS_TYPE = ($ba29336b455a78dd$var$_IS_TYPE = {}, $ba29336b455a78dd$var$_IS_TYPE[$8pBKt.ATTRIBUTE] = true, $ba29336b455a78dd$var$_IS_TYPE[$8pBKt.CLASS] = true, $ba29336b455a78dd$var$_IS_TYPE[$8pBKt.COMBINATOR] = true, $ba29336b455a78dd$var$_IS_TYPE[$8pBKt.COMMENT] = true, $ba29336b455a78dd$var$_IS_TYPE[$8pBKt.ID] = true, $ba29336b455a78dd$var$_IS_TYPE[$8pBKt.NESTING] = true, $ba29336b455a78dd$var$_IS_TYPE[$8pBKt.PSEUDO] = true, $ba29336b455a78dd$var$_IS_TYPE[$8pBKt.ROOT] = true, $ba29336b455a78dd$var$_IS_TYPE[$8pBKt.SELECTOR] = true, $ba29336b455a78dd$var$_IS_TYPE[$8pBKt.STRING] = true, $ba29336b455a78dd$var$_IS_TYPE[$8pBKt.TAG] = true, $ba29336b455a78dd$var$_IS_TYPE[$8pBKt.UNIVERSAL] = true, $ba29336b455a78dd$var$_IS_TYPE);
function $ba29336b455a78dd$var$isNode(node) {
    return typeof node === "object" && $ba29336b455a78dd$var$IS_TYPE[node.type];
}
function $ba29336b455a78dd$var$isNodeType(type, node) {
    return $ba29336b455a78dd$var$isNode(node) && node.type === type;
}
var $ba29336b455a78dd$var$isAttribute = $ba29336b455a78dd$var$isNodeType.bind(null, $8pBKt.ATTRIBUTE);
$ba29336b455a78dd$export$7500d9bbb9458138 = $ba29336b455a78dd$var$isAttribute;
var $ba29336b455a78dd$var$isClassName = $ba29336b455a78dd$var$isNodeType.bind(null, $8pBKt.CLASS);
$ba29336b455a78dd$export$d53f3db2f43345df = $ba29336b455a78dd$var$isClassName;
var $ba29336b455a78dd$var$isCombinator = $ba29336b455a78dd$var$isNodeType.bind(null, $8pBKt.COMBINATOR);
$ba29336b455a78dd$export$d16bf37c1d7d3358 = $ba29336b455a78dd$var$isCombinator;
var $ba29336b455a78dd$var$isComment = $ba29336b455a78dd$var$isNodeType.bind(null, $8pBKt.COMMENT);
$ba29336b455a78dd$export$3ab01370f5e64ac8 = $ba29336b455a78dd$var$isComment;
var $ba29336b455a78dd$var$isIdentifier = $ba29336b455a78dd$var$isNodeType.bind(null, $8pBKt.ID);
$ba29336b455a78dd$export$8ce3792bf42f8358 = $ba29336b455a78dd$var$isIdentifier;
var $ba29336b455a78dd$var$isNesting = $ba29336b455a78dd$var$isNodeType.bind(null, $8pBKt.NESTING);
$ba29336b455a78dd$export$c0384a4fd85c6979 = $ba29336b455a78dd$var$isNesting;
var $ba29336b455a78dd$var$isPseudo = $ba29336b455a78dd$var$isNodeType.bind(null, $8pBKt.PSEUDO);
$ba29336b455a78dd$export$128e5790e44a4eef = $ba29336b455a78dd$var$isPseudo;
var $ba29336b455a78dd$var$isRoot = $ba29336b455a78dd$var$isNodeType.bind(null, $8pBKt.ROOT);
$ba29336b455a78dd$export$e3140dc7d0c35e48 = $ba29336b455a78dd$var$isRoot;
var $ba29336b455a78dd$var$isSelector = $ba29336b455a78dd$var$isNodeType.bind(null, $8pBKt.SELECTOR);
$ba29336b455a78dd$export$faef9c3580d96b22 = $ba29336b455a78dd$var$isSelector;
var $ba29336b455a78dd$var$isString = $ba29336b455a78dd$var$isNodeType.bind(null, $8pBKt.STRING);
$ba29336b455a78dd$export$844ec244b1367d54 = $ba29336b455a78dd$var$isString;
var $ba29336b455a78dd$var$isTag = $ba29336b455a78dd$var$isNodeType.bind(null, $8pBKt.TAG);
$ba29336b455a78dd$export$3bf645f08efe3292 = $ba29336b455a78dd$var$isTag;
var $ba29336b455a78dd$var$isUniversal = $ba29336b455a78dd$var$isNodeType.bind(null, $8pBKt.UNIVERSAL);
$ba29336b455a78dd$export$c7e5a35eb76305e = $ba29336b455a78dd$var$isUniversal;
function $ba29336b455a78dd$var$isPseudoElement(node) {
    return $ba29336b455a78dd$var$isPseudo(node) && node.value && (node.value.startsWith("::") || node.value.toLowerCase() === ":before" || node.value.toLowerCase() === ":after" || node.value.toLowerCase() === ":first-letter" || node.value.toLowerCase() === ":first-line");
}
function $ba29336b455a78dd$var$isPseudoClass(node) {
    return $ba29336b455a78dd$var$isPseudo(node) && !$ba29336b455a78dd$var$isPseudoElement(node);
}
function $ba29336b455a78dd$var$isContainer(node) {
    return !!($ba29336b455a78dd$var$isNode(node) && node.walk);
}
function $ba29336b455a78dd$var$isNamespace(node) {
    return $ba29336b455a78dd$var$isAttribute(node) || $ba29336b455a78dd$var$isTag(node);
}

});





parcelRegister("jQyqX", function(module, exports) {

var $dXH7e = parcelRequire("dXH7e");
const $e72d9580ef9c0b65$var$baseStyles = {
    position: "relative",
    paddingBottom: `calc(var(--tw-aspect-h) / var(--tw-aspect-w) * 100%)`
};
const $e72d9580ef9c0b65$var$childStyles = {
    position: "absolute",
    height: "100%",
    width: "100%",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0"
};
const $e72d9580ef9c0b65$var$noneComponent = {
    ".aspect-none": {
        position: "static",
        paddingBottom: "0"
    },
    ".aspect-none > *": {
        position: "static",
        height: "auto",
        width: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        left: "auto"
    }
};
const $e72d9580ef9c0b65$var$aspectRatio = $dXH7e(function({ addComponents: addComponents, matchComponents: matchComponents, theme: theme, variants: variants, e: e }) {
    const values = theme("aspectRatio");
    if (matchComponents) {
        matchComponents({
            "aspect-w": (value)=>[
                    {
                        ...$e72d9580ef9c0b65$var$baseStyles,
                        "--tw-aspect-w": value
                    },
                    {
                        "> *": $e72d9580ef9c0b65$var$childStyles
                    }
                ],
            "aspect-h": (value)=>({
                    "--tw-aspect-h": value
                })
        }, {
            values: values
        });
        addComponents($e72d9580ef9c0b65$var$noneComponent);
        return;
    }
    const baseSelectors = Object.entries(values).map(([key, value])=>{
        return `.${e(`aspect-w-${key}`)}`;
    }).join(",\n");
    const childSelectors = Object.entries(values).map(([key, value])=>{
        return `.${e(`aspect-w-${key}`)} > *`;
    }).join(",\n");
    addComponents([
        {
            [baseSelectors]: $e72d9580ef9c0b65$var$baseStyles,
            [childSelectors]: $e72d9580ef9c0b65$var$childStyles
        },
        $e72d9580ef9c0b65$var$noneComponent,
        Object.entries(values).map(([key, value])=>{
            return {
                [`.${e(`aspect-w-${key}`)}`]: {
                    "--tw-aspect-w": value
                }
            };
        }),
        Object.entries(values).map(([key, value])=>{
            return {
                [`.${e(`aspect-h-${key}`)}`]: {
                    "--tw-aspect-h": value
                }
            };
        })
    ], variants("aspectRatio"));
}, {
    theme: {
        aspectRatio: {
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13",
            14: "14",
            15: "15",
            16: "16"
        }
    },
    variants: {
        aspectRatio: [
            "responsive"
        ]
    }
});
module.exports = $e72d9580ef9c0b65$var$aspectRatio;

});


parcelRegister("4YMR3", function(module, exports) {

var $61fJz = parcelRequire("61fJz");

var $dXH7e = parcelRequire("dXH7e");

var $4IP4c = parcelRequire("4IP4c");

var $7qkdK = parcelRequire("7qkdK");
const [$3a02a98659bd9f41$var$baseFontSize, { lineHeight: $3a02a98659bd9f41$var$baseLineHeight }] = $4IP4c.fontSize.base;
const { spacing: $3a02a98659bd9f41$var$spacing, borderWidth: $3a02a98659bd9f41$var$borderWidth, borderRadius: $3a02a98659bd9f41$var$borderRadius } = $4IP4c;
function $3a02a98659bd9f41$var$resolveColor(color, opacityVariableName) {
    return color.replace("<alpha-value>", `var(${opacityVariableName}, 1)`);
}
const $3a02a98659bd9f41$var$forms = $dXH7e.withOptions(function(options = {
    strategy: undefined
}) {
    return function({ addBase: addBase, addComponents: addComponents, theme: theme }) {
        function resolveChevronColor(color, fallback) {
            let resolved = theme(color);
            if (!resolved || resolved.includes("var(")) return fallback;
            return resolved.replace("<alpha-value>", "1");
        }
        const strategy = options.strategy === undefined ? [
            "base",
            "class"
        ] : [
            options.strategy
        ];
        const rules = [
            {
                base: [
                    "[type='text']",
                    "input:where(:not([type]))",
                    "[type='email']",
                    "[type='url']",
                    "[type='password']",
                    "[type='number']",
                    "[type='date']",
                    "[type='datetime-local']",
                    "[type='month']",
                    "[type='search']",
                    "[type='tel']",
                    "[type='time']",
                    "[type='week']",
                    "[multiple]",
                    "textarea",
                    "select"
                ],
                class: [
                    ".form-input",
                    ".form-textarea",
                    ".form-select",
                    ".form-multiselect"
                ],
                styles: {
                    appearance: "none",
                    "background-color": "#fff",
                    "border-color": $3a02a98659bd9f41$var$resolveColor(theme("colors.gray.500", $7qkdK.gray[500]), "--tw-border-opacity"),
                    "border-width": $3a02a98659bd9f41$var$borderWidth["DEFAULT"],
                    "border-radius": $3a02a98659bd9f41$var$borderRadius.none,
                    "padding-top": $3a02a98659bd9f41$var$spacing[2],
                    "padding-right": $3a02a98659bd9f41$var$spacing[3],
                    "padding-bottom": $3a02a98659bd9f41$var$spacing[2],
                    "padding-left": $3a02a98659bd9f41$var$spacing[3],
                    "font-size": $3a02a98659bd9f41$var$baseFontSize,
                    "line-height": $3a02a98659bd9f41$var$baseLineHeight,
                    "--tw-shadow": "0 0 #0000",
                    "&:focus": {
                        outline: "2px solid transparent",
                        "outline-offset": "2px",
                        "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
                        "--tw-ring-offset-width": "0px",
                        "--tw-ring-offset-color": "#fff",
                        "--tw-ring-color": $3a02a98659bd9f41$var$resolveColor(theme("colors.blue.600", $7qkdK.blue[600]), "--tw-ring-opacity"),
                        "--tw-ring-offset-shadow": `var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)`,
                        "--tw-ring-shadow": `var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)`,
                        "box-shadow": `var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)`,
                        "border-color": $3a02a98659bd9f41$var$resolveColor(theme("colors.blue.600", $7qkdK.blue[600]), "--tw-border-opacity")
                    }
                }
            },
            {
                base: [
                    "input::placeholder",
                    "textarea::placeholder"
                ],
                class: [
                    ".form-input::placeholder",
                    ".form-textarea::placeholder"
                ],
                styles: {
                    color: $3a02a98659bd9f41$var$resolveColor(theme("colors.gray.500", $7qkdK.gray[500]), "--tw-text-opacity"),
                    opacity: "1"
                }
            },
            {
                base: [
                    "::-webkit-datetime-edit-fields-wrapper"
                ],
                class: [
                    ".form-input::-webkit-datetime-edit-fields-wrapper"
                ],
                styles: {
                    padding: "0"
                }
            },
            {
                // Unfortunate hack until https://bugs.webkit.org/show_bug.cgi?id=198959 is fixed.
                // This sucks because users can't change line-height with a utility on date inputs now.
                // Reference: https://github.com/twbs/bootstrap/pull/31993
                base: [
                    "::-webkit-date-and-time-value"
                ],
                class: [
                    ".form-input::-webkit-date-and-time-value"
                ],
                styles: {
                    "min-height": "1.5em"
                }
            },
            {
                // In Safari on iOS date and time inputs are centered instead of left-aligned and can't be
                // changed with `text-align` utilities on the input by default. Resetting this to `inherit`
                // makes them left-aligned by default and makes it possible to override the alignment with
                // utility classes without using an arbitrary variant to target the pseudo-elements.
                base: [
                    "::-webkit-date-and-time-value"
                ],
                class: [
                    ".form-input::-webkit-date-and-time-value"
                ],
                styles: {
                    "text-align": "inherit"
                }
            },
            {
                // In Safari on macOS date time inputs that are set to `display: block` have unexpected
                // extra bottom spacing. This can be corrected by setting the `::-webkit-datetime-edit`
                // pseudo-element to `display: inline-flex`, instead of the browser default of
                // `display: inline-block`.
                base: [
                    "::-webkit-datetime-edit"
                ],
                class: [
                    ".form-input::-webkit-datetime-edit"
                ],
                styles: {
                    display: "inline-flex"
                }
            },
            {
                // In Safari on macOS date time inputs are 4px taller than normal inputs
                // This is because there is extra padding on the datetime-edit and datetime-edit-{part}-field pseudo elements
                // See https://github.com/tailwindlabs/tailwindcss-forms/issues/95
                base: [
                    "::-webkit-datetime-edit",
                    "::-webkit-datetime-edit-year-field",
                    "::-webkit-datetime-edit-month-field",
                    "::-webkit-datetime-edit-day-field",
                    "::-webkit-datetime-edit-hour-field",
                    "::-webkit-datetime-edit-minute-field",
                    "::-webkit-datetime-edit-second-field",
                    "::-webkit-datetime-edit-millisecond-field",
                    "::-webkit-datetime-edit-meridiem-field"
                ],
                class: [
                    ".form-input::-webkit-datetime-edit",
                    ".form-input::-webkit-datetime-edit-year-field",
                    ".form-input::-webkit-datetime-edit-month-field",
                    ".form-input::-webkit-datetime-edit-day-field",
                    ".form-input::-webkit-datetime-edit-hour-field",
                    ".form-input::-webkit-datetime-edit-minute-field",
                    ".form-input::-webkit-datetime-edit-second-field",
                    ".form-input::-webkit-datetime-edit-millisecond-field",
                    ".form-input::-webkit-datetime-edit-meridiem-field"
                ],
                styles: {
                    "padding-top": 0,
                    "padding-bottom": 0
                }
            },
            {
                base: [
                    "select"
                ],
                class: [
                    ".form-select"
                ],
                styles: {
                    "background-image": `url("${$61fJz(`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path stroke="${resolveChevronColor("colors.gray.500", $7qkdK.gray[500])}" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 8l4 4 4-4"/></svg>`)}")`,
                    "background-position": `right ${$3a02a98659bd9f41$var$spacing[2]} center`,
                    "background-repeat": `no-repeat`,
                    "background-size": `1.5em 1.5em`,
                    "padding-right": $3a02a98659bd9f41$var$spacing[10],
                    "print-color-adjust": `exact`
                }
            },
            {
                base: [
                    "[multiple]",
                    '[size]:where(select:not([size="1"]))'
                ],
                class: [
                    '.form-select:where([size]:not([size="1"]))'
                ],
                styles: {
                    "background-image": "initial",
                    "background-position": "initial",
                    "background-repeat": "unset",
                    "background-size": "initial",
                    "padding-right": $3a02a98659bd9f41$var$spacing[3],
                    "print-color-adjust": "unset"
                }
            },
            {
                base: [
                    `[type='checkbox']`,
                    `[type='radio']`
                ],
                class: [
                    ".form-checkbox",
                    ".form-radio"
                ],
                styles: {
                    appearance: "none",
                    padding: "0",
                    "print-color-adjust": "exact",
                    display: "inline-block",
                    "vertical-align": "middle",
                    "background-origin": "border-box",
                    "user-select": "none",
                    "flex-shrink": "0",
                    height: $3a02a98659bd9f41$var$spacing[4],
                    width: $3a02a98659bd9f41$var$spacing[4],
                    color: $3a02a98659bd9f41$var$resolveColor(theme("colors.blue.600", $7qkdK.blue[600]), "--tw-text-opacity"),
                    "background-color": "#fff",
                    "border-color": $3a02a98659bd9f41$var$resolveColor(theme("colors.gray.500", $7qkdK.gray[500]), "--tw-border-opacity"),
                    "border-width": $3a02a98659bd9f41$var$borderWidth["DEFAULT"],
                    "--tw-shadow": "0 0 #0000"
                }
            },
            {
                base: [
                    `[type='checkbox']`
                ],
                class: [
                    ".form-checkbox"
                ],
                styles: {
                    "border-radius": $3a02a98659bd9f41$var$borderRadius["none"]
                }
            },
            {
                base: [
                    `[type='radio']`
                ],
                class: [
                    ".form-radio"
                ],
                styles: {
                    "border-radius": "100%"
                }
            },
            {
                base: [
                    `[type='checkbox']:focus`,
                    `[type='radio']:focus`
                ],
                class: [
                    ".form-checkbox:focus",
                    ".form-radio:focus"
                ],
                styles: {
                    outline: "2px solid transparent",
                    "outline-offset": "2px",
                    "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
                    "--tw-ring-offset-width": "2px",
                    "--tw-ring-offset-color": "#fff",
                    "--tw-ring-color": $3a02a98659bd9f41$var$resolveColor(theme("colors.blue.600", $7qkdK.blue[600]), "--tw-ring-opacity"),
                    "--tw-ring-offset-shadow": `var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)`,
                    "--tw-ring-shadow": `var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)`,
                    "box-shadow": `var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)`
                }
            },
            {
                base: [
                    `[type='checkbox']:checked`,
                    `[type='radio']:checked`
                ],
                class: [
                    ".form-checkbox:checked",
                    ".form-radio:checked"
                ],
                styles: {
                    "border-color": `transparent`,
                    "background-color": `currentColor`,
                    "background-size": `100% 100%`,
                    "background-position": `center`,
                    "background-repeat": `no-repeat`
                }
            },
            {
                base: [
                    `[type='checkbox']:checked`
                ],
                class: [
                    ".form-checkbox:checked"
                ],
                styles: {
                    "background-image": `url("${$61fJz(`<svg viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><path d="M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z"/></svg>`)}")`,
                    "@media (forced-colors: active) ": {
                        appearance: "auto"
                    }
                }
            },
            {
                base: [
                    `[type='radio']:checked`
                ],
                class: [
                    ".form-radio:checked"
                ],
                styles: {
                    "background-image": `url("${$61fJz(`<svg viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="3"/></svg>`)}")`,
                    "@media (forced-colors: active) ": {
                        appearance: "auto"
                    }
                }
            },
            {
                base: [
                    `[type='checkbox']:checked:hover`,
                    `[type='checkbox']:checked:focus`,
                    `[type='radio']:checked:hover`,
                    `[type='radio']:checked:focus`
                ],
                class: [
                    ".form-checkbox:checked:hover",
                    ".form-checkbox:checked:focus",
                    ".form-radio:checked:hover",
                    ".form-radio:checked:focus"
                ],
                styles: {
                    "border-color": "transparent",
                    "background-color": "currentColor"
                }
            },
            {
                base: [
                    `[type='checkbox']:indeterminate`
                ],
                class: [
                    ".form-checkbox:indeterminate"
                ],
                styles: {
                    "background-image": `url("${$61fJz(`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h8"/></svg>`)}")`,
                    "border-color": `transparent`,
                    "background-color": `currentColor`,
                    "background-size": `100% 100%`,
                    "background-position": `center`,
                    "background-repeat": `no-repeat`,
                    "@media (forced-colors: active) ": {
                        appearance: "auto"
                    }
                }
            },
            {
                base: [
                    `[type='checkbox']:indeterminate:hover`,
                    `[type='checkbox']:indeterminate:focus`
                ],
                class: [
                    ".form-checkbox:indeterminate:hover",
                    ".form-checkbox:indeterminate:focus"
                ],
                styles: {
                    "border-color": "transparent",
                    "background-color": "currentColor"
                }
            },
            {
                base: [
                    `[type='file']`
                ],
                class: null,
                styles: {
                    background: "unset",
                    "border-color": "inherit",
                    "border-width": "0",
                    "border-radius": "0",
                    padding: "0",
                    "font-size": "unset",
                    "line-height": "inherit"
                }
            },
            {
                base: [
                    `[type='file']:focus`
                ],
                class: null,
                styles: {
                    outline: [
                        `1px solid ButtonText`,
                        `1px auto -webkit-focus-ring-color`
                    ]
                }
            }
        ];
        const getStrategyRules = (strategy)=>rules.map((rule)=>{
                if (rule[strategy] === null) return null;
                return {
                    [rule[strategy]]: rule.styles
                };
            }).filter(Boolean);
        if (strategy.includes("base")) addBase(getStrategyRules("base"));
        if (strategy.includes("class")) addComponents(getStrategyRules("class"));
    };
});
module.exports = $3a02a98659bd9f41$var$forms;

});
parcelRegister("61fJz", function(module, exports) {

var $hTG6Z = parcelRequire("hTG6Z");
var $461f0a8a1901e8a3$var$REGEX = {
    whitespace: /\s+/g,
    urlHexPairs: /%[\dA-F]{2}/g,
    quotes: /"/g
};
function $461f0a8a1901e8a3$var$collapseWhitespace(str) {
    return str.trim().replace($461f0a8a1901e8a3$var$REGEX.whitespace, " ");
}
function $461f0a8a1901e8a3$var$dataURIPayload(string) {
    return encodeURIComponent(string).replace($461f0a8a1901e8a3$var$REGEX.urlHexPairs, $461f0a8a1901e8a3$var$specialHexEncode);
}
// `#` gets converted to `%23`, so quite a few CSS named colors are shorter than
// their equivalent URL-encoded hex codes.
function $461f0a8a1901e8a3$var$colorCodeToShorterNames(string) {
    Object.keys($hTG6Z).forEach(function(key) {
        if ($hTG6Z[key].test(string)) string = string.replace($hTG6Z[key], key);
    });
    return string;
}
function $461f0a8a1901e8a3$var$specialHexEncode(match) {
    switch(match){
        case "%20":
            return " ";
        case "%3D":
            return "=";
        case "%3A":
            return ":";
        case "%2F":
            return "/";
        default:
            return match.toLowerCase(); // compresses better
    }
}
function $461f0a8a1901e8a3$var$svgToTinyDataUri(svgString) {
    if (typeof svgString !== "string") throw new TypeError("Expected a string, but received " + typeof svgString);
    // Strip the Byte-Order Mark if the SVG has one
    if (svgString.charCodeAt(0) === 0xfeff) svgString = svgString.slice(1);
    var body = $461f0a8a1901e8a3$var$colorCodeToShorterNames($461f0a8a1901e8a3$var$collapseWhitespace(svgString)).replace($461f0a8a1901e8a3$var$REGEX.quotes, "'");
    return "data:image/svg+xml," + $461f0a8a1901e8a3$var$dataURIPayload(body);
}
$461f0a8a1901e8a3$var$svgToTinyDataUri.toSrcset = function toSrcset(svgString) {
    return $461f0a8a1901e8a3$var$svgToTinyDataUri(svgString).replace(/ /g, "%20");
};
module.exports = $461f0a8a1901e8a3$var$svgToTinyDataUri;

});
parcelRegister("hTG6Z", function(module, exports) {
module.exports = {
    aqua: /#00ffff(ff)?(?!\w)|#0ff(f)?(?!\w)/gi,
    azure: /#f0ffff(ff)?(?!\w)/gi,
    beige: /#f5f5dc(ff)?(?!\w)/gi,
    bisque: /#ffe4c4(ff)?(?!\w)/gi,
    black: /#000000(ff)?(?!\w)|#000(f)?(?!\w)/gi,
    blue: /#0000ff(ff)?(?!\w)|#00f(f)?(?!\w)/gi,
    brown: /#a52a2a(ff)?(?!\w)/gi,
    coral: /#ff7f50(ff)?(?!\w)/gi,
    cornsilk: /#fff8dc(ff)?(?!\w)/gi,
    crimson: /#dc143c(ff)?(?!\w)/gi,
    cyan: /#00ffff(ff)?(?!\w)|#0ff(f)?(?!\w)/gi,
    darkblue: /#00008b(ff)?(?!\w)/gi,
    darkcyan: /#008b8b(ff)?(?!\w)/gi,
    darkgrey: /#a9a9a9(ff)?(?!\w)/gi,
    darkred: /#8b0000(ff)?(?!\w)/gi,
    deeppink: /#ff1493(ff)?(?!\w)/gi,
    dimgrey: /#696969(ff)?(?!\w)/gi,
    gold: /#ffd700(ff)?(?!\w)/gi,
    green: /#008000(ff)?(?!\w)/gi,
    grey: /#808080(ff)?(?!\w)/gi,
    honeydew: /#f0fff0(ff)?(?!\w)/gi,
    hotpink: /#ff69b4(ff)?(?!\w)/gi,
    indigo: /#4b0082(ff)?(?!\w)/gi,
    ivory: /#fffff0(ff)?(?!\w)/gi,
    khaki: /#f0e68c(ff)?(?!\w)/gi,
    lavender: /#e6e6fa(ff)?(?!\w)/gi,
    lime: /#00ff00(ff)?(?!\w)|#0f0(f)?(?!\w)/gi,
    linen: /#faf0e6(ff)?(?!\w)/gi,
    maroon: /#800000(ff)?(?!\w)/gi,
    moccasin: /#ffe4b5(ff)?(?!\w)/gi,
    navy: /#000080(ff)?(?!\w)/gi,
    oldlace: /#fdf5e6(ff)?(?!\w)/gi,
    olive: /#808000(ff)?(?!\w)/gi,
    orange: /#ffa500(ff)?(?!\w)/gi,
    orchid: /#da70d6(ff)?(?!\w)/gi,
    peru: /#cd853f(ff)?(?!\w)/gi,
    pink: /#ffc0cb(ff)?(?!\w)/gi,
    plum: /#dda0dd(ff)?(?!\w)/gi,
    purple: /#800080(ff)?(?!\w)/gi,
    red: /#ff0000(ff)?(?!\w)|#f00(f)?(?!\w)/gi,
    salmon: /#fa8072(ff)?(?!\w)/gi,
    seagreen: /#2e8b57(ff)?(?!\w)/gi,
    seashell: /#fff5ee(ff)?(?!\w)/gi,
    sienna: /#a0522d(ff)?(?!\w)/gi,
    silver: /#c0c0c0(ff)?(?!\w)/gi,
    skyblue: /#87ceeb(ff)?(?!\w)/gi,
    snow: /#fffafa(ff)?(?!\w)/gi,
    tan: /#d2b48c(ff)?(?!\w)/gi,
    teal: /#008080(ff)?(?!\w)/gi,
    thistle: /#d8bfd8(ff)?(?!\w)/gi,
    tomato: /#ff6347(ff)?(?!\w)/gi,
    violet: /#ee82ee(ff)?(?!\w)/gi,
    wheat: /#f5deb3(ff)?(?!\w)/gi,
    white: /#ffffff(ff)?(?!\w)|#fff(f)?(?!\w)/gi
};

});


parcelRegister("4IP4c", function(module, exports) {

var $lxzg5 = parcelRequire("lxzg5");
module.exports = ($lxzg5.__esModule ? $lxzg5 : {
    default: $lxzg5
}).default;

});
parcelRegister("lxzg5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fae8079cd9e3ddc8$var$_default;
    }
});

var $iwdVR = parcelRequire("iwdVR");

const $fae8079cd9e3ddc8$var$_configfull = /*#__PURE__*/ $fae8079cd9e3ddc8$var$_interop_require_default((parcelRequire("4Ie2b")));
function $fae8079cd9e3ddc8$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fae8079cd9e3ddc8$var$_default = (0, $iwdVR.cloneDeep)($fae8079cd9e3ddc8$var$_configfull.default.theme);

});
parcelRegister("iwdVR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "cloneDeep", {
    enumerable: true,
    get: function() {
        return $d7b605ca508ed9f6$var$cloneDeep;
    }
});
function $d7b605ca508ed9f6$var$cloneDeep(value) {
    if (Array.isArray(value)) return value.map((child)=>$d7b605ca508ed9f6$var$cloneDeep(child));
    if (typeof value === "object" && value !== null) return Object.fromEntries(Object.entries(value).map(([k, v])=>[
            k,
            $d7b605ca508ed9f6$var$cloneDeep(v)
        ]));
    return value;
}

});

parcelRegister("4Ie2b", function(module, exports) {
module.exports = {
    content: [],
    presets: [],
    darkMode: "media",
    theme: {
        accentColor: ({ theme: theme })=>({
                ...theme("colors"),
                auto: "auto"
            }),
        animation: {
            none: "none",
            spin: "spin 1s linear infinite",
            ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
            pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
            bounce: "bounce 1s infinite"
        },
        aria: {
            busy: 'busy="true"',
            checked: 'checked="true"',
            disabled: 'disabled="true"',
            expanded: 'expanded="true"',
            hidden: 'hidden="true"',
            pressed: 'pressed="true"',
            readonly: 'readonly="true"',
            required: 'required="true"',
            selected: 'selected="true"'
        },
        aspectRatio: {
            auto: "auto",
            square: "1 / 1",
            video: "16 / 9"
        },
        backdropBlur: ({ theme: theme })=>theme("blur"),
        backdropBrightness: ({ theme: theme })=>theme("brightness"),
        backdropContrast: ({ theme: theme })=>theme("contrast"),
        backdropGrayscale: ({ theme: theme })=>theme("grayscale"),
        backdropHueRotate: ({ theme: theme })=>theme("hueRotate"),
        backdropInvert: ({ theme: theme })=>theme("invert"),
        backdropOpacity: ({ theme: theme })=>theme("opacity"),
        backdropSaturate: ({ theme: theme })=>theme("saturate"),
        backdropSepia: ({ theme: theme })=>theme("sepia"),
        backgroundColor: ({ theme: theme })=>theme("colors"),
        backgroundImage: {
            none: "none",
            "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
            "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
            "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
            "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
            "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
            "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
            "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
            "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
        },
        backgroundOpacity: ({ theme: theme })=>theme("opacity"),
        backgroundPosition: {
            bottom: "bottom",
            center: "center",
            left: "left",
            "left-bottom": "left bottom",
            "left-top": "left top",
            right: "right",
            "right-bottom": "right bottom",
            "right-top": "right top",
            top: "top"
        },
        backgroundSize: {
            auto: "auto",
            cover: "cover",
            contain: "contain"
        },
        blur: {
            0: "0",
            none: "",
            sm: "4px",
            DEFAULT: "8px",
            md: "12px",
            lg: "16px",
            xl: "24px",
            "2xl": "40px",
            "3xl": "64px"
        },
        borderColor: ({ theme: theme })=>({
                ...theme("colors"),
                DEFAULT: theme("colors.gray.200", "currentColor")
            }),
        borderOpacity: ({ theme: theme })=>theme("opacity"),
        borderRadius: {
            none: "0px",
            sm: "0.125rem",
            DEFAULT: "0.25rem",
            md: "0.375rem",
            lg: "0.5rem",
            xl: "0.75rem",
            "2xl": "1rem",
            "3xl": "1.5rem",
            full: "9999px"
        },
        borderSpacing: ({ theme: theme })=>({
                ...theme("spacing")
            }),
        borderWidth: {
            DEFAULT: "1px",
            0: "0px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        boxShadow: {
            sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
            DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
            md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
            lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
            xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
            "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
            inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
            none: "none"
        },
        boxShadowColor: ({ theme: theme })=>theme("colors"),
        brightness: {
            0: "0",
            50: ".5",
            75: ".75",
            90: ".9",
            95: ".95",
            100: "1",
            105: "1.05",
            110: "1.1",
            125: "1.25",
            150: "1.5",
            200: "2"
        },
        caretColor: ({ theme: theme })=>theme("colors"),
        colors: ({ colors: colors })=>({
                inherit: colors.inherit,
                current: colors.current,
                transparent: colors.transparent,
                black: colors.black,
                white: colors.white,
                slate: colors.slate,
                gray: colors.gray,
                zinc: colors.zinc,
                neutral: colors.neutral,
                stone: colors.stone,
                red: colors.red,
                orange: colors.orange,
                amber: colors.amber,
                yellow: colors.yellow,
                lime: colors.lime,
                green: colors.green,
                emerald: colors.emerald,
                teal: colors.teal,
                cyan: colors.cyan,
                sky: colors.sky,
                blue: colors.blue,
                indigo: colors.indigo,
                violet: colors.violet,
                purple: colors.purple,
                fuchsia: colors.fuchsia,
                pink: colors.pink,
                rose: colors.rose
            }),
        columns: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            "3xs": "16rem",
            "2xs": "18rem",
            xs: "20rem",
            sm: "24rem",
            md: "28rem",
            lg: "32rem",
            xl: "36rem",
            "2xl": "42rem",
            "3xl": "48rem",
            "4xl": "56rem",
            "5xl": "64rem",
            "6xl": "72rem",
            "7xl": "80rem"
        },
        container: {},
        content: {
            none: "none"
        },
        contrast: {
            0: "0",
            50: ".5",
            75: ".75",
            100: "1",
            125: "1.25",
            150: "1.5",
            200: "2"
        },
        cursor: {
            auto: "auto",
            default: "default",
            pointer: "pointer",
            wait: "wait",
            text: "text",
            move: "move",
            help: "help",
            "not-allowed": "not-allowed",
            none: "none",
            "context-menu": "context-menu",
            progress: "progress",
            cell: "cell",
            crosshair: "crosshair",
            "vertical-text": "vertical-text",
            alias: "alias",
            copy: "copy",
            "no-drop": "no-drop",
            grab: "grab",
            grabbing: "grabbing",
            "all-scroll": "all-scroll",
            "col-resize": "col-resize",
            "row-resize": "row-resize",
            "n-resize": "n-resize",
            "e-resize": "e-resize",
            "s-resize": "s-resize",
            "w-resize": "w-resize",
            "ne-resize": "ne-resize",
            "nw-resize": "nw-resize",
            "se-resize": "se-resize",
            "sw-resize": "sw-resize",
            "ew-resize": "ew-resize",
            "ns-resize": "ns-resize",
            "nesw-resize": "nesw-resize",
            "nwse-resize": "nwse-resize",
            "zoom-in": "zoom-in",
            "zoom-out": "zoom-out"
        },
        divideColor: ({ theme: theme })=>theme("borderColor"),
        divideOpacity: ({ theme: theme })=>theme("borderOpacity"),
        divideWidth: ({ theme: theme })=>theme("borderWidth"),
        dropShadow: {
            sm: "0 1px 1px rgb(0 0 0 / 0.05)",
            DEFAULT: [
                "0 1px 2px rgb(0 0 0 / 0.1)",
                "0 1px 1px rgb(0 0 0 / 0.06)"
            ],
            md: [
                "0 4px 3px rgb(0 0 0 / 0.07)",
                "0 2px 2px rgb(0 0 0 / 0.06)"
            ],
            lg: [
                "0 10px 8px rgb(0 0 0 / 0.04)",
                "0 4px 3px rgb(0 0 0 / 0.1)"
            ],
            xl: [
                "0 20px 13px rgb(0 0 0 / 0.03)",
                "0 8px 5px rgb(0 0 0 / 0.08)"
            ],
            "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
            none: "0 0 #0000"
        },
        fill: ({ theme: theme })=>({
                none: "none",
                ...theme("colors")
            }),
        flex: {
            1: "1 1 0%",
            auto: "1 1 auto",
            initial: "0 1 auto",
            none: "none"
        },
        flexBasis: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                "1/5": "20%",
                "2/5": "40%",
                "3/5": "60%",
                "4/5": "80%",
                "1/6": "16.666667%",
                "2/6": "33.333333%",
                "3/6": "50%",
                "4/6": "66.666667%",
                "5/6": "83.333333%",
                "1/12": "8.333333%",
                "2/12": "16.666667%",
                "3/12": "25%",
                "4/12": "33.333333%",
                "5/12": "41.666667%",
                "6/12": "50%",
                "7/12": "58.333333%",
                "8/12": "66.666667%",
                "9/12": "75%",
                "10/12": "83.333333%",
                "11/12": "91.666667%",
                full: "100%"
            }),
        flexGrow: {
            0: "0",
            DEFAULT: "1"
        },
        flexShrink: {
            0: "0",
            DEFAULT: "1"
        },
        fontFamily: {
            sans: [
                "ui-sans-serif",
                "system-ui",
                "sans-serif",
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
                '"Noto Color Emoji"'
            ],
            serif: [
                "ui-serif",
                "Georgia",
                "Cambria",
                '"Times New Roman"',
                "Times",
                "serif"
            ],
            mono: [
                "ui-monospace",
                "SFMono-Regular",
                "Menlo",
                "Monaco",
                "Consolas",
                '"Liberation Mono"',
                '"Courier New"',
                "monospace"
            ]
        },
        fontSize: {
            xs: [
                "0.75rem",
                {
                    lineHeight: "1rem"
                }
            ],
            sm: [
                "0.875rem",
                {
                    lineHeight: "1.25rem"
                }
            ],
            base: [
                "1rem",
                {
                    lineHeight: "1.5rem"
                }
            ],
            lg: [
                "1.125rem",
                {
                    lineHeight: "1.75rem"
                }
            ],
            xl: [
                "1.25rem",
                {
                    lineHeight: "1.75rem"
                }
            ],
            "2xl": [
                "1.5rem",
                {
                    lineHeight: "2rem"
                }
            ],
            "3xl": [
                "1.875rem",
                {
                    lineHeight: "2.25rem"
                }
            ],
            "4xl": [
                "2.25rem",
                {
                    lineHeight: "2.5rem"
                }
            ],
            "5xl": [
                "3rem",
                {
                    lineHeight: "1"
                }
            ],
            "6xl": [
                "3.75rem",
                {
                    lineHeight: "1"
                }
            ],
            "7xl": [
                "4.5rem",
                {
                    lineHeight: "1"
                }
            ],
            "8xl": [
                "6rem",
                {
                    lineHeight: "1"
                }
            ],
            "9xl": [
                "8rem",
                {
                    lineHeight: "1"
                }
            ]
        },
        fontWeight: {
            thin: "100",
            extralight: "200",
            light: "300",
            normal: "400",
            medium: "500",
            semibold: "600",
            bold: "700",
            extrabold: "800",
            black: "900"
        },
        gap: ({ theme: theme })=>theme("spacing"),
        gradientColorStops: ({ theme: theme })=>theme("colors"),
        gradientColorStopPositions: {
            "0%": "0%",
            "5%": "5%",
            "10%": "10%",
            "15%": "15%",
            "20%": "20%",
            "25%": "25%",
            "30%": "30%",
            "35%": "35%",
            "40%": "40%",
            "45%": "45%",
            "50%": "50%",
            "55%": "55%",
            "60%": "60%",
            "65%": "65%",
            "70%": "70%",
            "75%": "75%",
            "80%": "80%",
            "85%": "85%",
            "90%": "90%",
            "95%": "95%",
            "100%": "100%"
        },
        grayscale: {
            0: "0",
            DEFAULT: "100%"
        },
        gridAutoColumns: {
            auto: "auto",
            min: "min-content",
            max: "max-content",
            fr: "minmax(0, 1fr)"
        },
        gridAutoRows: {
            auto: "auto",
            min: "min-content",
            max: "max-content",
            fr: "minmax(0, 1fr)"
        },
        gridColumn: {
            auto: "auto",
            "span-1": "span 1 / span 1",
            "span-2": "span 2 / span 2",
            "span-3": "span 3 / span 3",
            "span-4": "span 4 / span 4",
            "span-5": "span 5 / span 5",
            "span-6": "span 6 / span 6",
            "span-7": "span 7 / span 7",
            "span-8": "span 8 / span 8",
            "span-9": "span 9 / span 9",
            "span-10": "span 10 / span 10",
            "span-11": "span 11 / span 11",
            "span-12": "span 12 / span 12",
            "span-full": "1 / -1"
        },
        gridColumnEnd: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13"
        },
        gridColumnStart: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13"
        },
        gridRow: {
            auto: "auto",
            "span-1": "span 1 / span 1",
            "span-2": "span 2 / span 2",
            "span-3": "span 3 / span 3",
            "span-4": "span 4 / span 4",
            "span-5": "span 5 / span 5",
            "span-6": "span 6 / span 6",
            "span-7": "span 7 / span 7",
            "span-8": "span 8 / span 8",
            "span-9": "span 9 / span 9",
            "span-10": "span 10 / span 10",
            "span-11": "span 11 / span 11",
            "span-12": "span 12 / span 12",
            "span-full": "1 / -1"
        },
        gridRowEnd: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13"
        },
        gridRowStart: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13"
        },
        gridTemplateColumns: {
            none: "none",
            subgrid: "subgrid",
            1: "repeat(1, minmax(0, 1fr))",
            2: "repeat(2, minmax(0, 1fr))",
            3: "repeat(3, minmax(0, 1fr))",
            4: "repeat(4, minmax(0, 1fr))",
            5: "repeat(5, minmax(0, 1fr))",
            6: "repeat(6, minmax(0, 1fr))",
            7: "repeat(7, minmax(0, 1fr))",
            8: "repeat(8, minmax(0, 1fr))",
            9: "repeat(9, minmax(0, 1fr))",
            10: "repeat(10, minmax(0, 1fr))",
            11: "repeat(11, minmax(0, 1fr))",
            12: "repeat(12, minmax(0, 1fr))"
        },
        gridTemplateRows: {
            none: "none",
            subgrid: "subgrid",
            1: "repeat(1, minmax(0, 1fr))",
            2: "repeat(2, minmax(0, 1fr))",
            3: "repeat(3, minmax(0, 1fr))",
            4: "repeat(4, minmax(0, 1fr))",
            5: "repeat(5, minmax(0, 1fr))",
            6: "repeat(6, minmax(0, 1fr))",
            7: "repeat(7, minmax(0, 1fr))",
            8: "repeat(8, minmax(0, 1fr))",
            9: "repeat(9, minmax(0, 1fr))",
            10: "repeat(10, minmax(0, 1fr))",
            11: "repeat(11, minmax(0, 1fr))",
            12: "repeat(12, minmax(0, 1fr))"
        },
        height: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                "1/5": "20%",
                "2/5": "40%",
                "3/5": "60%",
                "4/5": "80%",
                "1/6": "16.666667%",
                "2/6": "33.333333%",
                "3/6": "50%",
                "4/6": "66.666667%",
                "5/6": "83.333333%",
                full: "100%",
                screen: "100vh",
                svh: "100svh",
                lvh: "100lvh",
                dvh: "100dvh",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        hueRotate: {
            0: "0deg",
            15: "15deg",
            30: "30deg",
            60: "60deg",
            90: "90deg",
            180: "180deg"
        },
        inset: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                full: "100%"
            }),
        invert: {
            0: "0",
            DEFAULT: "100%"
        },
        keyframes: {
            spin: {
                to: {
                    transform: "rotate(360deg)"
                }
            },
            ping: {
                "75%, 100%": {
                    transform: "scale(2)",
                    opacity: "0"
                }
            },
            pulse: {
                "50%": {
                    opacity: ".5"
                }
            },
            bounce: {
                "0%, 100%": {
                    transform: "translateY(-25%)",
                    animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
                },
                "50%": {
                    transform: "none",
                    animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
                }
            }
        },
        letterSpacing: {
            tighter: "-0.05em",
            tight: "-0.025em",
            normal: "0em",
            wide: "0.025em",
            wider: "0.05em",
            widest: "0.1em"
        },
        lineHeight: {
            none: "1",
            tight: "1.25",
            snug: "1.375",
            normal: "1.5",
            relaxed: "1.625",
            loose: "2",
            3: ".75rem",
            4: "1rem",
            5: "1.25rem",
            6: "1.5rem",
            7: "1.75rem",
            8: "2rem",
            9: "2.25rem",
            10: "2.5rem"
        },
        listStyleType: {
            none: "none",
            disc: "disc",
            decimal: "decimal"
        },
        listStyleImage: {
            none: "none"
        },
        margin: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing")
            }),
        lineClamp: {
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6"
        },
        maxHeight: ({ theme: theme })=>({
                ...theme("spacing"),
                none: "none",
                full: "100%",
                screen: "100vh",
                svh: "100svh",
                lvh: "100lvh",
                dvh: "100dvh",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        maxWidth: ({ theme: theme, breakpoints: breakpoints })=>({
                ...theme("spacing"),
                none: "none",
                xs: "20rem",
                sm: "24rem",
                md: "28rem",
                lg: "32rem",
                xl: "36rem",
                "2xl": "42rem",
                "3xl": "48rem",
                "4xl": "56rem",
                "5xl": "64rem",
                "6xl": "72rem",
                "7xl": "80rem",
                full: "100%",
                min: "min-content",
                max: "max-content",
                fit: "fit-content",
                prose: "65ch",
                ...breakpoints(theme("screens"))
            }),
        minHeight: ({ theme: theme })=>({
                ...theme("spacing"),
                full: "100%",
                screen: "100vh",
                svh: "100svh",
                lvh: "100lvh",
                dvh: "100dvh",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        minWidth: ({ theme: theme })=>({
                ...theme("spacing"),
                full: "100%",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        objectPosition: {
            bottom: "bottom",
            center: "center",
            left: "left",
            "left-bottom": "left bottom",
            "left-top": "left top",
            right: "right",
            "right-bottom": "right bottom",
            "right-top": "right top",
            top: "top"
        },
        opacity: {
            0: "0",
            5: "0.05",
            10: "0.1",
            15: "0.15",
            20: "0.2",
            25: "0.25",
            30: "0.3",
            35: "0.35",
            40: "0.4",
            45: "0.45",
            50: "0.5",
            55: "0.55",
            60: "0.6",
            65: "0.65",
            70: "0.7",
            75: "0.75",
            80: "0.8",
            85: "0.85",
            90: "0.9",
            95: "0.95",
            100: "1"
        },
        order: {
            first: "-9999",
            last: "9999",
            none: "0",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12"
        },
        outlineColor: ({ theme: theme })=>theme("colors"),
        outlineOffset: {
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        outlineWidth: {
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        padding: ({ theme: theme })=>theme("spacing"),
        placeholderColor: ({ theme: theme })=>theme("colors"),
        placeholderOpacity: ({ theme: theme })=>theme("opacity"),
        ringColor: ({ theme: theme })=>({
                DEFAULT: theme("colors.blue.500", "#3b82f6"),
                ...theme("colors")
            }),
        ringOffsetColor: ({ theme: theme })=>theme("colors"),
        ringOffsetWidth: {
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        ringOpacity: ({ theme: theme })=>({
                DEFAULT: "0.5",
                ...theme("opacity")
            }),
        ringWidth: {
            DEFAULT: "3px",
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        rotate: {
            0: "0deg",
            1: "1deg",
            2: "2deg",
            3: "3deg",
            6: "6deg",
            12: "12deg",
            45: "45deg",
            90: "90deg",
            180: "180deg"
        },
        saturate: {
            0: "0",
            50: ".5",
            100: "1",
            150: "1.5",
            200: "2"
        },
        scale: {
            0: "0",
            50: ".5",
            75: ".75",
            90: ".9",
            95: ".95",
            100: "1",
            105: "1.05",
            110: "1.1",
            125: "1.25",
            150: "1.5"
        },
        screens: {
            sm: "640px",
            md: "768px",
            lg: "1024px",
            xl: "1280px",
            "2xl": "1536px"
        },
        scrollMargin: ({ theme: theme })=>({
                ...theme("spacing")
            }),
        scrollPadding: ({ theme: theme })=>theme("spacing"),
        sepia: {
            0: "0",
            DEFAULT: "100%"
        },
        skew: {
            0: "0deg",
            1: "1deg",
            2: "2deg",
            3: "3deg",
            6: "6deg",
            12: "12deg"
        },
        space: ({ theme: theme })=>({
                ...theme("spacing")
            }),
        spacing: {
            px: "1px",
            0: "0px",
            0.5: "0.125rem",
            1: "0.25rem",
            1.5: "0.375rem",
            2: "0.5rem",
            2.5: "0.625rem",
            3: "0.75rem",
            3.5: "0.875rem",
            4: "1rem",
            5: "1.25rem",
            6: "1.5rem",
            7: "1.75rem",
            8: "2rem",
            9: "2.25rem",
            10: "2.5rem",
            11: "2.75rem",
            12: "3rem",
            14: "3.5rem",
            16: "4rem",
            20: "5rem",
            24: "6rem",
            28: "7rem",
            32: "8rem",
            36: "9rem",
            40: "10rem",
            44: "11rem",
            48: "12rem",
            52: "13rem",
            56: "14rem",
            60: "15rem",
            64: "16rem",
            72: "18rem",
            80: "20rem",
            96: "24rem"
        },
        stroke: ({ theme: theme })=>({
                none: "none",
                ...theme("colors")
            }),
        strokeWidth: {
            0: "0",
            1: "1",
            2: "2"
        },
        supports: {},
        data: {},
        textColor: ({ theme: theme })=>theme("colors"),
        textDecorationColor: ({ theme: theme })=>theme("colors"),
        textDecorationThickness: {
            auto: "auto",
            "from-font": "from-font",
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        textIndent: ({ theme: theme })=>({
                ...theme("spacing")
            }),
        textOpacity: ({ theme: theme })=>theme("opacity"),
        textUnderlineOffset: {
            auto: "auto",
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        transformOrigin: {
            center: "center",
            top: "top",
            "top-right": "top right",
            right: "right",
            "bottom-right": "bottom right",
            bottom: "bottom",
            "bottom-left": "bottom left",
            left: "left",
            "top-left": "top left"
        },
        transitionDelay: {
            0: "0s",
            75: "75ms",
            100: "100ms",
            150: "150ms",
            200: "200ms",
            300: "300ms",
            500: "500ms",
            700: "700ms",
            1000: "1000ms"
        },
        transitionDuration: {
            DEFAULT: "150ms",
            0: "0s",
            75: "75ms",
            100: "100ms",
            150: "150ms",
            200: "200ms",
            300: "300ms",
            500: "500ms",
            700: "700ms",
            1000: "1000ms"
        },
        transitionProperty: {
            none: "none",
            all: "all",
            DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
            colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
            opacity: "opacity",
            shadow: "box-shadow",
            transform: "transform"
        },
        transitionTimingFunction: {
            DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
            linear: "linear",
            in: "cubic-bezier(0.4, 0, 1, 1)",
            out: "cubic-bezier(0, 0, 0.2, 1)",
            "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
        },
        translate: ({ theme: theme })=>({
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                full: "100%"
            }),
        size: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                "1/5": "20%",
                "2/5": "40%",
                "3/5": "60%",
                "4/5": "80%",
                "1/6": "16.666667%",
                "2/6": "33.333333%",
                "3/6": "50%",
                "4/6": "66.666667%",
                "5/6": "83.333333%",
                "1/12": "8.333333%",
                "2/12": "16.666667%",
                "3/12": "25%",
                "4/12": "33.333333%",
                "5/12": "41.666667%",
                "6/12": "50%",
                "7/12": "58.333333%",
                "8/12": "66.666667%",
                "9/12": "75%",
                "10/12": "83.333333%",
                "11/12": "91.666667%",
                full: "100%",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        width: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                "1/5": "20%",
                "2/5": "40%",
                "3/5": "60%",
                "4/5": "80%",
                "1/6": "16.666667%",
                "2/6": "33.333333%",
                "3/6": "50%",
                "4/6": "66.666667%",
                "5/6": "83.333333%",
                "1/12": "8.333333%",
                "2/12": "16.666667%",
                "3/12": "25%",
                "4/12": "33.333333%",
                "5/12": "41.666667%",
                "6/12": "50%",
                "7/12": "58.333333%",
                "8/12": "66.666667%",
                "9/12": "75%",
                "10/12": "83.333333%",
                "11/12": "91.666667%",
                full: "100%",
                screen: "100vw",
                svw: "100svw",
                lvw: "100lvw",
                dvw: "100dvw",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        willChange: {
            auto: "auto",
            scroll: "scroll-position",
            contents: "contents",
            transform: "transform"
        },
        zIndex: {
            auto: "auto",
            0: "0",
            10: "10",
            20: "20",
            30: "30",
            40: "40",
            50: "50"
        }
    },
    plugins: []
};

});




parcelRegister("gcDGr", function(module, exports) {
/* eslint-disable @typescript-eslint/no-var-requires */ 
var $61fJz = parcelRequire("61fJz");

var $dXH7e = parcelRequire("dXH7e");

var $4IP4c = parcelRequire("4IP4c");

var $7qkdK = parcelRequire("7qkdK");
const [$bcbc8cac92a2c70a$var$baseFontSize, { lineHeight: $bcbc8cac92a2c70a$var$baseLineHeight }] = $4IP4c.fontSize.base;
const { spacing: $bcbc8cac92a2c70a$var$spacing, borderWidth: $bcbc8cac92a2c70a$var$borderWidth, borderRadius: $bcbc8cac92a2c70a$var$borderRadius, boxShadow: $bcbc8cac92a2c70a$var$boxShadow } = $4IP4c;
module.exports = $dXH7e.withOptions(function(options = {}) {
    // Enable forms and tooltip by default if not specified in options
    const { charts: charts = false, forms: forms = true, tooltips: tooltips = true } = options;
    return function({ addBase: addBase, addComponents: addComponents, theme: theme }) {
        // tooltip and popover styles
        if (tooltips) addBase({
            // remove from v2.x+ END
            [[
                ".tooltip-arrow",
                ".tooltip-arrow:before"
            ]]: {
                position: "absolute",
                width: "8px",
                height: "8px",
                background: "inherit"
            },
            [[
                ".tooltip-arrow"
            ]]: {
                visibility: "hidden"
            },
            [[
                ".tooltip-arrow:before"
            ]]: {
                content: '""',
                visibility: "visible",
                transform: "rotate(45deg)"
            },
            [`[data-tooltip-style^='light'] + .tooltip > .tooltip-arrow:before`]: {
                "border-style": "solid",
                "border-color": $7qkdK.gray[200]
            },
            [`[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='top'] > .tooltip-arrow:before`]: {
                "border-bottom-width": "1px",
                "border-right-width": "1px"
            },
            [`[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='right'] > .tooltip-arrow:before`]: {
                "border-bottom-width": "1px",
                "border-left-width": "1px"
            },
            [`[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='bottom'] > .tooltip-arrow:before`]: {
                "border-top-width": "1px",
                "border-left-width": "1px"
            },
            [`[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='left'] > .tooltip-arrow:before`]: {
                "border-top-width": "1px",
                "border-right-width": "1px"
            },
            [`.tooltip[data-popper-placement^='top'] > .tooltip-arrow`]: {
                bottom: "-4px"
            },
            [`.tooltip[data-popper-placement^='bottom'] > .tooltip-arrow`]: {
                top: "-4px"
            },
            [`.tooltip[data-popper-placement^='left'] > .tooltip-arrow`]: {
                right: "-4px"
            },
            [`.tooltip[data-popper-placement^='right'] > .tooltip-arrow`]: {
                left: "-4px"
            },
            [".tooltip.invisible > .tooltip-arrow:before"]: {
                visibility: "hidden"
            },
            [[
                "[data-popper-arrow]",
                "[data-popper-arrow]:before"
            ]]: {
                position: "absolute",
                width: "8px",
                height: "8px",
                background: "inherit"
            },
            ["[data-popper-arrow]"]: {
                visibility: "hidden"
            },
            ["[data-popper-arrow]:before"]: {
                content: '""',
                visibility: "visible",
                transform: "rotate(45deg)"
            },
            ["[data-popper-arrow]:after"]: {
                content: '""',
                visibility: "visible",
                transform: "rotate(45deg)",
                position: "absolute",
                width: "9px",
                height: "9px",
                background: "inherit"
            },
            [`[role="tooltip"] > [data-popper-arrow]:before`]: {
                "border-style": "solid",
                "border-color": $7qkdK.gray[200]
            },
            [`.dark [role="tooltip"] > [data-popper-arrow]:before`]: {
                "border-style": "solid",
                "border-color": $7qkdK.gray[600]
            },
            [`[role="tooltip"] > [data-popper-arrow]:after`]: {
                "border-style": "solid",
                "border-color": $7qkdK.gray[200]
            },
            [`.dark [role="tooltip"] > [data-popper-arrow]:after`]: {
                "border-style": "solid",
                "border-color": $7qkdK.gray[600]
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]:before`]: {
                "border-bottom-width": "1px",
                "border-right-width": "1px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]:after`]: {
                "border-bottom-width": "1px",
                "border-right-width": "1px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]:before`]: {
                "border-bottom-width": "1px",
                "border-left-width": "1px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]:after`]: {
                "border-bottom-width": "1px",
                "border-left-width": "1px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]:before`]: {
                "border-top-width": "1px",
                "border-left-width": "1px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]:after`]: {
                "border-top-width": "1px",
                "border-left-width": "1px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]:before`]: {
                "border-top-width": "1px",
                "border-right-width": "1px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]:after`]: {
                "border-top-width": "1px",
                "border-right-width": "1px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]`]: {
                bottom: "-5px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]`]: {
                top: "-5px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]`]: {
                right: "-5px"
            },
            [`[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]`]: {
                left: "-5px"
            },
            ['[role="tooltip"].invisible > [data-popper-arrow]:before']: {
                visibility: "hidden"
            },
            ['[role="tooltip"].invisible > [data-popper-arrow]:after']: {
                visibility: "hidden"
            }
        });
        // form styles
        if (forms) addBase({
            [[
                "[type='text']",
                "[type='email']",
                "[type='url']",
                "[type='password']",
                "[type='number']",
                "[type='date']",
                "[type='datetime-local']",
                "[type='month']",
                "[type='search']",
                "[type='tel']",
                "[type='time']",
                "[type='week']",
                "[multiple]",
                "textarea",
                "select"
            ]]: {
                appearance: "none",
                "background-color": "#fff",
                "border-color": theme("colors.gray.500", $7qkdK.gray[500]),
                "border-width": $bcbc8cac92a2c70a$var$borderWidth["DEFAULT"],
                "border-radius": $bcbc8cac92a2c70a$var$borderRadius.none,
                "padding-top": $bcbc8cac92a2c70a$var$spacing[2],
                "padding-right": $bcbc8cac92a2c70a$var$spacing[3],
                "padding-bottom": $bcbc8cac92a2c70a$var$spacing[2],
                "padding-left": $bcbc8cac92a2c70a$var$spacing[3],
                "font-size": $bcbc8cac92a2c70a$var$baseFontSize,
                "line-height": $bcbc8cac92a2c70a$var$baseLineHeight,
                "--tw-shadow": "0 0 #0000",
                "&:focus": {
                    outline: "2px solid transparent",
                    "outline-offset": "2px",
                    "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
                    "--tw-ring-offset-width": "0px",
                    "--tw-ring-offset-color": "#fff",
                    "--tw-ring-color": theme("colors.blue.600", $7qkdK.blue[600]),
                    "--tw-ring-offset-shadow": `var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)`,
                    "--tw-ring-shadow": `var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)`,
                    "box-shadow": `var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)`,
                    "border-color": theme("colors.blue.600", $7qkdK.blue[600])
                }
            },
            [[
                "input::placeholder",
                "textarea::placeholder"
            ]]: {
                color: theme("colors.gray.500", $7qkdK.gray[500]),
                opacity: "1"
            },
            ["::-webkit-datetime-edit-fields-wrapper"]: {
                padding: "0"
            },
            ["::-webkit-date-and-time-value"]: {
                "min-height": "1.5em"
            },
            ["select:not([size])"]: {
                "background-image": `url("${$61fJz(`<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                            <path stroke="${theme("colors.gray.500", $7qkdK.gray[500])}" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
                          </svg>`)}")`,
                "background-position": `right ${$bcbc8cac92a2c70a$var$spacing[3]} center`,
                "background-repeat": `no-repeat`,
                "background-size": `0.75em 0.75em`,
                "padding-right": $bcbc8cac92a2c70a$var$spacing[10],
                "print-color-adjust": `exact`
            },
            ["[multiple]"]: {
                "background-image": "initial",
                "background-position": "initial",
                "background-repeat": "unset",
                "background-size": "initial",
                "padding-right": $bcbc8cac92a2c70a$var$spacing[3],
                "print-color-adjust": "unset"
            },
            [[
                `[type='checkbox']`,
                `[type='radio']`
            ]]: {
                appearance: "none",
                padding: "0",
                "print-color-adjust": "exact",
                display: "inline-block",
                "vertical-align": "middle",
                "background-origin": "border-box",
                "user-select": "none",
                "flex-shrink": "0",
                height: $bcbc8cac92a2c70a$var$spacing[4],
                width: $bcbc8cac92a2c70a$var$spacing[4],
                color: theme("colors.blue.600", $7qkdK.blue[600]),
                "background-color": "#fff",
                "border-color": theme("colors.gray.500", $7qkdK.gray[500]),
                "border-width": $bcbc8cac92a2c70a$var$borderWidth["DEFAULT"],
                "--tw-shadow": "0 0 #0000"
            },
            [`[type='checkbox']`]: {
                "border-radius": $bcbc8cac92a2c70a$var$borderRadius["none"]
            },
            [`[type='radio']`]: {
                "border-radius": "100%"
            },
            [[
                `[type='checkbox']:focus`,
                `[type='radio']:focus`
            ]]: {
                outline: "2px solid transparent",
                "outline-offset": "2px",
                "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
                "--tw-ring-offset-width": "2px",
                "--tw-ring-offset-color": "#fff",
                "--tw-ring-color": theme("colors.blue.600", $7qkdK.blue[600]),
                "--tw-ring-offset-shadow": `var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)`,
                "--tw-ring-shadow": `var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)`,
                "box-shadow": `var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)`
            },
            [[
                `[type='checkbox']:checked`,
                `[type='radio']:checked`,
                `.dark [type='checkbox']:checked`,
                `.dark [type='radio']:checked`
            ]]: {
                "border-color": `transparent`,
                "background-color": `currentColor`,
                "background-size": `0.55em 0.55em`,
                "background-position": `center`,
                "background-repeat": `no-repeat`
            },
            [`[type='checkbox']:checked`]: {
                "background-image": `url("${$61fJz(`<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
                                <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M1 5.917 5.724 10.5 15 1.5"/>
                            </svg>`)}")`,
                "background-repeat": `no-repeat`,
                "background-size": `0.55em 0.55em`,
                "print-color-adjust": `exact`
            },
            [`[type='radio']:checked`]: {
                "background-image": `url("${$61fJz(`<svg viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="3"/></svg>`)}")`,
                "background-size": `1em 1em`
            },
            [`.dark [type='radio']:checked`]: {
                "background-image": `url("${$61fJz(`<svg viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="3"/></svg>`)}")`,
                "background-size": `1em 1em`
            },
            [`[type='checkbox']:indeterminate`]: {
                "background-image": `url("${$61fJz(`<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
                            <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M1 5.917 5.724 10.5 15 1.5"/>
                            </svg>`)}")`,
                "background-color": `currentColor`,
                "border-color": `transparent`,
                "background-position": `center`,
                "background-repeat": `no-repeat`,
                "background-size": `0.55em 0.55em`,
                "print-color-adjust": `exact`
            },
            [[
                `[type='checkbox']:indeterminate:hover`,
                `[type='checkbox']:indeterminate:focus`
            ]]: {
                "border-color": "transparent",
                "background-color": "currentColor"
            },
            [`[type='file']`]: {
                background: "unset",
                "border-color": "inherit",
                "border-width": "0",
                "border-radius": "0",
                padding: "0",
                "font-size": "unset",
                "line-height": "inherit"
            },
            [`[type='file']:focus`]: {
                outline: `1px auto inherit`
            },
            [[
                `input[type=file]::file-selector-button`
            ]]: {
                color: "white",
                background: theme("colors.gray.800", $7qkdK.gray[800]),
                border: 0,
                "font-weight": theme("fontWeight.medium"),
                "font-size": theme("fontSize.sm"),
                cursor: "pointer",
                "padding-top": $bcbc8cac92a2c70a$var$spacing[2.5],
                "padding-bottom": $bcbc8cac92a2c70a$var$spacing[2.5],
                "padding-left": $bcbc8cac92a2c70a$var$spacing[8],
                "padding-right": $bcbc8cac92a2c70a$var$spacing[4],
                "margin-inline-start": "-1rem",
                "margin-inline-end": "1rem",
                "&:hover": {
                    background: theme("colors.gray.700", $7qkdK.gray[700])
                }
            },
            [[
                `.dark input[type=file]::file-selector-button`
            ]]: {
                color: "white",
                background: theme("colors.gray.600", $7qkdK.gray[600]),
                "&:hover": {
                    background: theme("colors.gray.500", $7qkdK.gray[500])
                }
            },
            [[
                `input[type="range"]::-webkit-slider-thumb`
            ]]: {
                height: $bcbc8cac92a2c70a$var$spacing[5],
                width: $bcbc8cac92a2c70a$var$spacing[5],
                background: theme("colors.blue.600", $7qkdK.blue[600]),
                "border-radius": $bcbc8cac92a2c70a$var$borderRadius.full,
                border: 0,
                appearance: "none",
                "-moz-appearance": "none",
                "-webkit-appearance": "none",
                cursor: "pointer"
            },
            [[
                `input[type="range"]:disabled::-webkit-slider-thumb`
            ]]: {
                background: theme("colors.gray.400", $7qkdK.gray[400])
            },
            [[
                `.dark input[type="range"]:disabled::-webkit-slider-thumb`
            ]]: {
                background: theme("colors.gray.500", $7qkdK.gray[500])
            },
            [[
                `input[type="range"]:focus::-webkit-slider-thumb`
            ]]: {
                outline: "2px solid transparent",
                "outline-offset": "2px",
                "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
                "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
                "box-shadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
                "--tw-ring-opacity": 1,
                "--tw-ring-color": "rgb(164 202 254 / var(--tw-ring-opacity))"
            },
            [[
                `input[type="range"]::-moz-range-thumb`
            ]]: {
                height: $bcbc8cac92a2c70a$var$spacing[5],
                width: $bcbc8cac92a2c70a$var$spacing[5],
                background: theme("colors.blue.600", $7qkdK.blue[600]),
                "border-radius": $bcbc8cac92a2c70a$var$borderRadius.full,
                border: 0,
                appearance: "none",
                "-moz-appearance": "none",
                "-webkit-appearance": "none",
                cursor: "pointer"
            },
            [[
                `input[type="range"]:disabled::-moz-range-thumb`
            ]]: {
                background: theme("colors.gray.400", $7qkdK.gray[400])
            },
            [[
                `.dark input[type="range"]:disabled::-moz-range-thumb`
            ]]: {
                background: theme("colors.gray.500", $7qkdK.gray[500])
            },
            [[
                `input[type="range"]::-moz-range-progress`
            ]]: {
                background: theme("colors.blue.500", $7qkdK.blue[500])
            },
            [[
                `input[type="range"]::-ms-fill-lower`
            ]]: {
                background: theme("colors.blue.500", $7qkdK.blue[500])
            },
            [[
                `input[type="range"].range-sm::-webkit-slider-thumb`
            ]]: {
                height: $bcbc8cac92a2c70a$var$spacing[4],
                width: $bcbc8cac92a2c70a$var$spacing[4]
            },
            [[
                `input[type="range"].range-lg::-webkit-slider-thumb`
            ]]: {
                height: $bcbc8cac92a2c70a$var$spacing[6],
                width: $bcbc8cac92a2c70a$var$spacing[6]
            },
            [[
                `input[type="range"].range-sm::-moz-range-thumb`
            ]]: {
                height: $bcbc8cac92a2c70a$var$spacing[4],
                width: $bcbc8cac92a2c70a$var$spacing[4]
            },
            [[
                `input[type="range"].range-lg::-moz-range-thumb`
            ]]: {
                height: $bcbc8cac92a2c70a$var$spacing[6],
                width: $bcbc8cac92a2c70a$var$spacing[6]
            },
            // remove from v2.x+
            [[
                ".toggle-bg:after"
            ]]: {
                content: '""',
                position: "absolute",
                top: $bcbc8cac92a2c70a$var$spacing[0.5],
                left: $bcbc8cac92a2c70a$var$spacing[0.5],
                background: "white",
                "border-color": theme("colors.gray.300", $7qkdK.gray[300]),
                "border-width": $bcbc8cac92a2c70a$var$borderWidth["DEFAULT"],
                "border-radius": $bcbc8cac92a2c70a$var$borderRadius.full,
                height: theme("height.5"),
                width: theme("width.5"),
                "transition-property": "background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter",
                "transition-duration": ".15s",
                "box-shadow": "var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color)"
            },
            [[
                "input:checked + .toggle-bg:after"
            ]]: {
                transform: "translateX(100%);",
                "border-color": "white"
            },
            [[
                "input:checked + .toggle-bg"
            ]]: {
                background: theme("colors.blue.600", $7qkdK.gray[600]),
                "border-color": theme("colors.blue.600", $7qkdK.gray[600])
            }
        });
        // chart styles
        if (charts) addComponents({
            ".apexcharts-canvas .apexcharts-tooltip": {
                backgroundColor: "white",
                color: `${theme("colors.gray.500", $7qkdK.gray[500])}`,
                border: "0 !important",
                borderRadius: `${theme("borderRadius.DEFAULT", $bcbc8cac92a2c70a$var$borderRadius.DEFAULT)}`,
                // padding: `${theme('spacing.3', spacing[3])}`,
                boxShadow: `${theme("boxShadow.md", $bcbc8cac92a2c70a$var$boxShadow.md)}`
            },
            ".dark .apexcharts-canvas .apexcharts-tooltip": {
                backgroundColor: `${theme("colors.gray.700", $7qkdK.gray[700])}`,
                color: `${theme("colors.gray.400", $7qkdK.gray[400])}`,
                borderColor: "transparent",
                boxShadow: `${theme("boxShadow.md", $bcbc8cac92a2c70a$var$boxShadow.md)}`
            },
            ".apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title": {
                paddingTop: `${theme("spacing.2", $bcbc8cac92a2c70a$var$spacing[2])}`,
                paddingBottom: `${theme("spacing.2", $bcbc8cac92a2c70a$var$spacing[2])}`,
                paddingRight: `${theme("spacing.3", $bcbc8cac92a2c70a$var$spacing[3])}`,
                paddingLeft: `${theme("spacing.3", $bcbc8cac92a2c70a$var$spacing[3])}`,
                marginBottom: `${theme("spacing.3", $bcbc8cac92a2c70a$var$spacing[3])}`,
                backgroundColor: `${theme("colors.gray.100", $7qkdK.gray[100])}`,
                borderBottomColor: `${theme("colors.gray.200", $7qkdK.gray[200])}`,
                fontSize: `${theme("fontSize.sm", $4IP4c.fontSize.sm)} !important`,
                fontWeight: `${theme("fontWeight.normal", $4IP4c.fontWeight.normal)}`,
                color: `${theme("colors.gray.500", $7qkdK.gray[500])}`
            },
            ".dark .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title": {
                backgroundColor: `${theme("colors.gray.600", $7qkdK.gray[600])}`,
                borderColor: `${theme("colors.gray.500", $7qkdK.gray[500])}`,
                color: `${theme("colors.gray.400", $7qkdK.gray[400])}`
            },
            ".apexcharts-canvas .apexcharts-xaxistooltip": {
                color: `${theme("colors.gray.500", $7qkdK.gray[500])}`,
                paddingTop: `${theme("spacing.2", $bcbc8cac92a2c70a$var$spacing[2])}`,
                paddingBottom: `${theme("spacing.2", $bcbc8cac92a2c70a$var$spacing[2])}`,
                paddingRight: `${theme("spacing.3", $bcbc8cac92a2c70a$var$spacing[3])}`,
                paddingLeft: `${theme("spacing.3", $bcbc8cac92a2c70a$var$spacing[3])}`,
                borderColor: `transparent`,
                backgroundColor: "white",
                borderRadius: `${theme("borderRadius.DEFAULT", $bcbc8cac92a2c70a$var$borderRadius.DEFAULT)}`,
                boxShadow: `${theme("boxShadow.md", $bcbc8cac92a2c70a$var$boxShadow.md)}`
            },
            ".dark .apexcharts-canvas .apexcharts-xaxistooltip": {
                color: `${theme("colors.gray.400", $7qkdK.gray[400])}`,
                backgroundColor: `${theme("colors.gray.700", $7qkdK.gray[700])}`
            },
            ".apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-text-y-label": {
                color: `${theme("colors.gray.500", $7qkdK.gray[500])}`,
                fontSize: `${theme("fontSize.sm", $4IP4c.fontSize.sm)}`
            },
            ".dark .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-text-y-label": {
                color: `${theme("colors.gray.400", $7qkdK.gray[400])}`
            },
            ".apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-text-y-value": {
                color: `${theme("colors.gray.900", $7qkdK.gray[900])}`,
                fontSize: `${theme("fontSize.sm", $4IP4c.fontSize.sm)}`
            },
            ".dark .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-text-y-value": {
                color: "white"
            },
            ".apexcharts-canvas .apexcharts-xaxistooltip-text": {
                fontWeight: `${theme("fontWeight.normal", $4IP4c.fontWeight.normal)}`,
                fontSize: `${theme("fontSize.sm", $4IP4c.fontSize.sm)} !important`
            },
            ".apexcharts-canvas .apexcharts-xaxistooltip:after, .apexcharts-canvas .apexcharts-xaxistooltip:before": {
                borderBottomColor: "white"
            },
            ".apexcharts-canvas .apexcharts-xaxistooltip:after": {
                borderWidth: "8px",
                marginLeft: "-8px"
            },
            ".apexcharts-canvas .apexcharts-xaxistooltip:before": {
                borderWidth: "10px",
                marginLeft: "-10px"
            },
            ".dark .apexcharts-canvas .apexcharts-xaxistooltip:after, .dark .apexcharts-canvas .apexcharts-xaxistooltip:before": {
                borderBottomColor: `${theme("colors.gray.700", $7qkdK.gray[700])}`
            },
            ".apexcharts-canvas .apexcharts-tooltip-series-group.apexcharts-active .apexcharts-tooltip-y-group": {
                padding: "0"
            },
            ".apexcharts-canvas .apexcharts-tooltip-series-group.apexcharts-active": {
                paddingLeft: `${theme("spacing.3", $bcbc8cac92a2c70a$var$spacing[3])}`,
                paddingRight: `${theme("spacing.3", $bcbc8cac92a2c70a$var$spacing[3])}`,
                paddingBottom: `${theme("spacing.3", $bcbc8cac92a2c70a$var$spacing[3])}`,
                backgroundColor: "white !important",
                color: `${theme("colors.gray.500", $7qkdK.gray[500])} !important`
            },
            ".dark .apexcharts-canvas .apexcharts-tooltip-series-group.apexcharts-active": {
                backgroundColor: `${theme("colors.gray.700", $7qkdK.gray[700])} !important`,
                color: `${theme("colors.gray.400", $7qkdK.gray[400])} !important`
            },
            ".apexcharts-canvas .apexcharts-tooltip-series-group.apexcharts-active:first-of-type": {
                paddingTop: `${theme("spacing.3", $bcbc8cac92a2c70a$var$spacing[3])}`
            },
            ".apexcharts-canvas .apexcharts-legend": {
                padding: "0 !important"
            },
            ".apexcharts-canvas .apexcharts-legend-text": {
                fontSize: `${theme("fontSize.xs", $4IP4c.fontSize.xs)}`,
                fontWeight: `${theme("fontWeight.medium", $4IP4c.fontWeight.medium)} !important`,
                paddingLeft: `${theme("spacing.5", $bcbc8cac92a2c70a$var$spacing[5])}`,
                color: `${theme("colors.gray.500", $7qkdK.gray[500])} !important`
            },
            ".apexcharts-canvas .apexcharts-legend-text:not(.apexcharts-inactive-legend):hover": {
                color: `${theme("colors.gray.900", $7qkdK.gray[900])} !important`
            },
            ".dark .apexcharts-canvas .apexcharts-legend-text": {
                color: `${theme("colors.gray.400", $7qkdK.gray[400])} !important`
            },
            ".dark .apexcharts-canvas .apexcharts-legend-text:not(.apexcharts-inactive-legend):hover": {
                color: `white !important`
            },
            ".apexcharts-canvas .apexcharts-legend-series": {
                marginLeft: `${theme("spacing.2", $bcbc8cac92a2c70a$var$spacing[2])}`,
                marginRight: `${theme("spacing.2", $bcbc8cac92a2c70a$var$spacing[2])}`,
                marginBottom: `${theme("spacing.1", $bcbc8cac92a2c70a$var$spacing[1])} !important`,
                display: "flex",
                alignItems: "center"
            },
            ".apexcharts-datalabels-group .apexcharts-text.apexcharts-datalabel-value": {
                fill: `${theme("colors.gray.900", $7qkdK.gray[900])} !important`,
                fontSize: `${theme("fontSize.3xl")}`,
                fontWeight: `${theme("fontWeight.bold", $4IP4c.fontWeight.bold)}`
            },
            ".dark .apexcharts-canvas .apexcharts-datalabels-group .apexcharts-text.apexcharts-datalabel-value": {
                fill: `white !important`
            },
            ".apexcharts-canvas .apexcharts-datalabels-group .apexcharts-text.apexcharts-datalabel-label": {
                fill: `${theme("colors.gray.500", $7qkdK.gray[500])} !important`,
                fontSize: `${theme("fontSize.base")}`,
                fontWeight: `${theme("fontWeight.normal", $4IP4c.fontWeight.normal)}`
            },
            ".dark .apexcharts-canvas .apexcharts-datalabels-group .apexcharts-text.apexcharts-datalabel-label": {
                fill: `${theme("colors.gray.400", $7qkdK.gray[400])} !important`
            },
            ".apexcharts-canvas .apexcharts-datalabels .apexcharts-text.apexcharts-pie-label": {
                fontSize: `${theme("fontSize.xs")} !important`,
                fontWeight: `${theme("fontWeight.semibold", $4IP4c.fontWeight.semibold)} !important`,
                textShadow: `${theme("boxShadow.none", $bcbc8cac92a2c70a$var$boxShadow.none)} !important`,
                filter: `none !important`
            },
            ".apexcharts-gridline, .apexcharts-xcrosshairs, .apexcharts-ycrosshairs": {
                stroke: `${theme("colors.gray.200", $7qkdK.gray[200])} !important`
            },
            ".dark .apexcharts-gridline, .dark .apexcharts-xcrosshairs, .dark .apexcharts-ycrosshairs": {
                stroke: `${theme("colors.gray.700", $7qkdK.gray[700])} !important`
            }
        });
    };
}, function(options = {}) {
    // Enable forms and tooltip by default if not specified in options
    const { charts: charts = false, forms: forms = true, tooltips: tooltips = true } = options;
    const safelist = [
        "w-64",
        "w-1/2",
        "rounded-l-lg",
        "rounded-r-lg",
        "bg-gray-200",
        "grid-cols-4",
        "grid-cols-7",
        "h-6",
        "leading-6",
        "h-9",
        "leading-9",
        "shadow-lg"
    ];
    if (charts) safelist.push({
        pattern: /^apexcharts-.*$/
    });
    return {
        safelist: safelist,
        darkMode: "class",
        theme: {
            extend: {
                height: {
                    modal: "calc(100% - 2rem)"
                },
                boxShadow: {
                    "sm-light": "0 2px 5px 0px rgba(255, 255, 255, 0.08)"
                },
                colors: {
                    transparent: "transparent",
                    white: "#ffffff",
                    black: "#000000",
                    gray: {
                        50: "#F9FAFB",
                        100: "#F3F4F6",
                        200: "#E5E7EB",
                        300: "#D1D5DB",
                        400: "#9CA3AF",
                        500: "#6B7280",
                        600: "#4B5563",
                        700: "#374151",
                        800: "#1F2937",
                        900: "#111827"
                    },
                    red: {
                        50: "#FDF2F2",
                        100: "#FDE8E8",
                        200: "#FBD5D5",
                        300: "#F8B4B4",
                        400: "#F98080",
                        500: "#F05252",
                        600: "#E02424",
                        700: "#C81E1E",
                        800: "#9B1C1C",
                        900: "#771D1D"
                    },
                    orange: {
                        50: "#FFF8F1",
                        100: "#FEECDC",
                        200: "#FCD9BD",
                        300: "#FDBA8C",
                        400: "#FF8A4C",
                        500: "#FF5A1F",
                        600: "#D03801",
                        700: "#B43403",
                        800: "#8A2C0D",
                        900: "#771D1D"
                    },
                    yellow: {
                        50: "#FDFDEA",
                        100: "#FDF6B2",
                        200: "#FCE96A",
                        300: "#FACA15",
                        400: "#E3A008",
                        500: "#C27803",
                        600: "#9F580A",
                        700: "#8E4B10",
                        800: "#723B13",
                        900: "#633112"
                    },
                    green: {
                        50: "#F3FAF7",
                        100: "#DEF7EC",
                        200: "#BCF0DA",
                        300: "#84E1BC",
                        400: "#31C48D",
                        500: "#0E9F6E",
                        600: "#057A55",
                        700: "#046C4E",
                        800: "#03543F",
                        900: "#014737"
                    },
                    teal: {
                        50: "#EDFAFA",
                        100: "#D5F5F6",
                        200: "#AFECEF",
                        300: "#7EDCE2",
                        400: "#16BDCA",
                        500: "#0694A2",
                        600: "#047481",
                        700: "#036672",
                        800: "#05505C",
                        900: "#014451"
                    },
                    blue: {
                        50: "#EBF5FF",
                        100: "#E1EFFE",
                        200: "#C3DDFD",
                        300: "#A4CAFE",
                        400: "#76A9FA",
                        500: "#3F83F8",
                        600: "#1C64F2",
                        700: "#1A56DB",
                        800: "#1E429F",
                        900: "#233876"
                    },
                    indigo: {
                        50: "#F0F5FF",
                        100: "#E5EDFF",
                        200: "#CDDBFE",
                        300: "#B4C6FC",
                        400: "#8DA2FB",
                        500: "#6875F5",
                        600: "#5850EC",
                        700: "#5145CD",
                        800: "#42389D",
                        900: "#362F78"
                    },
                    purple: {
                        50: "#F6F5FF",
                        100: "#EDEBFE",
                        200: "#DCD7FE",
                        300: "#CABFFD",
                        400: "#AC94FA",
                        500: "#9061F9",
                        600: "#7E3AF2",
                        700: "#6C2BD9",
                        800: "#5521B5",
                        900: "#4A1D96"
                    },
                    pink: {
                        50: "#FDF2F8",
                        100: "#FCE8F3",
                        200: "#FAD1E8",
                        300: "#F8B4D9",
                        400: "#F17EB8",
                        500: "#E74694",
                        600: "#D61F69",
                        700: "#BF125D",
                        800: "#99154B",
                        900: "#751A3D"
                    }
                }
            }
        }
    };
});

});

parcelRegister("3MISw", function(module, exports) {

var $fDWVA = parcelRequire("fDWVA");

var $cWxRU = parcelRequire("cWxRU");
module.exports = function({ addUtilities: addUtilities, matchUtilities: matchUtilities, theme: theme, variants: variants }) {
    const gridAreaNames = $cWxRU(theme("gridTemplateAreas"));
    const templateAreas = $fDWVA.reduce(theme("gridTemplateAreas"), (templates, area, name)=>{
        return {
            ...templates,
            [`.grid-areas-${name}`]: {
                "grid-template-areas": area.map((row)=>{
                    return `"${row}"`;
                }).join("\n")
            }
        };
    }, {});
    const specialTemplateAreas = {
        ".grid-areas-none": {
            "grid-template-areas": "none"
        },
        ".grid-areas-inherit": {
            "grid-template-areas": "inherit"
        },
        ".grid-areas-initial": {
            "grid-template-areas": "initial"
        },
        ".grid-areas-revert": {
            "grid-template-areas": "revert"
        },
        ".grid-areas-revert-layer": {
            "grid-template-areas": "revert-layer"
        },
        ".grid-areas-unset": {
            "grid-template-areas": "unset"
        }
    };
    addUtilities([
        templateAreas,
        specialTemplateAreas
    ], variants("gridTemplateAreas"));
    const namedAreas = gridAreaNames.reduce((areas, name)=>{
        return {
            ...areas,
            [`.grid-in-${name}`]: {
                "grid-area": name
            }
        };
    }, {});
    const specialNamedAreas = {
        ".grid-in-auto": {
            "grid-area": "auto"
        },
        ".grid-in-inherit": {
            "grid-area": "inherit"
        },
        ".grid-in-initial": {
            "grid-area": "initial"
        },
        ".grid-in-revert": {
            "grid-area": "revert"
        },
        ".grid-in-revert-layer": {
            "grid-area": "revert-layer"
        },
        ".grid-in-unset": {
            "grid-area": "unset"
        }
    };
    addUtilities([
        namedAreas,
        specialNamedAreas
    ], []);
    const namedLines = gridAreaNames.reduce((lines, name)=>{
        return {
            ...lines,
            [`.row-start-${name}`]: {
                "grid-row-start": `${name}-start`
            },
            [`.row-end-${name}`]: {
                "grid-row-end": `${name}-end`
            },
            [`.col-start-${name}`]: {
                "grid-column-start": `${name}-start`
            },
            [`.col-end-${name}`]: {
                "grid-column-end": `${name}-end`
            }
        };
    }, {});
    addUtilities([
        namedLines
    ], []);
    // allow arbitrary values
    matchUtilities({
        "grid-areas": (value)=>{
            value = value.split(/ *, */).map((row)=>row.match(/var\(.*\)/g) ? row : `"${row}"`).join(" ");
            return {
                "grid-template-areas": `${value}`
            };
        },
        "grid-in": (value)=>{
            return {
                "grid-area": `${value}`
            };
        }
    });
};

});
parcelRegister("fDWVA", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("cWxRU", function(module, exports) {

var $fDWVA = parcelRequire("fDWVA");
module.exports = function(gridTemplateAreas) {
    return $fDWVA.uniq($fDWVA.flatMap(gridTemplateAreas, (row)=>{
        return $fDWVA.flatMap(row, (area)=>{
            // extract grid area names from the gridTemplate
            return $fDWVA.flatMap(area.match(/[^\s]+/g), (match)=>{
                if (match !== ".") return match;
                return [];
            });
        });
    }));
};

});


parcelRegister("ju1kk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e2f1d9235f90f3f2$var$resolveConfig;
    }
});

const $e2f1d9235f90f3f2$var$_negateValue = /*#__PURE__*/ $e2f1d9235f90f3f2$var$_interop_require_default((parcelRequire("bRkEy")));

const $e2f1d9235f90f3f2$var$_corePluginList = /*#__PURE__*/ $e2f1d9235f90f3f2$var$_interop_require_default((parcelRequire("hos6l")));

const $e2f1d9235f90f3f2$var$_configurePlugins = /*#__PURE__*/ $e2f1d9235f90f3f2$var$_interop_require_default((parcelRequire("8YypY")));

const $e2f1d9235f90f3f2$var$_colors = /*#__PURE__*/ $e2f1d9235f90f3f2$var$_interop_require_default((parcelRequire("iFKdC")));

var $anacy = parcelRequire("anacy");

var $fUyqp = parcelRequire("fUyqp");

var $4ckbF = parcelRequire("4ckbF");

const $e2f1d9235f90f3f2$var$_isPlainObject = /*#__PURE__*/ $e2f1d9235f90f3f2$var$_interop_require_default((parcelRequire("h4MuE")));

var $iwdVR = parcelRequire("iwdVR");

var $leuEn = parcelRequire("leuEn");

var $y20xN = parcelRequire("y20xN");

const $e2f1d9235f90f3f2$var$_toColorValue = /*#__PURE__*/ $e2f1d9235f90f3f2$var$_interop_require_default((parcelRequire("4m112")));
function $e2f1d9235f90f3f2$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e2f1d9235f90f3f2$var$isFunction(input) {
    return typeof input === "function";
}
function $e2f1d9235f90f3f2$var$mergeWith(target, ...sources) {
    let customizer = sources.pop();
    for (let source of sources)for(let k in source){
        let merged = customizer(target[k], source[k]);
        if (merged === undefined) {
            if ((0, $e2f1d9235f90f3f2$var$_isPlainObject.default)(target[k]) && (0, $e2f1d9235f90f3f2$var$_isPlainObject.default)(source[k])) target[k] = $e2f1d9235f90f3f2$var$mergeWith({}, target[k], source[k], customizer);
            else target[k] = source[k];
        } else target[k] = merged;
    }
    return target;
}
const $e2f1d9235f90f3f2$var$configUtils = {
    colors: $e2f1d9235f90f3f2$var$_colors.default,
    negative (scale) {
        // TODO: Log that this function isn't really needed anymore?
        return Object.keys(scale).filter((key)=>scale[key] !== "0").reduce((negativeScale, key)=>{
            let negativeValue = (0, $e2f1d9235f90f3f2$var$_negateValue.default)(scale[key]);
            if (negativeValue !== undefined) negativeScale[`-${key}`] = negativeValue;
            return negativeScale;
        }, {});
    },
    breakpoints (screens) {
        return Object.keys(screens).filter((key)=>typeof screens[key] === "string").reduce((breakpoints, key)=>({
                ...breakpoints,
                [`screen-${key}`]: screens[key]
            }), {});
    }
};
function $e2f1d9235f90f3f2$var$value(valueToResolve, ...args) {
    return $e2f1d9235f90f3f2$var$isFunction(valueToResolve) ? valueToResolve(...args) : valueToResolve;
}
function $e2f1d9235f90f3f2$var$collectExtends(items) {
    return items.reduce((merged, { extend: extend })=>{
        return $e2f1d9235f90f3f2$var$mergeWith(merged, extend, (mergedValue, extendValue)=>{
            if (mergedValue === undefined) return [
                extendValue
            ];
            if (Array.isArray(mergedValue)) return [
                extendValue,
                ...mergedValue
            ];
            return [
                extendValue,
                mergedValue
            ];
        });
    }, {});
}
function $e2f1d9235f90f3f2$var$mergeThemes(themes) {
    return {
        ...themes.reduce((merged, theme)=>(0, $anacy.defaults)(merged, theme), {}),
        // In order to resolve n config objects, we combine all of their `extend` properties
        // into arrays instead of objects so they aren't overridden.
        extend: $e2f1d9235f90f3f2$var$collectExtends(themes)
    };
}
function $e2f1d9235f90f3f2$var$mergeExtensionCustomizer(merged, value) {
    // When we have an array of objects, we do want to merge it
    if (Array.isArray(merged) && (0, $e2f1d9235f90f3f2$var$_isPlainObject.default)(merged[0])) return merged.concat(value);
    // When the incoming value is an array, and the existing config is an object, prepend the existing object
    if (Array.isArray(value) && (0, $e2f1d9235f90f3f2$var$_isPlainObject.default)(value[0]) && (0, $e2f1d9235f90f3f2$var$_isPlainObject.default)(merged)) return [
        merged,
        ...value
    ];
    // Override arrays (for example for font-families, box-shadows, ...)
    if (Array.isArray(value)) return value;
    // Execute default behaviour
    return undefined;
}
function $e2f1d9235f90f3f2$var$mergeExtensions({ extend: extend, ...theme }) {
    return $e2f1d9235f90f3f2$var$mergeWith(theme, extend, (themeValue, extensions)=>{
        // The `extend` property is an array, so we need to check if it contains any functions
        if (!$e2f1d9235f90f3f2$var$isFunction(themeValue) && !extensions.some($e2f1d9235f90f3f2$var$isFunction)) return $e2f1d9235f90f3f2$var$mergeWith({}, themeValue, ...extensions, $e2f1d9235f90f3f2$var$mergeExtensionCustomizer);
        return (resolveThemePath, utils)=>$e2f1d9235f90f3f2$var$mergeWith({}, ...[
                themeValue,
                ...extensions
            ].map((e)=>$e2f1d9235f90f3f2$var$value(e, resolveThemePath, utils)), $e2f1d9235f90f3f2$var$mergeExtensionCustomizer);
    });
}
/**
 *
 * @param {string} key
 * @return {Iterable<string[] & {alpha: string | undefined}>}
 */ function* $e2f1d9235f90f3f2$var$toPaths(key) {
    let path = (0, $fUyqp.toPath)(key);
    if (path.length === 0) return;
    yield path;
    if (Array.isArray(key)) return;
    let pattern = /^(.*?)\s*\/\s*([^/]+)$/;
    let matches = key.match(pattern);
    if (matches !== null) {
        let [, prefix, alpha] = matches;
        let newPath = (0, $fUyqp.toPath)(prefix);
        newPath.alpha = alpha;
        yield newPath;
    }
}
function $e2f1d9235f90f3f2$var$resolveFunctionKeys(object) {
    // theme('colors.red.500 / 0.5') -> ['colors', 'red', '500 / 0', '5]
    const resolvePath = (key, defaultValue)=>{
        for (const path of $e2f1d9235f90f3f2$var$toPaths(key)){
            let index = 0;
            let val = object;
            while(val !== undefined && val !== null && index < path.length){
                val = val[path[index++]];
                let shouldResolveAsFn = $e2f1d9235f90f3f2$var$isFunction(val) && (path.alpha === undefined || index <= path.length - 1);
                val = shouldResolveAsFn ? val(resolvePath, $e2f1d9235f90f3f2$var$configUtils) : val;
            }
            if (val !== undefined) {
                if (path.alpha !== undefined) {
                    let normalized = (0, $leuEn.parseColorFormat)(val);
                    return (0, $y20xN.withAlphaValue)(normalized, path.alpha, (0, $e2f1d9235f90f3f2$var$_toColorValue.default)(normalized));
                }
                if ((0, $e2f1d9235f90f3f2$var$_isPlainObject.default)(val)) return (0, $iwdVR.cloneDeep)(val);
                return val;
            }
        }
        return defaultValue;
    };
    Object.assign(resolvePath, {
        theme: resolvePath,
        ...$e2f1d9235f90f3f2$var$configUtils
    });
    return Object.keys(object).reduce((resolved, key)=>{
        resolved[key] = $e2f1d9235f90f3f2$var$isFunction(object[key]) ? object[key](resolvePath, $e2f1d9235f90f3f2$var$configUtils) : object[key];
        return resolved;
    }, {});
}
function $e2f1d9235f90f3f2$var$extractPluginConfigs(configs) {
    let allConfigs = [];
    configs.forEach((config)=>{
        allConfigs = [
            ...allConfigs,
            config
        ];
        var _config_plugins;
        const plugins = (_config_plugins = config === null || config === void 0 ? void 0 : config.plugins) !== null && _config_plugins !== void 0 ? _config_plugins : [];
        if (plugins.length === 0) return;
        plugins.forEach((plugin)=>{
            if (plugin.__isOptionsFunction) plugin = plugin();
            var _plugin_config;
            allConfigs = [
                ...allConfigs,
                ...$e2f1d9235f90f3f2$var$extractPluginConfigs([
                    (_plugin_config = plugin === null || plugin === void 0 ? void 0 : plugin.config) !== null && _plugin_config !== void 0 ? _plugin_config : {}
                ])
            ];
        });
    });
    return allConfigs;
}
function $e2f1d9235f90f3f2$var$resolveCorePlugins(corePluginConfigs) {
    const result = [
        ...corePluginConfigs
    ].reduceRight((resolved, corePluginConfig)=>{
        if ($e2f1d9235f90f3f2$var$isFunction(corePluginConfig)) return corePluginConfig({
            corePlugins: resolved
        });
        return (0, $e2f1d9235f90f3f2$var$_configurePlugins.default)(corePluginConfig, resolved);
    }, $e2f1d9235f90f3f2$var$_corePluginList.default);
    return result;
}
function $e2f1d9235f90f3f2$var$resolvePluginLists(pluginLists) {
    const result = [
        ...pluginLists
    ].reduceRight((resolved, pluginList)=>{
        return [
            ...resolved,
            ...pluginList
        ];
    }, []);
    return result;
}
function $e2f1d9235f90f3f2$var$resolveConfig(configs) {
    let allConfigs = [
        ...$e2f1d9235f90f3f2$var$extractPluginConfigs(configs),
        {
            prefix: "",
            important: false,
            separator: ":"
        }
    ];
    var _t_theme, _c_plugins;
    return (0, $4ckbF.normalizeConfig)((0, $anacy.defaults)({
        theme: $e2f1d9235f90f3f2$var$resolveFunctionKeys($e2f1d9235f90f3f2$var$mergeExtensions($e2f1d9235f90f3f2$var$mergeThemes(allConfigs.map((t)=>{
            return (_t_theme = t === null || t === void 0 ? void 0 : t.theme) !== null && _t_theme !== void 0 ? _t_theme : {};
        })))),
        corePlugins: $e2f1d9235f90f3f2$var$resolveCorePlugins(allConfigs.map((c)=>c.corePlugins)),
        plugins: $e2f1d9235f90f3f2$var$resolvePluginLists(configs.map((c)=>{
            return (_c_plugins = c === null || c === void 0 ? void 0 : c.plugins) !== null && _c_plugins !== void 0 ? _c_plugins : [];
        }))
    }, ...allConfigs));
}

});
parcelRegister("bRkEy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8a24aa3614bc1a6e$var$negateValue;
    }
});
function $8a24aa3614bc1a6e$var$negateValue(value) {
    value = `${value}`;
    if (value === "0") return "0";
    // Flip sign of numbers
    if (/^[+-]?(\d+|\d*\.\d+)(e[+-]?\d+)?(%|\w+)?$/.test(value)) return value.replace(/^[+-]?/, (sign)=>sign === "-" ? "" : "-");
    // What functions we support negating numeric values for
    // var() isn't inherently a numeric function but we support it anyway
    // The trigonometric functions are omitted because you'll need to use calc(…) with them _anyway_
    // to produce generally useful results and that will be covered already
    let numericFunctions = [
        "var",
        "calc",
        "min",
        "max",
        "clamp"
    ];
    for (const fn of numericFunctions){
        if (value.includes(`${fn}(`)) return `calc(${value} * -1)`;
    }
}

});

parcelRegister("hos6l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ca9a79eb68cc3df2$var$_default;
    }
});
const $ca9a79eb68cc3df2$var$_default = [
    "preflight",
    "container",
    "accessibility",
    "pointerEvents",
    "visibility",
    "position",
    "inset",
    "isolation",
    "zIndex",
    "order",
    "gridColumn",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRow",
    "gridRowStart",
    "gridRowEnd",
    "float",
    "clear",
    "margin",
    "boxSizing",
    "lineClamp",
    "display",
    "aspectRatio",
    "size",
    "height",
    "maxHeight",
    "minHeight",
    "width",
    "minWidth",
    "maxWidth",
    "flex",
    "flexShrink",
    "flexGrow",
    "flexBasis",
    "tableLayout",
    "captionSide",
    "borderCollapse",
    "borderSpacing",
    "transformOrigin",
    "translate",
    "rotate",
    "skew",
    "scale",
    "transform",
    "animation",
    "cursor",
    "touchAction",
    "userSelect",
    "resize",
    "scrollSnapType",
    "scrollSnapAlign",
    "scrollSnapStop",
    "scrollMargin",
    "scrollPadding",
    "listStylePosition",
    "listStyleType",
    "listStyleImage",
    "appearance",
    "columns",
    "breakBefore",
    "breakInside",
    "breakAfter",
    "gridAutoColumns",
    "gridAutoFlow",
    "gridAutoRows",
    "gridTemplateColumns",
    "gridTemplateRows",
    "flexDirection",
    "flexWrap",
    "placeContent",
    "placeItems",
    "alignContent",
    "alignItems",
    "justifyContent",
    "justifyItems",
    "gap",
    "space",
    "divideWidth",
    "divideStyle",
    "divideColor",
    "divideOpacity",
    "placeSelf",
    "alignSelf",
    "justifySelf",
    "overflow",
    "overscrollBehavior",
    "scrollBehavior",
    "textOverflow",
    "hyphens",
    "whitespace",
    "textWrap",
    "wordBreak",
    "borderRadius",
    "borderWidth",
    "borderStyle",
    "borderColor",
    "borderOpacity",
    "backgroundColor",
    "backgroundOpacity",
    "backgroundImage",
    "gradientColorStops",
    "boxDecorationBreak",
    "backgroundSize",
    "backgroundAttachment",
    "backgroundClip",
    "backgroundPosition",
    "backgroundRepeat",
    "backgroundOrigin",
    "fill",
    "stroke",
    "strokeWidth",
    "objectFit",
    "objectPosition",
    "padding",
    "textAlign",
    "textIndent",
    "verticalAlign",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "textTransform",
    "fontStyle",
    "fontVariantNumeric",
    "lineHeight",
    "letterSpacing",
    "textColor",
    "textOpacity",
    "textDecoration",
    "textDecorationColor",
    "textDecorationStyle",
    "textDecorationThickness",
    "textUnderlineOffset",
    "fontSmoothing",
    "placeholderColor",
    "placeholderOpacity",
    "caretColor",
    "accentColor",
    "opacity",
    "backgroundBlendMode",
    "mixBlendMode",
    "boxShadow",
    "boxShadowColor",
    "outlineStyle",
    "outlineWidth",
    "outlineOffset",
    "outlineColor",
    "ringWidth",
    "ringColor",
    "ringOpacity",
    "ringOffsetWidth",
    "ringOffsetColor",
    "blur",
    "brightness",
    "contrast",
    "dropShadow",
    "grayscale",
    "hueRotate",
    "invert",
    "saturate",
    "sepia",
    "filter",
    "backdropBlur",
    "backdropBrightness",
    "backdropContrast",
    "backdropGrayscale",
    "backdropHueRotate",
    "backdropInvert",
    "backdropOpacity",
    "backdropSaturate",
    "backdropSepia",
    "backdropFilter",
    "transitionProperty",
    "transitionDelay",
    "transitionDuration",
    "transitionTimingFunction",
    "willChange",
    "contain",
    "content",
    "forcedColorAdjust"
];

});

parcelRegister("8YypY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $688e9ffd4692fcf9$var$_default;
    }
});
function $688e9ffd4692fcf9$var$_default(pluginConfig, plugins) {
    if (pluginConfig === undefined) return plugins;
    const pluginNames = Array.isArray(pluginConfig) ? pluginConfig : [
        ...new Set(plugins.filter((pluginName)=>{
            return pluginConfig !== false && pluginConfig[pluginName] !== false;
        }).concat(Object.keys(pluginConfig).filter((pluginName)=>{
            return pluginConfig[pluginName] !== false;
        })))
    ];
    return pluginNames;
}

});

parcelRegister("anacy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "defaults", {
    enumerable: true,
    get: function() {
        return $78d3f72dbbdb72c1$var$defaults;
    }
});
function $78d3f72dbbdb72c1$var$defaults(target, ...sources) {
    for (let source of sources){
        for(let k in source){
            var _target_hasOwnProperty;
            if (!(target === null || target === void 0 ? void 0 : (_target_hasOwnProperty = target.hasOwnProperty) === null || _target_hasOwnProperty === void 0 ? void 0 : _target_hasOwnProperty.call(target, k))) target[k] = source[k];
        }
        for (let k of Object.getOwnPropertySymbols(source)){
            var _target_hasOwnProperty1;
            if (!(target === null || target === void 0 ? void 0 : (_target_hasOwnProperty1 = target.hasOwnProperty) === null || _target_hasOwnProperty1 === void 0 ? void 0 : _target_hasOwnProperty1.call(target, k))) target[k] = source[k];
        }
    }
    return target;
}

});

parcelRegister("fUyqp", function(module, exports) {
/**
 * Parse a path string into an array of path segments.
 *
 * Square bracket notation `a[b]` may be used to "escape" dots that would otherwise be interpreted as path separators.
 *
 * Example:
 * a -> ['a']
 * a.b.c -> ['a', 'b', 'c']
 * a[b].c -> ['a', 'b', 'c']
 * a[b.c].e.f -> ['a', 'b.c', 'e', 'f']
 * a[b][c][d] -> ['a', 'b', 'c', 'd']
 *
 * @param {string|string[]} path
 **/ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "toPath", {
    enumerable: true,
    get: function() {
        return $b956ca0bd0c22f08$var$toPath;
    }
});
function $b956ca0bd0c22f08$var$toPath(path) {
    if (Array.isArray(path)) return path;
    let openBrackets = path.split("[").length - 1;
    let closedBrackets = path.split("]").length - 1;
    if (openBrackets !== closedBrackets) throw new Error(`Path is invalid. Has unbalanced brackets: ${path}`);
    return path.split(/\.(?![^\[]*\])|[\[\]]/g).filter(Boolean);
}

});

parcelRegister("4ckbF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "normalizeConfig", {
    enumerable: true,
    get: function() {
        return $30e7f1256c60a868$var$normalizeConfig;
    }
});

var $9Wjkp = parcelRequire("9Wjkp");

const $30e7f1256c60a868$var$_log = /*#__PURE__*/ $30e7f1256c60a868$var$_interop_require_wildcard((parcelRequire("7uaNc")));
function $30e7f1256c60a868$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($30e7f1256c60a868$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $30e7f1256c60a868$var$_interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $30e7f1256c60a868$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $30e7f1256c60a868$var$normalizeConfig(config) {
    // Quick structure validation
    /**
   * type FilePath = string
   * type RawFile = { raw: string, extension?: string }
   * type ExtractorFn = (content: string) => Array<string>
   * type TransformerFn = (content: string) => string
   *
   * type Content =
   *   | Array<FilePath | RawFile>
   *   | {
   *       files: Array<FilePath | RawFile>,
   *       extract?: ExtractorFn | { [extension: string]: ExtractorFn }
   *       transform?: TransformerFn | { [extension: string]: TransformerFn }
   *   }
   */ let valid = (()=>{
        // `config.purge` should not exist anymore
        if (config.purge) return false;
        // `config.content` should exist
        if (!config.content) return false;
        // `config.content` should be an object or an array
        if (!Array.isArray(config.content) && !(typeof config.content === "object" && config.content !== null)) return false;
        // When `config.content` is an array, it should consist of FilePaths or RawFiles
        if (Array.isArray(config.content)) return config.content.every((path)=>{
            // `path` can be a string
            if (typeof path === "string") return true;
            // `path` can be an object { raw: string, extension?: string }
            // `raw` must be a string
            if (typeof (path === null || path === void 0 ? void 0 : path.raw) !== "string") return false;
            // `extension` (if provided) should also be a string
            if ((path === null || path === void 0 ? void 0 : path.extension) && typeof (path === null || path === void 0 ? void 0 : path.extension) !== "string") return false;
            return true;
        });
        // When `config.content` is an object
        if (typeof config.content === "object" && config.content !== null) {
            // Only `files`, `relative`, `extract`, and `transform` can exist in `config.content`
            if (Object.keys(config.content).some((key)=>![
                    "files",
                    "relative",
                    "extract",
                    "transform"
                ].includes(key))) return false;
            // `config.content.files` should exist of FilePaths or RawFiles
            if (Array.isArray(config.content.files)) {
                if (!config.content.files.every((path)=>{
                    // `path` can be a string
                    if (typeof path === "string") return true;
                    // `path` can be an object { raw: string, extension?: string }
                    // `raw` must be a string
                    if (typeof (path === null || path === void 0 ? void 0 : path.raw) !== "string") return false;
                    // `extension` (if provided) should also be a string
                    if ((path === null || path === void 0 ? void 0 : path.extension) && typeof (path === null || path === void 0 ? void 0 : path.extension) !== "string") return false;
                    return true;
                })) return false;
                // `config.content.extract` is optional, and can be a Function or a Record<String, Function>
                if (typeof config.content.extract === "object") for (let value of Object.values(config.content.extract)){
                    if (typeof value !== "function") return false;
                }
                else if (!(config.content.extract === undefined || typeof config.content.extract === "function")) return false;
                // `config.content.transform` is optional, and can be a Function or a Record<String, Function>
                if (typeof config.content.transform === "object") for (let value of Object.values(config.content.transform)){
                    if (typeof value !== "function") return false;
                }
                else if (!(config.content.transform === undefined || typeof config.content.transform === "function")) return false;
                // `config.content.relative` is optional and can be a boolean
                if (typeof config.content.relative !== "boolean" && typeof config.content.relative !== "undefined") return false;
            }
            return true;
        }
        return false;
    })();
    if (!valid) $30e7f1256c60a868$var$_log.default.warn("purge-deprecation", [
        "The `purge`/`content` options have changed in Tailwind CSS v3.0.",
        "Update your configuration file to eliminate this warning.",
        "https://tailwindcss.com/docs/upgrade-guide#configure-content-sources"
    ]);
    // Normalize the `safelist`
    config.safelist = (()=>{
        var _purge_options;
        let { content: content, purge: purge, safelist: safelist } = config;
        if (Array.isArray(safelist)) return safelist;
        if (Array.isArray(content === null || content === void 0 ? void 0 : content.safelist)) return content.safelist;
        if (Array.isArray(purge === null || purge === void 0 ? void 0 : purge.safelist)) return purge.safelist;
        if (Array.isArray(purge === null || purge === void 0 ? void 0 : (_purge_options = purge.options) === null || _purge_options === void 0 ? void 0 : _purge_options.safelist)) return purge.options.safelist;
        return [];
    })();
    // Normalize the `blocklist`
    config.blocklist = (()=>{
        let { blocklist: blocklist } = config;
        if (Array.isArray(blocklist)) {
            if (blocklist.every((item)=>typeof item === "string")) return blocklist;
            $30e7f1256c60a868$var$_log.default.warn("blocklist-invalid", [
                "The `blocklist` option must be an array of strings.",
                "https://tailwindcss.com/docs/content-configuration#discarding-classes"
            ]);
        }
        return [];
    })();
    // Normalize prefix option
    if (typeof config.prefix === "function") {
        $30e7f1256c60a868$var$_log.default.warn("prefix-function", [
            "As of Tailwind CSS v3.0, `prefix` cannot be a function.",
            "Update `prefix` in your configuration to be a string to eliminate this warning.",
            "https://tailwindcss.com/docs/upgrade-guide#prefix-cannot-be-a-function"
        ]);
        config.prefix = "";
    } else {
        var _config_prefix;
        config.prefix = (_config_prefix = config.prefix) !== null && _config_prefix !== void 0 ? _config_prefix : "";
    }
    // Normalize the `content`
    config.content = {
        relative: (()=>{
            let { content: content } = config;
            if (content === null || content === void 0 ? void 0 : content.relative) return content.relative;
            return (0, $9Wjkp.flagEnabled)(config, "relativeContentPathsByDefault");
        })(),
        files: (()=>{
            let { content: content, purge: purge } = config;
            if (Array.isArray(purge)) return purge;
            if (Array.isArray(purge === null || purge === void 0 ? void 0 : purge.content)) return purge.content;
            if (Array.isArray(content)) return content;
            if (Array.isArray(content === null || content === void 0 ? void 0 : content.content)) return content.content;
            if (Array.isArray(content === null || content === void 0 ? void 0 : content.files)) return content.files;
            return [];
        })(),
        extract: (()=>{
            let extract = (()=>{
                var _config_purge, _config_content, _config_purge1, _config_purge_extract, _config_content1, _config_content_extract, _config_purge2, _config_purge_options, _config_content2, _config_content_options;
                if ((_config_purge = config.purge) === null || _config_purge === void 0 ? void 0 : _config_purge.extract) return config.purge.extract;
                if ((_config_content = config.content) === null || _config_content === void 0 ? void 0 : _config_content.extract) return config.content.extract;
                if ((_config_purge1 = config.purge) === null || _config_purge1 === void 0 ? void 0 : (_config_purge_extract = _config_purge1.extract) === null || _config_purge_extract === void 0 ? void 0 : _config_purge_extract.DEFAULT) return config.purge.extract.DEFAULT;
                if ((_config_content1 = config.content) === null || _config_content1 === void 0 ? void 0 : (_config_content_extract = _config_content1.extract) === null || _config_content_extract === void 0 ? void 0 : _config_content_extract.DEFAULT) return config.content.extract.DEFAULT;
                if ((_config_purge2 = config.purge) === null || _config_purge2 === void 0 ? void 0 : (_config_purge_options = _config_purge2.options) === null || _config_purge_options === void 0 ? void 0 : _config_purge_options.extractors) return config.purge.options.extractors;
                if ((_config_content2 = config.content) === null || _config_content2 === void 0 ? void 0 : (_config_content_options = _config_content2.options) === null || _config_content_options === void 0 ? void 0 : _config_content_options.extractors) return config.content.options.extractors;
                return {};
            })();
            let extractors = {};
            let defaultExtractor = (()=>{
                var _config_purge, _config_purge_options, _config_content, _config_content_options;
                if ((_config_purge = config.purge) === null || _config_purge === void 0 ? void 0 : (_config_purge_options = _config_purge.options) === null || _config_purge_options === void 0 ? void 0 : _config_purge_options.defaultExtractor) return config.purge.options.defaultExtractor;
                if ((_config_content = config.content) === null || _config_content === void 0 ? void 0 : (_config_content_options = _config_content.options) === null || _config_content_options === void 0 ? void 0 : _config_content_options.defaultExtractor) return config.content.options.defaultExtractor;
                return undefined;
            })();
            if (defaultExtractor !== undefined) extractors.DEFAULT = defaultExtractor;
            // Functions
            if (typeof extract === "function") extractors.DEFAULT = extract;
            else if (Array.isArray(extract)) {
                for (let { extensions: extensions, extractor: extractor } of extract !== null && extract !== void 0 ? extract : [])for (let extension of extensions)extractors[extension] = extractor;
            } else if (typeof extract === "object" && extract !== null) Object.assign(extractors, extract);
            return extractors;
        })(),
        transform: (()=>{
            let transform = (()=>{
                var _config_purge, _config_content, _config_purge1, _config_purge_transform, _config_content1, _config_content_transform;
                if ((_config_purge = config.purge) === null || _config_purge === void 0 ? void 0 : _config_purge.transform) return config.purge.transform;
                if ((_config_content = config.content) === null || _config_content === void 0 ? void 0 : _config_content.transform) return config.content.transform;
                if ((_config_purge1 = config.purge) === null || _config_purge1 === void 0 ? void 0 : (_config_purge_transform = _config_purge1.transform) === null || _config_purge_transform === void 0 ? void 0 : _config_purge_transform.DEFAULT) return config.purge.transform.DEFAULT;
                if ((_config_content1 = config.content) === null || _config_content1 === void 0 ? void 0 : (_config_content_transform = _config_content1.transform) === null || _config_content_transform === void 0 ? void 0 : _config_content_transform.DEFAULT) return config.content.transform.DEFAULT;
                return {};
            })();
            let transformers = {};
            if (typeof transform === "function") transformers.DEFAULT = transform;
            else if (typeof transform === "object" && transform !== null) Object.assign(transformers, transform);
            return transformers;
        })()
    };
    // Validate globs to prevent bogus globs.
    // E.g.: `./src/*.{html}` is invalid, the `{html}` should just be `html`
    for (let file of config.content.files)if (typeof file === "string" && /{([^,]*?)}/g.test(file)) {
        $30e7f1256c60a868$var$_log.default.warn("invalid-glob-braces", [
            `The glob pattern ${(0, $30e7f1256c60a868$var$_log.dim)(file)} in your Tailwind CSS configuration is invalid.`,
            `Update it to ${(0, $30e7f1256c60a868$var$_log.dim)(file.replace(/{([^,]*?)}/g, "$1"))} to silence this warning.`
        ]);
        break;
    }
    return config;
}

});
parcelRegister("9Wjkp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $73c88600dbd18364$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$73c88600dbd18364$var$_export(module.exports, {
    flagEnabled: function() {
        return $73c88600dbd18364$var$flagEnabled;
    },
    issueFlagNotices: function() {
        return $73c88600dbd18364$var$issueFlagNotices;
    },
    default: function() {
        return $73c88600dbd18364$var$_default;
    }
});

const $73c88600dbd18364$var$_picocolors = /*#__PURE__*/ $73c88600dbd18364$var$_interop_require_default((parcelRequire("43SCK")));

const $73c88600dbd18364$var$_log = /*#__PURE__*/ $73c88600dbd18364$var$_interop_require_default((parcelRequire("7uaNc")));
function $73c88600dbd18364$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let $73c88600dbd18364$var$defaults = {
    optimizeUniversalDefaults: false,
    generalizedModifiers: true,
    disableColorOpacityUtilitiesByDefault: false,
    relativeContentPathsByDefault: false
};
let $73c88600dbd18364$var$featureFlags = {
    future: [
        "hoverOnlyWhenSupported",
        "respectDefaultRingColorOpacity",
        "disableColorOpacityUtilitiesByDefault",
        "relativeContentPathsByDefault"
    ],
    experimental: [
        "optimizeUniversalDefaults",
        "generalizedModifiers"
    ]
};
function $73c88600dbd18364$var$flagEnabled(config, flag) {
    if ($73c88600dbd18364$var$featureFlags.future.includes(flag)) {
        var _config_future;
        var _config_future_flag, _ref;
        return config.future === "all" || ((_ref = (_config_future_flag = config === null || config === void 0 ? void 0 : (_config_future = config.future) === null || _config_future === void 0 ? void 0 : _config_future[flag]) !== null && _config_future_flag !== void 0 ? _config_future_flag : $73c88600dbd18364$var$defaults[flag]) !== null && _ref !== void 0 ? _ref : false);
    }
    if ($73c88600dbd18364$var$featureFlags.experimental.includes(flag)) {
        var _config_experimental;
        var _config_experimental_flag, _ref1;
        return config.experimental === "all" || ((_ref1 = (_config_experimental_flag = config === null || config === void 0 ? void 0 : (_config_experimental = config.experimental) === null || _config_experimental === void 0 ? void 0 : _config_experimental[flag]) !== null && _config_experimental_flag !== void 0 ? _config_experimental_flag : $73c88600dbd18364$var$defaults[flag]) !== null && _ref1 !== void 0 ? _ref1 : false);
    }
    return false;
}
function $73c88600dbd18364$var$experimentalFlagsEnabled(config) {
    if (config.experimental === "all") return $73c88600dbd18364$var$featureFlags.experimental;
    var _config_experimental;
    return Object.keys((_config_experimental = config === null || config === void 0 ? void 0 : config.experimental) !== null && _config_experimental !== void 0 ? _config_experimental : {}).filter((flag)=>$73c88600dbd18364$var$featureFlags.experimental.includes(flag) && config.experimental[flag]);
}
function $73c88600dbd18364$var$issueFlagNotices(config) {
    if ($73c88600dbd18364$var$experimentalFlagsEnabled(config).length > 0) {
        let changes = $73c88600dbd18364$var$experimentalFlagsEnabled(config).map((s)=>$73c88600dbd18364$var$_picocolors.default.yellow(s)).join(", ");
        $73c88600dbd18364$var$_log.default.warn("experimental-flags-enabled", [
            `You have enabled experimental features: ${changes}`,
            "Experimental features in Tailwind CSS are not covered by semver, may introduce breaking changes, and can change at any time."
        ]);
    }
}
const $73c88600dbd18364$var$_default = $73c88600dbd18364$var$featureFlags;

});


parcelRegister("h4MuE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c6e86d2961300b1f$var$isPlainObject;
    }
});
function $c6e86d2961300b1f$var$isPlainObject(value) {
    if (Object.prototype.toString.call(value) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || Object.getPrototypeOf(prototype) === null;
}

});

parcelRegister("leuEn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $f752ae48e2391bef$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$f752ae48e2391bef$var$_export(module.exports, {
    updateAllClasses: function() {
        return $f752ae48e2391bef$var$updateAllClasses;
    },
    asValue: function() {
        return $f752ae48e2391bef$var$asValue;
    },
    parseColorFormat: function() {
        return $f752ae48e2391bef$var$parseColorFormat;
    },
    asColor: function() {
        return $f752ae48e2391bef$var$asColor;
    },
    asLookupValue: function() {
        return $f752ae48e2391bef$var$asLookupValue;
    },
    typeMap: function() {
        return $f752ae48e2391bef$var$typeMap;
    },
    coerceValue: function() {
        return $f752ae48e2391bef$var$coerceValue;
    },
    getMatchingTypes: function() {
        return $f752ae48e2391bef$var$getMatchingTypes;
    }
});

const $f752ae48e2391bef$var$_escapeCommas = /*#__PURE__*/ $f752ae48e2391bef$var$_interop_require_default((parcelRequire("kpO0N")));

var $y20xN = parcelRequire("y20xN");

var $5pHOO = parcelRequire("5pHOO");

const $f752ae48e2391bef$var$_negateValue = /*#__PURE__*/ $f752ae48e2391bef$var$_interop_require_default((parcelRequire("bRkEy")));

var $cZjON = parcelRequire("cZjON");

var $9Wjkp = parcelRequire("9Wjkp");
function $f752ae48e2391bef$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f752ae48e2391bef$var$updateAllClasses(selectors, updateClass) {
    selectors.walkClasses((sel)=>{
        sel.value = updateClass(sel.value);
        if (sel.raws && sel.raws.value) sel.raws.value = (0, $f752ae48e2391bef$var$_escapeCommas.default)(sel.raws.value);
    });
}
function $f752ae48e2391bef$var$resolveArbitraryValue(modifier, validate) {
    if (!$f752ae48e2391bef$var$isArbitraryValue(modifier)) return undefined;
    let value = modifier.slice(1, -1);
    if (!validate(value)) return undefined;
    return (0, $5pHOO.normalize)(value);
}
function $f752ae48e2391bef$var$asNegativeValue(modifier, lookup = {}, validate) {
    let positiveValue = lookup[modifier];
    if (positiveValue !== undefined) return (0, $f752ae48e2391bef$var$_negateValue.default)(positiveValue);
    if ($f752ae48e2391bef$var$isArbitraryValue(modifier)) {
        let resolved = $f752ae48e2391bef$var$resolveArbitraryValue(modifier, validate);
        if (resolved === undefined) return undefined;
        return (0, $f752ae48e2391bef$var$_negateValue.default)(resolved);
    }
}
function $f752ae48e2391bef$var$asValue(modifier, options = {}, { validate: validate = ()=>true } = {}) {
    var _options_values;
    let value = (_options_values = options.values) === null || _options_values === void 0 ? void 0 : _options_values[modifier];
    if (value !== undefined) return value;
    if (options.supportsNegativeValues && modifier.startsWith("-")) return $f752ae48e2391bef$var$asNegativeValue(modifier.slice(1), options.values, validate);
    return $f752ae48e2391bef$var$resolveArbitraryValue(modifier, validate);
}
function $f752ae48e2391bef$var$isArbitraryValue(input) {
    return input.startsWith("[") && input.endsWith("]");
}
function $f752ae48e2391bef$var$splitUtilityModifier(modifier) {
    let slashIdx = modifier.lastIndexOf("/");
    // If the `/` is inside an arbitrary, we want to find the previous one if any
    // This logic probably isn't perfect but it should work for most cases
    let arbitraryStartIdx = modifier.lastIndexOf("[", slashIdx);
    let arbitraryEndIdx = modifier.indexOf("]", slashIdx);
    let isNextToArbitrary = modifier[slashIdx - 1] === "]" || modifier[slashIdx + 1] === "[";
    // Backtrack to the previous `/` if the one we found was inside an arbitrary
    if (!isNextToArbitrary) {
        if (arbitraryStartIdx !== -1 && arbitraryEndIdx !== -1) {
            if (arbitraryStartIdx < slashIdx && slashIdx < arbitraryEndIdx) slashIdx = modifier.lastIndexOf("/", arbitraryStartIdx);
        }
    }
    if (slashIdx === -1 || slashIdx === modifier.length - 1) return [
        modifier,
        undefined
    ];
    let arbitrary = $f752ae48e2391bef$var$isArbitraryValue(modifier);
    // The modifier could be of the form `[foo]/[bar]`
    // We want to handle this case properly
    // without affecting `[foo/bar]`
    if (arbitrary && !modifier.includes("]/[")) return [
        modifier,
        undefined
    ];
    return [
        modifier.slice(0, slashIdx),
        modifier.slice(slashIdx + 1)
    ];
}
function $f752ae48e2391bef$var$parseColorFormat(value) {
    if (typeof value === "string" && value.includes("<alpha-value>")) {
        let oldValue = value;
        return ({ opacityValue: opacityValue = 1 })=>oldValue.replace(/<alpha-value>/g, opacityValue);
    }
    return value;
}
function $f752ae48e2391bef$var$unwrapArbitraryModifier(modifier) {
    return (0, $5pHOO.normalize)(modifier.slice(1, -1));
}
function $f752ae48e2391bef$var$asColor(modifier, options = {}, { tailwindConfig: tailwindConfig = {} } = {}) {
    var _options_values;
    if (((_options_values = options.values) === null || _options_values === void 0 ? void 0 : _options_values[modifier]) !== undefined) {
        var _options_values1;
        return $f752ae48e2391bef$var$parseColorFormat((_options_values1 = options.values) === null || _options_values1 === void 0 ? void 0 : _options_values1[modifier]);
    }
    // TODO: Hoist this up to getMatchingTypes or something
    // We do this here because we need the alpha value (if any)
    let [color, alpha] = $f752ae48e2391bef$var$splitUtilityModifier(modifier);
    if (alpha !== undefined) {
        var _options_values2, _tailwindConfig_theme, _tailwindConfig_theme_opacity;
        var _options_values_color;
        let normalizedColor = (_options_values_color = (_options_values2 = options.values) === null || _options_values2 === void 0 ? void 0 : _options_values2[color]) !== null && _options_values_color !== void 0 ? _options_values_color : $f752ae48e2391bef$var$isArbitraryValue(color) ? color.slice(1, -1) : undefined;
        if (normalizedColor === undefined) return undefined;
        normalizedColor = $f752ae48e2391bef$var$parseColorFormat(normalizedColor);
        if ($f752ae48e2391bef$var$isArbitraryValue(alpha)) return (0, $y20xN.withAlphaValue)(normalizedColor, $f752ae48e2391bef$var$unwrapArbitraryModifier(alpha));
        if (((_tailwindConfig_theme = tailwindConfig.theme) === null || _tailwindConfig_theme === void 0 ? void 0 : (_tailwindConfig_theme_opacity = _tailwindConfig_theme.opacity) === null || _tailwindConfig_theme_opacity === void 0 ? void 0 : _tailwindConfig_theme_opacity[alpha]) === undefined) return undefined;
        return (0, $y20xN.withAlphaValue)(normalizedColor, tailwindConfig.theme.opacity[alpha]);
    }
    return $f752ae48e2391bef$var$asValue(modifier, options, {
        validate: $5pHOO.color
    });
}
function $f752ae48e2391bef$var$asLookupValue(modifier, options = {}) {
    var _options_values;
    return (_options_values = options.values) === null || _options_values === void 0 ? void 0 : _options_values[modifier];
}
function $f752ae48e2391bef$var$guess(validate) {
    return (modifier, options)=>{
        return $f752ae48e2391bef$var$asValue(modifier, options, {
            validate: validate
        });
    };
}
let $f752ae48e2391bef$var$typeMap = {
    any: $f752ae48e2391bef$var$asValue,
    color: $f752ae48e2391bef$var$asColor,
    url: $f752ae48e2391bef$var$guess($5pHOO.url),
    image: $f752ae48e2391bef$var$guess($5pHOO.image),
    length: $f752ae48e2391bef$var$guess($5pHOO.length),
    percentage: $f752ae48e2391bef$var$guess($5pHOO.percentage),
    position: $f752ae48e2391bef$var$guess($5pHOO.position),
    lookup: $f752ae48e2391bef$var$asLookupValue,
    "generic-name": $f752ae48e2391bef$var$guess($5pHOO.genericName),
    "family-name": $f752ae48e2391bef$var$guess($5pHOO.familyName),
    number: $f752ae48e2391bef$var$guess($5pHOO.number),
    "line-width": $f752ae48e2391bef$var$guess($5pHOO.lineWidth),
    "absolute-size": $f752ae48e2391bef$var$guess($5pHOO.absoluteSize),
    "relative-size": $f752ae48e2391bef$var$guess($5pHOO.relativeSize),
    shadow: $f752ae48e2391bef$var$guess($5pHOO.shadow),
    size: $f752ae48e2391bef$var$guess($cZjON.backgroundSize)
};
let $f752ae48e2391bef$var$supportedTypes = Object.keys($f752ae48e2391bef$var$typeMap);
function $f752ae48e2391bef$var$splitAtFirst(input, delim) {
    let idx = input.indexOf(delim);
    if (idx === -1) return [
        undefined,
        input
    ];
    return [
        input.slice(0, idx),
        input.slice(idx + 1)
    ];
}
function $f752ae48e2391bef$var$coerceValue(types, modifier, options, tailwindConfig) {
    if (options.values && modifier in options.values) for (let { type: type } of types !== null && types !== void 0 ? types : []){
        let result = $f752ae48e2391bef$var$typeMap[type](modifier, options, {
            tailwindConfig: tailwindConfig
        });
        if (result === undefined) continue;
        return [
            result,
            type,
            null
        ];
    }
    if ($f752ae48e2391bef$var$isArbitraryValue(modifier)) {
        let arbitraryValue = modifier.slice(1, -1);
        let [explicitType, value] = $f752ae48e2391bef$var$splitAtFirst(arbitraryValue, ":");
        // It could be that this resolves to `url(https` which is not a valid
        // identifier. We currently only support "simple" words with dashes or
        // underscores. E.g.: family-name
        if (!/^[\w-_]+$/g.test(explicitType)) value = arbitraryValue;
        else if (explicitType !== undefined && !$f752ae48e2391bef$var$supportedTypes.includes(explicitType)) return [];
        if (value.length > 0 && $f752ae48e2391bef$var$supportedTypes.includes(explicitType)) return [
            $f752ae48e2391bef$var$asValue(`[${value}]`, options),
            explicitType,
            null
        ];
    }
    let matches = $f752ae48e2391bef$var$getMatchingTypes(types, modifier, options, tailwindConfig);
    // Find first matching type
    for (let match of matches)return match;
    return [];
}
function* $f752ae48e2391bef$var$getMatchingTypes(types, rawModifier, options, tailwindConfig) {
    let modifiersEnabled = (0, $9Wjkp.flagEnabled)(tailwindConfig, "generalizedModifiers");
    let [modifier, utilityModifier] = $f752ae48e2391bef$var$splitUtilityModifier(rawModifier);
    let canUseUtilityModifier = modifiersEnabled && options.modifiers != null && (options.modifiers === "any" || typeof options.modifiers === "object" && (utilityModifier && $f752ae48e2391bef$var$isArbitraryValue(utilityModifier) || utilityModifier in options.modifiers));
    if (!canUseUtilityModifier) {
        modifier = rawModifier;
        utilityModifier = undefined;
    }
    if (utilityModifier !== undefined && modifier === "") modifier = "DEFAULT";
    // Check the full value first
    // TODO: Move to asValue… somehow
    if (utilityModifier !== undefined) {
        if (typeof options.modifiers === "object") {
            var _options_modifiers;
            var _options_modifiers_utilityModifier;
            let configValue = (_options_modifiers_utilityModifier = (_options_modifiers = options.modifiers) === null || _options_modifiers === void 0 ? void 0 : _options_modifiers[utilityModifier]) !== null && _options_modifiers_utilityModifier !== void 0 ? _options_modifiers_utilityModifier : null;
            if (configValue !== null) utilityModifier = configValue;
            else if ($f752ae48e2391bef$var$isArbitraryValue(utilityModifier)) utilityModifier = $f752ae48e2391bef$var$unwrapArbitraryModifier(utilityModifier);
        }
    }
    for (let { type: type } of types !== null && types !== void 0 ? types : []){
        let result = $f752ae48e2391bef$var$typeMap[type](modifier, options, {
            tailwindConfig: tailwindConfig
        });
        if (result === undefined) continue;
        yield [
            result,
            type,
            utilityModifier !== null && utilityModifier !== void 0 ? utilityModifier : null
        ];
    }
}

});
parcelRegister("kpO0N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $edccefc28555ef50$var$escapeCommas;
    }
});
function $edccefc28555ef50$var$escapeCommas(className) {
    return className.replace(/\\,/g, "\\2c ");
}

});

parcelRegister("y20xN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $0664bbcaef026d49$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$0664bbcaef026d49$var$_export(module.exports, {
    withAlphaValue: function() {
        return $0664bbcaef026d49$var$withAlphaValue;
    },
    default: function() {
        return $0664bbcaef026d49$var$withAlphaVariable;
    }
});

var $eU4qi = parcelRequire("eU4qi");
function $0664bbcaef026d49$var$withAlphaValue(color, alphaValue, defaultValue) {
    if (typeof color === "function") return color({
        opacityValue: alphaValue
    });
    let parsed = (0, $eU4qi.parseColor)(color, {
        loose: true
    });
    if (parsed === null) return defaultValue;
    return (0, $eU4qi.formatColor)({
        ...parsed,
        alpha: alphaValue
    });
}
function $0664bbcaef026d49$var$withAlphaVariable({ color: color, property: property, variable: variable }) {
    let properties = [].concat(property);
    if (typeof color === "function") return {
        [variable]: "1",
        ...Object.fromEntries(properties.map((p)=>{
            return [
                p,
                color({
                    opacityVariable: variable,
                    opacityValue: `var(${variable})`
                })
            ];
        }))
    };
    const parsed = (0, $eU4qi.parseColor)(color);
    if (parsed === null) return Object.fromEntries(properties.map((p)=>[
            p,
            color
        ]));
    if (parsed.alpha !== undefined) // Has an alpha value, return color as-is
    return Object.fromEntries(properties.map((p)=>[
            p,
            color
        ]));
    return {
        [variable]: "1",
        ...Object.fromEntries(properties.map((p)=>{
            return [
                p,
                (0, $eU4qi.formatColor)({
                    ...parsed,
                    alpha: `var(${variable})`
                })
            ];
        }))
    };
}

});
parcelRegister("eU4qi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $ad99b9fcfe78cf50$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$ad99b9fcfe78cf50$var$_export(module.exports, {
    parseColor: function() {
        return $ad99b9fcfe78cf50$var$parseColor;
    },
    formatColor: function() {
        return $ad99b9fcfe78cf50$var$formatColor;
    }
});

const $ad99b9fcfe78cf50$var$_colorNames = /*#__PURE__*/ $ad99b9fcfe78cf50$var$_interop_require_default((parcelRequire("8sMdR")));
function $ad99b9fcfe78cf50$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let $ad99b9fcfe78cf50$var$HEX = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i;
let $ad99b9fcfe78cf50$var$SHORT_HEX = /^#([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i;
let $ad99b9fcfe78cf50$var$VALUE = /(?:\d+|\d*\.\d+)%?/;
let $ad99b9fcfe78cf50$var$SEP = /(?:\s*,\s*|\s+)/;
let $ad99b9fcfe78cf50$var$ALPHA_SEP = /\s*[,/]\s*/;
let $ad99b9fcfe78cf50$var$CUSTOM_PROPERTY = /var\(--(?:[^ )]*?)(?:,(?:[^ )]*?|var\(--[^ )]*?\)))?\)/;
let $ad99b9fcfe78cf50$var$RGB = new RegExp(`^(rgba?)\\(\\s*(${$ad99b9fcfe78cf50$var$VALUE.source}|${$ad99b9fcfe78cf50$var$CUSTOM_PROPERTY.source})(?:${$ad99b9fcfe78cf50$var$SEP.source}(${$ad99b9fcfe78cf50$var$VALUE.source}|${$ad99b9fcfe78cf50$var$CUSTOM_PROPERTY.source}))?(?:${$ad99b9fcfe78cf50$var$SEP.source}(${$ad99b9fcfe78cf50$var$VALUE.source}|${$ad99b9fcfe78cf50$var$CUSTOM_PROPERTY.source}))?(?:${$ad99b9fcfe78cf50$var$ALPHA_SEP.source}(${$ad99b9fcfe78cf50$var$VALUE.source}|${$ad99b9fcfe78cf50$var$CUSTOM_PROPERTY.source}))?\\s*\\)$`);
let $ad99b9fcfe78cf50$var$HSL = new RegExp(`^(hsla?)\\(\\s*((?:${$ad99b9fcfe78cf50$var$VALUE.source})(?:deg|rad|grad|turn)?|${$ad99b9fcfe78cf50$var$CUSTOM_PROPERTY.source})(?:${$ad99b9fcfe78cf50$var$SEP.source}(${$ad99b9fcfe78cf50$var$VALUE.source}|${$ad99b9fcfe78cf50$var$CUSTOM_PROPERTY.source}))?(?:${$ad99b9fcfe78cf50$var$SEP.source}(${$ad99b9fcfe78cf50$var$VALUE.source}|${$ad99b9fcfe78cf50$var$CUSTOM_PROPERTY.source}))?(?:${$ad99b9fcfe78cf50$var$ALPHA_SEP.source}(${$ad99b9fcfe78cf50$var$VALUE.source}|${$ad99b9fcfe78cf50$var$CUSTOM_PROPERTY.source}))?\\s*\\)$`);
function $ad99b9fcfe78cf50$var$parseColor(value, { loose: loose = false } = {}) {
    var _match_, _match__toString;
    if (typeof value !== "string") return null;
    value = value.trim();
    if (value === "transparent") return {
        mode: "rgb",
        color: [
            "0",
            "0",
            "0"
        ],
        alpha: "0"
    };
    if (value in $ad99b9fcfe78cf50$var$_colorNames.default) return {
        mode: "rgb",
        color: $ad99b9fcfe78cf50$var$_colorNames.default[value].map((v)=>v.toString())
    };
    let hex = value.replace($ad99b9fcfe78cf50$var$SHORT_HEX, (_, r, g, b, a)=>[
            "#",
            r,
            r,
            g,
            g,
            b,
            b,
            a ? a + a : ""
        ].join("")).match($ad99b9fcfe78cf50$var$HEX);
    if (hex !== null) return {
        mode: "rgb",
        color: [
            parseInt(hex[1], 16),
            parseInt(hex[2], 16),
            parseInt(hex[3], 16)
        ].map((v)=>v.toString()),
        alpha: hex[4] ? (parseInt(hex[4], 16) / 255).toString() : undefined
    };
    var _value_match;
    let match = (_value_match = value.match($ad99b9fcfe78cf50$var$RGB)) !== null && _value_match !== void 0 ? _value_match : value.match($ad99b9fcfe78cf50$var$HSL);
    if (match === null) return null;
    let color = [
        match[2],
        match[3],
        match[4]
    ].filter(Boolean).map((v)=>v.toString());
    // rgba(var(--my-color), 0.1)
    // hsla(var(--my-color), 0.1)
    if (color.length === 2 && color[0].startsWith("var(")) return {
        mode: match[1],
        color: [
            color[0]
        ],
        alpha: color[1]
    };
    if (!loose && color.length !== 3) return null;
    if (color.length < 3 && !color.some((part)=>/^var\(.*?\)$/.test(part))) return null;
    return {
        mode: match[1],
        color: color,
        alpha: (_match_ = match[5]) === null || _match_ === void 0 ? void 0 : (_match__toString = _match_.toString) === null || _match__toString === void 0 ? void 0 : _match__toString.call(_match_)
    };
}
function $ad99b9fcfe78cf50$var$formatColor({ mode: mode, color: color, alpha: alpha }) {
    let hasAlpha = alpha !== undefined;
    if (mode === "rgba" || mode === "hsla") return `${mode}(${color.join(", ")}${hasAlpha ? `, ${alpha}` : ""})`;
    return `${mode}(${color.join(" ")}${hasAlpha ? ` / ${alpha}` : ""})`;
}

});
parcelRegister("8sMdR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $62965843170fc165$var$_default;
    }
});
const $62965843170fc165$var$_default = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};

});



parcelRegister("5pHOO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $3f1147054f625e27$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$3f1147054f625e27$var$_export(module.exports, {
    normalize: function() {
        return $3f1147054f625e27$var$normalize;
    },
    normalizeAttributeSelectors: function() {
        return $3f1147054f625e27$var$normalizeAttributeSelectors;
    },
    url: function() {
        return $3f1147054f625e27$var$url;
    },
    number: function() {
        return $3f1147054f625e27$var$number;
    },
    percentage: function() {
        return $3f1147054f625e27$var$percentage;
    },
    length: function() {
        return $3f1147054f625e27$var$length;
    },
    lineWidth: function() {
        return $3f1147054f625e27$var$lineWidth;
    },
    shadow: function() {
        return $3f1147054f625e27$var$shadow;
    },
    color: function() {
        return $3f1147054f625e27$var$color;
    },
    image: function() {
        return $3f1147054f625e27$var$image;
    },
    gradient: function() {
        return $3f1147054f625e27$var$gradient;
    },
    position: function() {
        return $3f1147054f625e27$var$position;
    },
    familyName: function() {
        return $3f1147054f625e27$var$familyName;
    },
    genericName: function() {
        return $3f1147054f625e27$var$genericName;
    },
    absoluteSize: function() {
        return $3f1147054f625e27$var$absoluteSize;
    },
    relativeSize: function() {
        return $3f1147054f625e27$var$relativeSize;
    }
});

var $eU4qi = parcelRequire("eU4qi");

var $eMpJY = parcelRequire("eMpJY");

var $7OLFY = parcelRequire("7OLFY");
let $3f1147054f625e27$var$cssFunctions = [
    "min",
    "max",
    "clamp",
    "calc"
];
// Ref: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Types
function $3f1147054f625e27$var$isCSSFunction(value) {
    return $3f1147054f625e27$var$cssFunctions.some((fn)=>new RegExp(`^${fn}\\(.*\\)`).test(value));
}
// These properties accept a `<dashed-ident>` as one of the values. This means that you can use them
// as: `timeline-scope: --tl;`
//
// Without the `var(--tl)`, in these cases we don't want to normalize the value, and you should add
// the `var()` yourself.
//
// More info:
// - https://drafts.csswg.org/scroll-animations/#propdef-timeline-scope
// - https://developer.mozilla.org/en-US/docs/Web/CSS/timeline-scope#dashed-ident
// - https://www.w3.org/TR/css-anchor-position-1
//
const $3f1147054f625e27$var$AUTO_VAR_INJECTION_EXCEPTIONS = new Set([
    // Concrete properties
    "scroll-timeline-name",
    "timeline-scope",
    "view-timeline-name",
    "font-palette",
    "anchor-name",
    "anchor-scope",
    "position-anchor",
    "position-try-options",
    // Shorthand properties
    "scroll-timeline",
    "animation-timeline",
    "view-timeline",
    "position-try"
]);
function $3f1147054f625e27$var$normalize(value, context = null, isRoot = true) {
    let isVarException = context && $3f1147054f625e27$var$AUTO_VAR_INJECTION_EXCEPTIONS.has(context.property);
    if (value.startsWith("--") && !isVarException) return `var(${value})`;
    // Keep raw strings if it starts with `url(`
    if (value.includes("url(")) return value.split(/(url\(.*?\))/g).filter(Boolean).map((part)=>{
        if (/^url\(.*?\)$/.test(part)) return part;
        return $3f1147054f625e27$var$normalize(part, context, false);
    }).join("");
    // Convert `_` to ` `, except for escaped underscores `\_`
    value = value.replace(/([^\\])_+/g, (fullMatch, characterBefore)=>characterBefore + " ".repeat(fullMatch.length - 1)).replace(/^_/g, " ").replace(/\\_/g, "_");
    // Remove leftover whitespace
    if (isRoot) value = value.trim();
    value = $3f1147054f625e27$var$normalizeMathOperatorSpacing(value);
    return value;
}
function $3f1147054f625e27$var$normalizeAttributeSelectors(value) {
    // Wrap values in attribute selectors with quotes
    if (value.includes("=")) value = value.replace(/(=.*)/g, (_fullMatch, match)=>{
        if (match[1] === "'" || match[1] === '"') return match;
        // Handle regex flags on unescaped values
        if (match.length > 2) {
            let trailingCharacter = match[match.length - 1];
            if (match[match.length - 2] === " " && (trailingCharacter === "i" || trailingCharacter === "I" || trailingCharacter === "s" || trailingCharacter === "S")) return `="${match.slice(1, -2)}" ${match[match.length - 1]}`;
        }
        return `="${match.slice(1)}"`;
    });
    return value;
}
/**
 * Add spaces around operators inside math functions
 * like calc() that do not follow an operator, '(', or `,`.
 *
 * @param {string} value
 * @returns {string}
 */ function $3f1147054f625e27$var$normalizeMathOperatorSpacing(value) {
    let preventFormattingInFunctions = [
        "theme"
    ];
    let preventFormattingKeywords = [
        "min-content",
        "max-content",
        "fit-content",
        // Env
        "safe-area-inset-top",
        "safe-area-inset-right",
        "safe-area-inset-bottom",
        "safe-area-inset-left",
        "titlebar-area-x",
        "titlebar-area-y",
        "titlebar-area-width",
        "titlebar-area-height",
        "keyboard-inset-top",
        "keyboard-inset-right",
        "keyboard-inset-bottom",
        "keyboard-inset-left",
        "keyboard-inset-width",
        "keyboard-inset-height",
        "radial-gradient",
        "linear-gradient",
        "conic-gradient",
        "repeating-radial-gradient",
        "repeating-linear-gradient",
        "repeating-conic-gradient",
        "anchor-size"
    ];
    return value.replace(/(calc|min|max|clamp)\(.+\)/g, (match)=>{
        let result = "";
        function lastChar() {
            let char = result.trimEnd();
            return char[char.length - 1];
        }
        for(let i = 0; i < match.length; i++){
            function peek(word) {
                return word.split("").every((char, j)=>match[i + j] === char);
            }
            function consumeUntil(chars) {
                let minIndex = Infinity;
                for (let char of chars){
                    let index = match.indexOf(char, i);
                    if (index !== -1 && index < minIndex) minIndex = index;
                }
                let result = match.slice(i, minIndex);
                i += result.length - 1;
                return result;
            }
            let char = match[i];
            // Handle `var(--variable)`
            if (peek("var")) // When we consume until `)`, then we are dealing with this scenario:
            //   `var(--example)`
            //
            // When we consume until `,`, then we are dealing with this scenario:
            //   `var(--example, 1rem)`
            //
            //   In this case we do want to "format", the default value as well
            result += consumeUntil([
                ")",
                ","
            ]);
            else if (preventFormattingKeywords.some((keyword)=>peek(keyword))) {
                let keyword = preventFormattingKeywords.find((keyword)=>peek(keyword));
                result += keyword;
                i += keyword.length - 1;
            } else if (preventFormattingInFunctions.some((fn)=>peek(fn))) result += consumeUntil([
                ")"
            ]);
            else if (peek("[")) result += consumeUntil([
                "]"
            ]);
            else if ([
                "+",
                "-",
                "*",
                "/"
            ].includes(char) && ![
                "(",
                "+",
                "-",
                "*",
                "/",
                ","
            ].includes(lastChar())) result += ` ${char} `;
            else result += char;
        }
        // Simplify multiple spaces
        return result.replace(/\s+/g, " ");
    });
}
function $3f1147054f625e27$var$url(value) {
    return value.startsWith("url(");
}
function $3f1147054f625e27$var$number(value) {
    return !isNaN(Number(value)) || $3f1147054f625e27$var$isCSSFunction(value);
}
function $3f1147054f625e27$var$percentage(value) {
    return value.endsWith("%") && $3f1147054f625e27$var$number(value.slice(0, -1)) || $3f1147054f625e27$var$isCSSFunction(value);
}
// Please refer to MDN when updating this list:
// https://developer.mozilla.org/en-US/docs/Learn/CSS/Building_blocks/Values_and_units
// https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Container_Queries#container_query_length_units
let $3f1147054f625e27$var$lengthUnits = [
    "cm",
    "mm",
    "Q",
    "in",
    "pc",
    "pt",
    "px",
    "em",
    "ex",
    "ch",
    "rem",
    "lh",
    "rlh",
    "vw",
    "vh",
    "vmin",
    "vmax",
    "vb",
    "vi",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh",
    "cqw",
    "cqh",
    "cqi",
    "cqb",
    "cqmin",
    "cqmax"
];
let $3f1147054f625e27$var$lengthUnitsPattern = `(?:${$3f1147054f625e27$var$lengthUnits.join("|")})`;
function $3f1147054f625e27$var$length(value) {
    return value === "0" || new RegExp(`^[+-]?[0-9]*\.?[0-9]+(?:[eE][+-]?[0-9]+)?${$3f1147054f625e27$var$lengthUnitsPattern}$`).test(value) || $3f1147054f625e27$var$isCSSFunction(value);
}
let $3f1147054f625e27$var$lineWidths = new Set([
    "thin",
    "medium",
    "thick"
]);
function $3f1147054f625e27$var$lineWidth(value) {
    return $3f1147054f625e27$var$lineWidths.has(value);
}
function $3f1147054f625e27$var$shadow(value) {
    let parsedShadows = (0, $eMpJY.parseBoxShadowValue)($3f1147054f625e27$var$normalize(value));
    for (let parsedShadow of parsedShadows){
        if (!parsedShadow.valid) return false;
    }
    return true;
}
function $3f1147054f625e27$var$color(value) {
    let colors = 0;
    let result = (0, $7OLFY.splitAtTopLevelOnly)(value, "_").every((part)=>{
        part = $3f1147054f625e27$var$normalize(part);
        if (part.startsWith("var(")) return true;
        if ((0, $eU4qi.parseColor)(part, {
            loose: true
        }) !== null) return colors++, true;
        return false;
    });
    if (!result) return false;
    return colors > 0;
}
function $3f1147054f625e27$var$image(value) {
    let images = 0;
    let result = (0, $7OLFY.splitAtTopLevelOnly)(value, ",").every((part)=>{
        part = $3f1147054f625e27$var$normalize(part);
        if (part.startsWith("var(")) return true;
        if ($3f1147054f625e27$var$url(part) || $3f1147054f625e27$var$gradient(part) || [
            "element(",
            "image(",
            "cross-fade(",
            "image-set("
        ].some((fn)=>part.startsWith(fn))) {
            images++;
            return true;
        }
        return false;
    });
    if (!result) return false;
    return images > 0;
}
let $3f1147054f625e27$var$gradientTypes = new Set([
    "conic-gradient",
    "linear-gradient",
    "radial-gradient",
    "repeating-conic-gradient",
    "repeating-linear-gradient",
    "repeating-radial-gradient"
]);
function $3f1147054f625e27$var$gradient(value) {
    value = $3f1147054f625e27$var$normalize(value);
    for (let type of $3f1147054f625e27$var$gradientTypes){
        if (value.startsWith(`${type}(`)) return true;
    }
    return false;
}
let $3f1147054f625e27$var$validPositions = new Set([
    "center",
    "top",
    "right",
    "bottom",
    "left"
]);
function $3f1147054f625e27$var$position(value) {
    let positions = 0;
    let result = (0, $7OLFY.splitAtTopLevelOnly)(value, "_").every((part)=>{
        part = $3f1147054f625e27$var$normalize(part);
        if (part.startsWith("var(")) return true;
        if ($3f1147054f625e27$var$validPositions.has(part) || $3f1147054f625e27$var$length(part) || $3f1147054f625e27$var$percentage(part)) {
            positions++;
            return true;
        }
        return false;
    });
    if (!result) return false;
    return positions > 0;
}
function $3f1147054f625e27$var$familyName(value) {
    let fonts = 0;
    let result = (0, $7OLFY.splitAtTopLevelOnly)(value, ",").every((part)=>{
        part = $3f1147054f625e27$var$normalize(part);
        if (part.startsWith("var(")) return true;
        // If it contains spaces, then it should be quoted
        if (part.includes(" ")) {
            if (!/(['"])([^"']+)\1/g.test(part)) return false;
        }
        // If it starts with a number, it's invalid
        if (/^\d/g.test(part)) return false;
        fonts++;
        return true;
    });
    if (!result) return false;
    return fonts > 0;
}
let $3f1147054f625e27$var$genericNames = new Set([
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui",
    "ui-serif",
    "ui-sans-serif",
    "ui-monospace",
    "ui-rounded",
    "math",
    "emoji",
    "fangsong"
]);
function $3f1147054f625e27$var$genericName(value) {
    return $3f1147054f625e27$var$genericNames.has(value);
}
let $3f1147054f625e27$var$absoluteSizes = new Set([
    "xx-small",
    "x-small",
    "small",
    "medium",
    "large",
    "x-large",
    "xx-large",
    "xxx-large"
]);
function $3f1147054f625e27$var$absoluteSize(value) {
    return $3f1147054f625e27$var$absoluteSizes.has(value);
}
let $3f1147054f625e27$var$relativeSizes = new Set([
    "larger",
    "smaller"
]);
function $3f1147054f625e27$var$relativeSize(value) {
    return $3f1147054f625e27$var$relativeSizes.has(value);
}

});
parcelRegister("eMpJY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $ac2983e9e299b64a$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$ac2983e9e299b64a$var$_export(module.exports, {
    parseBoxShadowValue: function() {
        return $ac2983e9e299b64a$var$parseBoxShadowValue;
    },
    formatBoxShadowValue: function() {
        return $ac2983e9e299b64a$var$formatBoxShadowValue;
    }
});

var $7OLFY = parcelRequire("7OLFY");
let $ac2983e9e299b64a$var$KEYWORDS = new Set([
    "inset",
    "inherit",
    "initial",
    "revert",
    "unset"
]);
let $ac2983e9e299b64a$var$SPACE = /\ +(?![^(]*\))/g // Similar to the one above, but with spaces instead.
;
let $ac2983e9e299b64a$var$LENGTH = /^-?(\d+|\.\d+)(.*?)$/g;
function $ac2983e9e299b64a$var$parseBoxShadowValue(input) {
    let shadows = (0, $7OLFY.splitAtTopLevelOnly)(input, ",");
    return shadows.map((shadow)=>{
        let value = shadow.trim();
        let result = {
            raw: value
        };
        let parts = value.split($ac2983e9e299b64a$var$SPACE);
        let seen = new Set();
        for (let part of parts){
            // Reset index, since the regex is stateful.
            $ac2983e9e299b64a$var$LENGTH.lastIndex = 0;
            // Keyword
            if (!seen.has("KEYWORD") && $ac2983e9e299b64a$var$KEYWORDS.has(part)) {
                result.keyword = part;
                seen.add("KEYWORD");
            } else if ($ac2983e9e299b64a$var$LENGTH.test(part)) {
                if (!seen.has("X")) {
                    result.x = part;
                    seen.add("X");
                } else if (!seen.has("Y")) {
                    result.y = part;
                    seen.add("Y");
                } else if (!seen.has("BLUR")) {
                    result.blur = part;
                    seen.add("BLUR");
                } else if (!seen.has("SPREAD")) {
                    result.spread = part;
                    seen.add("SPREAD");
                }
            } else if (!result.color) result.color = part;
            else {
                if (!result.unknown) result.unknown = [];
                result.unknown.push(part);
            }
        }
        // Check if valid
        result.valid = result.x !== undefined && result.y !== undefined;
        return result;
    });
}
function $ac2983e9e299b64a$var$formatBoxShadowValue(shadows) {
    return shadows.map((shadow)=>{
        if (!shadow.valid) return shadow.raw;
        return [
            shadow.keyword,
            shadow.x,
            shadow.y,
            shadow.blur,
            shadow.spread,
            shadow.color
        ].filter(Boolean).join(" ");
    }).join(", ");
}

});
parcelRegister("7OLFY", function(module, exports) {
/**
 * This splits a string on a top-level character.
 *
 * Regex doesn't support recursion (at least not the JS-flavored version).
 * So we have to use a tiny state machine to keep track of paren placement.
 *
 * Expected behavior using commas:
 * var(--a, 0 0 1px rgb(0, 0, 0)), 0 0 1px rgb(0, 0, 0)
 *       ─┬─             ┬  ┬    ┬
 *        x              x  x    ╰──────── Split because top-level
 *        ╰──────────────┴──┴───────────── Ignored b/c inside >= 1 levels of parens
 *
 * @param {string} input
 * @param {string} separator
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "splitAtTopLevelOnly", {
    enumerable: true,
    get: function() {
        return $5b122f5edbf1d93d$var$splitAtTopLevelOnly;
    }
});
function $5b122f5edbf1d93d$var$splitAtTopLevelOnly(input, separator) {
    let stack = [];
    let parts = [];
    let lastPos = 0;
    let isEscaped = false;
    for(let idx = 0; idx < input.length; idx++){
        let char = input[idx];
        if (stack.length === 0 && char === separator[0] && !isEscaped) {
            if (separator.length === 1 || input.slice(idx, idx + separator.length) === separator) {
                parts.push(input.slice(lastPos, idx));
                lastPos = idx + separator.length;
            }
        }
        isEscaped = isEscaped ? false : char === "\\";
        if (char === "(" || char === "[" || char === "{") stack.push(char);
        else if (char === ")" && stack[stack.length - 1] === "(" || char === "]" && stack[stack.length - 1] === "[" || char === "}" && stack[stack.length - 1] === "{") stack.pop();
    }
    parts.push(input.slice(lastPos));
    return parts;
}

});



parcelRegister("cZjON", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "backgroundSize", {
    enumerable: true,
    get: function() {
        return $974a8e0c35b4e1c6$var$backgroundSize;
    }
});

var $5pHOO = parcelRequire("5pHOO");

var $7OLFY = parcelRequire("7OLFY");
function $974a8e0c35b4e1c6$var$backgroundSize(value) {
    let keywordValues = [
        "cover",
        "contain"
    ];
    // the <length-percentage> type will probably be a css function
    // so we have to use `splitAtTopLevelOnly`
    return (0, $7OLFY.splitAtTopLevelOnly)(value, ",").every((part)=>{
        let sizes = (0, $7OLFY.splitAtTopLevelOnly)(part, "_").filter(Boolean);
        if (sizes.length === 1 && keywordValues.includes(sizes[0])) return true;
        if (sizes.length !== 1 && sizes.length !== 2) return false;
        return sizes.every((size)=>(0, $5pHOO.length)(size) || (0, $5pHOO.percentage)(size) || size === "auto");
    });
}

});


parcelRegister("4m112", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $32ba0130a0b60e0d$var$toColorValue;
    }
});
function $32ba0130a0b60e0d$var$toColorValue(maybeFunction) {
    return typeof maybeFunction === "function" ? maybeFunction({}) : maybeFunction;
}

});


parcelRegister("hKw0S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cebf90b2e980ac14$var$getAllConfigs;
    }
});

const $cebf90b2e980ac14$var$_configfull = /*#__PURE__*/ $cebf90b2e980ac14$var$_interop_require_default((parcelRequire("4Ie2b")));

var $9Wjkp = parcelRequire("9Wjkp");
function $cebf90b2e980ac14$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cebf90b2e980ac14$var$getAllConfigs(config) {
    var _config_presets;
    const configs = ((_config_presets = config === null || config === void 0 ? void 0 : config.presets) !== null && _config_presets !== void 0 ? _config_presets : [
        $cebf90b2e980ac14$var$_configfull.default
    ]).slice().reverse().flatMap((preset)=>$cebf90b2e980ac14$var$getAllConfigs(preset instanceof Function ? preset() : preset));
    const features = {
        // Add experimental configs here...
        respectDefaultRingColorOpacity: {
            theme: {
                ringColor: ({ theme: theme })=>({
                        DEFAULT: "#3b82f67f",
                        ...theme("colors")
                    })
            }
        },
        disableColorOpacityUtilitiesByDefault: {
            corePlugins: {
                backgroundOpacity: false,
                borderOpacity: false,
                divideOpacity: false,
                placeholderOpacity: false,
                ringOpacity: false,
                textOpacity: false
            }
        }
    };
    const experimentals = Object.keys(features).filter((feature)=>(0, $9Wjkp.flagEnabled)(config, feature)).map((feature)=>features[feature]);
    return [
        config,
        ...experimentals,
        ...configs
    ];
}

});


function $20e8b1c4c5440ada$var$debounce(func, timeout = 800) {
    // call the function passed as argument only after a set amount of time has passed
    // prevent launching an action when the user is still actively changing the value
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(this, args);
        }, timeout);
    };
}
const $20e8b1c4c5440ada$export$f2cc568221ba213f = ((o)=>{
    o.search = {
        init: function() {
            o.search.initFacetWidgets();
        },
        initFacetWidgets: ()=>{
            // Bind events to facet checkboxes
            const facet_checkboxes = Array.from(document.getElementsByClassName("facet_checkbox"));
            facet_checkboxes.forEach((facet_checkbox)=>{
                facet_checkbox.addEventListener("change", (event)=>{
                    window.location.href = event.target.nextElementSibling.value;
                });
            });
        }
    };
    o.customer = {
        initOrderDetail: ()=>{
            function setCurrentOrder(label) {
                const clickEvent = new MouseEvent("click", {
                    view: window,
                    bubbles: true,
                    cancelable: false
                });
                label.dispatchEvent(clickEvent);
                label.classList.add("selected-tab");
            }
            const selectOrder = document.getElementById("order_select");
            setCurrentOrder(selectOrder.children[0]);
            const labels = Array.from(selectOrder.children);
            labels.forEach((label)=>{
                label.addEventListener("click", (e)=>{
                    labels.forEach((l)=>l.classList.remove("selected-tab"));
                    label.classList.add("selected-tab");
                });
            });
        }
    };
    o.notifications = {
        init: function() {
            const buttons = Array.from(document.getElementsByClassName("notif-update"));
            buttons.forEach((button, index)=>{
                button.addEventListener("click", (event)=>{
                    const checkboxTarget = button.getAttribute("data-target");
                    const typeTarget = button.getAttribute("data-type");
                    const checkbox = document.getElementById(checkboxTarget);
                    checkbox.checked = true;
                    const submitTypeInput = document.getElementById(`action-${typeTarget}`);
                    submitTypeInput.checked = true;
                    submitTypeInput.form.submit();
                });
            });
        }
    };
    o.productDetail = {
        updateSelectableAttributes: (selectionAttrUrl, attributes, index)=>{
            const formValues = attributes.reduce((acc, elt)=>{
                acc[elt.name] = elt.value;
                return acc;
            }, {});
            fetch(`${selectionAttrUrl}?${new URLSearchParams(formValues)}`, {
                method: "GET"
            }).then((response)=>response.json()).then((data)=>{
                attributes.filter((value, i)=>i !== index).forEach((update_attr)=>{
                    for (const option of update_attr){
                        let selectable = data[update_attr.name][option.label];
                        if (selectable === undefined) selectable = true;
                        option.disabled = !selectable;
                    }
                });
            });
        },
        initAddToBasket: (childProductSelected = false)=>{
            const addToBasketForm = document.getElementById("add_to_basket_form");
            const selectionAttrUrl = addToBasketForm.getAttribute("selectionAttrUrl");
            const attributes = Array.from(document.getElementsByClassName("attribute-select"));
            attributes.forEach((attr, index)=>{
                attr.addEventListener("change", (event)=>{
                    if (attributes.every((elt)=>elt.value) || childProductSelected) {
                        addToBasketForm.method = "get";
                        addToBasketForm.action = document.location;
                        const inputs = Array.from(addToBasketForm.getElementsByTagName("input"));
                        inputs.forEach((input)=>{
                            if (input.type === "hidden") input.disabled = true;
                        });
                        addToBasketForm.submit();
                        return;
                    }
                    o.productDetail.updateSelectableAttributes(selectionAttrUrl, attributes, index);
                });
            });
            if (attributes.some((elt)=>elt.value)) o.productDetail.updateSelectableAttributes(selectionAttrUrl, attributes, -1);
        }
    };
    return o;
})({});
const $20e8b1c4c5440ada$export$97d12247d9e02166 = (()=>{
    return {
        init: ()=>{
            $20e8b1c4c5440ada$export$97d12247d9e02166.initAutoSubmit();
            $20e8b1c4c5440ada$export$97d12247d9e02166.initSubmitOnce();
            $20e8b1c4c5440ada$export$97d12247d9e02166.initToggleRadio();
        },
        initAutoSubmit: ()=>{
            // set class on a field to automatically submit the associated form if that field change value
            const fields = Array.from(document.getElementsByClassName("auto-submit"));
            fields.forEach((field, index)=>{
                field.addEventListener("change", (event)=>{
                    event.target.form.submit();
                });
            });
        },
        initSubmitOnce: ()=>{
            // set class on a form so that it can only ever be submitted once
            const forms = Array.from(document.getElementsByClassName("submit-once"));
            forms.forEach((form, index)=>{
                form.addEventListener("submit", (event)=>{
                    // ignore invalid form, the user should be able to click again after fixing errors
                    if (!event.target.checkValidity()) return;
                    if (event.target.hasAttribute("locked")) {
                        event.preventDefault();
                        return;
                    }
                    event.target.setAttribute("locked", "");
                    const buttons = Array.from(event.target.getElementsByTagName("button"));
                    buttons.forEach((button)=>{
                        if (button.type === "submit") {
                            button.disabled = true;
                            button.classList.add("cursor-wait");
                            const loadingText = button.getAttribute("data-loading-text");
                            if (loadingText) {
                                button.innerHTML = loadingText;
                                button.classList.add("!bg-dm-primary-light", "!text-white");
                            }
                        }
                    });
                });
            });
        },
        initToggleInput: (classSelector, inputName, values, extraFunction)=>{
            // For a class, get all inputs (radiobutton) with given name and toggle div with corresponding ID
            [
                ...document.getElementsByClassName(classSelector)
            ].filter((item)=>{
                return item.nodeName === "INPUT" && item.name === inputName;
            }).forEach((radioInput)=>{
                radioInput.addEventListener("change", (event)=>{
                    document.getElementById(`${inputName}-${event.target.value}`).classList.remove("hidden");
                    values.filter((value)=>value !== event.target.value).forEach((value)=>{
                        document.getElementById(`${inputName}-${value}`).classList.add("hidden");
                    });
                    if (extraFunction != null) extraFunction(event);
                });
            });
        },
        initToggleRadio: ()=>{
            // set class on a radio so that it can be unselected
            const radios = Array.from(document.getElementsByClassName("toggle-radio"));
            radios.forEach((radio, index)=>{
                radio.nextElementSibling.addEventListener("mouseup", (evt)=>{
                    if (radio.checked) setTimeout(()=>{
                        radio.checked = false;
                    });
                });
            });
        }
    };
})();
const $20e8b1c4c5440ada$export$35a1b15942a0f275 = function() {
    return {
        leftToRight: "l-to-r",
        rightToLeft: "r-to-l",
        /**
         * sliding menu initialization
         * @param menuId id of root div of sliding menu that is translated
         * @param openBtnId
         * @param hideBtnId
         * @param direction direction of translation can be "r-to-l" or "l-to-r", anything else throws an error
         */ init: function(menuId, openBtnId, hideBtnId, direction = this.rightToLeft) {
            const menu = document.getElementById(menuId);
            const openBtn = document.getElementById(openBtnId);
            const hideBtn = document.getElementById(hideBtnId);
            // default value covers "r-to-l" case
            let translation = "translate-x-full";
            if (direction === this.leftToRight) translation = "-" + translation;
            else if (direction !== this.rightToLeft) throw new Error("SlidingMenuAnimations.init(menu, direction) direction argument can only have the valus 'l-to-r' or 'r-to-l'");
            const toggleMenu = ()=>{
                menu.classList.toggle(translation);
            };
            if (openBtn) openBtn.addEventListener("click", toggleMenu);
            if (hideBtn) hideBtn.addEventListener("click", toggleMenu);
        }
    };
}();
const $20e8b1c4c5440ada$export$41d9423e59b4a594 = function() {
    return {
        /**
         * mobile nav menu
         */ catTree: null,
        /**
         * widescreen nav menu
         */ header: null,
        /**
         * entrypoint
         */ init: function() {
            this.catTree = document.getElementById("category_tree");
            this.header = document.getElementById("header");
            this._init(this.catTree);
            this._init(this.header);
            // in header, make it so left-side categories expand towards the right and vice-versa
            const rootUl = this.header.children[1];
            const middle = Math.ceil(rootUl.children.length / 2);
            for(let i = 0; i < rootUl.children.length; i++)if (i > middle) // right-side categories
            rootUl.children[i].querySelectorAll(":scope ul").forEach((ul)=>{
                Array.from(ul.children).forEach((li)=>{
                    li.classList.add("left");
                    li.parentElement.classList.add("left");
                });
            });
            else // left-side categories
            rootUl.children[i].querySelectorAll(":scope ul").forEach((ul)=>{
                Array.from(ul.children).forEach((li)=>{
                    li.classList.add("right");
                    li.parentElement.classList.add("right");
                });
            });
        },
        /**
         * set event listeners for the top-most category, then call
         * for recursive listener setting down the category tree
         * @param rootElement
         * @private
         */ _init (rootElement) {
            rootElement.addEventListener("click", (e)=>{
                rootElement.querySelector(":scope > ul").classList.toggle("expand");
                this._close_non_parents(rootElement);
                e.stopPropagation();
            });
            document.addEventListener("click", (e)=>{
                // close root menus when clicking outside the nav menu
                this._close_non_parents(rootElement, true);
            });
            const rootUl = rootElement.querySelector(":scope > ul");
            this._init_recursively(rootUl);
        },
        /**
         * recurses down the category tree setting the click event listener for every subcategory
         * @param ul
         * @private
         */ _init_recursively: function(ul) {
            const lis = ul.querySelectorAll(":scope > .has-categories");
            lis.forEach((li)=>{
                const childUl = li.querySelector(":scope ul");
                li.addEventListener("click", (e)=>{
                    if (childUl.classList.toggle("expand")) this._find_and_close_non_parents(childUl);
                    childUl.parentElement.querySelector(".material-icons").classList.toggle("rotate");
                    e.stopPropagation();
                });
                this._init_recursively(childUl);
            });
        },
        /**
         * walk up the DOM from clickedEl until reaching the root of the nav bar, flagging all HTMLElements with the
         * ".no-touch" class so they will be ignored when "closing" all menus
         * @param clickedEl
         * @private
         */ _find_and_close_non_parents: function(clickedEl) {
            clickedEl.classList.add("no-touch");
            let nextEl = clickedEl;
            const hierarchyEls = [
                clickedEl
            ];
            while(true){
                nextEl = nextEl.parentElement;
                if (nextEl.id === "category_tree" || nextEl.id === "header") break;
                nextEl.classList.add("no-touch");
                hierarchyEls.push(nextEl);
            }
            this._close_non_parents(this.catTree);
            this._close_non_parents(this.header);
            hierarchyEls.forEach((el)=>el.classList.remove("no-touch"));
        },
        /**
         * selects all children of root in order to reset their nav menu state
         * @param root
         * @param {boolean} [closeRoot=false] whether root itself should be closed
         * @private
         */ _close_non_parents (root, closeRoot = false) {
            if (closeRoot) root.querySelector(":scope > ul").classList.remove("expand");
            // remove ".expand" from all non-flagged elements that are not the open mobile menu
            root.querySelectorAll(".expand:not(.expand.no-touch):not(#category_tree>ul)").forEach((el)=>{
                el.classList.remove("expand");
                const icon = el.parentElement.querySelector(".material-icons");
                if (icon) icon.classList.remove("rotate");
            });
        }
    };
}();
const $20e8b1c4c5440ada$export$f5e4bb818687d04f = function() {
    return {
        init: function(containerId, leftButtonId, rightButtonId) {
            this.partnersContainer = document.getElementById(containerId);
            if (!this.partnersContainer) return;
            this.partnersArrowForward = document.getElementById(leftButtonId);
            this.partnersArrowBack = document.getElementById(rightButtonId);
            this.partnersContainer.onscroll = ()=>$20e8b1c4c5440ada$export$f5e4bb818687d04f.hideScrollButtons(this);
            this.partnersArrowForward.onclick = ()=>{
                const scrolled = this.partnersContainer.scrollLeft + this.partnersContainer.getBoundingClientRect().width;
                let scrollAmount = 300;
                if (scrolled >= this.partnersContainer.scrollWidth - 450) // if the remaining space on the right will be (after the click scroll is applyed) less than 150px, add those px to the scroll amount
                scrollAmount += 150;
                this.partnersContainer.scrollBy({
                    left: scrollAmount,
                    behavior: "smooth"
                });
            };
            this.partnersArrowBack.onclick = ()=>{
                let scrollAmount = 300;
                // if the remaining space on the left will be (after the click scroll is applyed) less than 150px, add those px to the scroll amount
                if (this.partnersContainer.scrollLeft <= 450) scrollAmount += 150;
                this.partnersContainer.scrollBy({
                    left: -scrollAmount,
                    behavior: "smooth"
                });
            };
            setTimeout(()=>{
                this.hideScrollButtons(this);
            });
            return this;
        },
        hideScrollButtons: function(obj) {
            const scrollLeft = obj.partnersContainer.scrollLeft;
            const scrolled = Math.ceil(scrollLeft + obj.partnersContainer.getBoundingClientRect().width);
            // {# if we scrolled at the left make the left button disapear #}
            if (scrolled === this.partnersContainer.scrollWidth) obj.partnersArrowForward.classList.add("opacity-0");
            else obj.partnersArrowForward.classList.remove("opacity-0");
            // if we scrolled at the right (with epsilon of 150px), make the right button disapear
            if (Math.floor(scrollLeft) === 0) obj.partnersArrowBack.classList.add("opacity-0");
            else obj.partnersArrowBack.classList.remove("opacity-0");
        }
    };
}();


var $90fa1419acb105b2$var$Events = /** @class */ function() {
    function Events(eventType, eventFunctions) {
        if (eventFunctions === void 0) eventFunctions = [];
        this._eventType = eventType;
        this._eventFunctions = eventFunctions;
    }
    Events.prototype.init = function() {
        var _this = this;
        this._eventFunctions.forEach(function(eventFunction) {
            if (typeof window !== "undefined") window.addEventListener(_this._eventType, eventFunction);
        });
    };
    return Events;
}();
var $90fa1419acb105b2$export$2e2bcd8739ae039 = $90fa1419acb105b2$var$Events;


var $26689838630f0c2a$var$__assign = undefined && undefined.__assign || function() {
    $26689838630f0c2a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $26689838630f0c2a$var$__assign.apply(this, arguments);
};
var $26689838630f0c2a$var$Default = {
    alwaysOpen: false,
    activeClasses: "bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white",
    inactiveClasses: "text-gray-500 dark:text-gray-400",
    onOpen: function() {},
    onClose: function() {},
    onToggle: function() {}
};
var $26689838630f0c2a$var$Accordion = /** @class */ function() {
    function Accordion(items, options) {
        if (items === void 0) items = [];
        if (options === void 0) options = $26689838630f0c2a$var$Default;
        this._items = items;
        this._options = $26689838630f0c2a$var$__assign($26689838630f0c2a$var$__assign({}, $26689838630f0c2a$var$Default), options);
        this._init();
    }
    Accordion.prototype._init = function() {
        var _this = this;
        if (this._items.length) // show accordion item based on click
        this._items.map(function(item) {
            if (item.active) _this.open(item.id);
            item.triggerEl.addEventListener("click", function() {
                _this.toggle(item.id);
            });
        });
    };
    Accordion.prototype.getItem = function(id) {
        return this._items.filter(function(item) {
            return item.id === id;
        })[0];
    };
    Accordion.prototype.open = function(id) {
        var _a, _b;
        var _this = this;
        var item = this.getItem(id);
        // don't hide other accordions if always open
        if (!this._options.alwaysOpen) this._items.map(function(i) {
            var _a, _b;
            if (i !== item) {
                (_a = i.triggerEl.classList).remove.apply(_a, _this._options.activeClasses.split(" "));
                (_b = i.triggerEl.classList).add.apply(_b, _this._options.inactiveClasses.split(" "));
                i.targetEl.classList.add("hidden");
                i.triggerEl.setAttribute("aria-expanded", "false");
                i.active = false;
                // rotate icon if set
                if (i.iconEl) i.iconEl.classList.remove("rotate-180");
            }
        });
        // show active item
        (_a = item.triggerEl.classList).add.apply(_a, this._options.activeClasses.split(" "));
        (_b = item.triggerEl.classList).remove.apply(_b, this._options.inactiveClasses.split(" "));
        item.triggerEl.setAttribute("aria-expanded", "true");
        item.targetEl.classList.remove("hidden");
        item.active = true;
        // rotate icon if set
        if (item.iconEl) item.iconEl.classList.add("rotate-180");
        // callback function
        this._options.onOpen(this, item);
    };
    Accordion.prototype.toggle = function(id) {
        var item = this.getItem(id);
        if (item.active) this.close(id);
        else this.open(id);
        // callback function
        this._options.onToggle(this, item);
    };
    Accordion.prototype.close = function(id) {
        var _a, _b;
        var item = this.getItem(id);
        (_a = item.triggerEl.classList).remove.apply(_a, this._options.activeClasses.split(" "));
        (_b = item.triggerEl.classList).add.apply(_b, this._options.inactiveClasses.split(" "));
        item.targetEl.classList.add("hidden");
        item.triggerEl.setAttribute("aria-expanded", "false");
        item.active = false;
        // rotate icon if set
        if (item.iconEl) item.iconEl.classList.remove("rotate-180");
        // callback function
        this._options.onClose(this, item);
    };
    return Accordion;
}();
function $26689838630f0c2a$export$226c1dc98323ee4d() {
    document.querySelectorAll("[data-accordion]").forEach(function($accordionEl) {
        var alwaysOpen = $accordionEl.getAttribute("data-accordion");
        var activeClasses = $accordionEl.getAttribute("data-active-classes");
        var inactiveClasses = $accordionEl.getAttribute("data-inactive-classes");
        var items = [];
        $accordionEl.querySelectorAll("[data-accordion-target]").forEach(function($triggerEl) {
            // Consider only items that directly belong to $accordionEl
            // (to make nested accordions work).
            if ($triggerEl.closest("[data-accordion]") === $accordionEl) {
                var item = {
                    id: $triggerEl.getAttribute("data-accordion-target"),
                    triggerEl: $triggerEl,
                    targetEl: document.querySelector($triggerEl.getAttribute("data-accordion-target")),
                    iconEl: $triggerEl.querySelector("[data-accordion-icon]"),
                    active: $triggerEl.getAttribute("aria-expanded") === "true" ? true : false
                };
                items.push(item);
            }
        });
        new $26689838630f0c2a$var$Accordion(items, {
            alwaysOpen: alwaysOpen === "open" ? true : false,
            activeClasses: activeClasses ? activeClasses : $26689838630f0c2a$var$Default.activeClasses,
            inactiveClasses: inactiveClasses ? inactiveClasses : $26689838630f0c2a$var$Default.inactiveClasses
        });
    });
}
if (typeof window !== "undefined") {
    window.Accordion = $26689838630f0c2a$var$Accordion;
    window.initAccordions = $26689838630f0c2a$export$226c1dc98323ee4d;
}
var $26689838630f0c2a$export$2e2bcd8739ae039 = $26689838630f0c2a$var$Accordion;


var $e6d090ef20b61d7c$var$__assign = undefined && undefined.__assign || function() {
    $e6d090ef20b61d7c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e6d090ef20b61d7c$var$__assign.apply(this, arguments);
};
var $e6d090ef20b61d7c$var$Default = {
    onCollapse: function() {},
    onExpand: function() {},
    onToggle: function() {}
};
var $e6d090ef20b61d7c$var$Collapse = /** @class */ function() {
    function Collapse(targetEl, triggerEl, options) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $e6d090ef20b61d7c$var$Default;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $e6d090ef20b61d7c$var$__assign($e6d090ef20b61d7c$var$__assign({}, $e6d090ef20b61d7c$var$Default), options);
        this._visible = false;
        this._init();
    }
    Collapse.prototype._init = function() {
        var _this = this;
        if (this._triggerEl) {
            if (this._triggerEl.hasAttribute("aria-expanded")) this._visible = this._triggerEl.getAttribute("aria-expanded") === "true";
            else // fix until v2 not to break previous single collapses which became dismiss
            this._visible = !this._targetEl.classList.contains("hidden");
            this._triggerEl.addEventListener("click", function() {
                _this.toggle();
            });
        }
    };
    Collapse.prototype.collapse = function() {
        this._targetEl.classList.add("hidden");
        if (this._triggerEl) this._triggerEl.setAttribute("aria-expanded", "false");
        this._visible = false;
        // callback function
        this._options.onCollapse(this);
    };
    Collapse.prototype.expand = function() {
        this._targetEl.classList.remove("hidden");
        if (this._triggerEl) this._triggerEl.setAttribute("aria-expanded", "true");
        this._visible = true;
        // callback function
        this._options.onExpand(this);
    };
    Collapse.prototype.toggle = function() {
        if (this._visible) this.collapse();
        else this.expand();
        // callback function
        this._options.onToggle(this);
    };
    return Collapse;
}();
function $e6d090ef20b61d7c$export$355ba5a528b4009a() {
    document.querySelectorAll("[data-collapse-toggle]").forEach(function($triggerEl) {
        var targetId = $triggerEl.getAttribute("data-collapse-toggle");
        var $targetEl = document.getElementById(targetId);
        // check if the target element exists
        if ($targetEl) new $e6d090ef20b61d7c$var$Collapse($targetEl, $triggerEl);
        else console.error('The target element with id "'.concat(targetId, '" does not exist. Please check the data-collapse-toggle attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.Collapse = $e6d090ef20b61d7c$var$Collapse;
    window.initCollapses = $e6d090ef20b61d7c$export$355ba5a528b4009a;
}
var $e6d090ef20b61d7c$export$2e2bcd8739ae039 = $e6d090ef20b61d7c$var$Collapse;


var $8d99b07e34ee7239$var$__assign = undefined && undefined.__assign || function() {
    $8d99b07e34ee7239$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8d99b07e34ee7239$var$__assign.apply(this, arguments);
};
var $8d99b07e34ee7239$var$Default = {
    defaultPosition: 0,
    indicators: {
        items: [],
        activeClasses: "bg-white dark:bg-gray-800",
        inactiveClasses: "bg-white/50 dark:bg-gray-800/50 hover:bg-white dark:hover:bg-gray-800"
    },
    interval: 3000,
    onNext: function() {},
    onPrev: function() {},
    onChange: function() {}
};
var $8d99b07e34ee7239$var$Carousel = /** @class */ function() {
    function Carousel(items, options) {
        if (items === void 0) items = [];
        if (options === void 0) options = $8d99b07e34ee7239$var$Default;
        this._items = items;
        this._options = $8d99b07e34ee7239$var$__assign($8d99b07e34ee7239$var$__assign($8d99b07e34ee7239$var$__assign({}, $8d99b07e34ee7239$var$Default), options), {
            indicators: $8d99b07e34ee7239$var$__assign($8d99b07e34ee7239$var$__assign({}, $8d99b07e34ee7239$var$Default.indicators), options.indicators)
        });
        this._activeItem = this.getItem(this._options.defaultPosition);
        this._indicators = this._options.indicators.items;
        this._intervalDuration = this._options.interval;
        this._intervalInstance = null;
        this._init();
    }
    /**
     * initialize carousel and items based on active one
     */ Carousel.prototype._init = function() {
        var _this = this;
        this._items.map(function(item) {
            item.el.classList.add("absolute", "inset-0", "transition-transform", "transform");
        });
        // if no active item is set then first position is default
        if (this._getActiveItem()) this.slideTo(this._getActiveItem().position);
        else this.slideTo(0);
        this._indicators.map(function(indicator, position) {
            indicator.el.addEventListener("click", function() {
                _this.slideTo(position);
            });
        });
    };
    Carousel.prototype.getItem = function(position) {
        return this._items[position];
    };
    /**
     * Slide to the element based on id
     * @param {*} position
     */ Carousel.prototype.slideTo = function(position) {
        var nextItem = this._items[position];
        var rotationItems = {
            left: nextItem.position === 0 ? this._items[this._items.length - 1] : this._items[nextItem.position - 1],
            middle: nextItem,
            right: nextItem.position === this._items.length - 1 ? this._items[0] : this._items[nextItem.position + 1]
        };
        this._rotate(rotationItems);
        this._setActiveItem(nextItem);
        if (this._intervalInstance) {
            this.pause();
            this.cycle();
        }
        this._options.onChange(this);
    };
    /**
     * Based on the currently active item it will go to the next position
     */ Carousel.prototype.next = function() {
        var activeItem = this._getActiveItem();
        var nextItem = null;
        // check if last item
        if (activeItem.position === this._items.length - 1) nextItem = this._items[0];
        else nextItem = this._items[activeItem.position + 1];
        this.slideTo(nextItem.position);
        // callback function
        this._options.onNext(this);
    };
    /**
     * Based on the currently active item it will go to the previous position
     */ Carousel.prototype.prev = function() {
        var activeItem = this._getActiveItem();
        var prevItem = null;
        // check if first item
        if (activeItem.position === 0) prevItem = this._items[this._items.length - 1];
        else prevItem = this._items[activeItem.position - 1];
        this.slideTo(prevItem.position);
        // callback function
        this._options.onPrev(this);
    };
    /**
     * This method applies the transform classes based on the left, middle, and right rotation carousel items
     * @param {*} rotationItems
     */ Carousel.prototype._rotate = function(rotationItems) {
        // reset
        this._items.map(function(item) {
            item.el.classList.add("hidden");
        });
        // left item (previously active)
        rotationItems.left.el.classList.remove("-translate-x-full", "translate-x-full", "translate-x-0", "hidden", "z-20");
        rotationItems.left.el.classList.add("-translate-x-full", "z-10");
        // currently active item
        rotationItems.middle.el.classList.remove("-translate-x-full", "translate-x-full", "translate-x-0", "hidden", "z-10");
        rotationItems.middle.el.classList.add("translate-x-0", "z-20");
        // right item (upcoming active)
        rotationItems.right.el.classList.remove("-translate-x-full", "translate-x-full", "translate-x-0", "hidden", "z-20");
        rotationItems.right.el.classList.add("translate-x-full", "z-10");
    };
    /**
     * Set an interval to cycle through the carousel items
     */ Carousel.prototype.cycle = function() {
        var _this = this;
        if (typeof window !== "undefined") this._intervalInstance = window.setInterval(function() {
            _this.next();
        }, this._intervalDuration);
    };
    /**
     * Clears the cycling interval
     */ Carousel.prototype.pause = function() {
        clearInterval(this._intervalInstance);
    };
    /**
     * Get the currently active item
     */ Carousel.prototype._getActiveItem = function() {
        return this._activeItem;
    };
    /**
     * Set the currently active item and data attribute
     * @param {*} position
     */ Carousel.prototype._setActiveItem = function(item) {
        var _a, _b;
        var _this = this;
        this._activeItem = item;
        var position = item.position;
        // update the indicators if available
        if (this._indicators.length) {
            this._indicators.map(function(indicator) {
                var _a, _b;
                indicator.el.setAttribute("aria-current", "false");
                (_a = indicator.el.classList).remove.apply(_a, _this._options.indicators.activeClasses.split(" "));
                (_b = indicator.el.classList).add.apply(_b, _this._options.indicators.inactiveClasses.split(" "));
            });
            (_a = this._indicators[position].el.classList).add.apply(_a, this._options.indicators.activeClasses.split(" "));
            (_b = this._indicators[position].el.classList).remove.apply(_b, this._options.indicators.inactiveClasses.split(" "));
            this._indicators[position].el.setAttribute("aria-current", "true");
        }
    };
    return Carousel;
}();
function $8d99b07e34ee7239$export$3ab77386b16b9e58() {
    document.querySelectorAll("[data-carousel]").forEach(function($carouselEl) {
        var interval = $carouselEl.getAttribute("data-carousel-interval");
        var slide = $carouselEl.getAttribute("data-carousel") === "slide" ? true : false;
        var items = [];
        var defaultPosition = 0;
        if ($carouselEl.querySelectorAll("[data-carousel-item]").length) Array.from($carouselEl.querySelectorAll("[data-carousel-item]")).map(function($carouselItemEl, position) {
            items.push({
                position: position,
                el: $carouselItemEl
            });
            if ($carouselItemEl.getAttribute("data-carousel-item") === "active") defaultPosition = position;
        });
        var indicators = [];
        if ($carouselEl.querySelectorAll("[data-carousel-slide-to]").length) Array.from($carouselEl.querySelectorAll("[data-carousel-slide-to]")).map(function($indicatorEl) {
            indicators.push({
                position: parseInt($indicatorEl.getAttribute("data-carousel-slide-to")),
                el: $indicatorEl
            });
        });
        var carousel = new $8d99b07e34ee7239$var$Carousel(items, {
            defaultPosition: defaultPosition,
            indicators: {
                items: indicators
            },
            interval: interval ? interval : $8d99b07e34ee7239$var$Default.interval
        });
        if (slide) carousel.cycle();
        // check for controls
        var carouselNextEl = $carouselEl.querySelector("[data-carousel-next]");
        var carouselPrevEl = $carouselEl.querySelector("[data-carousel-prev]");
        if (carouselNextEl) carouselNextEl.addEventListener("click", function() {
            carousel.next();
        });
        if (carouselPrevEl) carouselPrevEl.addEventListener("click", function() {
            carousel.prev();
        });
    });
}
if (typeof window !== "undefined") {
    window.Carousel = $8d99b07e34ee7239$var$Carousel;
    window.initCarousels = $8d99b07e34ee7239$export$3ab77386b16b9e58;
}
var $8d99b07e34ee7239$export$2e2bcd8739ae039 = $8d99b07e34ee7239$var$Carousel;


var $3ebd65f2e6828ef3$var$__assign = undefined && undefined.__assign || function() {
    $3ebd65f2e6828ef3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3ebd65f2e6828ef3$var$__assign.apply(this, arguments);
};
var $3ebd65f2e6828ef3$var$Default = {
    transition: "transition-opacity",
    duration: 300,
    timing: "ease-out",
    onHide: function() {}
};
var $3ebd65f2e6828ef3$var$Dismiss = /** @class */ function() {
    function Dismiss(targetEl, triggerEl, options) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $3ebd65f2e6828ef3$var$Default;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $3ebd65f2e6828ef3$var$__assign($3ebd65f2e6828ef3$var$__assign({}, $3ebd65f2e6828ef3$var$Default), options);
        this._init();
    }
    Dismiss.prototype._init = function() {
        var _this = this;
        if (this._triggerEl) this._triggerEl.addEventListener("click", function() {
            _this.hide();
        });
    };
    Dismiss.prototype.hide = function() {
        var _this = this;
        this._targetEl.classList.add(this._options.transition, "duration-".concat(this._options.duration), this._options.timing, "opacity-0");
        setTimeout(function() {
            _this._targetEl.classList.add("hidden");
        }, this._options.duration);
        // callback function
        this._options.onHide(this, this._targetEl);
    };
    return Dismiss;
}();
function $3ebd65f2e6828ef3$export$69c84787a503daef() {
    document.querySelectorAll("[data-dismiss-target]").forEach(function($triggerEl) {
        var targetId = $triggerEl.getAttribute("data-dismiss-target");
        var $dismissEl = document.querySelector(targetId);
        if ($dismissEl) new $3ebd65f2e6828ef3$var$Dismiss($dismissEl, $triggerEl);
        else console.error('The dismiss element with id "'.concat(targetId, '" does not exist. Please check the data-dismiss-target attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.Dismiss = $3ebd65f2e6828ef3$var$Dismiss;
    window.initDismisses = $3ebd65f2e6828ef3$export$69c84787a503daef;
}
var $3ebd65f2e6828ef3$export$2e2bcd8739ae039 = $3ebd65f2e6828ef3$var$Dismiss;


function $225372f33665d118$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $67c84f7b9d68974e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $225372f33665d118$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $67c84f7b9d68974e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $225372f33665d118$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $67c84f7b9d68974e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $225372f33665d118$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $e0beaf1fc26deee3$export$8960430cfd85939f = Math.max;
var $e0beaf1fc26deee3$export$96ec731ed4dcb222 = Math.min;
var $e0beaf1fc26deee3$export$2077e0241d6afd3c = Math.round;



function $6394c1ff52742048$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $df11fd8e9d8c1389$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6394c1ff52742048$export$2e2bcd8739ae039)());
}


function $1a6f7dd7003a50a1$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(element) ? (0, $225372f33665d118$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $df11fd8e9d8c1389$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $1ed31100e25348a7$export$2e2bcd8739ae039(node) {
    var win = (0, $225372f33665d118$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $729cc555c22ff063$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $bfa783b4c9ad111f$export$2e2bcd8739ae039(node) {
    if (node === (0, $225372f33665d118$export$2e2bcd8739ae039)(node) || !(0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(node)) return (0, $1ed31100e25348a7$export$2e2bcd8739ae039)(node);
    else return (0, $729cc555c22ff063$export$2e2bcd8739ae039)(node);
}


function $b053670add32783c$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $1d3b5d4e772ef8d4$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $9875449f0bf8dff4$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)((0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(element)).left + (0, $1ed31100e25348a7$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $c125cc314f75f1af$export$2e2bcd8739ae039(element) {
    return (0, $225372f33665d118$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $a527afd9af1fd91d$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $d861eebf1f8322fe$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $d861eebf1f8322fe$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(offsetParent) && $d861eebf1f8322fe$var$isElementScaled(offsetParent);
    var documentElement = (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $b053670add32783c$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $a527afd9af1fd91d$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $bfa783b4c9ad111f$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $9875449f0bf8dff4$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $c0579089f336dea9$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $49c4da5606d9971e$export$2e2bcd8739ae039(element) {
    if ((0, $b053670add32783c$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $67c84f7b9d68974e$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $c2945e92d9880f1c$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $b053670add32783c$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(node) && (0, $a527afd9af1fd91d$export$2e2bcd8739ae039)(node)) return node;
    return $c2945e92d9880f1c$export$2e2bcd8739ae039((0, $49c4da5606d9971e$export$2e2bcd8739ae039)(node));
}





function $354a82c9e8edb67d$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $c2945e92d9880f1c$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $225372f33665d118$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $a527afd9af1fd91d$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($354a82c9e8edb67d$export$2e2bcd8739ae039((0, $49c4da5606d9971e$export$2e2bcd8739ae039)(target)));
}







function $d29f6785fa19ef29$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $b053670add32783c$export$2e2bcd8739ae039)(element)) >= 0;
}




function $1fdd6cf5db426e4d$var$getTrueOffsetParent(element) {
    if (!(0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $1fdd6cf5db426e4d$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6394c1ff52742048$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6394c1ff52742048$export$2e2bcd8739ae039)());
    if (isIE && (0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $49c4da5606d9971e$export$2e2bcd8739ae039)(element);
    if ((0, $67c84f7b9d68974e$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $b053670add32783c$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $1fdd6cf5db426e4d$export$2e2bcd8739ae039(element) {
    var window = (0, $225372f33665d118$export$2e2bcd8739ae039)(element);
    var offsetParent = $1fdd6cf5db426e4d$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $d29f6785fa19ef29$export$2e2bcd8739ae039)(offsetParent) && (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $1fdd6cf5db426e4d$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $b053670add32783c$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $b053670add32783c$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $1fdd6cf5db426e4d$var$getContainingBlock(element) || window;
}


var $a94704e3133fbe16$export$1e95b668f3b82d = "top";
var $a94704e3133fbe16$export$40e543e69a8b3fbb = "bottom";
var $a94704e3133fbe16$export$79ffe56a765070d2 = "right";
var $a94704e3133fbe16$export$eabcd2c8791e7bf4 = "left";
var $a94704e3133fbe16$export$dfb5619354ba860 = "auto";
var $a94704e3133fbe16$export$aec2ce47c367b8c3 = [
    $a94704e3133fbe16$export$1e95b668f3b82d,
    $a94704e3133fbe16$export$40e543e69a8b3fbb,
    $a94704e3133fbe16$export$79ffe56a765070d2,
    $a94704e3133fbe16$export$eabcd2c8791e7bf4
];
var $a94704e3133fbe16$export$b3571188c770cc5a = "start";
var $a94704e3133fbe16$export$bd5df0f255a350f8 = "end";
var $a94704e3133fbe16$export$390fd549c5303b4d = "clippingParents";
var $a94704e3133fbe16$export$d7b7311ec04a3e8f = "viewport";
var $a94704e3133fbe16$export$ae5ab1c730825774 = "popper";
var $a94704e3133fbe16$export$ca50aac9f3ba507f = "reference";
var $a94704e3133fbe16$export$368f9a87e87fa4e1 = /*#__PURE__*/ $a94704e3133fbe16$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $a94704e3133fbe16$export$b3571188c770cc5a,
        placement + "-" + $a94704e3133fbe16$export$bd5df0f255a350f8
    ]);
}, []);
var $a94704e3133fbe16$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($a94704e3133fbe16$export$aec2ce47c367b8c3, [
    $a94704e3133fbe16$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $a94704e3133fbe16$export$b3571188c770cc5a,
        placement + "-" + $a94704e3133fbe16$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $a94704e3133fbe16$export$421679a7c3d56e = "beforeRead";
var $a94704e3133fbe16$export$aafa59e2e03f2942 = "read";
var $a94704e3133fbe16$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $a94704e3133fbe16$export$c65e99957a05207c = "beforeMain";
var $a94704e3133fbe16$export$f22da7240b7add18 = "main";
var $a94704e3133fbe16$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $a94704e3133fbe16$export$8d4d2d70e7d46032 = "beforeWrite";
var $a94704e3133fbe16$export$68d8715fc104d294 = "write";
var $a94704e3133fbe16$export$70a6e5159acce2e6 = "afterWrite";
var $a94704e3133fbe16$export$d087d3878fdf71d5 = [
    $a94704e3133fbe16$export$421679a7c3d56e,
    $a94704e3133fbe16$export$aafa59e2e03f2942,
    $a94704e3133fbe16$export$6964f6c886723980,
    $a94704e3133fbe16$export$c65e99957a05207c,
    $a94704e3133fbe16$export$f22da7240b7add18,
    $a94704e3133fbe16$export$bab79516f2d662fe,
    $a94704e3133fbe16$export$8d4d2d70e7d46032,
    $a94704e3133fbe16$export$68d8715fc104d294,
    $a94704e3133fbe16$export$70a6e5159acce2e6
];


function $3ba14eba4f91aa83$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $3ba14eba4f91aa83$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $3ba14eba4f91aa83$var$order(modifiers); // order based on phase
    return (0, $a94704e3133fbe16$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $0f1640117aceffba$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $fe67b122da4891e2$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $5bebade71559124e$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $5bebade71559124e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $5bebade71559124e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $5bebade71559124e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $5bebade71559124e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(reference) ? (0, $354a82c9e8edb67d$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $354a82c9e8edb67d$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $354a82c9e8edb67d$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $3ba14eba4f91aa83$export$2e2bcd8739ae039)((0, $fe67b122da4891e2$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$5bebade71559124e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $d861eebf1f8322fe$export$2e2bcd8739ae039)(reference, (0, $1fdd6cf5db426e4d$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $c0579089f336dea9$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $0f1640117aceffba$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$5bebade71559124e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $5bebade71559124e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $5bebade71559124e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $41bc2dfc6eb96248$var$passive = {
    passive: true
};
function $41bc2dfc6eb96248$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $225372f33665d118$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $41bc2dfc6eb96248$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $41bc2dfc6eb96248$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $41bc2dfc6eb96248$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $41bc2dfc6eb96248$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $41bc2dfc6eb96248$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $41bc2dfc6eb96248$var$effect,
    data: {}
};



function $62df636877274c69$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $873b81dce61132cd$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $8cdaee54ad91b509$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $36cc5fd00eec4fbb$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $62df636877274c69$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $873b81dce61132cd$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $a94704e3133fbe16$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $a94704e3133fbe16$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $a94704e3133fbe16$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $a94704e3133fbe16$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $8cdaee54ad91b509$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $a94704e3133fbe16$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $a94704e3133fbe16$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $13f1c3bc9b36621c$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $36cc5fd00eec4fbb$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $13f1c3bc9b36621c$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $13f1c3bc9b36621c$var$popperOffsets,
    data: {}
};










var $5106537fe02a42d1$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $5106537fe02a42d1$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $5106537fe02a42d1$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4);
    var sideY = (0, $a94704e3133fbe16$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $1fdd6cf5db426e4d$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $225372f33665d118$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(popper);
            if ((0, $c125cc314f75f1af$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $a94704e3133fbe16$export$1e95b668f3b82d) || (placement === (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4) || placement === (0, $a94704e3133fbe16$export$79ffe56a765070d2)) && variation === (0, $a94704e3133fbe16$export$bd5df0f255a350f8)) {
            sideY = (0, $a94704e3133fbe16$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4) || (placement === (0, $a94704e3133fbe16$export$1e95b668f3b82d) || placement === (0, $a94704e3133fbe16$export$40e543e69a8b3fbb)) && variation === (0, $a94704e3133fbe16$export$bd5df0f255a350f8)) {
            sideX = (0, $a94704e3133fbe16$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $5106537fe02a42d1$var$unsetSides);
    var _ref4 = roundOffsets === true ? $5106537fe02a42d1$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $225372f33665d118$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $5106537fe02a42d1$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $62df636877274c69$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $873b81dce61132cd$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $5106537fe02a42d1$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $5106537fe02a42d1$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $5106537fe02a42d1$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $5106537fe02a42d1$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $89d890c165874cff$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element) || !(0, $b053670add32783c$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $89d890c165874cff$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element) || !(0, $b053670add32783c$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $89d890c165874cff$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $89d890c165874cff$var$applyStyles,
    effect: $89d890c165874cff$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $bea6e8d498694752$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $62df636877274c69$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4),
        (0, $a94704e3133fbe16$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4),
        (0, $a94704e3133fbe16$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $bea6e8d498694752$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $a94704e3133fbe16$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $bea6e8d498694752$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $bea6e8d498694752$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $bea6e8d498694752$var$offset
};


var $d8d1c19fcab8b98a$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $d8d1c19fcab8b98a$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d8d1c19fcab8b98a$var$hash[matched];
    });
}



var $3d8b1e96ae7b2b33$var$hash = {
    start: "end",
    end: "start"
};
function $3d8b1e96ae7b2b33$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $3d8b1e96ae7b2b33$var$hash[matched];
    });
}







function $99269cfb0c30a849$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $225372f33665d118$export$2e2bcd8739ae039)(element);
    var html = (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $df11fd8e9d8c1389$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $9875449f0bf8dff4$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $e10e7e39ab68972d$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $1ed31100e25348a7$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $9875449f0bf8dff4$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $c125cc314f75f1af$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $fe95fa72fab69498$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $67c84f7b9d68974e$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $dec119a2e5377521$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $b15c2dc09d4d708d$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $b15c2dc09d4d708d$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $a94704e3133fbe16$export$d7b7311ec04a3e8f) ? (0, $dec119a2e5377521$export$2e2bcd8739ae039)((0, $99269cfb0c30a849$export$2e2bcd8739ae039)(element, strategy)) : (0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(clippingParent) ? $b15c2dc09d4d708d$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $dec119a2e5377521$export$2e2bcd8739ae039)((0, $e10e7e39ab68972d$export$2e2bcd8739ae039)((0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $b15c2dc09d4d708d$var$getClippingParents(element) {
    var clippingParents = (0, $354a82c9e8edb67d$export$2e2bcd8739ae039)((0, $49c4da5606d9971e$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $c125cc314f75f1af$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element) ? (0, $1fdd6cf5db426e4d$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(clippingParent) && (0, $fe95fa72fab69498$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $b053670add32783c$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $b15c2dc09d4d708d$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $b15c2dc09d4d708d$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $b15c2dc09d4d708d$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $e0beaf1fc26deee3$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $e0beaf1fc26deee3$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $b15c2dc09d4d708d$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $f7baa3d7766ddfd5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $c11f65b1ae4396ba$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $f7baa3d7766ddfd5$export$2e2bcd8739ae039)(), paddingObject);
}


function $8c698fce3c6fce96$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $724adaa25380997c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $a94704e3133fbe16$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $a94704e3133fbe16$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $a94704e3133fbe16$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $c11f65b1ae4396ba$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $8c698fce3c6fce96$export$2e2bcd8739ae039)(padding, (0, $a94704e3133fbe16$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $a94704e3133fbe16$export$ae5ab1c730825774) ? (0, $a94704e3133fbe16$export$ca50aac9f3ba507f) : (0, $a94704e3133fbe16$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $b15c2dc09d4d708d$export$2e2bcd8739ae039)((0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $36cc5fd00eec4fbb$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $dec119a2e5377521$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $a94704e3133fbe16$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $a94704e3133fbe16$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $a94704e3133fbe16$export$79ffe56a765070d2),
                (0, $a94704e3133fbe16$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $a94704e3133fbe16$export$1e95b668f3b82d),
                (0, $a94704e3133fbe16$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $f977f9f0436520a0$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $a94704e3133fbe16$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $873b81dce61132cd$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $a94704e3133fbe16$export$368f9a87e87fa4e1) : (0, $a94704e3133fbe16$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $873b81dce61132cd$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $a94704e3133fbe16$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $724adaa25380997c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $62df636877274c69$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $5fa2f8fc84eb9429$var$getExpandedFallbackPlacements(placement) {
    if ((0, $62df636877274c69$export$2e2bcd8739ae039)(placement) === (0, $a94704e3133fbe16$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $d8d1c19fcab8b98a$export$2e2bcd8739ae039)(placement);
    return [
        (0, $3d8b1e96ae7b2b33$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $3d8b1e96ae7b2b33$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $5fa2f8fc84eb9429$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $62df636877274c69$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $d8d1c19fcab8b98a$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $5fa2f8fc84eb9429$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $62df636877274c69$export$2e2bcd8739ae039)(placement) === (0, $a94704e3133fbe16$export$dfb5619354ba860) ? (0, $f977f9f0436520a0$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $62df636877274c69$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $873b81dce61132cd$export$2e2bcd8739ae039)(placement) === (0, $a94704e3133fbe16$export$b3571188c770cc5a);
        var isVertical = [
            (0, $a94704e3133fbe16$export$1e95b668f3b82d),
            (0, $a94704e3133fbe16$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $724adaa25380997c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $a94704e3133fbe16$export$79ffe56a765070d2) : (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $a94704e3133fbe16$export$40e543e69a8b3fbb) : (0, $a94704e3133fbe16$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $d8d1c19fcab8b98a$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $d8d1c19fcab8b98a$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $5fa2f8fc84eb9429$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $5fa2f8fc84eb9429$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $4f97934e8dbef3cc$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $711bed0e4fb75d3f$export$f28d906d67a997f3(min, value, max) {
    return (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(min, (0, $e0beaf1fc26deee3$export$96ec731ed4dcb222)(value, max));
}
function $711bed0e4fb75d3f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $711bed0e4fb75d3f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $0598b84f7e68d489$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $724adaa25380997c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $62df636877274c69$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $873b81dce61132cd$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $8cdaee54ad91b509$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $4f97934e8dbef3cc$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $a94704e3133fbe16$export$1e95b668f3b82d) : (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $a94704e3133fbe16$export$40e543e69a8b3fbb) : (0, $a94704e3133fbe16$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $a94704e3133fbe16$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $a94704e3133fbe16$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $c0579089f336dea9$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $f7baa3d7766ddfd5$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $711bed0e4fb75d3f$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $1fdd6cf5db426e4d$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $711bed0e4fb75d3f$export$f28d906d67a997f3)(tether ? (0, $e0beaf1fc26deee3$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $a94704e3133fbe16$export$1e95b668f3b82d) : (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $a94704e3133fbe16$export$40e543e69a8b3fbb) : (0, $a94704e3133fbe16$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $a94704e3133fbe16$export$1e95b668f3b82d),
            (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $711bed0e4fb75d3f$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $711bed0e4fb75d3f$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $0598b84f7e68d489$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $0598b84f7e68d489$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $671483b845900ee3$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $c11f65b1ae4396ba$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $8c698fce3c6fce96$export$2e2bcd8739ae039)(padding, (0, $a94704e3133fbe16$export$aec2ce47c367b8c3)));
};
function $671483b845900ee3$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $62df636877274c69$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $8cdaee54ad91b509$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4),
        (0, $a94704e3133fbe16$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $671483b845900ee3$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $c0579089f336dea9$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $a94704e3133fbe16$export$1e95b668f3b82d) : (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $a94704e3133fbe16$export$40e543e69a8b3fbb) : (0, $a94704e3133fbe16$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $1fdd6cf5db426e4d$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $711bed0e4fb75d3f$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $671483b845900ee3$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $fe95fa72fab69498$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $671483b845900ee3$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $671483b845900ee3$var$arrow,
    effect: $671483b845900ee3$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $be0e5a97b5c4f0a9$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $be0e5a97b5c4f0a9$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $a94704e3133fbe16$export$1e95b668f3b82d),
        (0, $a94704e3133fbe16$export$79ffe56a765070d2),
        (0, $a94704e3133fbe16$export$40e543e69a8b3fbb),
        (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $be0e5a97b5c4f0a9$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $724adaa25380997c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $724adaa25380997c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $be0e5a97b5c4f0a9$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $be0e5a97b5c4f0a9$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $be0e5a97b5c4f0a9$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $be0e5a97b5c4f0a9$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $be0e5a97b5c4f0a9$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $be0e5a97b5c4f0a9$var$hide
};




var $55c7f2385d3e922b$export$d34966752335dd47 = [
    (0, $41bc2dfc6eb96248$export$2e2bcd8739ae039),
    (0, $13f1c3bc9b36621c$export$2e2bcd8739ae039),
    (0, $5106537fe02a42d1$export$2e2bcd8739ae039),
    (0, $89d890c165874cff$export$2e2bcd8739ae039),
    (0, $bea6e8d498694752$export$2e2bcd8739ae039),
    (0, $5fa2f8fc84eb9429$export$2e2bcd8739ae039),
    (0, $0598b84f7e68d489$export$2e2bcd8739ae039),
    (0, $671483b845900ee3$export$2e2bcd8739ae039),
    (0, $be0e5a97b5c4f0a9$export$2e2bcd8739ae039)
];
var $55c7f2385d3e922b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $5bebade71559124e$export$ed5e13716264f202)({
    defaultModifiers: $55c7f2385d3e922b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $7c795eb159d1df54$var$__assign = undefined && undefined.__assign || function() {
    $7c795eb159d1df54$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7c795eb159d1df54$var$__assign.apply(this, arguments);
};
var $7c795eb159d1df54$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $7c795eb159d1df54$var$Default = {
    placement: "bottom",
    triggerType: "click",
    offsetSkidding: 0,
    offsetDistance: 10,
    delay: 300,
    ignoreClickOutsideClass: false,
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $7c795eb159d1df54$var$Dropdown = /** @class */ function() {
    function Dropdown(targetElement, triggerElement, options) {
        if (targetElement === void 0) targetElement = null;
        if (triggerElement === void 0) triggerElement = null;
        if (options === void 0) options = $7c795eb159d1df54$var$Default;
        this._targetEl = targetElement;
        this._triggerEl = triggerElement;
        this._options = $7c795eb159d1df54$var$__assign($7c795eb159d1df54$var$__assign({}, $7c795eb159d1df54$var$Default), options);
        this._popperInstance = this._createPopperInstance();
        this._visible = false;
        this._init();
    }
    Dropdown.prototype._init = function() {
        if (this._triggerEl) this._setupEventListeners();
    };
    Dropdown.prototype._setupEventListeners = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        // click event handling for trigger element
        if (this._options.triggerType === "click") triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, function() {
                _this.toggle();
            });
        });
        // hover event handling for trigger element
        if (this._options.triggerType === "hover") {
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.addEventListener(ev, function() {
                    if (ev === "click") _this.toggle();
                    else setTimeout(function() {
                        _this.show();
                    }, _this._options.delay);
                });
                _this._targetEl.addEventListener(ev, function() {
                    _this.show();
                });
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.addEventListener(ev, function() {
                    setTimeout(function() {
                        if (!_this._targetEl.matches(":hover")) _this.hide();
                    }, _this._options.delay);
                });
                _this._targetEl.addEventListener(ev, function() {
                    setTimeout(function() {
                        if (!_this._triggerEl.matches(":hover")) _this.hide();
                    }, _this._options.delay);
                });
            });
        }
    };
    Dropdown.prototype._createPopperInstance = function() {
        return (0, $55c7f2385d3e922b$export$8f7491d57c8f97a9)(this._triggerEl, this._targetEl, {
            placement: this._options.placement,
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            this._options.offsetSkidding,
                            this._options.offsetDistance
                        ]
                    }
                }
            ]
        });
    };
    Dropdown.prototype._setupClickOutsideListener = function() {
        var _this = this;
        this._clickOutsideEventListener = function(ev) {
            _this._handleClickOutside(ev, _this._targetEl);
        };
        document.body.addEventListener("click", this._clickOutsideEventListener, true);
    };
    Dropdown.prototype._removeClickOutsideListener = function() {
        document.body.removeEventListener("click", this._clickOutsideEventListener, true);
    };
    Dropdown.prototype._handleClickOutside = function(ev, targetEl) {
        var clickedEl = ev.target;
        // Ignore clicks on the trigger element (ie. a datepicker input)
        var ignoreClickOutsideClass = this._options.ignoreClickOutsideClass;
        var isIgnored = false;
        if (ignoreClickOutsideClass) {
            var ignoredClickOutsideEls = document.querySelectorAll(".".concat(ignoreClickOutsideClass));
            ignoredClickOutsideEls.forEach(function(el) {
                if (el.contains(clickedEl)) {
                    isIgnored = true;
                    return;
                }
            });
        }
        // Ignore clicks on the target element (ie. dropdown itself)
        if (clickedEl !== targetEl && !targetEl.contains(clickedEl) && !this._triggerEl.contains(clickedEl) && !isIgnored && this.isVisible()) this.hide();
    };
    Dropdown.prototype._getTriggerEvents = function() {
        switch(this._options.triggerType){
            case "hover":
                return {
                    showEvents: [
                        "mouseenter",
                        "click"
                    ],
                    hideEvents: [
                        "mouseleave"
                    ]
                };
            case "click":
                return {
                    showEvents: [
                        "click"
                    ],
                    hideEvents: []
                };
            case "none":
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        "click"
                    ],
                    hideEvents: []
                };
        }
    };
    Dropdown.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
        this._options.onToggle(this);
    };
    Dropdown.prototype.isVisible = function() {
        return this._visible;
    };
    Dropdown.prototype.show = function() {
        this._targetEl.classList.remove("hidden");
        this._targetEl.classList.add("block");
        // Enable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $7c795eb159d1df54$var$__assign($7c795eb159d1df54$var$__assign({}, options), {
                modifiers: $7c795eb159d1df54$var$__spreadArray($7c795eb159d1df54$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: true
                    }
                ], false)
            });
        });
        this._setupClickOutsideListener();
        // Update its position
        this._popperInstance.update();
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Dropdown.prototype.hide = function() {
        this._targetEl.classList.remove("block");
        this._targetEl.classList.add("hidden");
        // Disable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $7c795eb159d1df54$var$__assign($7c795eb159d1df54$var$__assign({}, options), {
                modifiers: $7c795eb159d1df54$var$__spreadArray($7c795eb159d1df54$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: false
                    }
                ], false)
            });
        });
        this._visible = false;
        this._removeClickOutsideListener();
        // callback function
        this._options.onHide(this);
    };
    return Dropdown;
}();
function $7c795eb159d1df54$export$8cb65a02593bf108() {
    document.querySelectorAll("[data-dropdown-toggle]").forEach(function($triggerEl) {
        var dropdownId = $triggerEl.getAttribute("data-dropdown-toggle");
        var $dropdownEl = document.getElementById(dropdownId);
        if ($dropdownEl) {
            var placement = $triggerEl.getAttribute("data-dropdown-placement");
            var offsetSkidding = $triggerEl.getAttribute("data-dropdown-offset-skidding");
            var offsetDistance = $triggerEl.getAttribute("data-dropdown-offset-distance");
            var triggerType = $triggerEl.getAttribute("data-dropdown-trigger");
            var delay = $triggerEl.getAttribute("data-dropdown-delay");
            var ignoreClickOutsideClass = $triggerEl.getAttribute("data-dropdown-ignore-click-outside-class");
            new $7c795eb159d1df54$var$Dropdown($dropdownEl, $triggerEl, {
                placement: placement ? placement : $7c795eb159d1df54$var$Default.placement,
                triggerType: triggerType ? triggerType : $7c795eb159d1df54$var$Default.triggerType,
                offsetSkidding: offsetSkidding ? parseInt(offsetSkidding) : $7c795eb159d1df54$var$Default.offsetSkidding,
                offsetDistance: offsetDistance ? parseInt(offsetDistance) : $7c795eb159d1df54$var$Default.offsetDistance,
                delay: delay ? parseInt(delay) : $7c795eb159d1df54$var$Default.delay,
                ignoreClickOutsideClass: ignoreClickOutsideClass ? ignoreClickOutsideClass : $7c795eb159d1df54$var$Default.ignoreClickOutsideClass
            });
        } else console.error('The dropdown element with id "'.concat(dropdownId, '" does not exist. Please check the data-dropdown-toggle attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.Dropdown = $7c795eb159d1df54$var$Dropdown;
    window.initDropdowns = $7c795eb159d1df54$export$8cb65a02593bf108;
}
var $7c795eb159d1df54$export$2e2bcd8739ae039 = $7c795eb159d1df54$var$Dropdown;


var $dcd9805f7c8a4cc2$var$__assign = undefined && undefined.__assign || function() {
    $dcd9805f7c8a4cc2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dcd9805f7c8a4cc2$var$__assign.apply(this, arguments);
};
var $dcd9805f7c8a4cc2$var$Default = {
    placement: "center",
    backdropClasses: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40",
    backdrop: "dynamic",
    closable: true,
    onHide: function() {},
    onShow: function() {},
    onToggle: function() {}
};
var $dcd9805f7c8a4cc2$var$Modal = /** @class */ function() {
    function Modal(targetEl, options) {
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $dcd9805f7c8a4cc2$var$Default;
        this._targetEl = targetEl;
        this._options = $dcd9805f7c8a4cc2$var$__assign($dcd9805f7c8a4cc2$var$__assign({}, $dcd9805f7c8a4cc2$var$Default), options);
        this._isHidden = true;
        this._backdropEl = null;
        this._init();
    }
    Modal.prototype._init = function() {
        var _this = this;
        if (this._targetEl) this._getPlacementClasses().map(function(c) {
            _this._targetEl.classList.add(c);
        });
    };
    Modal.prototype._createBackdrop = function() {
        var _a;
        if (this._isHidden) {
            var backdropEl = document.createElement("div");
            backdropEl.setAttribute("modal-backdrop", "");
            (_a = backdropEl.classList).add.apply(_a, this._options.backdropClasses.split(" "));
            document.querySelector("body").append(backdropEl);
            this._backdropEl = backdropEl;
        }
    };
    Modal.prototype._destroyBackdropEl = function() {
        if (!this._isHidden) document.querySelector("[modal-backdrop]").remove();
    };
    Modal.prototype._setupModalCloseEventListeners = function() {
        var _this = this;
        if (this._options.backdrop === "dynamic") {
            this._clickOutsideEventListener = function(ev) {
                _this._handleOutsideClick(ev.target);
            };
            this._targetEl.addEventListener("click", this._clickOutsideEventListener, true);
        }
        this._keydownEventListener = function(ev) {
            if (ev.key === "Escape") _this.hide();
        };
        document.body.addEventListener("keydown", this._keydownEventListener, true);
    };
    Modal.prototype._removeModalCloseEventListeners = function() {
        if (this._options.backdrop === "dynamic") this._targetEl.removeEventListener("click", this._clickOutsideEventListener, true);
        document.body.removeEventListener("keydown", this._keydownEventListener, true);
    };
    Modal.prototype._handleOutsideClick = function(target) {
        if (target === this._targetEl || target === this._backdropEl && this.isVisible()) this.hide();
    };
    Modal.prototype._getPlacementClasses = function() {
        switch(this._options.placement){
            // top
            case "top-left":
                return [
                    "justify-start",
                    "items-start"
                ];
            case "top-center":
                return [
                    "justify-center",
                    "items-start"
                ];
            case "top-right":
                return [
                    "justify-end",
                    "items-start"
                ];
            // center
            case "center-left":
                return [
                    "justify-start",
                    "items-center"
                ];
            case "center":
                return [
                    "justify-center",
                    "items-center"
                ];
            case "center-right":
                return [
                    "justify-end",
                    "items-center"
                ];
            // bottom
            case "bottom-left":
                return [
                    "justify-start",
                    "items-end"
                ];
            case "bottom-center":
                return [
                    "justify-center",
                    "items-end"
                ];
            case "bottom-right":
                return [
                    "justify-end",
                    "items-end"
                ];
            default:
                return [
                    "justify-center",
                    "items-center"
                ];
        }
    };
    Modal.prototype.toggle = function() {
        if (this._isHidden) this.show();
        else this.hide();
        // callback function
        this._options.onToggle(this);
    };
    Modal.prototype.show = function() {
        if (this.isHidden) {
            this._targetEl.classList.add("flex");
            this._targetEl.classList.remove("hidden");
            this._targetEl.setAttribute("aria-modal", "true");
            this._targetEl.setAttribute("role", "dialog");
            this._targetEl.removeAttribute("aria-hidden");
            this._createBackdrop();
            this._isHidden = false;
            // prevent body scroll
            document.body.classList.add("overflow-hidden");
            // Add keyboard event listener to the document
            if (this._options.closable) this._setupModalCloseEventListeners();
            // callback function
            this._options.onShow(this);
        }
    };
    Modal.prototype.hide = function() {
        if (this.isVisible) {
            this._targetEl.classList.add("hidden");
            this._targetEl.classList.remove("flex");
            this._targetEl.setAttribute("aria-hidden", "true");
            this._targetEl.removeAttribute("aria-modal");
            this._targetEl.removeAttribute("role");
            this._destroyBackdropEl();
            this._isHidden = true;
            // re-apply body scroll
            document.body.classList.remove("overflow-hidden");
            if (this._options.closable) this._removeModalCloseEventListeners();
            // callback function
            this._options.onHide(this);
        }
    };
    Modal.prototype.isVisible = function() {
        return !this._isHidden;
    };
    Modal.prototype.isHidden = function() {
        return this._isHidden;
    };
    return Modal;
}();
var $dcd9805f7c8a4cc2$var$getModalInstance = function(id, instances) {
    if (instances.some(function(modalInstance) {
        return modalInstance.id === id;
    })) return instances.find(function(modalInstance) {
        return modalInstance.id === id;
    });
    return null;
};
function $dcd9805f7c8a4cc2$export$e14d3bc873a8b9b1() {
    var modalInstances = [];
    // initiate modal based on data-modal-target
    document.querySelectorAll("[data-modal-target]").forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute("data-modal-target");
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var placement = $modalEl.getAttribute("data-modal-placement");
            var backdrop = $modalEl.getAttribute("data-modal-backdrop");
            if (!$dcd9805f7c8a4cc2$var$getModalInstance(modalId, modalInstances)) modalInstances.push({
                id: modalId,
                object: new $dcd9805f7c8a4cc2$var$Modal($modalEl, {
                    placement: placement ? placement : $dcd9805f7c8a4cc2$var$Default.placement,
                    backdrop: backdrop ? backdrop : $dcd9805f7c8a4cc2$var$Default.backdrop
                })
            });
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-target attribute points to the correct modal id?."));
    });
    // support pre v1.6.0 data-modal-toggle initialization
    document.querySelectorAll("[data-modal-toggle]").forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute("data-modal-toggle");
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var placement = $modalEl.getAttribute("data-modal-placement");
            var backdrop = $modalEl.getAttribute("data-modal-backdrop");
            var modal_1 = $dcd9805f7c8a4cc2$var$getModalInstance(modalId, modalInstances);
            if (!modal_1) {
                modal_1 = {
                    id: modalId,
                    object: new $dcd9805f7c8a4cc2$var$Modal($modalEl, {
                        placement: placement ? placement : $dcd9805f7c8a4cc2$var$Default.placement,
                        backdrop: backdrop ? backdrop : $dcd9805f7c8a4cc2$var$Default.backdrop
                    })
                };
                modalInstances.push(modal_1);
            }
            $triggerEl.addEventListener("click", function() {
                modal_1.object.toggle();
            });
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-toggle attribute points to the correct modal id?"));
    });
    // show modal on click if exists based on id
    document.querySelectorAll("[data-modal-show]").forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute("data-modal-show");
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var modal_2 = $dcd9805f7c8a4cc2$var$getModalInstance(modalId, modalInstances);
            if (modal_2) $triggerEl.addEventListener("click", function() {
                if (modal_2.object.isHidden) modal_2.object.show();
            });
            else console.error("Modal with id ".concat(modalId, " has not been initialized. Please initialize it using the data-modal-target attribute."));
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-show attribute points to the correct modal id?"));
    });
    // hide modal on click if exists based on id
    document.querySelectorAll("[data-modal-hide]").forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute("data-modal-hide");
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var modal_3 = $dcd9805f7c8a4cc2$var$getModalInstance(modalId, modalInstances);
            if (modal_3) $triggerEl.addEventListener("click", function() {
                if (modal_3.object.isVisible) modal_3.object.hide();
            });
            else console.error("Modal with id ".concat(modalId, " has not been initialized. Please initialize it using the data-modal-target attribute."));
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-hide attribute points to the correct modal id?"));
    });
}
if (typeof window !== "undefined") {
    window.Modal = $dcd9805f7c8a4cc2$var$Modal;
    window.initModals = $dcd9805f7c8a4cc2$export$e14d3bc873a8b9b1;
}
var $dcd9805f7c8a4cc2$export$2e2bcd8739ae039 = $dcd9805f7c8a4cc2$var$Modal;


var $e4af0c1adc25a84d$var$__assign = undefined && undefined.__assign || function() {
    $e4af0c1adc25a84d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e4af0c1adc25a84d$var$__assign.apply(this, arguments);
};
var $e4af0c1adc25a84d$var$Default = {
    placement: "left",
    bodyScrolling: false,
    backdrop: true,
    edge: false,
    edgeOffset: "bottom-[60px]",
    backdropClasses: "bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-30",
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $e4af0c1adc25a84d$var$Drawer = /** @class */ function() {
    function Drawer(targetEl, options) {
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $e4af0c1adc25a84d$var$Default;
        this._targetEl = targetEl;
        this._options = $e4af0c1adc25a84d$var$__assign($e4af0c1adc25a84d$var$__assign({}, $e4af0c1adc25a84d$var$Default), options);
        this._visible = false;
        this._init();
    }
    Drawer.prototype._init = function() {
        var _this = this;
        // set initial accessibility attributes
        if (this._targetEl) {
            this._targetEl.setAttribute("aria-hidden", "true");
            this._targetEl.classList.add("transition-transform");
        }
        // set base placement classes
        this._getPlacementClasses(this._options.placement).base.map(function(c) {
            _this._targetEl.classList.add(c);
        });
        // add keyboard event listener to document
        document.addEventListener("keydown", function(event) {
            if (event.key === "Escape") // if 'Escape' key is pressed
            {
                if (_this.isVisible()) // if the Drawer is visible
                _this.hide(); // hide the Drawer
            }
        });
    };
    Drawer.prototype.hide = function() {
        var _this = this;
        // based on the edge option show placement classes
        if (this._options.edge) {
            this._getPlacementClasses(this._options.placement + "-edge").active.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
            this._getPlacementClasses(this._options.placement + "-edge").inactive.map(function(c) {
                _this._targetEl.classList.add(c);
            });
        } else {
            this._getPlacementClasses(this._options.placement).active.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
            this._getPlacementClasses(this._options.placement).inactive.map(function(c) {
                _this._targetEl.classList.add(c);
            });
        }
        // set accessibility attributes
        this._targetEl.setAttribute("aria-hidden", "true");
        this._targetEl.removeAttribute("aria-modal");
        this._targetEl.removeAttribute("role");
        // enable body scroll
        if (!this._options.bodyScrolling) document.body.classList.remove("overflow-hidden");
        // destroy backdrop
        if (this._options.backdrop) this._destroyBackdropEl();
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Drawer.prototype.show = function() {
        var _this = this;
        if (this._options.edge) {
            this._getPlacementClasses(this._options.placement + "-edge").active.map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._getPlacementClasses(this._options.placement + "-edge").inactive.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
        } else {
            this._getPlacementClasses(this._options.placement).active.map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._getPlacementClasses(this._options.placement).inactive.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
        }
        // set accessibility attributes
        this._targetEl.setAttribute("aria-modal", "true");
        this._targetEl.setAttribute("role", "dialog");
        this._targetEl.removeAttribute("aria-hidden");
        // disable body scroll
        if (!this._options.bodyScrolling) document.body.classList.add("overflow-hidden");
        // show backdrop
        if (this._options.backdrop) this._createBackdrop();
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Drawer.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
    };
    Drawer.prototype._createBackdrop = function() {
        var _a;
        var _this = this;
        if (!this._visible) {
            var backdropEl = document.createElement("div");
            backdropEl.setAttribute("drawer-backdrop", "");
            (_a = backdropEl.classList).add.apply(_a, this._options.backdropClasses.split(" "));
            document.querySelector("body").append(backdropEl);
            backdropEl.addEventListener("click", function() {
                _this.hide();
            });
        }
    };
    Drawer.prototype._destroyBackdropEl = function() {
        if (this._visible) document.querySelector("[drawer-backdrop]").remove();
    };
    Drawer.prototype._getPlacementClasses = function(placement) {
        switch(placement){
            case "top":
                return {
                    base: [
                        "top-0",
                        "left-0",
                        "right-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "-translate-y-full"
                    ]
                };
            case "right":
                return {
                    base: [
                        "right-0",
                        "top-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "translate-x-full"
                    ]
                };
            case "bottom":
                return {
                    base: [
                        "bottom-0",
                        "left-0",
                        "right-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "translate-y-full"
                    ]
                };
            case "left":
                return {
                    base: [
                        "left-0",
                        "top-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "-translate-x-full"
                    ]
                };
            case "bottom-edge":
                return {
                    base: [
                        "left-0",
                        "top-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "translate-y-full",
                        this._options.edgeOffset
                    ]
                };
            default:
                return {
                    base: [
                        "left-0",
                        "top-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "-translate-x-full"
                    ]
                };
        }
    };
    Drawer.prototype.isHidden = function() {
        return !this._visible;
    };
    Drawer.prototype.isVisible = function() {
        return this._visible;
    };
    return Drawer;
}();
var $e4af0c1adc25a84d$var$getDrawerInstance = function(id, instances) {
    if (instances.some(function(drawerInstance) {
        return drawerInstance.id === id;
    })) return instances.find(function(drawerInstance) {
        return drawerInstance.id === id;
    });
};
function $e4af0c1adc25a84d$export$319df2b10e87c8ec() {
    var drawerInstances = [];
    document.querySelectorAll("[data-drawer-target]").forEach(function($triggerEl) {
        // mandatory
        var drawerId = $triggerEl.getAttribute("data-drawer-target");
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            // optional
            var placement = $triggerEl.getAttribute("data-drawer-placement");
            var bodyScrolling = $triggerEl.getAttribute("data-drawer-body-scrolling");
            var backdrop = $triggerEl.getAttribute("data-drawer-backdrop");
            var edge = $triggerEl.getAttribute("data-drawer-edge");
            var edgeOffset = $triggerEl.getAttribute("data-drawer-edge-offset");
            if (!$e4af0c1adc25a84d$var$getDrawerInstance(drawerId, drawerInstances)) drawerInstances.push({
                id: drawerId,
                object: new $e4af0c1adc25a84d$var$Drawer($drawerEl, {
                    placement: placement ? placement : $e4af0c1adc25a84d$var$Default.placement,
                    bodyScrolling: bodyScrolling ? bodyScrolling === "true" ? true : false : $e4af0c1adc25a84d$var$Default.bodyScrolling,
                    backdrop: backdrop ? backdrop === "true" ? true : false : $e4af0c1adc25a84d$var$Default.backdrop,
                    edge: edge ? edge === "true" ? true : false : $e4af0c1adc25a84d$var$Default.edge,
                    edgeOffset: edgeOffset ? edgeOffset : $e4af0c1adc25a84d$var$Default.edgeOffset
                })
            });
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
    });
    document.querySelectorAll("[data-drawer-toggle]").forEach(function($triggerEl) {
        var drawerId = $triggerEl.getAttribute("data-drawer-toggle");
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var drawer_1 = $e4af0c1adc25a84d$var$getDrawerInstance(drawerId, drawerInstances);
            if (drawer_1) $triggerEl.addEventListener("click", function() {
                drawer_1.object.toggle();
            });
            else console.error("Drawer with id ".concat(drawerId, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
    });
    document.querySelectorAll("[data-drawer-dismiss], [data-drawer-hide]").forEach(function($triggerEl) {
        var drawerId = $triggerEl.getAttribute("data-drawer-dismiss") ? $triggerEl.getAttribute("data-drawer-dismiss") : $triggerEl.getAttribute("data-drawer-hide");
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var drawer_2 = $e4af0c1adc25a84d$var$getDrawerInstance(drawerId, drawerInstances);
            if (drawer_2) $triggerEl.addEventListener("click", function() {
                drawer_2.object.hide();
            });
            else console.error("Drawer with id ".concat(drawerId, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id"));
    });
    document.querySelectorAll("[data-drawer-show]").forEach(function($triggerEl) {
        var drawerId = $triggerEl.getAttribute("data-drawer-show");
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var drawer_3 = $e4af0c1adc25a84d$var$getDrawerInstance(drawerId, drawerInstances);
            if (drawer_3) $triggerEl.addEventListener("click", function() {
                drawer_3.object.show();
            });
            else console.error("Drawer with id ".concat(drawerId, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
    });
}
if (typeof window !== "undefined") {
    window.Drawer = $e4af0c1adc25a84d$var$Drawer;
    window.initDrawers = $e4af0c1adc25a84d$export$319df2b10e87c8ec;
}
var $e4af0c1adc25a84d$export$2e2bcd8739ae039 = $e4af0c1adc25a84d$var$Drawer;


var $396c077f99e01ff2$var$__assign = undefined && undefined.__assign || function() {
    $396c077f99e01ff2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $396c077f99e01ff2$var$__assign.apply(this, arguments);
};
var $396c077f99e01ff2$var$Default = {
    defaultTabId: null,
    activeClasses: "text-blue-600 hover:text-blue-600 dark:text-blue-500 dark:hover:text-blue-500 border-blue-600 dark:border-blue-500",
    inactiveClasses: "dark:border-transparent text-gray-500 hover:text-gray-600 dark:text-gray-400 border-gray-100 hover:border-gray-300 dark:border-gray-700 dark:hover:text-gray-300",
    onShow: function() {}
};
var $396c077f99e01ff2$var$Tabs = /** @class */ function() {
    function Tabs(items, options) {
        if (items === void 0) items = [];
        if (options === void 0) options = $396c077f99e01ff2$var$Default;
        this._items = items;
        this._activeTab = options ? this.getTab(options.defaultTabId) : null;
        this._options = $396c077f99e01ff2$var$__assign($396c077f99e01ff2$var$__assign({}, $396c077f99e01ff2$var$Default), options);
        this._init();
    }
    Tabs.prototype._init = function() {
        var _this = this;
        if (this._items.length) {
            // set the first tab as active if not set by explicitly
            if (!this._activeTab) this._setActiveTab(this._items[0]);
            // force show the first default tab
            this.show(this._activeTab.id, true);
            // show tab content based on click
            this._items.map(function(tab) {
                tab.triggerEl.addEventListener("click", function() {
                    _this.show(tab.id);
                });
            });
        }
    };
    Tabs.prototype.getActiveTab = function() {
        return this._activeTab;
    };
    Tabs.prototype._setActiveTab = function(tab) {
        this._activeTab = tab;
    };
    Tabs.prototype.getTab = function(id) {
        return this._items.filter(function(t) {
            return t.id === id;
        })[0];
    };
    Tabs.prototype.show = function(id, forceShow) {
        var _a, _b;
        var _this = this;
        if (forceShow === void 0) forceShow = false;
        var tab = this.getTab(id);
        // don't do anything if already active
        if (tab === this._activeTab && !forceShow) return;
        // hide other tabs
        this._items.map(function(t) {
            var _a, _b;
            if (t !== tab) {
                (_a = t.triggerEl.classList).remove.apply(_a, _this._options.activeClasses.split(" "));
                (_b = t.triggerEl.classList).add.apply(_b, _this._options.inactiveClasses.split(" "));
                t.targetEl.classList.add("hidden");
                t.triggerEl.setAttribute("aria-selected", "false");
            }
        });
        // show active tab
        (_a = tab.triggerEl.classList).add.apply(_a, this._options.activeClasses.split(" "));
        (_b = tab.triggerEl.classList).remove.apply(_b, this._options.inactiveClasses.split(" "));
        tab.triggerEl.setAttribute("aria-selected", "true");
        tab.targetEl.classList.remove("hidden");
        this._setActiveTab(tab);
        // callback function
        this._options.onShow(this, tab);
    };
    return Tabs;
}();
function $396c077f99e01ff2$export$c92e8f569ad2976f() {
    document.querySelectorAll("[data-tabs-toggle]").forEach(function($triggerEl) {
        var tabItems = [];
        var defaultTabId = null;
        $triggerEl.querySelectorAll('[role="tab"]').forEach(function($triggerEl) {
            var isActive = $triggerEl.getAttribute("aria-selected") === "true";
            var tab = {
                id: $triggerEl.getAttribute("data-tabs-target"),
                triggerEl: $triggerEl,
                targetEl: document.querySelector($triggerEl.getAttribute("data-tabs-target"))
            };
            tabItems.push(tab);
            if (isActive) defaultTabId = tab.id;
        });
        new $396c077f99e01ff2$var$Tabs(tabItems, {
            defaultTabId: defaultTabId
        });
    });
}
if (typeof window !== "undefined") {
    window.Tabs = $396c077f99e01ff2$var$Tabs;
    window.initTabs = $396c077f99e01ff2$export$c92e8f569ad2976f;
}
var $396c077f99e01ff2$export$2e2bcd8739ae039 = $396c077f99e01ff2$var$Tabs;



var $ccaf4f9ef3a2b995$var$__assign = undefined && undefined.__assign || function() {
    $ccaf4f9ef3a2b995$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ccaf4f9ef3a2b995$var$__assign.apply(this, arguments);
};
var $ccaf4f9ef3a2b995$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $ccaf4f9ef3a2b995$var$Default = {
    placement: "top",
    triggerType: "hover",
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $ccaf4f9ef3a2b995$var$Tooltip = /** @class */ function() {
    function Tooltip(targetEl, triggerEl, options) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $ccaf4f9ef3a2b995$var$Default;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $ccaf4f9ef3a2b995$var$__assign($ccaf4f9ef3a2b995$var$__assign({}, $ccaf4f9ef3a2b995$var$Default), options);
        this._popperInstance = this._createPopperInstance();
        this._visible = false;
        this._init();
    }
    Tooltip.prototype._init = function() {
        if (this._triggerEl) this._setupEventListeners();
    };
    Tooltip.prototype._setupEventListeners = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, function() {
                _this.show();
            });
        });
        triggerEvents.hideEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, function() {
                _this.hide();
            });
        });
    };
    Tooltip.prototype._createPopperInstance = function() {
        return (0, $55c7f2385d3e922b$export$8f7491d57c8f97a9)(this._triggerEl, this._targetEl, {
            placement: this._options.placement,
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                }
            ]
        });
    };
    Tooltip.prototype._getTriggerEvents = function() {
        switch(this._options.triggerType){
            case "hover":
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
            case "click":
                return {
                    showEvents: [
                        "click",
                        "focus"
                    ],
                    hideEvents: [
                        "focusout",
                        "blur"
                    ]
                };
            case "none":
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
        }
    };
    Tooltip.prototype._setupKeydownListener = function() {
        var _this = this;
        this._keydownEventListener = function(ev) {
            if (ev.key === "Escape") _this.hide();
        };
        document.body.addEventListener("keydown", this._keydownEventListener, true);
    };
    Tooltip.prototype._removeKeydownListener = function() {
        document.body.removeEventListener("keydown", this._keydownEventListener, true);
    };
    Tooltip.prototype._setupClickOutsideListener = function() {
        var _this = this;
        this._clickOutsideEventListener = function(ev) {
            _this._handleClickOutside(ev, _this._targetEl);
        };
        document.body.addEventListener("click", this._clickOutsideEventListener, true);
    };
    Tooltip.prototype._removeClickOutsideListener = function() {
        document.body.removeEventListener("click", this._clickOutsideEventListener, true);
    };
    Tooltip.prototype._handleClickOutside = function(ev, targetEl) {
        var clickedEl = ev.target;
        if (clickedEl !== targetEl && !targetEl.contains(clickedEl) && !this._triggerEl.contains(clickedEl) && this.isVisible()) this.hide();
    };
    Tooltip.prototype.isVisible = function() {
        return this._visible;
    };
    Tooltip.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
    };
    Tooltip.prototype.show = function() {
        this._targetEl.classList.remove("opacity-0", "invisible");
        this._targetEl.classList.add("opacity-100", "visible");
        // Enable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $ccaf4f9ef3a2b995$var$__assign($ccaf4f9ef3a2b995$var$__assign({}, options), {
                modifiers: $ccaf4f9ef3a2b995$var$__spreadArray($ccaf4f9ef3a2b995$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: true
                    }
                ], false)
            });
        });
        // handle click outside
        this._setupClickOutsideListener();
        // handle esc keydown
        this._setupKeydownListener();
        // Update its position
        this._popperInstance.update();
        // set visibility
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Tooltip.prototype.hide = function() {
        this._targetEl.classList.remove("opacity-100", "visible");
        this._targetEl.classList.add("opacity-0", "invisible");
        // Disable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $ccaf4f9ef3a2b995$var$__assign($ccaf4f9ef3a2b995$var$__assign({}, options), {
                modifiers: $ccaf4f9ef3a2b995$var$__spreadArray($ccaf4f9ef3a2b995$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: false
                    }
                ], false)
            });
        });
        // handle click outside
        this._removeClickOutsideListener();
        // handle esc keydown
        this._removeKeydownListener();
        // set visibility
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    return Tooltip;
}();
function $ccaf4f9ef3a2b995$export$8f2a38c1f9d9dc3e() {
    document.querySelectorAll("[data-tooltip-target]").forEach(function($triggerEl) {
        var tooltipId = $triggerEl.getAttribute("data-tooltip-target");
        var $tooltipEl = document.getElementById(tooltipId);
        if ($tooltipEl) {
            var triggerType = $triggerEl.getAttribute("data-tooltip-trigger");
            var placement = $triggerEl.getAttribute("data-tooltip-placement");
            new $ccaf4f9ef3a2b995$var$Tooltip($tooltipEl, $triggerEl, {
                placement: placement ? placement : $ccaf4f9ef3a2b995$var$Default.placement,
                triggerType: triggerType ? triggerType : $ccaf4f9ef3a2b995$var$Default.triggerType
            });
        } else console.error('The tooltip element with id "'.concat(tooltipId, '" does not exist. Please check the data-tooltip-target attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.Tooltip = $ccaf4f9ef3a2b995$var$Tooltip;
    window.initTooltips = $ccaf4f9ef3a2b995$export$8f2a38c1f9d9dc3e;
}
var $ccaf4f9ef3a2b995$export$2e2bcd8739ae039 = $ccaf4f9ef3a2b995$var$Tooltip;



var $dc776f0b4a1e78cc$var$__assign = undefined && undefined.__assign || function() {
    $dc776f0b4a1e78cc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dc776f0b4a1e78cc$var$__assign.apply(this, arguments);
};
var $dc776f0b4a1e78cc$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $dc776f0b4a1e78cc$var$Default = {
    placement: "top",
    offset: 10,
    triggerType: "hover",
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $dc776f0b4a1e78cc$var$Popover = /** @class */ function() {
    function Popover(targetEl, triggerEl, options) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $dc776f0b4a1e78cc$var$Default;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $dc776f0b4a1e78cc$var$__assign($dc776f0b4a1e78cc$var$__assign({}, $dc776f0b4a1e78cc$var$Default), options);
        this._popperInstance = this._createPopperInstance();
        this._visible = false;
        this._init();
    }
    Popover.prototype._init = function() {
        if (this._triggerEl) this._setupEventListeners();
    };
    Popover.prototype._setupEventListeners = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, function() {
                _this.show();
            });
            _this._targetEl.addEventListener(ev, function() {
                _this.show();
            });
        });
        triggerEvents.hideEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, function() {
                setTimeout(function() {
                    if (!_this._targetEl.matches(":hover")) _this.hide();
                }, 100);
            });
            _this._targetEl.addEventListener(ev, function() {
                setTimeout(function() {
                    if (!_this._triggerEl.matches(":hover")) _this.hide();
                }, 100);
            });
        });
    };
    Popover.prototype._createPopperInstance = function() {
        return (0, $55c7f2385d3e922b$export$8f7491d57c8f97a9)(this._triggerEl, this._targetEl, {
            placement: this._options.placement,
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            this._options.offset
                        ]
                    }
                }
            ]
        });
    };
    Popover.prototype._getTriggerEvents = function() {
        switch(this._options.triggerType){
            case "hover":
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
            case "click":
                return {
                    showEvents: [
                        "click",
                        "focus"
                    ],
                    hideEvents: [
                        "focusout",
                        "blur"
                    ]
                };
            case "none":
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
        }
    };
    Popover.prototype._setupKeydownListener = function() {
        var _this = this;
        this._keydownEventListener = function(ev) {
            if (ev.key === "Escape") _this.hide();
        };
        document.body.addEventListener("keydown", this._keydownEventListener, true);
    };
    Popover.prototype._removeKeydownListener = function() {
        document.body.removeEventListener("keydown", this._keydownEventListener, true);
    };
    Popover.prototype._setupClickOutsideListener = function() {
        var _this = this;
        this._clickOutsideEventListener = function(ev) {
            _this._handleClickOutside(ev, _this._targetEl);
        };
        document.body.addEventListener("click", this._clickOutsideEventListener, true);
    };
    Popover.prototype._removeClickOutsideListener = function() {
        document.body.removeEventListener("click", this._clickOutsideEventListener, true);
    };
    Popover.prototype._handleClickOutside = function(ev, targetEl) {
        var clickedEl = ev.target;
        if (clickedEl !== targetEl && !targetEl.contains(clickedEl) && !this._triggerEl.contains(clickedEl) && this.isVisible()) this.hide();
    };
    Popover.prototype.isVisible = function() {
        return this._visible;
    };
    Popover.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
        this._options.onToggle(this);
    };
    Popover.prototype.show = function() {
        this._targetEl.classList.remove("opacity-0", "invisible");
        this._targetEl.classList.add("opacity-100", "visible");
        // Enable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $dc776f0b4a1e78cc$var$__assign($dc776f0b4a1e78cc$var$__assign({}, options), {
                modifiers: $dc776f0b4a1e78cc$var$__spreadArray($dc776f0b4a1e78cc$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: true
                    }
                ], false)
            });
        });
        // handle click outside
        this._setupClickOutsideListener();
        // handle esc keydown
        this._setupKeydownListener();
        // Update its position
        this._popperInstance.update();
        // set visibility to true
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Popover.prototype.hide = function() {
        this._targetEl.classList.remove("opacity-100", "visible");
        this._targetEl.classList.add("opacity-0", "invisible");
        // Disable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $dc776f0b4a1e78cc$var$__assign($dc776f0b4a1e78cc$var$__assign({}, options), {
                modifiers: $dc776f0b4a1e78cc$var$__spreadArray($dc776f0b4a1e78cc$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: false
                    }
                ], false)
            });
        });
        // handle click outside
        this._removeClickOutsideListener();
        // handle esc keydown
        this._removeKeydownListener();
        // set visibility to false
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    return Popover;
}();
function $dc776f0b4a1e78cc$export$200409e83b2a0dd4() {
    document.querySelectorAll("[data-popover-target]").forEach(function($triggerEl) {
        var popoverID = $triggerEl.getAttribute("data-popover-target");
        var $popoverEl = document.getElementById(popoverID);
        if ($popoverEl) {
            var triggerType = $triggerEl.getAttribute("data-popover-trigger");
            var placement = $triggerEl.getAttribute("data-popover-placement");
            var offset = $triggerEl.getAttribute("data-popover-offset");
            new $dc776f0b4a1e78cc$var$Popover($popoverEl, $triggerEl, {
                placement: placement ? placement : $dc776f0b4a1e78cc$var$Default.placement,
                offset: offset ? parseInt(offset) : $dc776f0b4a1e78cc$var$Default.offset,
                triggerType: triggerType ? triggerType : $dc776f0b4a1e78cc$var$Default.triggerType
            });
        } else console.error('The popover element with id "'.concat(popoverID, '" does not exist. Please check the data-popover-target attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.Popover = $dc776f0b4a1e78cc$var$Popover;
    window.initPopovers = $dc776f0b4a1e78cc$export$200409e83b2a0dd4;
}
var $dc776f0b4a1e78cc$export$2e2bcd8739ae039 = $dc776f0b4a1e78cc$var$Popover;


var $2a26befad433fe35$var$__assign = undefined && undefined.__assign || function() {
    $2a26befad433fe35$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2a26befad433fe35$var$__assign.apply(this, arguments);
};
var $2a26befad433fe35$var$Default = {
    triggerType: "hover",
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $2a26befad433fe35$var$Dial = /** @class */ function() {
    function Dial(parentEl, triggerEl, targetEl, options) {
        if (parentEl === void 0) parentEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $2a26befad433fe35$var$Default;
        this._parentEl = parentEl;
        this._triggerEl = triggerEl;
        this._targetEl = targetEl;
        this._options = $2a26befad433fe35$var$__assign($2a26befad433fe35$var$__assign({}, $2a26befad433fe35$var$Default), options);
        this._visible = false;
        this._init();
    }
    Dial.prototype._init = function() {
        var _this = this;
        if (this._triggerEl) {
            var triggerEventTypes = this._getTriggerEventTypes(this._options.triggerType);
            triggerEventTypes.showEvents.forEach(function(ev) {
                _this._triggerEl.addEventListener(ev, function() {
                    _this.show();
                });
                _this._targetEl.addEventListener(ev, function() {
                    _this.show();
                });
            });
            triggerEventTypes.hideEvents.forEach(function(ev) {
                _this._parentEl.addEventListener(ev, function() {
                    if (!_this._parentEl.matches(":hover")) _this.hide();
                });
            });
        }
    };
    Dial.prototype.hide = function() {
        this._targetEl.classList.add("hidden");
        if (this._triggerEl) this._triggerEl.setAttribute("aria-expanded", "false");
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Dial.prototype.show = function() {
        this._targetEl.classList.remove("hidden");
        if (this._triggerEl) this._triggerEl.setAttribute("aria-expanded", "true");
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Dial.prototype.toggle = function() {
        if (this._visible) this.hide();
        else this.show();
    };
    Dial.prototype.isHidden = function() {
        return !this._visible;
    };
    Dial.prototype.isVisible = function() {
        return this._visible;
    };
    Dial.prototype._getTriggerEventTypes = function(triggerType) {
        switch(triggerType){
            case "hover":
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
            case "click":
                return {
                    showEvents: [
                        "click",
                        "focus"
                    ],
                    hideEvents: [
                        "focusout",
                        "blur"
                    ]
                };
            case "none":
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
        }
    };
    return Dial;
}();
function $2a26befad433fe35$export$33aa68e0bfaa065d() {
    document.querySelectorAll("[data-dial-init]").forEach(function($parentEl) {
        var $triggerEl = $parentEl.querySelector("[data-dial-toggle]");
        if ($triggerEl) {
            var dialId = $triggerEl.getAttribute("data-dial-toggle");
            var $dialEl = document.getElementById(dialId);
            if ($dialEl) {
                var triggerType = $triggerEl.getAttribute("data-dial-trigger");
                new $2a26befad433fe35$var$Dial($parentEl, $triggerEl, $dialEl, {
                    triggerType: triggerType ? triggerType : $2a26befad433fe35$var$Default.triggerType
                });
            } else console.error("Dial with id ".concat(dialId, " does not exist. Are you sure that the data-dial-toggle attribute points to the correct modal id?"));
        } else console.error("Dial with id ".concat($parentEl.id, " does not have a trigger element. Are you sure that the data-dial-toggle attribute exists?"));
    });
}
if (typeof window !== "undefined") {
    window.Dial = $2a26befad433fe35$var$Dial;
    window.initDials = $2a26befad433fe35$export$33aa68e0bfaa065d;
}
var $2a26befad433fe35$export$2e2bcd8739ae039 = $2a26befad433fe35$var$Dial;













function $f0e28f288bcb3579$export$4cd50b9c69a85fd5() {
    (0, $26689838630f0c2a$export$226c1dc98323ee4d)();
    (0, $e6d090ef20b61d7c$export$355ba5a528b4009a)();
    (0, $8d99b07e34ee7239$export$3ab77386b16b9e58)();
    (0, $3ebd65f2e6828ef3$export$69c84787a503daef)();
    (0, $7c795eb159d1df54$export$8cb65a02593bf108)();
    (0, $dcd9805f7c8a4cc2$export$e14d3bc873a8b9b1)();
    (0, $e4af0c1adc25a84d$export$319df2b10e87c8ec)();
    (0, $396c077f99e01ff2$export$c92e8f569ad2976f)();
    (0, $ccaf4f9ef3a2b995$export$8f2a38c1f9d9dc3e)();
    (0, $dc776f0b4a1e78cc$export$200409e83b2a0dd4)();
    (0, $2a26befad433fe35$export$33aa68e0bfaa065d)();
}
if (typeof window !== "undefined") window.initFlowbite = $f0e28f288bcb3579$export$4cd50b9c69a85fd5;














































// setup events for data attributes
var $04a7558898fa7c15$var$events = new (0, $90fa1419acb105b2$export$2e2bcd8739ae039)("load", [
    (0, $26689838630f0c2a$export$226c1dc98323ee4d),
    (0, $e6d090ef20b61d7c$export$355ba5a528b4009a),
    (0, $8d99b07e34ee7239$export$3ab77386b16b9e58),
    (0, $3ebd65f2e6828ef3$export$69c84787a503daef),
    (0, $7c795eb159d1df54$export$8cb65a02593bf108),
    (0, $dcd9805f7c8a4cc2$export$e14d3bc873a8b9b1),
    (0, $e4af0c1adc25a84d$export$319df2b10e87c8ec),
    (0, $396c077f99e01ff2$export$c92e8f569ad2976f),
    (0, $ccaf4f9ef3a2b995$export$8f2a38c1f9d9dc3e),
    (0, $dc776f0b4a1e78cc$export$200409e83b2a0dd4),
    (0, $2a26befad433fe35$export$33aa68e0bfaa065d)
]);
$04a7558898fa7c15$var$events.init();



var $15ca565b540fc1a6$exports = {};
/**
 * This is a minimal config.
 *
 * If you need the full config, get it from here:
 * https://unpkg.com/browse/tailwindcss@latest/stubs/defaultConfig.stub.js
 */ 
var $dXH7e = parcelRequire("dXH7e");
// We override lineCamp because of a bug in safari and firefox where lineClamping only works when all children are display:inline
const $15ca565b540fc1a6$var$lineClamp = $dXH7e(function({ matchUtilities: matchUtilities, addUtilities: addUtilities, theme: theme, variants: variants, e: e }) {
    const values = theme("lineClamp");
    matchUtilities({
        "line-clamp": (value)=>({
                "& *": {
                    "display": "inline"
                }
            })
    }, {
        values: values
    });
});




$15ca565b540fc1a6$exports = {
    presets: [
        (parcelRequire("kXWDL"))
    ],
    content: [
        "./node_modules/flowbite/**/*.js",
        "./src/oscar_override/order/templatetags/order_status.py",
        "./src/oscar_override/shipping/models/methods.py",
        //
        // /*
        //  * Main templates directory of the project (BASE_DIR/templates).
        //  * Adjust the following line to match your project structure.
        //  */
        "src/**/templates/**/*.html",
        "!*.pdf.html"
    ],
    theme: {
        screens: {
            // explicite all screen sizes instead of extending default one to avoir conflicts.
            // see https://stackoverflow.com/questions/59999022/why-screen-xl-and-screen-lg-gets-overridden-by-screen-md-in-tailwindcss
            // and https://tailwindcss.com/docs/screens#max-width-breakpoints
            "xs": "540px",
            "sm": "640px",
            "md": "768px",
            "lg": "1024px",
            "xl": "1280px",
            "2xl": "1536px"
        },
        extend: {
            listStyleType: {
                circle: "circle"
            },
            fontSize: {
                "xxs": [
                    "0.625rem",
                    "0.85rem"
                ]
            },
            gridTemplateAreas: {
                "headerwide": [
                    "logo    countryselector searchbar   usermenu",
                    "btmenu  promotional     promotional promotional",
                    "modal   modal           modal       modal"
                ],
                "headerslim": [
                    "btmenu          logo            usermenu",
                    "modal           modal           modal",
                    "countryselector countryselector countryselector",
                    "searchbar       searchbar       searchbar",
                    "promotional     promotional     promotional"
                ]
            }
        }
    },
    plugins: [
        /**
         * '@tailwindcss/forms' is the forms plugin that provides a minimal styling
         * for forms. If you don't like it or have own styling for forms,
         * comment the line below to disable '@tailwindcss/forms'.
         */ (parcelRequire("4YMR3")),
        // require("@tailwindcss/line-clamp"), // now included by default in Tailwind CSS v3.3+
        (parcelRequire("gcDGr")),
        (parcelRequire("3MISw")),
        $15ca565b540fc1a6$var$lineClamp
    ],
    variants: {
        gridTemplateAreas: [
            "responsive"
        ]
    }
};


var $3b476aeba6fd754f$exports = {};
var $8a2b6a13f7d7f26e$exports = {};
"use strict";
Object.defineProperty($8a2b6a13f7d7f26e$exports, "__esModule", {
    value: true
});
Object.defineProperty($8a2b6a13f7d7f26e$exports, "default", {
    enumerable: true,
    get: function() {
        return $8a2b6a13f7d7f26e$var$resolveConfig;
    }
});

const $8a2b6a13f7d7f26e$var$_resolveConfig = /*#__PURE__*/ $8a2b6a13f7d7f26e$var$_interop_require_default((parcelRequire("ju1kk")));

const $8a2b6a13f7d7f26e$var$_getAllConfigs = /*#__PURE__*/ $8a2b6a13f7d7f26e$var$_interop_require_default((parcelRequire("hKw0S")));
function $8a2b6a13f7d7f26e$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8a2b6a13f7d7f26e$var$resolveConfig(...configs) {
    let [, ...defaultConfigs] = (0, $8a2b6a13f7d7f26e$var$_getAllConfigs.default)(configs[0]);
    return (0, $8a2b6a13f7d7f26e$var$_resolveConfig.default)([
        ...configs,
        ...defaultConfigs
    ]);
}


$3b476aeba6fd754f$exports = ($8a2b6a13f7d7f26e$exports.__esModule ? $8a2b6a13f7d7f26e$exports : {
    default: $8a2b6a13f7d7f26e$exports
}).default;


const $b76f906e21ef9c10$var$fullConfig = $3b476aeba6fd754f$exports((0, (/*@__PURE__*/$parcel$interopDefault($15ca565b540fc1a6$exports))));
class $b76f906e21ef9c10$export$91c3802922dc3ba9 extends (0, $dcd9805f7c8a4cc2$export$2e2bcd8739ae039) {
    _handleOutsideClick(target) {
        if (this._targetEl.contains(target)) return;
        this.hide();
    }
    _setupModalCloseEventListeners() {
        if (this._options.backdrop === "dynamic") {
            this._clickOutsideEventListener = (ev)=>{
                this._handleOutsideClick(ev.target);
            };
            document.addEventListener("click", this._clickOutsideEventListener, true);
        }
        this._keydownEventListener = (ev)=>{
            if (ev.key === "Escape") // @ts-ignore
            this._options.onPressEscape(this);
        };
        document.body.addEventListener("keydown", this._keydownEventListener, true);
    }
    _removeModalCloseEventListeners() {
        document.removeEventListener("click", this._clickOutsideEventListener, true);
        document.body.removeEventListener("keydown", this._keydownEventListener, true);
    }
    hide() {
        if (this.isVisible) {
            this._options.onHide(this);
            this._targetEl.removeAttribute("role");
            setTimeout(()=>{
                this._targetEl.classList.add("hidden");
                this._targetEl.classList.remove("flex");
                this._targetEl.setAttribute("aria-hidden", "true");
                this._targetEl.removeAttribute("aria-modal");
                this._destroyBackdropEl();
                this._isHidden = true;
                // re-apply body scroll
                document.body.classList.remove("overflow-hidden");
                if (this._options.closable) this._removeModalCloseEventListeners();
            }, 200);
        }
    }
}
function $b76f906e21ef9c10$export$e07921c8785c67b2() {
    const $universeList = document.getElementById("universe-list");
    const $modalEl = document.getElementById("menuModal");
    const $button = document.getElementById("menuModalOpenButton");
    const $modalContainer = document.getElementById("menuModalContainer");
    const $menuModalAnchor = document.getElementById("menuModalAnchor");
    const fixModalMaxHeight = ()=>{
        const { y: y } = $menuModalAnchor.getBoundingClientRect();
        $modalContainer.style.height = `calc(95vh - ${y}px)`;
    };
    const headerModal = new $b76f906e21ef9c10$export$91c3802922dc3ba9($modalEl, {
        onShow: ()=>{
            fixModalMaxHeight();
            $button.classList.add("active");
            $universeList.classList.add("default-open");
            $universeList.classList.remove("root-selected");
        },
        onHide: ()=>{
            $button.classList.remove("active");
            $button.blur();
            document.forms["universe_selection_form"].universe_selection.value = "-1";
            document.forms["universe_selection_form"].root_selection.value = "-1";
        },
        // @ts-ignore
        onPressEscape: (modal)=>{
            // >md: hide modal
            if (window.matchMedia(`(min-width: ${$b76f906e21ef9c10$var$fullConfig.theme.screens["md"]})`).matches) {
                modal.hide();
                return;
            }
            // <md: hide if no universe selected, unselect it otherwise
            const universeSelectionValue = document.forms["universe_selection_form"].universe_selection.value;
            if (universeSelectionValue === "-1" || universeSelectionValue === undefined) modal.hide();
            else document.forms["universe_selection_form"].universe_selection.value = "-1";
        }
    });
    // // // show modal on click if exists based on id
    document.querySelectorAll("[data-modal-header-show]").forEach(($triggerEl)=>{
        $triggerEl.addEventListener("click", ()=>{
            if (headerModal.isHidden()) headerModal.show();
        });
    });
    // allow user to unselect a root category
    document.querySelectorAll("[data-unselect-radio]").forEach(($triggerEl)=>{
        $triggerEl.addEventListener("click", ()=>{
            const radio = document.getElementById($triggerEl.getAttribute("for"));
            if (radio.checked) setTimeout(()=>{
                radio.checked = false;
            });
        });
    });
    // // // hide modal on click if exists based on id
    document.querySelectorAll("[data-modal-header-hide]").forEach(($triggerEl)=>{
        $triggerEl.addEventListener("click", ()=>{
            if (headerModal.isVisible) headerModal.hide();
        });
    });
    window.addEventListener("resize", ()=>{
        fixModalMaxHeight();
    });
    fixModalMaxHeight();
    document.querySelector("form[name=universe_selection_form]").addEventListener("change", (e)=>{
        $universeList.classList.remove("default-open");
        if (document.forms["universe_selection_form"].universe_selection.value === "-1") $universeList.classList.remove("root-selected");
        else $universeList.classList.add("root-selected");
    });
}


window.addEventListener("DOMContentLoaded", ()=>{
    (0, $b76f906e21ef9c10$export$e07921c8785c67b2)();
    (0, $20e8b1c4c5440ada$export$97d12247d9e02166).init();
    (0, $20e8b1c4c5440ada$export$f5e4bb818687d04f).init("partnersContainer", "partnersArrowForward", "partnersArrowBack");
});
window["oscar"] = (0, $20e8b1c4c5440ada$export$f2cc568221ba213f);
window["SlidingMenuAnimations"] = (0, $20e8b1c4c5440ada$export$35a1b15942a0f275);

})();
//# sourceMappingURL=parcel-entry.js.map
